/**
 * A function to create a log object for the 'newUserManagerBackendEvents' event (evid: 3200)
 *
 * Event description: Client requests/alters data from User Manager server.      Important; some events are triggered from other platforms that are using the same services - use the 'source' field to filter
 *
 * @param {newUserManagerBackendEventsParams} params - The parameters for this event
 * @property {string} source - The platform from which the user performed the action
 * @property {string} errorMessage - In case the performed action triggered an error, including the content of the message
 * @property {string} params - Includes all the parameters sent with the action request
 * @property {boolean} actionSucceed - Was the action success {true,false]
 * @property {string} actionType - {extra info, navigation}
 * @property {string} umUserType - The ending of the user email that was logged in the user manager
 * @property {string} actionName - The performed action that triggered the event
 * @property {string} userName - The user email (part until @) that was logged in the user manager
 * @return {LogObject<newUserManagerBackendEventsParams>} LogObject<newUserManagerBackendEventsParams>
 */
export function newUserManagerBackendEvents(params) {
    return { evid: 3200, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newUserManagerImpersonateEvents' event (evid: 3300)
 *
 * Event description: Client impersonated a Wix user through the User Manager.     Important; some events are triggered from other platforms that are using the same services - use the 'source' field to filter
 *
 * @param {newUserManagerImpersonateEventsParams} params - The parameters for this event
 * @property {string} source - The platform from which the user performed the action
 * @property {string} errorMessage - In case the performed action triggered an error, including the content of the message
 * @property {string} params - Includes all the parameters sent with the action request
 * @property {boolean} actionSucceed - Was the action success {true,false]
 * @property {string} umUserType - The ending of the user email that was logged in the user manager
 * @property {string} actionName - The performed action that triggered the event
 * @property {string} userName - The user email (part until @) that was logged in the user manager
 * @return {LogObject<newUserManagerImpersonateEventsParams>} LogObject<newUserManagerImpersonateEventsParams>
 */
export function newUserManagerImpersonateEvents(params) {
    return { evid: 3300, src: 18, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainHelperChoosingSiteFromList' event (evid: 1000)
 *
 * Event description: Domain Helper - Choosing site from list.
 *
 * @param {domainHelperChoosingSiteFromListParams} params - The parameters for this event
 * @return {LogObject<domainHelperChoosingSiteFromListParams>} LogObject<domainHelperChoosingSiteFromListParams>
 */
export function domainHelperChoosingSiteFromList(params) {
    return { evid: 1000, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainHelperClickGetStarted' event (evid: 1034)
 *
 * Event description: The user clicks Get Started on the first page of the domain helper
 *
 * @param {domainHelperClickGetStartedParams} params - The parameters for this event
 * @property {Url} referral_url - url directing the user to the domain helper
 * @return {LogObject<domainHelperClickGetStartedParams>} LogObject<domainHelperClickGetStartedParams>
 */
export function domainHelperClickGetStarted(params) {
    return { evid: 1034, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadChatbot' event (evid: 1051)
 *
 * Event description: User successfully loads the chatbot
 *
 * @param {chatbotLoadChatbotParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbotFloating, helpWidgetFloating, chatbotContactPage, helpWidgetContactPage
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {number} ts - total load time of the page, in ms
 * @property {string} referral_info - DEPRECATED- DO NOT USE!
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} real_estate_id - real_estate_id
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} group_name - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} offer_id - offer_id
 * @property {string} suggestion_id - suggestion_id
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotLoadChatbotParams>} LogObject<chatbotLoadChatbotParams>
 */
export function chatbotLoadChatbot(params) {
    return { evid: 1051, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotUserMessage' event (evid: 1052)
 *
 * Event description: The user clicks on any part of the chatbot
 *
 * @param {chatbotUserMessageParams} params - The parameters for this event
 * @property {string} ticket_id - ticket id
 * @property {string} node_name - node_name
 * @property {string} selected_account - The account selected by the user in the Account-Selector
 * @property {string} main_option_id - id for the category the user clicked
 * @property {string} chosen_site - The msid of the site chosen by the user in the Site-Selector
 * @property {string} button_type - the type of the button_id chosen by the user
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} survey_interaction_id - id of interaction (related for surveys only)
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - list of all button ids shown to the user in order, separated by commas
 * @property {string} soft_goal_name - Name of the goal the user is meeting
 * @property {string} node_type_id - ID of node_type
 * @property {string} button_type_id - the button ID type of the chosen button_id
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} button_name - name of the button clicked
 * @property {string} intent_id - ID of the user_intent
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} button_name_list - list of all button names shown to the user in order, separated by |
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message
 * @property {string} button_id - id of the button clicked
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} request_id - ID of the support request (ticket, call, chat) from earlier in the conversation
 * @property {number} position - position of the button (left-to-right, top-to-bottom)
 * @property {string} message - User message with PII removed
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} chat_type - live or chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} group - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} action_type - action the user is taking (click link, CTA, send message, etc.))
 * @property {number} sites_count - The number of sites the user has
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - Name of the group causing the user to go to live chat (payments, partners, etc)
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {boolean} soft_goal_met - Is this action the soft goal for the user's flow?
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotUserMessageParams>} LogObject<chatbotUserMessageParams>
 */
export function chatbotUserMessage(params) {
    return { evid: 1052, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotChatbotMessage' event (evid: 1053)
 *
 * Event description: Sent every time the chatbot sends a batch of messages to the user
 *
 * @param {chatbotChatbotMessageParams} params - The parameters for this event
 * @property {number} num_of_messages - number_of_messages- number of separate messages in this batch
 * @property {string} ticket_id - ticket id
 * @property {string} solution_ids - The article ID if was suggested by the chatbot; The article IDs if a selector was involved in the process
 * @property {string} node_name - name of the chatbot node
 * @property {string} selected_account - The account selected by the user in the Account-Selector
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} survey_interaction_id - id of interaction (related for surveys only)
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - IDs of all the button options shown to the user
 * @property {string} node_type_id - ID of node_type
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {GUID} reported_abuse_msid - reported_abuse_msid
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} intent_id - id of the user_intent
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} message_text - text of the message sent by the chatbot
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} next_suggestion_ids - next_suggestion_ids
 * @property {string} user_agent - user_agent
 * @property {string} button_name_list - button_name_list
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} reported_abuse_premium_state - reported_abuse_premium_state
 * @property {string} group_name - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain). It exists
 * @property {string} extraInfo - any extra relevant info
 * @property {string} user_response_type - does the node allow for free text, bubbles, popup, or some combination?
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} sites_count - The number of sites the user has
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - The specific user intent that was recognized by NLP. For example a specific critical flow intent name
 *
 * @property {string} ai_user_intent_list - This is the vey granular intent of a user message that arrived from NLP. the first intent in the list is the most likely to be the relevant intent. It's equal to 'user_intent' field exist in classic chatbot
 * @property {GUID} ai_message_id -  AI message ID
 * @property {GUID} ai_assistant_id - AI Assistant ID, if the user reached to the chatbot through the AI Assistant platform.
 * @property {string} ai_user_intent_type - The user intent type of the 'ai_user_intent' - for specific cases like critical flow
 * @property {string} ai_revised_request_summary - The second summary that goes to NLP
 * @property {string} ai_articles_details - Array/json of all articles with their scores, relevancy and details from the retrieval mechanism. When article is 'relevant' meaning it sent to the prompt.
 * @property {string} ai_response_type - The response type of the mechanism.  (answer, question, contact, not prohibited)
 * @property {number} ai_last_customer_support_request_message_index - The last message index where user asked for support. can be null, a previous or current message.
 * @property {string} ai_request_summary - The user Request Summary based on the current and previous messages (Main)
 * @property {string} ai_cf_triggered_type -
 * Reasons for the Contact Flow to be triggered:
 *
 * 1. SR - Support Request (needs to happen twice to trigger the Contact Flow)
 *
 * 2. NS - Negative Sentiment
 *
 * 3. SSA - when the AI Chatbot suggests the user to contact support and the user agrees
 * Null - None of the above
 * @return {LogObject<chatbotChatbotMessageParams>} LogObject<chatbotChatbotMessageParams>
 */
export function chatbotChatbotMessage(params) {
    return { evid: 1053, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStartOver' event (evid: 1054)
 *
 * Event description: The user clicks the Start Over button to restart the chat
 *
 * @param {chatbotStartOverParams} params - The parameters for this event
 * @property {string} node_name - name of the current chatbot node
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe, mobile
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotStartOverParams>} LogObject<chatbotStartOverParams>
 */
export function chatbotStartOver(params) {
    return { evid: 1054, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotContactSupport' event (evid: 1056)
 *
 * Event description: The user responds “Yes” to the question “Do you still need to talk to support?”
 *
 * @param {chatbotContactSupportParams} params - The parameters for this event
 * @property {string} node_name - name of the current chatbot node
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} node_id - ID of the chatbot node
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {GUID} bot_id - ID of the chatbot
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotContactSupportParams>} LogObject<chatbotContactSupportParams>
 */
export function chatbotContactSupport(params) {
    return { evid: 1056, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationMessageSent' event (evid: 1080)
 *
 * Event description: The verification message is sent to the phone number entered by the user.
 *
 * @param {smsVerificationMessageSentParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} phone_number_error - Null if there is no error
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationMessageSentParams>} LogObject<smsVerificationMessageSentParams>
 */
export function smsVerificationMessageSent(params) {
    return { evid: 1080, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmitted' event (evid: 1082)
 *
 * Event description: The user successfully submits the code sent to their phone
 *
 * @param {smsVerificationCodeSubmittedParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @return {LogObject<smsVerificationCodeSubmittedParams>} LogObject<smsVerificationCodeSubmittedParams>
 */
export function smsVerificationCodeSubmitted(params) {
    return { evid: 1082, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmissionError' event (evid: 1083)
 *
 * Event description: The user submits an incorrect code
 *
 * @param {smsVerificationCodeSubmissionErrorParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationCodeSubmissionErrorParams>} LogObject<smsVerificationCodeSubmissionErrorParams>
 */
export function smsVerificationCodeSubmissionError(params) {
    return { evid: 1083, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotClickLink' event (evid: 1088)
 *
 * Event description: The user clicks on a link from the chatbot
 *
 * @param {chatbotClickLinkParams} params - The parameters for this event
 * @property {string} node_id - previous_node_id
 * @property {string} node_name - name of the chatbot node
 * @property {string} main_option_id - main_option_id
 * @property {string} linkUrl - url of the link the user clicked
 * @property {string} button_type - Did the user click a link or CTA
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - lang
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotClickLinkParams>} LogObject<chatbotClickLinkParams>
 */
export function chatbotClickLink(params) {
    return { evid: 1088, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDialogueflowIntentMatch' event (evid: 1089)
 *
 * Event description: Dialogueflow is given input by the user and returns a matching intent.
 *
 * @param {chatbotDialogueflowIntentMatchParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} main_option_id - main_option_id
 * @property {string} entity_string - Part of the user's message that matched the DF entities separated by commas
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} intent_name_multiple - cases of several results of entity
 * @property {string} node_id - node ID of the chatbot message
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {boolean} low_sentiment - Flags if the user has a low sentiment that will be flagged by our system
 * @property {string} intent_prediction_id - intent_prediction_id
 * @property {string} referral_info - referral_info
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} confidence_multiple - confidence rate for multiple intents
 * @property {string} agent_name - agent_name
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} confidence - Confidence Level returned by Dialogflow
 * @property {string} agent - Wix_Context or MegaBot
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} version - Version of Dialogflow
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} entity_name - All Dialogflow entities matched by the user's message separated by commas
 * @property {string} referral - referral
 * @property {string} entity_prediction_id - entity_prediction_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} intent_name - the matched intent from Dialogflow
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - previous intent of the user before Dialogflow
 * @property {string} df_context_name - Context passed from one DF agent to another
 * @property {string} product_mapping - product mapping for DS team
 * @property {string} message - User message with PII removed
 * @property {string} sentiment_magnitude - magnitude returned by Dialogflow sentiment analysis
 * @property {string} lang - Answers language
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} model_environment - model_environment
 * @property {string} url_mapping - url mapping for DS team
 * @property {string} sentiment_score - score returned by Dialogflow sentiment analysis
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 * @return {LogObject<chatbotDialogueflowIntentMatchParams>} LogObject<chatbotDialogueflowIntentMatchParams>
 */
export function chatbotDialogueflowIntentMatch(params) {
    return { evid: 1089, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotArticlePrediction' event (evid: 1093)
 *
 * Event description: Sent when a user is shown an article from the data science prediction model in the Chatbot
 *
 * @param {chatbotArticlePredictionParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} articles_shown - IDs of articles shown to the user (comma separated)
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} prediction_id - id of the article prediction
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} message - User message with PII removed
 * @property {string} model_name - model_name
 * @property {string} lang - lang
 * @property {string} conversation_id - id of the conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 * @return {LogObject<chatbotArticlePredictionParams>} LogObject<chatbotArticlePredictionParams>
 */
export function chatbotArticlePrediction(params) {
    return { evid: 1093, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotFunctionFailure' event (evid: 1095)
 *
 * Event description: A chatbot function fails
 *
 * @param {chatbotFunctionFailureParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} function_name - Function that failed
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} issue - Reason the function failed
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - id of the conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotFunctionFailureParams>} LogObject<chatbotFunctionFailureParams>
 */
export function chatbotFunctionFailure(params) {
    return { evid: 1095, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotToggleSwitch' event (evid: 1097)
 *
 * Event description: A switch on the chatbot's setting page (https://www.wix.com/support/conversations/settings?botId=717b0e2d-a564-4ef7-b965-481b1983133b) is toggle on or off
 *
 * @param {chatbotToggleSwitchParams} params - The parameters for this event
 * @property {number} chats_per_agent - Number of live chats per agent
 * @property {boolean} toggle_state - True when the toggle is being switched on
 * @property {string} toggleName - name of the toggle being switch
 * @property {string} wait_time - maximum waiting time for live chat toggle
 * @property {string} button_text - text on the announcement banner's button
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} announcement_text - Message of the announcement banner
 * @property {string} lang - Language of toggle
 * @property {number} num_agents - Number of agents in Live Chat
 * @property {Url} button_link - link included in the announcement banner
 * @return {LogObject<chatbotToggleSwitchParams>} LogObject<chatbotToggleSwitchParams>
 */
export function chatbotToggleSwitch(params) {
    return { evid: 1097, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'triggerTrialChurnModelFromSupportRequest' event (evid: 1099)
 *
 * Event description: right after chatbot triggers the model it sends a monitor event
 *
 * @param {triggerTrialChurnModelFromSupportRequestParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} context - chatbot
 * @property {string} node_id - node_id
 * @property {GUID} bot_id - bot id
 * @property {string} subscription_id - subscription_id
 * @property {string} interaction_type_name - interaction_type_name
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<triggerTrialChurnModelFromSupportRequestParams>} LogObject<triggerTrialChurnModelFromSupportRequestParams>
 */
export function triggerTrialChurnModelFromSupportRequest(params) {
    return { evid: 1099, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickingOnSubCategoryOnHomePage' event (evid: 11)
 *
 * Event description: clicking on sub- category on home page.
 *
 * @param {clickingOnSubCategoryOnHomePageParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickingOnSubCategoryOnHomePageParams>} LogObject<clickingOnSubCategoryOnHomePageParams>
 */
export function clickingOnSubCategoryOnHomePage(params) {
    return { evid: 11, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveChatAgentMessage' event (evid: 1100)
 *
 * Event description: Sent every time a Wix agent sends a message to the user
 *
 * @param {liveChatAgentMessageParams} params - The parameters for this event
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} message_text - text of the message sent by the chatbot
 * @property {string} user_agent - user_agent
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {GUID} agent_id - Wix agent sending the message
 * @return {LogObject<liveChatAgentMessageParams>} LogObject<liveChatAgentMessageParams>
 */
export function liveChatAgentMessage(params) {
    return { evid: 1100, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveChatCloseChat' event (evid: 1101)
 *
 * Event description: The user or agent closes the chat
 *
 * @param {liveChatCloseChatParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} close_method - agent or user
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} user_agent - user_agent
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} lang - lang
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} live_chat_group - reason the user was given the option to chat
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<liveChatCloseChatParams>} LogObject<liveChatCloseChatParams>
 */
export function liveChatCloseChat(params) {
    return { evid: 1101, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveChatAgentEntersLeavesChat' event (evid: 1102)
 *
 * Event description: Sent when the agent enters or leaves the chat
 *
 * @param {liveChatAgentEntersLeavesChatParams} params - The parameters for this event
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_agent - user_agent
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} action - enter or exit
 * @property {GUID} agent_id - id of the Wix Agent
 * @return {LogObject<liveChatAgentEntersLeavesChatParams>} LogObject<liveChatAgentEntersLeavesChatParams>
 */
export function liveChatAgentEntersLeavesChat(params) {
    return { evid: 1102, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveChatLoadChat' event (evid: 1103)
 *
 * Event description: When the user switches to live chat
 *
 * @param {liveChatLoadChatParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - Chatbot node before live chat
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - Chatbot node before live chat
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} live_chat_group - Name of the group causing the user to go to live chat (payments, partners, etc)
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @property {string} lang - Chatbot Language
 * @return {LogObject<liveChatLoadChatParams>} LogObject<liveChatLoadChatParams>
 */
export function liveChatLoadChat(params) {
    return { evid: 1103, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveChatChatStatus' event (evid: 1104)
 *
 * Event description: Returns whether or not live chat is available to the user
 *
 * @param {liveChatChatStatusParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - Chatbot node before live chat
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - Chatbot node before live chat
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - Why Live Chat is unavailable (null if chat is available)
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} status_text - Is Live Chat available to this users
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language used by the chatbot (from Answers)
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<liveChatChatStatusParams>} LogObject<liveChatChatStatusParams>
 */
export function liveChatChatStatus(params) {
    return { evid: 1104, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDisplayWarning' event (evid: 1106)
 *
 * Event description: A Warning message (note) should be displayed to the user if it takes to the chatbot to respond more than 5 seconds (Just a moment..) or 10 seconds (We're still working on it...) since user message.
 *
 * @param {chatbotDisplayWarningParams} params - The parameters for this event
 * @property {number} num_of_messages - number_of_messages- number of separate messages in this batch
 * @property {string} ticket_id - ticket id
 * @property {number} time_waited - the time user already waited and didn't get a response yet. could be 5 or 10
 * @property {string} node_name - name of the chatbot node
 * @property {string} selected_account - The account selected by the user in the Account-Selector
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - IDs of all the button options shown to the user
 * @property {string} node_type_id - ID of node_type
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} intent_id - id of the user_intent
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} message_text - text of the message sent by the chatbot
 * @property {string} button_name_list - Names of all the button options shown to the user
 * @property {string} context_uuid - context_uuid
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} user_response_type - does the node allow for free text, bubbles, popup, or some combination?
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {number} sites_count - The number of sites the user has
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<chatbotDisplayWarningParams>} LogObject<chatbotDisplayWarningParams>
 */
export function chatbotDisplayWarning(params) {
    return { evid: 1106, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDragWidget' event (evid: 1108)
 *
 * Event description: The event is triggered whenever a user drags the widget
 *
 * @param {chatbotDragWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} old_position - {X,Y}
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - {X,Y}
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the referral of the widget
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - {open, closed}
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<chatbotDragWidgetParams>} LogObject<chatbotDragWidgetParams>
 */
export function chatbotDragWidget(params) {
    return { evid: 1108, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotOpenWidget' event (evid: 1109)
 *
 * Event description: The Help Widget is opened after being minimized
 *
 * @param {chatbotOpenWidgetParams} params - The parameters for this event
 * @property {number} context_page_numLevels - context_page_numlevels
 * @property {string} context_page_topLevelRoute - context_page_toplevelroute
 * @property {string} context_parentUrl - context_parenturl
 * @property {string} context_page_queryParams - context_page_queryparams
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_iframeUrlList - context_iframeurllist
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} widget_open_origin - where the user opened the widget from (editor top bar, editor component, etc.)
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_urlChunks - context_page_urlchunks
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<chatbotOpenWidgetParams>} LogObject<chatbotOpenWidgetParams>
 */
export function chatbotOpenWidget(params) {
    return { evid: 1109, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotCloseWidget' event (evid: 1110)
 *
 * Event description: The Help Widget is closed after being opened
 *
 * @param {chatbotCloseWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} closing_trigger - The trigger for closing the widget {close_button, click_outside_widget}
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotCloseWidgetParams>} LogObject<chatbotCloseWidgetParams>
 */
export function chatbotCloseWidget(params) {
    return { evid: 1110, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidget' event (evid: 1111)
 *
 * Event description: The Help Widget is loaded in the background
 *
 * @param {chatbotLoadWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} context_parenturl - context_parenturl
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} real_estate_id - Dealer real estate ID
 * @property {string} issue - in case of failure to send context fields, there will be a string explaining what failed
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} dealer_offer_id - Null if no dealer offer exists
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} offer_id - Dealer offer ID
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} triggerType - Reason the widget appeared (dealer offer, active session, etc.)
 * @return {LogObject<chatbotLoadWidgetParams>} LogObject<chatbotLoadWidgetParams>
 */
export function chatbotLoadWidget(params) {
    return { evid: 1111, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetAttempt' event (evid: 1113)
 *
 * Event description: The user attempts to load the chatbot widget
 *
 * @param {chatbotLoadWidgetAttemptParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} node_id - ID of the chatbot node
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {GUID} visitor_id - visitor ID used for load widget events when uuid is unavailable
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @return {LogObject<chatbotLoadWidgetAttemptParams>} LogObject<chatbotLoadWidgetAttemptParams>
 */
export function chatbotLoadWidgetAttempt(params) {
    return { evid: 1113, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetFailure' event (evid: 1114)
 *
 * Event description: The user fails to open the Help Widget
 *
 * @param {chatbotLoadWidgetFailureParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} fail_details - to log dealer offer or any other valuable information for debug purpose
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - chatbot_view
 * @property {string} fail_reason - Reason why the chatbot couldn't load
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {GUID} visitor_id - visitor ID used for load widget events when uuid is unavailable
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} dealer_offer_id - only if loaded because of dealer offer
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<chatbotLoadWidgetFailureParams>} LogObject<chatbotLoadWidgetFailureParams>
 */
export function chatbotLoadWidgetFailure(params) {
    return { evid: 1114, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotLoadTooltip' event (evid: 1115)
 *
 * Event description: The user is shown a tooltip near the help widget
 *
 * @param {chatbotLoadTooltipParams} params - The parameters for this event
 * @property {string} node_name - the name of the node
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - the ID of the node type
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - the type of the node
 * @property {string} node_id - the ID of the node
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget is placed
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @property {string} chatbot_view - Chatbot View
 * @return {LogObject<chatbotLoadTooltipParams>} LogObject<chatbotLoadTooltipParams>
 */
export function chatbotLoadTooltip(params) {
    return { evid: 1115, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotClickTooltip' event (evid: 1116)
 *
 * Event description: The help widget is opened after the user clicks on a tooltip
 *
 * @param {chatbotClickTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotClickTooltipParams>} LogObject<chatbotClickTooltipParams>
 */
export function chatbotClickTooltip(params) {
    return { evid: 1116, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotCloseTooltip' event (evid: 1117)
 *
 * Event description: The user closes a Help Widget tooltip
 *
 * @param {chatbotCloseTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {Url} referral_url - Referral's URL
 * @property {string} chatbot_view - Chatbot View
 * @return {LogObject<chatbotCloseTooltipParams>} LogObject<chatbotCloseTooltipParams>
 */
export function chatbotCloseTooltip(params) {
    return { evid: 1117, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetPresentedContent' event (evid: 1119)
 *
 * Event description: Fires when suggested solutions are presented to the user in the Help Widget
 *
 * @param {widgetPresentedContentParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} lng - user's language
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - presented article _id for single article state
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} article_recommendation_version - version of DS article recommendation module
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<widgetPresentedContentParams>} LogObject<widgetPresentedContentParams>
 */
export function widgetPresentedContent(params) {
    return { evid: 1119, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetContentInteraction' event (evid: 1120)
 *
 * Event description: Fires when a user clicks on one of the content items or buttons in the help widget
 *
 * @param {widgetContentInteractionParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} button_clicked - widget button/link/solution that was clicked
 * @property {string} lng - user's language
 * @property {string} last_user_intent_name - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - article_id
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} article_recommendation_version - version of DS article recommendation module
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} clicked_value - In case of button_clicked = 'chatbot_notifications', this number indicates the number of notifications.
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<widgetContentInteractionParams>} LogObject<widgetContentInteractionParams>
 */
export function widgetContentInteraction(params) {
    return { evid: 1120, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetPageEngagement' event (evid: 1121)
 *
 * Event description: Fires every 10 seconds to indicate the user is active on the Help Widget
 *
 * @param {widgetPageEngagementParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} lng - user's language
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {boolean} max_scroll_at_first_position - indicates if the entire article/page is visible to the user without having to scroll
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - article id in a single article solution view the user interacts with
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {number} max_scroll - max % of the page the user reached while visiting the page
 * @property {boolean} activity_type_mouse_click - Type of activity the user performed (T if user clicked the mouse in the widget)
 * @property {boolean} activity_type_scroll - Type of activity the user performed (T if user scrolled)
 * @property {boolean} activity_type_widget_is_open - To indicate if the widget is open and in focus
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {boolean} activity_type_scroll_to_bottom - Type of activity the user performed (T if user scrolled all the way to the bottom of the widget page)
 * @property {string} lang - Answers language
 * @property {boolean} activity_type_scroll_added_content - Type of activity performed (T if content was added following a scroll down)
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {boolean} activity_type_mouse_move - activity_type_mouse_move
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<widgetPageEngagementParams>} LogObject<widgetPageEngagementParams>
 */
export function widgetPageEngagement(params) {
    return { evid: 1121, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetHeaderButtonClick' event (evid: 1122)
 *
 * Event description: Fires when the user clicks one of these options in the widget header: resize, dock, minimize, undock.
 *
 * @param {widgetHeaderButtonClickParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} button_clicked - widget button/link/solution that was clicked
 * @property {string} lng - user's language
 * @property {number} context_page_numLevels - context_page_numLevels
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} old_position - location of the widget on the screen {x,y}
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - location of the widget on the screen {x,y}
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @return {LogObject<widgetHeaderButtonClickParams>} LogObject<widgetHeaderButtonClickParams>
 */
export function widgetHeaderButtonClick(params) {
    return { evid: 1122, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotDisplayWarningSrc4Evid1123' event (evid: 1123)
 *
 * Event description: A Warning message (note) should be displayed to the user if it takes to the chatbot to respond more than 5 seconds (Just a moment..) or 10 seconds (We're still working on it...) since user message.
 *
 * @param {chatbotDisplayWarningSrc4Evid1123Params} params - The parameters for this event
 * @property {number} time_waited - the time user already waited and didn't get a response yet. could be 5 or 10
 * @property {string} node_name - name of the current chatbot node
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe, mobile
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} warning_type - the type of the warning for example 'ai model loading'
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} message_text - text of the message sent by the chatbot - could be  (Just a moment.., We're still working on it...)
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message, if the two warnings happen together they will get the same message_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotDisplayWarningSrc4Evid1123Params>} LogObject<chatbotDisplayWarningSrc4Evid1123Params>
 */
export function chatbotDisplayWarningSrc4Evid1123(params) {
    return { evid: 1123, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotSessionExpired' event (evid: 1124)
 *
 * Event description: Fires every time the conversation expired
 *
 * @param {chatbotSessionExpiredParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} message - User message with PII removed
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} action_type - action the user is taking (click link, CTA, send message, etc.))
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotSessionExpiredParams>} LogObject<chatbotSessionExpiredParams>
 */
export function chatbotSessionExpired(params) {
    return { evid: 1124, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotTooltipButtonClick' event (evid: 1125)
 *
 * Event description: Fires every time the user clicks on a button in the tooltip
 *
 * @param {chatbotTooltipButtonClickParams} params - The parameters for this event
 * @property {string} node_name - the name of the node
 * @property {string} tooltip_name - title of the tooltip
 * @property {string} lng - user's language
 * @property {string} button_type - the type of the button_id chosen by the user
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - the ID of the node type
 * @property {string} button_type_id - the button ID type of the chosen button_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - the node type
 * @property {string} node_id - the ID of the node
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} button_name - the text on the button
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} button_id - button_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - chatbot language
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotTooltipButtonClickParams>} LogObject<chatbotTooltipButtonClickParams>
 */
export function chatbotTooltipButtonClick(params) {
    return { evid: 1125, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotVersionUnDeployment' event (evid: 1126)
 *
 * Event description: Fired when a chatbot version is being deployed/undeployed
 *
 * @param {chatbotVersionUnDeploymentParams} params - The parameters for this event
 * @property {string} state - [deployment,undeployment]
 * @property {DateTime} start_date_ts - date of deployment
 * @property {DateTime} stop_date_ts - date of undeployment (can be null in case of state=deployment)
 * @property {string} chatbot_version_id - chatbot version id
 * @return {LogObject<chatbotVersionUnDeploymentParams>} LogObject<chatbotVersionUnDeploymentParams>
 */
export function chatbotVersionUnDeployment(params) {
    return { evid: 1126, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerShowed' event (evid: 1127)
 *
 * Event description: This event is triggered every time the banner is shown to users (meaning there is an incident / there was one in the past 10 minutes)
 *
 * @param {chatbotStatusBannerStatusBannerShowedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - the url where the user sees the widget
 * @property {string} banner_type - {'status','announcement'}
 * @property {string} banner_name - The banner unique name which describes it
 * @property {string} banner_text - the text that appeared inside the banner
 * @return {LogObject<chatbotStatusBannerStatusBannerShowedParams>} LogObject<chatbotStatusBannerStatusBannerShowedParams>
 */
export function chatbotStatusBannerStatusBannerShowed(params) {
    return { evid: 1127, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerClicked' event (evid: 1128)
 *
 * Event description: This event is triggered every time the banner is clicked on by a user
 *
 * @param {chatbotStatusBannerStatusBannerClickedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<chatbotStatusBannerStatusBannerClickedParams>} LogObject<chatbotStatusBannerStatusBannerClickedParams>
 */
export function chatbotStatusBannerStatusBannerClicked(params) {
    return { evid: 1128, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerDismissed' event (evid: 1129)
 *
 * Event description: This event is triggered every time the banner is dismissed by a user (clicked x)
 *
 * @param {chatbotStatusBannerStatusBannerDismissedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - parent_url
 * @property {string} banner_type - {'status','announcement'}
 *
 * @property {string} banner_name - The banner unique name which describes it
 *
 * @property {string} banner_text - the text that appeared inside the banner
 *
 * @return {LogObject<chatbotStatusBannerStatusBannerDismissedParams>} LogObject<chatbotStatusBannerStatusBannerDismissedParams>
 */
export function chatbotStatusBannerStatusBannerDismissed(params) {
    return { evid: 1129, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotChatFilterSave' event (evid: 1130)
 *
 * Event description: Fires when clicking on the “Save” button in the Chat Filter settings
 *
 * @param {chatbotChatFilterSaveParams} params - The parameters for this event
 * @property {boolean} live_chat_status - True if the live chat toggle is on, else False
 * @property {number} previous_maximum_chats_per_agent - Previous state of maximum chats per agent
 * @property {boolean} priority_users_chat_status - True if the live chat - priority users only toggle is on, else False
 * @property {number} number_of_agents_in_chat - The number of agents in chat
 * @property {boolean} saved_successfully - Indicate if the changes were successfully saved
 * @property {GUID} uuid - The wix uuid of the user who clicked on the Save button
 * @property {number} previous_number_of_agents_in_chat - Previous state of number of agents in chat
 * @property {boolean} previous_live_chat_status - Previous state of live chat status
 * @property {boolean} previous_priority_users_chat_status - Previous state of priority users chat status
 * @property {string} filter_name - The filter name as it defined on the back office
 * @property {string} language - The chat language
 * @property {number} maximum_chats_per_agent - The maximum chats per agent
 * @property {string} custom_schedule_info - The timeframes that the live chat is open
 * @property {number} maximum_waiting_time - The maximum waiting time for live chat
 * @property {string} display_filter_name - The filter name as it displayed in the UI
 * @property {boolean} previous_open_twenty_four_seven - Previous state of open twenty four seven
 * @property {string} error_message - The error message in case the change failed to save
 * @property {number} previous_maximum_waiting_time - previous_maximum_waiting_time
 * @property {string} previous_custom_schedule_info - Previous state of custom schedule info
 * @property {boolean} open_twenty_four_seven - True if the twenty four seven toggle is on, else False
 * @return {LogObject<chatbotChatFilterSaveParams>} LogObject<chatbotChatFilterSaveParams>
 */
export function chatbotChatFilterSave(params) {
    return { evid: 1130, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetScrolledToBottom' event (evid: 1132)
 *
 * Event description: Fires when user reaches the bottom of the widget
 *
 * @param {helpWidgetScrolledToBottomParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} lng - language
 * @property {string} session_id - session_id
 * @property {string} context_platform - context_platform
 * @property {boolean} max_scroll_at_first_position - max_scroll_at_first_position
 * @property {string} previous_presented_state - previous_presented_state
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - widget_view_mode
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - kb_widget_state
 * @property {string} current_presented_state - current_presented_state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} priority_class - priority_class
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - last_conversation_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - placement
 * @property {string} referral - referral
 * @property {string} user_experience - user_experience
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - article_id
 * @property {string} suggestion_id - suggestion_id
 * @property {string} category_id - category_id
 * @property {string} widget_state - widget_state
 * @property {string} lang - lang
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} solution_info - solution_info
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<helpWidgetScrolledToBottomParams>} LogObject<helpWidgetScrolledToBottomParams>
 */
export function helpWidgetScrolledToBottom(params) {
    return { evid: 1132, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotInContextTriggeredSrc4Evid1133' event (evid: 1133)
 *
 * Event description: Fire when the AI Chatbot using in context information that effects the prompt and the output
 *
 * @param {aiChatbotInContextTriggeredSrc4Evid1133Params} params - The parameters for this event
 * @property {string} conversation_id - the Chatbot conversation id
 * @property {string} incontext_type - (e.g. "editor type")
 * @property {string} Incontext_returned_value - {e.g. 'classic editor', 'studio editor','adi'}
 * @property {string} incontext_based_on_type - {e.g. 'msid','account'}
 * @property {GUID} incontext_based_on_value - {the msid/account id that the incontext used to return the value}
 * @property {string} Incontext_input_type - {e.g. 'msid','account','user'}
 * @property {GUID} Incontext_input_value - {the msid/account id/user id that the incontext got to calculate the value}
 * @property {GUID} logged_user_id - logged uuid
 * @property {GUID} logged_account_id - logged account
 * @property {string} session_id - self service session id
 * @return {LogObject<aiChatbotInContextTriggeredSrc4Evid1133Params>} LogObject<aiChatbotInContextTriggeredSrc4Evid1133Params>
 */
export function aiChatbotInContextTriggeredSrc4Evid1133(params) {
    return { evid: 1133, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotContactFlowQuickAccessAvailableSrc4Evid1134' event (evid: 1134)
 *
 * Event description: Fire if the Chatbot conversation includes the quick access button to the contact flow
 *
 * @param {chatbotContactFlowQuickAccessAvailableSrc4Evid1134Params} params - The parameters for this event
 * @property {string} conversation_id - id of the conversation
 * @return {LogObject<chatbotContactFlowQuickAccessAvailableSrc4Evid1134Params>} LogObject<chatbotContactFlowQuickAccessAvailableSrc4Evid1134Params>
 */
export function chatbotContactFlowQuickAccessAvailableSrc4Evid1134(params) {
    return { evid: 1134, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotInputFieldTextIndicationSrc4Evid1135' event (evid: 1135)
 *
 * Event description: This event fires for every chatbot message and indicates the input field placeholder text, allowing us to analyze user behavior based on different input texts.
 *
 * @param {aiChatbotInputFieldTextIndicationSrc4Evid1135Params} params - The parameters for this event
 * @property {GUID} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {GUID} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} input_field_text -  The input field placeholder text - (“What’s your question“ / “Ask me anything“)
 * @return {LogObject<aiChatbotInputFieldTextIndicationSrc4Evid1135Params>} LogObject<aiChatbotInputFieldTextIndicationSrc4Evid1135Params>
 */
export function aiChatbotInputFieldTextIndicationSrc4Evid1135(params) {
    return { evid: 1135, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAnswerFeedbackPresentedSrc4Evid1136' event (evid: 1136)
 *
 * Event description: This event fires time the answer level feedback is presented to the user (should be displayed for every full answer)
 *
 * @param {aiChatbotAnswerFeedbackPresentedSrc4Evid1136Params} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} message_id - The message id the feedback presented for
 * @return {LogObject<aiChatbotAnswerFeedbackPresentedSrc4Evid1136Params>} LogObject<aiChatbotAnswerFeedbackPresentedSrc4Evid1136Params>
 */
export function aiChatbotAnswerFeedbackPresentedSrc4Evid1136(params) {
    return { evid: 1136, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAnswerFeedbackClickedSrc4Evid1137' event (evid: 1137)
 *
 * Event description: This event fires every time a user clicks on one of the thumbs
 *
 * @param {aiChatbotAnswerFeedbackClickedSrc4Evid1137Params} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} message_id - The message id the feedback presented for
 * @property {string} vote_click_type - The user's clicks on one of the thumbs ("Positive" / "Negative")
 * @return {LogObject<aiChatbotAnswerFeedbackClickedSrc4Evid1137Params>} LogObject<aiChatbotAnswerFeedbackClickedSrc4Evid1137Params>
 */
export function aiChatbotAnswerFeedbackClickedSrc4Evid1137(params) {
    return { evid: 1137, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138' event (evid: 1138)
 *
 * Event description: This event fires every time a user clicks on one of the buttons from the reasons options
 *
 * @param {aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138Params} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} message_id - The message id the feedback presented for
 * @property {string} feedback_reason_button_type - The chosen button by the user as an explanation for his negative feedback ("wrong_info", "irrelevant_info" ",hard_to_read","confusing", "other")
 * @return {LogObject<aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138Params>} LogObject<aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138Params>
 */
export function aiChatbotAnswerFeedbackReasonButtonClickedSrc4Evid1138(params) {
    return { evid: 1138, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAnswerFeedbackFreeTextSrc4Evid1139' event (evid: 1139)
 *
 * Event description: This event fires every time a user clicks "submit" or 'skip' on the answer feedback - free text component
 *
 * @param {aiChatbotAnswerFeedbackFreeTextSrc4Evid1139Params} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} message_id - The message id the feedback presented for
 * @property {string} feedback_free_text - The user free text explanation of the feedback
 * @property {string} click_type - The user's click after he opened the free text component ("skip" / "submit")
 * @return {LogObject<aiChatbotAnswerFeedbackFreeTextSrc4Evid1139Params>} LogObject<aiChatbotAnswerFeedbackFreeTextSrc4Evid1139Params>
 */
export function aiChatbotAnswerFeedbackFreeTextSrc4Evid1139(params) {
    return { evid: 1139, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantParticipantMessage' event (evid: 1140)
 *
 * Event description: This event fires every time a message from the user/expert triggers a request to the model
 *
 * @param {aiAssistantParticipantMessageParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id (if the operation occurred in Answers)
 * @property {string} participant_type - The participant who triggers the event
 * @property {string} session_id - Widget session ID (if the operation occurred in the Self-Service (e.g. Chatbot))
 * @property {string} platform_name - The platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {GUID} operation_id - The entity that gathers all of the inquiries the user sent to the AI
 * @property {GUID} participant_id - participant_id
 * @property {string} content - The message the user delivered to the AI
 * @property {string} conversation_id - conversation_id (if the operation occurred in the Chatbot)
 * @property {GUID} platform_id - The ID of the platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @return {LogObject<aiAssistantParticipantMessageParams>} LogObject<aiAssistantParticipantMessageParams>
 */
export function aiAssistantParticipantMessage(params) {
    return { evid: 1140, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAiAgentProcedureStage' event (evid: 1141)
 *
 * Event description: This event fires every time a model triggers a thought and/or an action
 *
 * @param {aiAssistantAiAgentProcedureStageParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id (if the operation occurred in Answers)
 * @property {string} participant_type - The participant who triggers the event
 * @property {string} content_action_input - The input of the tool
 * @property {string} session_id - Widget session ID (if the operation occurred in the Self-Service (e.g. Chatbot))
 * @property {GUID} procedure_id - The entity that represents either a thought, action or response by an AI agent.
 * @property {string} platform_name - The platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} content_thought - The content of the thought
 * @property {string} content_action - The tool that implement the thought and retrieve an input
 * @property {string} model_version - The ID of the version of the AI Agent
 * @property {GUID} operation_id - The entity that gathers all of the inquiries the user sent to the AI
 * @property {GUID} participant_id - The ID of the participant who triggers the event
 * @property {string} participant_name - The name of the participant who triggers the event
 * @property {string} conversation_id - conversation_id (if the operation occurred in the Chatbot)
 * @property {GUID} platform_id - The ID of the platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @return {LogObject<aiAssistantAiAgentProcedureStageParams>} LogObject<aiAssistantAiAgentProcedureStageParams>
 */
export function aiAssistantAiAgentProcedureStage(params) {
    return { evid: 1141, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantAiAgentResponse' event (evid: 1142)
 *
 * Event description: This event fires every time a response is triggered by a model, by the number of responses
 *
 * @param {aiAssistantAiAgentResponseParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id (if the operation occurred in Answers)
 * @property {string} alternatives - JSON that holds an entire source information (in case of knowledge agent)/entire action possibilities (in case of action agent), etc.
 * @property {string} participant_type - The participant who triggers the event
 * @property {string} session_id - Widget session ID (if the operation occurred in the Self-Service (e.g. Chatbot))
 * @property {GUID} procedure_id - The entity that represents either a thought, action or response by an AI agent.
 * @property {string} platform_name - The platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} model_version - The ID of the version of the AI Agent
 * @property {GUID} operation_id - The entity that gathers all of the inquiries the user sent to the AI
 * @property {GUID} participant_id - The ID of the participant who triggers the event
 * @property {string} content - The content of the response
 * @property {string} participant_name - The name of the participant who triggers the event
 * @property {string} conversation_id - conversation_id (if the operation occurred in the Chatbot)
 * @property {GUID} platform_id - The ID of the platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} chosen_alternative - JSON that holds the entire chosen source information/action possibility (can be only 0 or 1 chosen sources/actions)
 * @return {LogObject<aiAssistantAiAgentResponseParams>} LogObject<aiAssistantAiAgentResponseParams>
 */
export function aiAssistantAiAgentResponse(params) {
    return { evid: 1142, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantFinalInquiryOutput' event (evid: 1143)
 *
 * Event description: This event fires every time the inquiry comes to a conclusion - either a final response to the user or a fallback that occurred to one of the models or to the inquiry itself
 *
 * @param {aiAssistantFinalInquiryOutputParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id (if the operation occurred in Answers)
 * @property {string} alternatives - JSON that holds an entire source information (in case of knowledge agent)/entire action possibilities (in case of action agent), etc.
 * @property {string} participant_type - The participant who triggers the event
 * @property {string} final_output_destination - The destination of the final output [Support, Builder {for fallback} / User {for final response}]
 * @property {string} triggered_by_type - Indicates who triggered the final output
 * @property {string} session_id - Widget session ID (if the operation occurred in the Self-Service (e.g. Chatbot))
 * @property {string} platform_name - The platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} final_output_reason - The reason of the fallback (the "familiy" of the error) / placeholder for future responses purposes [Runtime, Timeout, Policy misconduct]
 * @property {string} final_output_type - The type of the final output [Fallback / Final Response to user]
 * @property {string} model_version - The ID of the version of the AI Agent
 * @property {GUID} operation_id - The entity that gathers all of the inquiries the user sent to the AI
 * @property {GUID} participant_id - The ID of the participant who triggers the event
 * @property {string} content - The content of the response
 * @property {GUID} response_id - response_id that is unique per each response by the AI agent and shall be later linked with the feedback
 * @property {string} triggered_by - Indicates the ID of who triggered the final output
 * @property {string} participant_name - The name of the participant who triggers the event
 * @property {string} conversation_id - conversation_id (if the operation occurred in the Chatbot)
 * @property {GUID} platform_id - The ID of the platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} chosen_alternative - JSON that holds the entire chosen source information/action possibility (can be only 0 or 1 chosen sources/actions)
 * @return {LogObject<aiAssistantFinalInquiryOutputParams>} LogObject<aiAssistantFinalInquiryOutputParams>
 */
export function aiAssistantFinalInquiryOutput(params) {
    return { evid: 1143, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiAssistantParticipantFeedback' event (evid: 1144)
 *
 * Event description: This event fires every time feedback (of each type) is given from the user/expert to a response
 *
 * @param {aiAssistantParticipantFeedbackParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id (if the operation occurred in Answers)
 * @property {string} participant_type - The participant who triggers the event
 * @property {string} feedback_type - The type of feedback clicked by the user: if it was 1 feedback click for all responses or an individual click for each response [all-inclusive, independent]
 * @property {string} session_id - Widget session ID (if the operation occurred in the Self-Service (e.g. Chatbot))
 * @property {number} feedback_answer_level - The level of feedback given to the system [Primary feedback="Was the answer helpful?"=1, Secondary feedback="Why wasn't it helpful?"=2, etc.]
 * @property {string} platform_name - The platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} feedback_question - The question that was asked by the system
 * @property {GUID} operation_id - The entity that gathers all of the inquiries the user sent to the AI
 * @property {GUID} participant_id - The ID of the participant who triggers the event
 * @property {string} content - The content of the response
 * @property {GUID} response_id - response_id that is unique per each response by the AI agent and shall be later linked with the feedback
 * @property {string} feedback_answer_type - The type of feedback given to the system [(yes, ya, si, sim)=>yes, (no, nein, nao)=>no, etc.]
 * @property {string} conversation_id - conversation_id (if the operation occurred in the Chatbot)
 * @property {GUID} platform_id - The ID of the platform [Chatbot/Wix Answers (Knowledge Agent / AI Assitant)] in which the operation occurred.
 * @property {string} chosen_alternative - JSON that holds the entire chosen source information/action possibility (can be only 0 or 1 chosen sources/actions)
 * @return {LogObject<aiAssistantParticipantFeedbackParams>} LogObject<aiAssistantParticipantFeedbackParams>
 */
export function aiAssistantParticipantFeedback(params) {
    return { evid: 1144, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserWasEligibleForCallback' event (evid: 1150)
 *
 * Event description: New Scheduler Indicates what was the decision on the eligibility of a user for a scheduled callback, in terms of the number of previously scheduled callbacks. If the user has more the 5 scheduled callbacks, the option for a callback is rejected
 *
 * @param {schedulerUserWasEligibleForCallbackParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {boolean} eligible_for_callback - was the user eligible for callback (False= reached max of 5 scheduled callbacks)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserWasEligibleForCallbackParams>} LogObject<schedulerUserWasEligibleForCallbackParams>
 */
export function schedulerUserWasEligibleForCallback(params) {
    return { evid: 1150, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserSearchedADifferentMonth' event (evid: 1151)
 *
 * Event description: New Scheduler This event should fire every time the user clicks on one of the left/right arrows that enable searching for different months
 *
 * @param {schedulerUserSearchedADifferentMonthParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserSearchedADifferentMonthParams>} LogObject<schedulerUserSearchedADifferentMonthParams>
 */
export function schedulerUserSearchedADifferentMonth(params) {
    return { evid: 1151, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoosesADay' event (evid: 1152)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a day in the calendar
 *
 * @param {schedulerUserChoosesADayParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} info - array of new offered slots (day:hour)
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserChoosesADayParams>} LogObject<schedulerUserChoosesADayParams>
 */
export function schedulerUserChoosesADay(params) {
    return { evid: 1152, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserClickedOnASlot' event (evid: 1153)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a slot
 *
 * @param {schedulerUserClickedOnASlotParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} info - picked slot (day:hour)
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserClickedOnASlotParams>} LogObject<schedulerUserClickedOnASlotParams>
 */
export function schedulerUserClickedOnASlot(params) {
    return { evid: 1153, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserSubmittedScheduledCallbackRequest' event (evid: 1154)
 *
 * Event description: New Scheduler This event is triggered when a request for scheduling a callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserSubmittedScheduledCallbackRequestParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserSubmittedScheduledCallbackRequestParams>} LogObject<schedulerUserSubmittedScheduledCallbackRequestParams>
 */
export function schedulerUserSubmittedScheduledCallbackRequest(params) {
    return { evid: 1154, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerScheduledCallbackSuccess' event (evid: 1155)
 *
 * Event description: New Scheduler This event is triggered when the request for scheduling a callback was approved by the system (callback was scheduled)
 *
 * @param {schedulerScheduledCallbackSuccessParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {GUID} scheduler_request_id - The scheduled call request id
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerScheduledCallbackSuccessParams>} LogObject<schedulerScheduledCallbackSuccessParams>
 */
export function schedulerScheduledCallbackSuccess(params) {
    return { evid: 1155, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoseToRescheduleACallback' event (evid: 1156)
 *
 * Event description: New Scheduler This event is triggered when a request for rescheduling a scheduled callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserChoseToRescheduleACallbackParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {GUID} scheduler_request_id - The scheduled call request id
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserChoseToRescheduleACallbackParams>} LogObject<schedulerUserChoseToRescheduleACallbackParams>
 */
export function schedulerUserChoseToRescheduleACallback(params) {
    return { evid: 1156, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerUserChoseToCancelACallback' event (evid: 1157)
 *
 * Event description: New Scheduler This event is triggered when a request for canceling a scheduled callback is sent by a user (not only by clicking the button)
 *
 * @param {schedulerUserChoseToCancelACallbackParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {GUID} scheduler_request_id - The scheduled call request id
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserChoseToCancelACallbackParams>} LogObject<schedulerUserChoseToCancelACallbackParams>
 */
export function schedulerUserChoseToCancelACallback(params) {
    return { evid: 1157, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulerCancelScheduledCallback' event (evid: 1158)
 *
 * Event description: New Scheduler This event is triggered when the request for canceling the scheduled callback was approved by the system (the scheduled callback was canceled)
 *
 * @param {schedulerCancelScheduledCallbackParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {GUID} scheduler_request_id - The scheduled call request id
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerCancelScheduledCallbackParams>} LogObject<schedulerCancelScheduledCallbackParams>
 */
export function schedulerCancelScheduledCallback(params) {
    return { evid: 1158, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotClickOnSolution' event (evid: 1159)
 *
 * Event description: Fires every time a user clicks on a solution (e.g. article) in order to view the full solution
 *
 * @param {chatbotClickOnSolutionParams} params - The parameters for this event
 * @property {string} lng - user's language
 * @property {number} context_page_numLevels - context_page_numLevels
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_page_name - page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} intent_id - id of the user_intent
 * @property {string} mapping_product - product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} solution_id - the ID of the solution
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - where the user is coming from
 * @property {string} orig_platform - location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} solution_type - the type of the solution {e.g. Article...}
 * @property {string} lang - chatbot language
 * @property {string} conversation_id - id of the conversation
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<chatbotClickOnSolutionParams>} LogObject<chatbotClickOnSolutionParams>
 */
export function chatbotClickOnSolution(params) {
    return { evid: 1159, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetEmptySearchResults' event (evid: 1160)
 *
 * Event description: Fires when the user got no results after searching in the Help Widget
 *
 * @param {widgetEmptySearchResultsParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<widgetEmptySearchResultsParams>} LogObject<widgetEmptySearchResultsParams>
 */
export function widgetEmptySearchResults(params) {
    return { evid: 1160, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'breadcrumbsScroll' event (evid: 1161)
 *
 * Event description: Fires when the user clicks the breadcrumbs inside an article/category page
 *
 * @param {breadcrumbsScrollParams} params - The parameters for this event
 * @property {string} scroll_direction - to indicate left/right scroll
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} percent_scrolled - max scroll position
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {Url} referral_url - Referral's URL
 * @return {LogObject<breadcrumbsScrollParams>} LogObject<breadcrumbsScrollParams>
 */
export function breadcrumbsScroll(params) {
    return { evid: 1161, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotNotifications' event (evid: 1162)
 *
 * Event description: Fires when a new notification is fired from the Chabot while the Help Widget is minimized
 *
 * @param {chatbotNotificationsParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {number} counter_value - number of unread notifications
 * @return {LogObject<chatbotNotificationsParams>} LogObject<chatbotNotificationsParams>
 */
export function chatbotNotifications(params) {
    return { evid: 1162, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetHeaderClick' event (evid: 1164)
 *
 * Event description: Fires when a user clicks an icon in the widget header
 *
 * @param {widgetHeaderClickParams} params - The parameters for this event
 * @property {string} button_clicked - button clicked
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} clicked_value - value clicked
 * @property {string} last_user_intent_id - last_user_intent_id
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetHeaderClickParams>} LogObject<widgetHeaderClickParams>
 */
export function widgetHeaderClick(params) {
    return { evid: 1164, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'channelAvailabilityOfflineExpertsChatbot' event (evid: 1165)
 *
 * Event description: before offering the user relevant live channels, receive from the API if there are experts not offline, and the queue in business hours
 *
 * @param {channelAvailabilityOfflineExpertsChatbotParams} params - The parameters for this event
 * @property {string} phone_availability - the final result of the API for phone
 * @property {string} chat_reason - reasons for unavailable chat
 * @property {string} phone_reason - reasons for unavailable phone
 * @property {GUID} user_id - user_id
 * @property {GUID} topic_id - topic id of the conversation
 * @property {string} chat_availability - the final result of the API for chat
 * @property {string} lang - language of the conversation
 * @property {string} conversation_id - conversation_id
 * @property {string} request_id - request_id of the API
 * @return {LogObject<channelAvailabilityOfflineExpertsChatbotParams>} LogObject<channelAvailabilityOfflineExpertsChatbotParams>
 */
export function channelAvailabilityOfflineExpertsChatbot(params) {
    return { evid: 1165, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAiChatbotResponseSrc4Evid1170' event (evid: 1170)
 *
 * Event description: Fires every response from the ai system (per each user message).
 * If it wasn't fired, an error event should be fired instead.
 *
 * @param {aiChatbotAiChatbotResponseSrc4Evid1170Params} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} chatbot_view - type of chatbot view
 * @property {string} session_id - Help widget session id
 * @property {string} user_message - The original user message that triggered the response (same in 1052)
 * @property {string} request_summery - The user Request Summary based on the current and previous messages
 * @property {string} revised_request_summary - The second summery that goes to NLP in cases of contact
 * @property {string} articles_score - Array/json of all articles with their scores from the retrieval mechanism
 * @property {string} articles_relevancy - Array/json of all articles with their relevancy indication from the classifier
 * @property {string} response_type - The actual response that presented to the user from the AI mechanism
 * @property {boolean} is_answer_given - boolean, wether response contains answer
 * @property {boolean} is_negative_sentiment - Does the user message contains a negative sentiment
 * @property {string} last_customer_support_request_message_index - the index of the last message that user asked for support
 * @return {LogObject<aiChatbotAiChatbotResponseSrc4Evid1170Params>} LogObject<aiChatbotAiChatbotResponseSrc4Evid1170Params>
 */
export function aiChatbotAiChatbotResponseSrc4Evid1170(params) {
    return { evid: 1170, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotAiChatbotResponseFailedSrc4Evid1171' event (evid: 1171)
 *
 * Event description: Fires if the AI response failed to send, followed by resend appear event
 *
 * @param {aiChatbotAiChatbotResponseFailedSrc4Evid1171Params} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} session_id - Help widget session id
 * @property {string} user_message - The original user message that triggered the response (same in 1052)
 * @property {string} request_id - server request id
 * @property {string} error_message - the error message with the type of error
 * @property {GUID} message_id - id of the message sent from 1052
 * @return {LogObject<aiChatbotAiChatbotResponseFailedSrc4Evid1171Params>} LogObject<aiChatbotAiChatbotResponseFailedSrc4Evid1171Params>
 */
export function aiChatbotAiChatbotResponseFailedSrc4Evid1171(params) {
    return { evid: 1171, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotErrorMessagePresentedSrc4Evid1172' event (evid: 1172)
 *
 * Event description: Fires every time that error message presented for the user during a conversation, for a user message
 *
 * @param {chatbotErrorMessagePresentedSrc4Evid1172Params} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} chatbot_view - type of chatbot view
 * @property {string} session_id - Help widget session id
 * @property {string} user_message - The original user message that triggered the response (same in 1052)
 * @property {GUID} message_id - id of the message sent from 1052 that filed to send
 * @property {string} node_id - The ID of the chatbot node
 * where the resend button presented
 * @property {string} extra_fields - Extra fields
 * @property {string} error_type - 1 of 3 options - connection lost, timeout, internal error
 * @property {string} button_name - the EN button name that exist in the error message, if is button_exist=True
 * @property {boolean} is_button_exist - If the error message contain an actionable button = True
 * @property {string} lang - Chatbot Language
 * @return {LogObject<chatbotErrorMessagePresentedSrc4Evid1172Params>} LogObject<chatbotErrorMessagePresentedSrc4Evid1172Params>
 */
export function chatbotErrorMessagePresentedSrc4Evid1172(params) {
    return { evid: 1172, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiChatbotResendButtonClickedSrc4Evid1173' event (evid: 1173)
 *
 * Event description: Fires every time that 'Resend' button clicked
 *
 * @param {aiChatbotResendButtonClickedSrc4Evid1173Params} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} chatbot_view - type of chatbot view
 * @property {string} session_id - Help widget session id
 * @property {string} user_message - The original user message that triggered the response (same in 1052)
 * @property {GUID} message_id - id of the message sent from 1052
 * @property {string} node_id - The ID of the chatbot node
 * where the resend button clicked
 * @property {string} lang - Chatbot Language
 * @return {LogObject<aiChatbotResendButtonClickedSrc4Evid1173Params>} LogObject<aiChatbotResendButtonClickedSrc4Evid1173Params>
 */
export function aiChatbotResendButtonClickedSrc4Evid1173(params) {
    return { evid: 1173, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotGeneralClientLog' event (evid: 1174)
 *
 * Event description: Client log for test and debugging  in Wix CC chatbot
 *
 * @param {chatbotGeneralClientLogParams} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} session_id - Widget session ID
 * @property {string} message - message test
 * @property {string} data - log content
 * @property {string} chatbot_view - current view of chatbot
 * @return {LogObject<chatbotGeneralClientLogParams>} LogObject<chatbotGeneralClientLogParams>
 */
export function chatbotGeneralClientLog(params) {
    return { evid: 1174, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotConnectionLostMessagePresentedSrc4Evid1175' event (evid: 1175)
 *
 * Event description: Fires every time that user is offline during conversation and the send button is blocked.
 *
 * @param {chatbotConnectionLostMessagePresentedSrc4Evid1175Params} params - The parameters for this event
 * @property {string} conversation_id - chatbot conversation id
 * @property {string} chatbot_view - type of chatbot view
 * @property {string} session_id - Help widget session id
 * @property {string} extra_fields - Extra fields
 * @property {string} lang - Chatbot Language
 * @return {LogObject<chatbotConnectionLostMessagePresentedSrc4Evid1175Params>} LogObject<chatbotConnectionLostMessagePresentedSrc4Evid1175Params>
 */
export function chatbotConnectionLostMessagePresentedSrc4Evid1175(params) {
    return { evid: 1175, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'askChooseAProduct' event (evid: 1500)
 *
 * Event description: Choose a product in the first step inside ASK app in the ticket page
 *
 * @param {askChooseAProductParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket id the agent is working on and in which he used ASK product
 * @property {string} ask_url - the url of the selected option in ASK feature
 * @property {string} productName - the name of the product selected from the dropdown
 * @property {string} ticket_url - the ticket url the agent is working on and in which he used ASK product
 * @return {LogObject<askChooseAProductParams>} LogObject<askChooseAProductParams>
 */
export function askChooseAProduct(params) {
    return { evid: 1500, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501' event (evid: 1501)
 *
 * Event description: Fire when a Wix page with the widget entry point was opened
 *
 * @param {helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {number} notification_count - The notification counter value that appeared on the widget header button
 * @return {LogObject<helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501Params>} LogObject<helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501Params>
 */
export function helpWidgetLoadWidgetInBackgroundNewSrc4Evid1501(params) {
    return { evid: 1501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetPageViewNewSrc4Evid1502' event (evid: 1502)
 *
 * Event description: Fire when the Help Widget is being opened or when a new page is being loaded in the widget
 *
 * @param {helpWidgetPageViewNewSrc4Evid1502Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {string} previous_widget_page_type - The type of page in the widget the user was on before the event occur
 * @property {GUID} previous_widget_page_id - The page id in the widget the user was on before the event occur
 * @property {string} open_source - The type of entry point from which the user opened the widget
 * @property {string} open_source_info - The entry point from which the user opened the widget
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} recommended_articles_list - List of all recomended articles that are apearing in the widget
 * @property {number} notification_count - The notification counter value that appeared on the widget header button
 * @return {LogObject<helpWidgetPageViewNewSrc4Evid1502Params>} LogObject<helpWidgetPageViewNewSrc4Evid1502Params>
 */
export function helpWidgetPageViewNewSrc4Evid1502(params) {
    return { evid: 1502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetWidgetCloseNewSrc4Evid1503' event (evid: 1503)
 *
 * Event description: Fire when a user close the widget by close button or clicking outside the widget
 *
 * @param {helpWidgetWidgetCloseNewSrc4Evid1503Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} closing_trigger - The trigger that closed the widget
 * @return {LogObject<helpWidgetWidgetCloseNewSrc4Evid1503Params>} LogObject<helpWidgetWidgetCloseNewSrc4Evid1503Params>
 */
export function helpWidgetWidgetCloseNewSrc4Evid1503(params) {
    return { evid: 1503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetPageEngagementNewSrc4Evid1504' event (evid: 1504)
 *
 * Event description: Fires every 10 seconds to indicate the user is active on the Help Widget
 *
 * @param {helpWidgetPageEngagementNewSrc4Evid1504Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {boolean} max_scroll_at_first_position - indicates if the entire article/page is visible to the user without having to scroll
 * @property {string} max_scroll_reached - max % of the page the user reached while visiting the page
 * @property {string} activity_type - List of activities the user performed within the widget in the past 10 seconds (click,mousemove,scroll)
 * @return {LogObject<helpWidgetPageEngagementNewSrc4Evid1504Params>} LogObject<helpWidgetPageEngagementNewSrc4Evid1504Params>
 */
export function helpWidgetPageEngagementNewSrc4Evid1504(params) {
    return { evid: 1504, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetItemOnViewNewSrc4Evid1505' event (evid: 1505)
 *
 * Event description: When a component in the widget is visible for the user
 *
 * @param {helpWidgetItemOnViewNewSrc4Evid1505Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} recommended_articles_list - List of all recomended articles that are apearing in the widget
 * @property {string} item_name - The name of the component in the widget that was visible for the user
 * @return {LogObject<helpWidgetItemOnViewNewSrc4Evid1505Params>} LogObject<helpWidgetItemOnViewNewSrc4Evid1505Params>
 */
export function helpWidgetItemOnViewNewSrc4Evid1505(params) {
    return { evid: 1505, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetItemClickNewSrc4Evid1506' event (evid: 1506)
 *
 * Event description: Fires when a user clicks on one of the content items or buttons in the help widget
 *
 * @param {helpWidgetItemClickNewSrc4Evid1506Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} recommended_articles_list - List of all recomended articles that are apearing in the widget
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {Url} clicked_url - The URL of the link the user clicked on
 * @property {string} clicked_text - The text of the button/link the user clicked on
 * @property {string} clicked_item_type - The type of link/button the user clicked on
 * @property {number} clicked_item_order_value - The order value of the link/button the user clicked on
 * @property {GUID} clicked_item_id - The id of the target article/category of the link the user clicked on
 * @property {string} searched_text - The search term the user used in the search
 * @property {GUID} search_session_id - The search sesison id of the user's search
 * @return {LogObject<helpWidgetItemClickNewSrc4Evid1506Params>} LogObject<helpWidgetItemClickNewSrc4Evid1506Params>
 */
export function helpWidgetItemClickNewSrc4Evid1506(params) {
    return { evid: 1506, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetPageErrorNewSrc4Evid1507' event (evid: 1507)
 *
 * Event description: Fire when an error is shown after a user clicked a link within the widget
 *
 * @param {helpWidgetPageErrorNewSrc4Evid1507Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} error_type - the type of error that was recived(400/500/404/etc)
 * @property {string} error_type_description - Description of the error
 * @property {Url} clicked_url - URL of the link that triggered the error
 * @property {string} clicked_text - the text on the link that triggered the error
 * @return {LogObject<helpWidgetPageErrorNewSrc4Evid1507Params>} LogObject<helpWidgetPageErrorNewSrc4Evid1507Params>
 */
export function helpWidgetPageErrorNewSrc4Evid1507(params) {
    return { evid: 1507, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetDragWidgetNewSrc4Evid1508' event (evid: 1508)
 *
 * Event description: Fire when the user drags the widget to a different location on the screen
 *
 * @param {helpWidgetDragWidgetNewSrc4Evid1508Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {GUID} chatbot_conversation_id - The Chatbot conversation id that was opened in the widget during the event
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @return {LogObject<helpWidgetDragWidgetNewSrc4Evid1508Params>} LogObject<helpWidgetDragWidgetNewSrc4Evid1508Params>
 */
export function helpWidgetDragWidgetNewSrc4Evid1508(params) {
    return { evid: 1508, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetSearchResultsNewSrc4Evid1509' event (evid: 1509)
 *
 * Event description: Fire when the search results returned after user searched in the widget
 *
 * @param {helpWidgetSearchResultsNewSrc4Evid1509Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} input_type - The type of input the user used to search
 * @property {string} searched_text - The search term the user used in the search
 * @property {string} search_method - The search method that was used in the user search
 * @property {GUID} search_session_id - The search sesison id of the user's search
 * @property {string} answer_type - The type of answer the user got after the search
 * @return {LogObject<helpWidgetSearchResultsNewSrc4Evid1509Params>} LogObject<helpWidgetSearchResultsNewSrc4Evid1509Params>
 */
export function helpWidgetSearchResultsNewSrc4Evid1509(params) {
    return { evid: 1509, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpWidgetClickOnAnswerOrResultNewSrc4Evid1510' event (evid: 1510)
 *
 * Event description: Fire when the user selects one of the search results in the widget
 *
 * @param {helpWidgetClickOnAnswerOrResultNewSrc4Evid1510Params} params - The parameters for this event
 * @property {GUID} target_account_id - The Wix account id that the user has performed the action on
 * @property {GUID} context_msid - The site id the user is working on
 * @property {string} context_platfrom - The Wix platform the user is on
 * @property {string} context_area - The user location within the platform
 * @property {Url} context_url - The URL of the page the user is on
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} widget_language - The language of the widget the user interacted with
 * @property {string} widget_page_type - The type of page in the widget the user was on
 * @property {string} presented_content - The components and content type that appear in the widget during the event
 * @property {string} searched_text - The search term the user used in the search
 * @property {string} search_method - The search method that was used in the user search
 * @property {GUID} search_session_id - The search sesison id of the user's search
 * @property {string} answer_type - The type of answer the user got after the search
 * @property {string} clicked_output_distance_str - The distance value from the Knowledge Agent search of the clicked search results
 * @property {Url} clicked_url - The URL of the clicked search result
 * @property {string} clicked_item_type - The type of result that was clicked
 * @property {number} clicked_item_order_value - The order value of the clicked result in the the search result list
 * @property {GUID} clicked_item_id - The ID of the clicked search result
 * @return {LogObject<helpWidgetClickOnAnswerOrResultNewSrc4Evid1510Params>} LogObject<helpWidgetClickOnAnswerOrResultNewSrc4Evid1510Params>
 */
export function helpWidgetClickOnAnswerOrResultNewSrc4Evid1510(params) {
    return { evid: 1510, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainToolReceivePassword' event (evid: 2010)
 *
 * Event description: domain tool -> receive password.
 *
 * @param {domainToolReceivePasswordParams} params - The parameters for this event
 * @property {string} registrar - registrar
 * @return {LogObject<domainToolReceivePasswordParams>} LogObject<domainToolReceivePasswordParams>
 */
export function domainToolReceivePassword(params) {
    return { evid: 2010, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnBackToTopButton' event (evid: 21)
 *
 * Event description: click on back to top button.
 *
 * @param {clickOnBackToTopButtonParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickOnBackToTopButtonParams>} LogObject<clickOnBackToTopButtonParams>
 */
export function clickOnBackToTopButton(params) {
    return { evid: 21, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeLanguage' event (evid: 25)
 *
 * Event description: change language.
 *
 * @param {changeLanguageParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {string} url - url
 * @property {string} to_language - to_language
 * @property {string} target_url - target_url
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} from_language - from_language
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<changeLanguageParams>} LogObject<changeLanguageParams>
 */
export function changeLanguage(params) {
    return { evid: 25, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnContactUsLink' event (evid: 26)
 *
 * Event description: click on contact us link.
 *
 * @param {clickOnContactUsLinkParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickOnContactUsLinkParams>} LogObject<clickOnContactUsLinkParams>
 */
export function clickOnContactUsLink(params) {
    return { evid: 26, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chooseCategory' event (evid: 3)
 *
 * Event description: choose category.
 *
 * @param {chooseCategoryParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<chooseCategoryParams>} LogObject<chooseCategoryParams>
 */
export function chooseCategory(params) {
    return { evid: 3, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'unifiedChatAgentSendMessage' event (evid: 3007)
 *
 * Event description: The event is triggered whenever an agent clicks on send message (on answers side - not on the user UI side)
 *
 * @param {unifiedChatAgentSendMessageParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket guid in Answers
 * @property {boolean} inc_linked_article - Does the message include an article
 * @property {boolean} inc_file - Does the message include a file
 * @property {GUID} message_id - Message guid in answers
 * @property {string} message_num - Message number by the agent in this chat
 * @property {boolean} inc_saved_reply - Does the message include a saved reply
 * @property {string} lang - Answers language
 * @property {boolean} is_note - Is this message internal note
 * @property {GUID} agent_id - ID of the agent in Answers
 * @return {LogObject<unifiedChatAgentSendMessageParams>} LogObject<unifiedChatAgentSendMessageParams>
 */
export function unifiedChatAgentSendMessage(params) {
    return { evid: 3007, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newUserManagerPageView' event (evid: 3300)
 *
 * Event description: Basic page view event, tracking all page views. this event will be fired for every page user view (load) in the new User Manager
 *
 * @param {newUserManagerPageViewParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {string} wix_services_status - The Wix service status that appears when the view was loaded (relevant for entry page only)
 * @property {Url} previous_page_url - The URL of the previous page within the tool that was viewed
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} labels_list - List of all labels of the Wix user the view it currently on
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<newUserManagerPageViewParams>} LogObject<newUserManagerPageViewParams>
 */
export function newUserManagerPageView(params) {
    return { evid: 3300, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickItem' event (evid: 3301)
 *
 * Event description: Records of all button clicks within the new User Manager
 *
 * @param {clickItemParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} item_name - The name of the button that was clicked
 * @property {string} item_type - The group of buttons' name the button is related to
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<clickItemParams>} LogObject<clickItemParams>
 */
export function clickItem(params) {
    return { evid: 3301, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'search' event (evid: 3302)
 *
 * Event description: Records of all searched that have been made within the new User Manager
 *
 * @param {searchParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {boolean} search_succeed - Does the search return result
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} search_type - based on {email, msid}
 * @property {string} param - Extra info the search action returns
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} search_value - The value that was in the search box when was clicked
 * @property {string} error_message - The message text in case the system returned error for the search
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<searchParams>} LogObject<searchParams>
 */
export function search(params) {
    return { evid: 3302, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'approveAction' event (evid: 3303)
 *
 * Event description: Records of the action's requests made by the users of the new User Manager for changes in the Wix user's account
 *
 * @param {approveActionParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} param - The list of parameters the user filled and send with the request
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} page_type - {entry_page, main}
 * @property {boolean} approved - Does the request for the action returned successful or not
 * @property {string} post_approved_message - The text of the system message that returned for the request
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @property {string} action - The action the user requested to perform
 * @return {LogObject<approveActionParams>} LogObject<approveActionParams>
 */
export function approveAction(params) {
    return { evid: 3303, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'systemMessage' event (evid: 3304)
 *
 * Event description: Records of all the system messages and notifications that are being sent within the new User Manager
 *
 * @param {systemMessageParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} message_text - The content of the message
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<systemMessageParams>} LogObject<systemMessageParams>
 */
export function systemMessage(params) {
    return { evid: 3304, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCopy' event (evid: 3305)
 *
 * Event description: Records of all click to copy being performed within the new User Manager
 *
 * @param {clickToCopyParams} params - The parameters for this event
 * @property {string} sub_tab - sub_tab
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} item_content - item_content
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} item_contect - The content that was copied
 * @property {string} item_type - {msid / uuid}
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<clickToCopyParams>} LogObject<clickToCopyParams>
 */
export function clickToCopy(params) {
    return { evid: 3305, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filter' event (evid: 3306)
 *
 * Event description: Records of all filters that have been used within the new User Manager
 *
 * @param {filterParams} params - The parameters for this event
 * @property {string} filtered_by - The list of parameters chosen for the filter
 * @property {string} sub_tab - {Active sites, Trashed sites..} table's name inside of the main tab
 * @property {string} um_user_name - The user email (part until @) that was logged in the user manager
 * @property {string} tab - {sites , plans, activity_log}
 * @property {string} um_user_type - The ending of the user email that was logged in the user manager
 * @property {string} list_view - The list that was filtered
 * @property {string} section - {outer_frame, user_info, account_overview}
 * @property {GUID} user_id - The Wix ID of the user the UM's user is currently on his account
 * @property {string} filter_type - {multiple choices / one choice}
 * @property {string} page_type - {entry_page, main}
 * @property {Url} page_url - The URL of the page that is currently being viewed
 * @return {LogObject<filterParams>} LogObject<filterParams>
 */
export function filter(params) {
    return { evid: 3306, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalClickedOnSiteUrlMainTable' event (evid: 3501)
 *
 * Event description: Sent when a user clicks on a site URL in the main table of the Customer Care Tickets Page
 *
 * @param {customersPortalClickedOnSiteUrlMainTableParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket which the user trying to add/edit the site of
 * @property {Url} url - The URL that was clicked
 * @property {GUID} current_site_value - The current assigned site's MSID to the ticket (null if no site assigned)
 * @property {GUID} uuid - account id of the user
 * @return {LogObject<customersPortalClickedOnSiteUrlMainTableParams>} LogObject<customersPortalClickedOnSiteUrlMainTableParams>
 */
export function customersPortalClickedOnSiteUrlMainTable(params) {
    return { evid: 3501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalUpdateTicketSSiteModelOpened' event (evid: 3502)
 *
 * Event description: Sent when a user clicks to edit/add a site to a ticket and the modal window is open, in the main table of the Customer Care Tickets Page
 *
 * @param {customersPortalUpdateTicketSSiteModelOpenedParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket which the user trying to add/edit the site of
 * @property {GUID} current_site_value - The current assigned site's MSID to the ticket (null if no site assigned)
 * @property {GUID} uuid - account id of the user
 * @return {LogObject<customersPortalUpdateTicketSSiteModelOpenedParams>} LogObject<customersPortalUpdateTicketSSiteModelOpenedParams>
 */
export function customersPortalUpdateTicketSSiteModelOpened(params) {
    return { evid: 3502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalUpdatedTicketSSiteSaved' event (evid: 3503)
 *
 * Event description: Sent when a user saves a site for a ticket in the main table of the Customer Care Tickets Page
 *
 * @param {customersPortalUpdatedTicketSSiteSavedParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket which the user trying to add/edit the site of
 * @property {GUID} current_site_value - The current assigned site's MSID to the ticket (null if no site assigned)
 * @property {GUID} uuid - account id of the user
 * @property {GUID} previous_site_value - The previous assigned site's MSID to the ticket (null if no site assigned)
 * @property {boolean} site_assigned_successfully - true if successful, false if an error occurs when trying to assign the site
 * @return {LogObject<customersPortalUpdatedTicketSSiteSavedParams>} LogObject<customersPortalUpdatedTicketSSiteSavedParams>
 */
export function customersPortalUpdatedTicketSSiteSaved(params) {
    return { evid: 3503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'customersPortalButtonClicked' event (evid: 3507)
 *
 * Event description: Sent when a user clicks on a button in the main table of the Customer Care Tickets page
 *
 * @param {customersPortalButtonClickedParams} params - The parameters for this event
 * @property {string} button_name - {ticket_view, new_ticket}
 * @property {GUID} ticket_id - (optional) The ticket which the user clicked to view
 * @return {LogObject<customersPortalButtonClickedParams>} LogObject<customersPortalButtonClickedParams>
 */
export function customersPortalButtonClicked(params) {
    return { evid: 3507, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotSecurityModelsScanResultsSrc4Evid39' event (evid: 39)
 *
 * Event description: Sent when the Security model(s) are done scanning a site reported for phishing by a user in the chatbot
 *
 * @param {chatbotSecurityModelsScanResultsSrc4Evid39Params} params - The parameters for this event
 * @property {string} site_url - Reported site URL
 * @property {GUID} reporter_id - account ID of site reporter
 * @property {GUID} site_owner_id - account ID of reported site owner
 * @property {GUID} conversation_id - The conversation in which the site was reported
 * @property {boolean} is_suspicious - Is the site suspicious of phishing according to the Security models verdict. TRUE if site is suspicious; FALSE if site it not suspicious; NULL if scan was run unsuccessfully.
 * @property {GUID} reported_msid - Reported site ID
 * @return {LogObject<chatbotSecurityModelsScanResultsSrc4Evid39Params>} LogObject<chatbotSecurityModelsScanResultsSrc4Evid39Params>
 */
export function chatbotSecurityModelsScanResultsSrc4Evid39(params) {
    return { evid: 39, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotAutomaticBlockResultsSrc4Evid40' event (evid: 40)
 *
 * Event description: Sent after attempting to automatically block a site that was reported for phishing and found suspicious by the Security models
 *
 * @param {chatbotAutomaticBlockResultsSrc4Evid40Params} params - The parameters for this event
 * @property {string} site_url - Reported site URL
 * @property {GUID} site_owner_id - account ID of reported site owner
 * @property {GUID} reporter_id - account ID of site reporter
 * @property {GUID} conversation_id - The conversation in which the site was reported
 * @property {GUID} reported_msid - Reported site ID
 * @return {LogObject<chatbotAutomaticBlockResultsSrc4Evid40Params>} LogObject<chatbotAutomaticBlockResultsSrc4Evid40Params>
 */
export function chatbotAutomaticBlockResultsSrc4Evid40(params) {
    return { evid: 40, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyTaskLoad' event (evid: 4001)
 *
 * Event description: Sends when tasks are loaded and are visible for the agent.
 *
 * @param {userJourneyTaskLoadParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} site_business_type - The site's business type as reflected in the tool {Store, Services, Blog, etc.}
 * @property {string} referrer_platform_name - {UM}
 * @property {string} site_goal_detailed - The site's detailed goal as reflected in the tool
 * @property {number} location - Location from top
 * @property {string} tab - {User tasks, Site info}
 * @property {string} phase - {Site Completion, Business Setup, Business Growth}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} translated_into - The language in which the suggestion's content was translated into from Dealer (if it was not translated it will return NULL)
 * @property {string} view_type - the type of the view {extention,full_page,answers}
 * @property {number} success_level_id - The site's success level as reflected in the tool
 * @property {string} applied_filter - The tasks' filter that is currently activated
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} location_country - The site's location country as reflected in the tool
 * @property {string} site_industry - The site's business industry as reflected in the tool {Beauty, Food, etc.}
 * @property {string} site_goal - The site's goal as reflected in the tool
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {string} current_status - The status on load of the task
 * @property {GUID} msid - Site the agent is looking at
 * @property {string} site_progress_step - The site's user journey phase as reflected in the tool
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyTaskLoadParams>} LogObject<userJourneyTaskLoadParams>
 */
export function userJourneyTaskLoad(params) {
    return { evid: 4001, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyAgentChangeTaskStatus' event (evid: 4002)
 *
 * Event description: Sends when an agent changes the status of a task in user tasks tab.
 *
 * @param {userJourneyAgentChangeTaskStatusParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} site_business_type - The site's business type as reflected in the tool {Store, Services, Blog, etc.}
 * @property {string} prev_status - The status of the task before changing- not started, suggested, rejected, user rejected
 * @property {string} referrer_platform_name - {UM}
 * @property {number} location - Location from top
 * @property {string} phase - {Site Completion, Business Setup, Business Growth}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {string} applied_filter - The tasks' filter that is currently activated
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {string} current_status - The status of the task after changing- not started, suggested, rejected, user rejected
 * @property {GUID} msid - Site the agent is looking at
 * @property {string} site_progress_step - The site's progress step as reflected in the tool {create, launch, grow}
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyAgentChangeTaskStatusParams>} LogObject<userJourneyAgentChangeTaskStatusParams>
 */
export function userJourneyAgentChangeTaskStatus(params) {
    return { evid: 4002, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyOpenTab' event (evid: 4005)
 *
 * Event description: when a tab is loaded or an agent manually opens a tab, this event is sent.
 *
 * @param {userJourneyOpenTabParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {number} tasks_completed_business_growth - Number of completed tasks in business growth phase
 * @property {string} tab - {user tasks, site info}
 * @property {GUID} uuid - DO NOT USE
 * @property {number} tasks_total_business_setup - Number of tasks in business setup phase
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {number} tasks_completed_site_completion - Number of completed tasks in site completion phase
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {number} tasks_completed_business_setup - Number of completed tasks in business setup phase
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} open_method - Was the tab opened on load or manually by the agent - auto/manual
 * @property {number} tasks_total_site_completion - Number of tasks in site completion phase
 * @property {GUID} msid - Site the agent is looking at
 * @property {number} tasks_total_business_growth - Number of tasks in business growth phase
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyOpenTabParams>} LogObject<userJourneyOpenTabParams>
 */
export function userJourneyOpenTab(params) {
    return { evid: 4005, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyOpenTopTab' event (evid: 4006)
 *
 * Event description: move between user journey, ask, tickets tabs.
 *
 * @param {userJourneyOpenTopTabParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} tab - {user journey, ask, tickets, goals}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} open_method - auto/manual
 * @property {GUID} msid - ******* not relevant **********
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyOpenTopTabParams>} LogObject<userJourneyOpenTopTabParams>
 */
export function userJourneyOpenTopTab(params) {
    return { evid: 4006, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneySwitchSite' event (evid: 4009)
 *
 * Event description: switch site inside user journey tab
 *
 * @param {userJourneySwitchSiteParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {GUID} uuid - DO NOT USE
 * @property {GUID} prev_msid - Previous site the agent was looking at
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - New site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneySwitchSiteParams>} LogObject<userJourneySwitchSiteParams>
 */
export function userJourneySwitchSite(params) {
    return { evid: 4009, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyItemClick' event (evid: 4014)
 *
 * Event description: When an agent clicks on a CTA (eg. add, edit, delete, etc.)
 *
 * @param {userJourneyItemClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} note_type - for goals section indicate which type is it {note,IQ}
 * @property {number} location - The location of the tip that was clicked from left to right
 * @property {string} tab - {site info, Goals,Tasks}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} button_name - the clickable text {ADD/Edit/Delete/impersonate/bo, etc}
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - the site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyItemClickParams>} LogObject<userJourneyItemClickParams>
 */
export function userJourneyItemClick(params) {
    return { evid: 4014, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyChooseImpactQuestion' event (evid: 4015)
 *
 * Event description: will be fired when a user chooses an impactful question on the timeline tab
 *
 * @param {userJourneyChooseImpactQuestionParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} tab - {site info, Goals,Tasks}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} question_id - the id of the question the agent clicked on
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} question_name - the question the agent clicked on
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - New site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyChooseImpactQuestionParams>} LogObject<userJourneyChooseImpactQuestionParams>
 */
export function userJourneyChooseImpactQuestion(params) {
    return { evid: 4015, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyAgentSubmittedFeedbackForTask' event (evid: 4016)
 *
 * Event description: Sends when an agent submitted feedback for a task
 *
 * @param {userJourneyAgentSubmittedFeedbackForTaskParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} site_business_type - The site's business type as reflected in the tool {Store, Services, Blog, etc.}
 * @property {string} referrer_platform_name - {UM}
 * @property {number} location - location_y
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} feedback_value - The feedback option the agent chose
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {boolean} generated_another_task - Does the submitting of these feedback reveled another task for the agent
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} feedback_text - In case the agent chose 'other' in the option, show the free text that was added
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - task_id
 * @property {string} current_status - The status of the task when submitted the feedback
 * @property {GUID} msid - Site the agent is looking at
 * @property {string} site_progress_step - The site's progress step as reflected in the tool {create, launch, grow}
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyAgentSubmittedFeedbackForTaskParams>} LogObject<userJourneyAgentSubmittedFeedbackForTaskParams>
 */
export function userJourneyAgentSubmittedFeedbackForTask(params) {
    return { evid: 4016, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneySaveClick' event (evid: 4017)
 *
 * Event description: will be fired when an agent saves answer to Impactful Question or Clicking Done
 *
 * @param {userJourneySaveClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} note_type - for goals section indicate which type is it {note,IQ}
 * @property {boolean} is_edited - true if the change was made on existing IQ/note ,false if not
 * @property {string} tab - {site info, Goals,Tasks}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} text - The text the agent saved under the impactful question or note
 * @property {string} question_category - The category of the question the agent saved
 * @property {string} question_id - the id of the question the agent saved
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} question_name - the question the agent saved
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - New site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneySaveClickParams>} LogObject<userJourneySaveClickParams>
 */
export function userJourneySaveClick(params) {
    return { evid: 4017, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyClickToCopy' event (evid: 4018)
 *
 * Event description: the event will be fired every time an agent will click on item to copy, available on site_info & tasks
 *
 * @param {userJourneyClickToCopyParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} item_id - if its article then article_id , if its marketing then URL, if its value proposition then task_id
 * @property {string} tab - {Site info, Goals, Tasks}
 * @property {string} phase - if the click to copy was done on tasks pages then the phase of the task {Site Completion, Business Setup, Business Growth}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - If rich content then task name
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} sub_page_name - If rich content then 'rich content'
 * @property {string} item_name - if its an article then article name, if its marketing its the video name, if its value proposition then task_name
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - If rich content then task id
 * @property {string} item_type - the type of the item that was copied {email,phone,article,marketing metirials, value proposition etc.}
 * @property {GUID} msid - Site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyClickToCopyParams>} LogObject<userJourneyClickToCopyParams>
 */
export function userJourneyClickToCopy(params) {
    return { evid: 4018, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyPageView' event (evid: 4020)
 *
 * Event description: Basic page view event, tracking all page views. this event will be fired for every page agent view (load) in the user journey tool
 *
 * @param {userJourneyPageViewParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {GUID} referral_id - A unique generated key that will pass to event 4;4022 (user journey tab closed) to relate between the two events for the same session. Only relevant for the Timeline tab.
 * @property {Url} url - url of the page view
 * @property {boolean} scrolling_possible - True if scrolling down is needed to see all the page content. Only relevant for the Timeline tab.
 * @property {string} tab - which tab is being shown {Site info, Timeline, Tasks}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - if the page is rich content then task_name
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} sub_page_name - if rich content then 'rich content'
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {number} num_of_items - The number of items existing on the page when open. Only relevant for the Timeline tab (impactful questions and notes).
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - if the page is rich content then task_id
 * @property {GUID} msid - Site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @property {string} entry_type - the view type source of the page view  {extension, full page, answers}
 * @return {LogObject<userJourneyPageViewParams>} LogObject<userJourneyPageViewParams>
 */
export function userJourneyPageView(params) {
    return { evid: 4020, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyUpdateSiteDetailesSaved' event (evid: 4023)
 *
 * Event description: Fire when an expert modify the user's site details (business type, industry, goal, etc)
 *
 * @param {userJourneyUpdateSiteDetailesSavedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} previous_site_goal_detailed - The original site's detailed goal before the change
 * @property {string} site_business_type - The new site's business type after the change
 * @property {string} referrer_platform_name - {UM}
 * @property {string} site_goal_detailed - The new site's detailed goal after the change
 * @property {GUID} uuid - DO NOT USE
 * @property {string} view_type - the view type {extention,full page,answers}
 * @property {string} previous_site_business_type - The original site's business type before the change
 * @property {string} previous_site_goal - The original site's goal before the change
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} site_industry - The new site's industry after the change
 * @property {string} previous_site_industry - The original site's industry before the change
 * @property {string} site_goal - The new site's goal after the change
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} previous_location_country - The original site's location country before the change
 * @property {GUID} msid - Site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyUpdateSiteDetailesSavedParams>} LogObject<userJourneyUpdateSiteDetailesSavedParams>
 */
export function userJourneyUpdateSiteDetailesSaved(params) {
    return { evid: 4023, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyClickToRichContent' event (evid: 4030)
 *
 * Event description: when an agent clicks on a task to view the rich content
 *
 * @param {userJourneyClickToRichContentParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {number} location - Location from top
 * @property {string} tab - {site info, Goals,Tasks}
 * @property {string} phase - {Site Completion, Business Setup, Business Growth}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} applied_filter - The tasks' filter that is currently activated
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {string} current_status - The status of the task
 * @property {GUID} msid - New site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyClickToRichContentParams>} LogObject<userJourneyClickToRichContentParams>
 */
export function userJourneyClickToRichContent(params) {
    return { evid: 4030, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyTaskNavigationClicks' event (evid: 4031)
 *
 * Event description: when an agent clicks on the task rich content to navigate to marketing materials or articles
 *
 * @param {userJourneyTaskNavigationClicksParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} resources_type - { article,video }
 * @property {string} referrer_platform_name - {UM}
 * @property {string} item_id - if its article then article_id , if its marketing then URL
 * @property {number} location - Location from top
 * @property {string} section_name - {article,resources}
 * @property {string} tab - {User tasks, Site info}
 * @property {string} phase - {Site Completion, Business Setup, Business Growth}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} applied_filter - The tasks' filter that is currently activated
 * @property {string} item_name - if its an article then article name if its marketing its the video name
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {string} current_status - The status on load of the task
 * @property {GUID} msid - Site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyTaskNavigationClicksParams>} LogObject<userJourneyTaskNavigationClicksParams>
 */
export function userJourneyTaskNavigationClicks(params) {
    return { evid: 4031, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneySearchTask' event (evid: 4032)
 *
 * Event description: When a user clicks on the search button or presses 'enter' on the keyboard to search for a task in the tasks tab, he will get a result or error. This event will reflect the result of the search.
 *
 * @param {userJourneySearchTaskParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} referrer_platform_name - {UM}
 * @property {string} tab - {user tasks, site info}
 * @property {string} search_error - The error the agent saw in a false result
 * @property {number} num_of_tasks - Number of tasks returned for the search
 * @property {GUID} uuid - The wix ID of the Agent
 * @property {string} filter_by - The type of filter {Top Tasks, Products, Suggested Status}
 * @property {string} view_type - the view type {extension, full page, answers}
 * @property {string} search_result_name - List of all the tasks names that returned for the search
 * @property {string} search_value - The string (input) the user searched for
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} search_result_id - List of all the tasks ids that returned for the search
 * @property {boolean} has_result - True if there was a match for the string false if there wasn’t a match
 * @property {GUID} userId - The wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - New site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneySearchTaskParams>} LogObject<userJourneySearchTaskParams>
 */
export function userJourneySearchTask(params) {
    return { evid: 4032, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyTabLocked' event (evid: 4036)
 *
 * Event description: the event triggered when the USP tab is locked and the Expert cant use it
 *
 * @param {userJourneyTabLockedParams} params - The parameters for this event
 * @property {GUID} ticket_id - The answers ticket ID
 * @property {string} lock_reason - what is the reason the usp was locked? {ab test, crisis mode}
 * @property {string} uuid - DO NOT USE
 * @property {GUID} userId - The Wix user ID for which the ticket was open
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyTabLockedParams>} LogObject<userJourneyTabLockedParams>
 */
export function userJourneyTabLocked(params) {
    return { evid: 4036, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyAgentChangeTaskStatusSystem' event (evid: 4040)
 *
 * Event description: Sends when an agent changes the status of a task in the tasks tab.
 *
 * @param {userJourneyAgentChangeTaskStatusSystemParams} params - The parameters for this event
 * @property {string} prev_status - The status of the task before changing { not started, suggested, rejected, user rejected}
 * @property {string} referrer_platform_name - {UM}
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {GUID} userId - The Wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {string} current_status - The status of the task after changing { not started, suggested, rejected, user rejected}
 * @property {GUID} msid - Site the agent is looking at
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyAgentChangeTaskStatusSystemParams>} LogObject<userJourneyAgentChangeTaskStatusSystemParams>
 */
export function userJourneyAgentChangeTaskStatusSystem(params) {
    return { evid: 4040, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyArticleMissingTranslation' event (evid: 4044)
 *
 * Event description: Sends when an agent clicked on an article in a suggestion and the article doesnt have matching language like the ticket
 *
 * @param {userJourneyArticleMissingTranslationParams} params - The parameters for this event
 * @property {GUID} uuid - DO NOT USE
 * @property {string} task_name - Task name
 * @property {string} bo_uuid - The BO ID of the agent
 * @property {string} article_id - The article ID in the suggestion that the agent clicked on
 * @property {GUID} userId - The Wix ID (uuid) of the user the agent is talking with
 * @property {string} task_id - Task ID
 * @property {GUID} msid - Site the agent is looking at
 * @property {string} require_language - The required article language that didnt had translation
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyArticleMissingTranslationParams>} LogObject<userJourneyArticleMissingTranslationParams>
 */
export function userJourneyArticleMissingTranslation(params) {
    return { evid: 4044, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userJourneyNoSuggestionsReturn' event (evid: 4045)
 *
 * Event description: Event triggered when no suggestions were returned to the client, either because of dealer availability or there were no suggestions to the site
 *
 * @param {userJourneyNoSuggestionsReturnParams} params - The parameters for this event
 * @property {GUID} ticket_id - The answers ticket ID
 * @property {GUID} uuid - DO NOT USE
 * @property {string} empty_reason - what is the reason the usp suggestions to be empty? {dealer issue, no relevant suggestion}
 * @property {GUID} userId - The Wix ID (uuid) of the user the agent is talking with
 * @property {GUID} msid - The Wix site for which the API call for dealer made for
 * @property {GUID} agent_id - The answers ID of the agent
 * @return {LogObject<userJourneyNoSuggestionsReturnParams>} LogObject<userJourneyNoSuggestionsReturnParams>
 */
export function userJourneyNoSuggestionsReturn(params) {
    return { evid: 4045, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientPostUserSuggestionEvent' event (evid: 4061)
 *
 * Event description: When a USP client post User Suggestion Event to the User Success Platform through an API
 *
 * @param {uspApiClientPostUserSuggestionEventParams} params - The parameters for this event
 * @property {string} event_type_name - The event type the client post in relation to the suggestion and the site {view , reject}
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {GUID} snapshot_id - Unique auto generate ID for each respones that the USP sent to a client with a list of suggestions
 * @property {GUID} meta_site_id - The site ID for which the post was made
 * @property {GUID} user_id - The Wix user ID for which the post was made
 * @property {GUID} suggestion_id - The suggestion ID for which the post was made
 * @property {GUID} flow_id - The USP flow of the user which triggered the suggestion event
 * @return {LogObject<uspApiClientPostUserSuggestionEventParams>} LogObject<uspApiClientPostUserSuggestionEventParams>
 */
export function uspApiClientPostUserSuggestionEvent(params) {
    return { evid: 4061, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiFailedToValidateSomeSuggestionsFromDealerSchema' event (evid: 4071)
 *
 * Event description: When the USP failed to validate some of the suggestions from the Dealer due to required fields' value and skip them
 *
 * @param {uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams} params - The parameters for this event
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {GUID} meta_site_id - The site ID for which the request was made
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} issues - The list of suggestions and fields in Dealer schema for which the USP failed to validate the suggestion and the reasons for that
 * @return {LogObject<uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams>} LogObject<uspApiFailedToValidateSomeSuggestionsFromDealerSchemaParams>
 */
export function uspApiFailedToValidateSomeSuggestionsFromDealerSchema(params) {
    return { evid: 4071, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSuggestions' event (evid: 4072)
 *
 * Event description: When a USP client makes an API request to the User Success Platform to get suggestions
 *
 * @param {uspApiClientRequestSuggestionsParams} params - The parameters for this event
 * @property {string} state_trigger - State which type of suggestions states the client wish to receive
 * @property {string} request_language - (optional) The language of the account for which the request was made
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {boolean} state_active - State if the client only want to receive active suggestions or not
 * @property {GUID} meta_site_id - The site ID for which the request was made
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} paging - The number of suggestions the client requested, starting from the offset { “offset”: number, “limit”: number}
 * @property {GUID} flow_id - {optional} The flow_id that triggered the API request
 * @return {LogObject<uspApiClientRequestSuggestionsParams>} LogObject<uspApiClientRequestSuggestionsParams>
 */
export function uspApiClientRequestSuggestions(params) {
    return { evid: 4072, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSuggestionsReturnSuccessfully' event (evid: 4073)
 *
 * Event description: When the User Success Platform successfully returns a client's API request for suggestions
 *
 * @param {uspApiClientRequestSuggestionsReturnSuccessfullyParams} params - The parameters for this event
 * @property {string} suggestions_carousel_fields - The list of fields for each suggestion that were passed to the client out of carousel fields
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {GUID} snapshot_id - Unique auto generate ID for each respones that the USP sent to a client with a list of suggestions
 * @property {GUID} meta_site_id - The site ID for which the request was made
 * @property {string} suggestions - The list of the returned suggestions and their changing attributes (state, implementation method, language, etc.)
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} api_client_config - The settings that was used to generate the suggestions list that was sent to the client (sorting strategy)
 * @property {GUID} flow_id - The flow_id that triggered the API request. If no flow triggered the request, the the id of the new flow
 * @property {string} reason_for_empty_list - The reason for which the list of suggestions returned empty to the client
 * @return {LogObject<uspApiClientRequestSuggestionsReturnSuccessfullyParams>} LogObject<uspApiClientRequestSuggestionsReturnSuccessfullyParams>
 */
export function uspApiClientRequestSuggestionsReturnSuccessfully(params) {
    return { evid: 4073, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSpecificSuggestion' event (evid: 4075)
 *
 * Event description: When a USP client makes an API request to the User Success Platform to get a specific suggestion
 *
 * @param {uspApiClientRequestSpecificSuggestionParams} params - The parameters for this event
 * @property {string} request_language - (optional) The language of the account for which the request was made
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {GUID} meta_site_id - The site ID for which the request was made
 * @property {GUID} user_id - user_id
 * @property {GUID} suggestion_id - The specific suggestion the client requested
 * @property {GUID} flow_id - The flow_id that triggered the API request
 * @return {LogObject<uspApiClientRequestSpecificSuggestionParams>} LogObject<uspApiClientRequestSpecificSuggestionParams>
 */
export function uspApiClientRequestSpecificSuggestion(params) {
    return { evid: 4075, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspApiClientRequestSpecificSuggestionReturnSuccessfully' event (evid: 4076)
 *
 * Event description: When the User Success Platform successfully returns a client's API request for a specific suggestion
 *
 * @param {uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams} params - The parameters for this event
 * @property {GUID} api_client_id - {chatbot,kb,answers}
 * @property {GUID} snapshot_id - Unique auto generate ID for each respones that the USP sent to a client with the suggestion
 * @property {GUID} meta_site_id - The site ID for which the request was made
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} suggestion_carousel_fields - The list of fields that were passed to the client out of carousel fields
 * @property {string} suggestion - The returned suggestion and it's changing attributes  (state, implementation method, language, etc.)
 * @property {GUID} flow_id - The flow_id that triggered the API request.
 * @return {LogObject<uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams>} LogObject<uspApiClientRequestSpecificSuggestionReturnSuccessfullyParams>
 */
export function uspApiClientRequestSpecificSuggestionReturnSuccessfully(params) {
    return { evid: 4076, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotConversationCreatedFromStartOver' event (evid: 41)
 *
 * Event description: This event is being triggered every time a new chatbot conversation was created as a result of a "start over" click by the user.
 *
 * @param {chatbotConversationCreatedFromStartOverParams} params - The parameters for this event
 * @property {GUID} source_conversation_id - The conversation_id the user clicked "Start Over" from
 * @property {GUID} destination_conversation_id - The conversation_id that was opened as a result of "Start Over" click
 * @property {GUID} session_id - The session ID the user is in
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_area - context_area
 * @property {string} context_domain - context_domain
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_platform - context_platform
 * @property {string} context_uuid - context_uuid
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - user_experience
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} chatbot_view - widget, full screen, iframe, mobile
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @return {LogObject<chatbotConversationCreatedFromStartOverParams>} LogObject<chatbotConversationCreatedFromStartOverParams>
 */
export function chatbotConversationCreatedFromStartOver(params) {
    return { evid: 41, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurveyWebhookTriggered' event (evid: 4201)
 *
 * Event description: Webhook triggered when a call is completed (status = completed), or chat ended or ticket status has changed to "closed" or "solved"
 *
 * Payload to include the Ticket object fields (same as in the tickets webhooks) and the call object.
 *
 * @param {potentialSurveyWebhookTriggeredParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'ticket'}
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<potentialSurveyWebhookTriggeredParams>} LogObject<potentialSurveyWebhookTriggeredParams>
 */
export function potentialSurveyWebhookTriggered(params) {
    return { evid: 4201, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurveyForwardMarketing' event (evid: 4202)
 *
 * Event description: Webhook payload forward to marketing
 *
 * @param {potentialSurveyForwardMarketingParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'reply', 'live chat')
 * @property {string} template_name - The template that defined which flow will the survey will be sent (gizmo / chatbot etc)
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {GUID} mail_guid - Unique identifier of specific uuid and email template
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<potentialSurveyForwardMarketingParams>} LogObject<potentialSurveyForwardMarketingParams>
 */
export function potentialSurveyForwardMarketing(params) {
    return { evid: 4202, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurveyAnswersWebhookTriggered' event (evid: 4203)
 *
 * Event description: Fired when a potential survey's ticket or call received from Answers
 *
 * @param {potentialSurveyAnswersWebhookTriggeredParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'ticket'}
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<potentialSurveyAnswersWebhookTriggeredParams>} LogObject<potentialSurveyAnswersWebhookTriggeredParams>
 */
export function potentialSurveyAnswersWebhookTriggered(params) {
    return { evid: 4203, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'surveyFilteredOutByLogic' event (evid: 4204)
 *
 * Event description: Fired when a potential survey's ticket from Answers got filtered by the logic. This event reflecting the reason why the ticket was filtered.
 *
 * @param {surveyFilteredOutByLogicParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} filtered_by - The first filter in the model logic that filtered the ticket
 * @property {string} interaction_type - {'chat', 'call', 'reply'}
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<surveyFilteredOutByLogicParams>} LogObject<surveyFilteredOutByLogicParams>
 */
export function surveyFilteredOutByLogic(params) {
    return { evid: 4204, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'potentialSurvey' event (evid: 4205)
 *
 * Event description: eligible interaction for survey
 *
 * @param {potentialSurveyParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'reply', 'live chat')
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {GUID} mail_guid - Unique identifier of specific uuid and email template
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<potentialSurveyParams>} LogObject<potentialSurveyParams>
 */
export function potentialSurvey(params) {
    return { evid: 4205, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'interactionForwardMarketing' event (evid: 4206)
 *
 * Event description: forward to marketing
 *
 * @param {interactionForwardMarketingParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'reply', 'live chat')
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {GUID} mail_guid - Unique identifier of specific uuid and email template
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<interactionForwardMarketingParams>} LogObject<interactionForwardMarketingParams>
 */
export function interactionForwardMarketing(params) {
    return { evid: 4206, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'surveySkippedOrAnswered' event (evid: 4207)
 *
 * Event description: Fired when a potential survey's ticket from Answers got filtered by the logic. This event reflecting the reason why the ticket was filtered.
 *
 * @param {surveySkippedOrAnsweredParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {number} call_process_time - call_process_time
 * @property {string} chat_status - {'completed'}
 * @property {string} interaction_type - {'chat', 'call', 'reply'}
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {string} call_type - {'inbound','outbound','callback'}
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} reason - The reason for triggering this event (survey skipped/at least 1 survey's question answered)
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @property {number} call_status - {'completed'}
 * @return {LogObject<surveySkippedOrAnsweredParams>} LogObject<surveySkippedOrAnsweredParams>
 */
export function surveySkippedOrAnswered(params) {
    return { evid: 4207, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hidingOfChatbotSurvey' event (evid: 4208)
 *
 * Event description: After 2 hours from the moment the survey is available to the user in the chatbot, it will be hidden (for users who completed at least 1 question in the survey)
 * (Intended for bi complex field usage-recalculating and deleting interaction_id field)
 *
 * @param {hidingOfChatbotSurveyParams} params - The parameters for this event
 * @property {GUID} ticket_id - cs ticket_id
 * @property {string} interaction_type - {'chat', 'call', 'reply', 'live chat')
 * @property {string} occurrence_id - unique identification of occurrence
 * @property {GUID} uuid - wix uuid
 * @property {number} num_user_batch_messages - number of msg batches by user
 * @property {number} ticket_last_status - Last ticket status {120 (closed),140 (solved)}
 * @property {string} interaction_id - {'chat_id','call_id','ticket_id'}
 * @property {string} user_timezone - The user's timezone description as received from Answers
 * @return {LogObject<hidingOfChatbotSurveyParams>} LogObject<hidingOfChatbotSurveyParams>
 */
export function hidingOfChatbotSurvey(params) {
    return { evid: 4208, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoiceSyntheticEventForUserTypesSrc4Evid43' event (evid: 43)
 *
 * Event description: This synthetic event is fired once we receive an user/account that is linked to the interaction we aim to classify
 *
 * @param {userVoiceSyntheticEventForUserTypesSrc4Evid43Params} params - The parameters for this event
 * @property {GUID} user_id - Wix User ID
 * @property {GUID} account_id - Wix Account ID
 * @property {string} labels_list - The User/Account type
 * @return {LogObject<userVoiceSyntheticEventForUserTypesSrc4Evid43Params>} LogObject<userVoiceSyntheticEventForUserTypesSrc4Evid43Params>
 */
export function userVoiceSyntheticEventForUserTypesSrc4Evid43(params) {
    return { evid: 43, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoicePageViewSrc4Evid44' event (evid: 44)
 *
 * Event description: Wis users who reach User Voice platform
 *
 * @param {userVoicePageViewSrc4Evid44Params} params - The parameters for this event
 * @property {string} page_name - The name of the page the Wix user reaches out at User Voice platform
 * @property {string} session_id - ***TBD
 * @property {string} referral_url - The full URL address the Wix User came from
 * @property {string} refferal_page_name - The URL name address the Wix User came from
 * @property {string} issue_id - The ID of the issue page the Wix user reaches out  to at User Voice platform
 * @property {string} issue_name - The name of the issue page the Wix user reaches out  to at User Voice platform
 * @property {string} product_ids - The ID/s of the product/s the Wix user exposes to while using User Voice platform
 * @property {string} page_names - The name of the page the Wix user reaches out at User Voice platform
 * @property {string} user_email - The email address of the Wix user who entered User Voice platform
 * @property {string} user_full_name - The full name of the Wix user who entered User Voice platform
 * @property {string} comapnies - The Wix company of the Wix user
 * @property {string} departments - The Wix department of the Wix user
 * @property {string} guilds - The Wix guild of the Wix user
 * @return {LogObject<userVoicePageViewSrc4Evid44Params>} LogObject<userVoicePageViewSrc4Evid44Params>
 */
export function userVoicePageViewSrc4Evid44(params) {
    return { evid: 44, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoiceSearchEventSrc4Evid45' event (evid: 45)
 *
 * Event description: The searches made by Wix users at User Voice platform
 *
 * @param {userVoiceSearchEventSrc4Evid45Params} params - The parameters for this event
 * @property {string} page_section - An area within the  User Voice platform which refers to a specific function
 * @property {string} issue_id - The ID of the issue page the Wix user reaches out  while using User Voice platform
 * @property {string} page_name - The name of the page the Wix user reaches out at User Voice platform
 *
 * @property {string} product_ids - The ID/s of the product/s the Wix user exposes to while using User Voice platform
 * @property {string} product_names - The name/s of the product/s the Wix user exposes to while using User Voice platform
 * @property {string} feature_ids - The ID/s of the feature/s  the User uses to during a search or a click of filters
 * @property {string} feature_names - The name/s of the feature/s  the User uses to during a search or a click of filters
 * @property {string} issue_name - The name of the issue page the Wix user reaches out to at User Voice platform
 * @property {string} filter_by - The filters choices made by the Wix user in order to conduct a search at one of the pages at User Voice platform
 * @property {string} search_phrase - The phrase the Wix user enters in the search bar (please note: each phrase is counted after 1 second of typing)
 * @property {string} session_id - TBD
 * @property {string} filters_used - The name of the options made in the filters during the Wix user's search
 * @property {string} presented_content - For each search, the output needs to show the id of issue or highlight based on the Wix user search and the order of the search results
 * @property {string} user_email - The email address of the Wix user who entered User Voice platform
 *
 * @property {string} user_full_name - The full name of the Wix user who entered User Voice platform
 *
 * @property {string} highlight_id - The ID of the highlight within Issue Overview Page in UV’s where user reaches out  to during the scrolling of the results
 * @property {string} companies - The Wix company of the Wix user
 * @property {string} departments - The Wix department of the Wix user
 * @property {string} guilds - The Wix guild of the Wix user
 * @property {string} search_id - The ID of the unique  search done by the Wix user whether it ends w or w/o click
 * @return {LogObject<userVoiceSearchEventSrc4Evid45Params>} LogObject<userVoiceSearchEventSrc4Evid45Params>
 */
export function userVoiceSearchEventSrc4Evid45(params) {
    return { evid: 45, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoiceClickSrc4Evid46' event (evid: 46)
 *
 * Event description: Monitoring clicks actions at User Voice platform
 *
 * @param {userVoiceClickSrc4Evid46Params} params - The parameters for this event
 * @property {string} page_name	 - The name of the page the Wix user reaches out at User Voice platform
 * @property {string} page_section - An area within the UX of User Voice which refers to a specific function
 * @property {string} click_item - The type of button or symbol clicked by the Wix user once using User Voice platform
 * @property {string} action_type - The category of action which was made by the Wix user within the product
 * @property {string} filter_by - The filters choices made by the Wix user in order to conduct a search at one of the pages at User Voice platform
 * @property {string} filters_used	 - The name of the options made in the filters during the Wix user's search
 * @property {string} action_type_details - This indicates the options appear under the activity done by the Wix user on the page
 * @property {string} product_ids	 - The ID/s of the product/s the Wix user exposes to while using User Voice platform
 * @property {string} product_names	 - The name/s of the product/s the Wix user exposes to while using User Voice platform
 * @property {string} feature_ids	 - The ID/s of the feature/s the User uses to during a search or a click of filters
 * @property {string} feature_names	 - The name/s of the feature/s the User uses to during a search or a click of filters
 * @property {string} issue_id	 - The ID of the issue page the Wix user reaches out while using User Voice platform
 * @property {string} issue_name	 - The name of the issue page the Wix user reaches out to at User Voice platform
 * @property {string} highlight_id	 - The ID of the highlight within issues page in UV’s where user reaches out to during the scrolling of the results
 * @property {string} session_id - TBD
 * @property {string} search_phrase - The phrase the Wix user enters in the search bar (please note: each phrase is counted after 1 second of typing)
 * @property {string} user_email	 - The email address of the Wix user who entered User Voice platform
 * @property {string} user_full_name	 - The full name of the Wix user who entered User Voice platform
 * @property {string} company - The Wix company of the Wix user
 * @property {string} department - The Wix department of the Wix user
 * @property {string} guild - The Wix guild of the Wix user
 * @property {string} search_id - The ID of the unique  search done by the Wix user whether it ends w or w/o click
 * @return {LogObject<userVoiceClickSrc4Evid46Params>} LogObject<userVoiceClickSrc4Evid46Params>
 */
export function userVoiceClickSrc4Evid46(params) {
    return { evid: 46, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoiceErrorMessageSrc4Evid47' event (evid: 47)
 *
 * Event description: This event is fired once the Wix user experiences an error message at the User Voice Platform
 *
 * @param {userVoiceErrorMessageSrc4Evid47Params} params - The parameters for this event
 * @property {string} page_name - The name of the page the Wix user reaches out at User Voice platform
 * @property {string} page_section - An area within the User Voice platform which refers to a specific function
 * @property {string} click_item - the type of button or symbol clicked by the User
 * @property {string} error_type - The type of error user encounters within the User Voice platform
 * @property {string} error_type_id - The ID of the error which was sent in case of a broken link or the search result has failed
 * @property {string} error__text - The description of the error in case of a broken link or the search result has failed
 * @property {string} user_email	 - The email address of the Wix user who entered User Voice platform
 * @property {string} user_full_name	 - The full name of the Wix user who entered User Voice platform
 * @return {LogObject<userVoiceErrorMessageSrc4Evid47Params>} LogObject<userVoiceErrorMessageSrc4Evid47Params>
 */
export function userVoiceErrorMessageSrc4Evid47(params) {
    return { evid: 47, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoicePageEngagementSrc4Evid48' event (evid: 48)
 *
 * Event description: This event fires once the Wix user is still active on one of the User Voice pages but only do a ping action
 *
 * @param {userVoicePageEngagementSrc4Evid48Params} params - The parameters for this event
 * @property {string} page_name - The name of the page the UV’s user reaches out
 * @property {string} page_section - An area within the UX of User Voice which refers to a specific function
 * @property {string} action_type - indicates the type of activity done by the user who was still active on the page but use ping actions instead of options represented on the User Voice platform
 * @property {string} product_ids - The ID/s of the product the User exposes to
 * @property {string} product_names - The name of the product/s the User exposes to
 * @property {string} feature_ids - The ID/s of the feature the User uses to during a search or a click of filters
 * @property {string} feature_names - The name/s of the feature the User uses to during a search or a click of filters
 * @return {LogObject<userVoicePageEngagementSrc4Evid48Params>} LogObject<userVoicePageEngagementSrc4Evid48Params>
 */
export function userVoicePageEngagementSrc4Evid48(params) {
    return { evid: 48, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheWasItHelpfulButtons' event (evid: 501)
 *
 * Event description: fired when a user votes helpful/unhelpful
 *
 * @param {clickTheWasItHelpfulButtonsParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - item_id
 * @property {boolean} thumbs_up - Indicate if the user vote helpful or unhelpful
 * @property {string} feedback_details - feedback_details
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} clicked_text - the answer the user selected
 * @return {LogObject<clickTheWasItHelpfulButtonsParams>} LogObject<clickTheWasItHelpfulButtonsParams>
 */
export function clickTheWasItHelpfulButtons(params) {
    return { evid: 501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voteUnVoteForWishList' event (evid: 502)
 *
 * Event description: fired when a user votes / unvote for a feature request
 *
 * @param {voteUnVoteForWishListParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - include the article_id
 * @property {boolean} thumbs_up - Indicate if the user vote or unvote
 * @property {string} tab - tab
 * @property {string} filter_by - filter_by
 * @property {string} item_name - item_name
 * @property {string} vote_type - vote_type
 * @property {string} source_name - the kb page the vote occurred on. Can be article or roadmap.
 * @property {string} sort_by - sort_by
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} source_component_name - source_component_name
 * @property {string} item_type - item_type
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<voteUnVoteForWishListParams>} LogObject<voteUnVoteForWishListParams>
 */
export function voteUnVoteForWishList(params) {
    return { evid: 502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheIHaveThisProblemBugButton' event (evid: 503)
 *
 * Event description: fire when a user votes/ unvote for a known issue
 *
 * @param {clickTheIHaveThisProblemBugButtonParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} item_id - item_id
 * @property {boolean} thumbs_up - Indicate if the user vote or unvote
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<clickTheIHaveThisProblemBugButtonParams>} LogObject<clickTheIHaveThisProblemBugButtonParams>
 */
export function clickTheIHaveThisProblemBugButton(params) {
    return { evid: 503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheFollowUnFollowButton' event (evid: 504)
 *
 * Event description: fired when users (wix users) click the top bar chackbox to follow/unfollow an article in the help center
 *
 * @param {clickTheFollowUnFollowButtonParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - the article's id
 * @property {boolean} thumbs_up - Indicate if the user follow or unfollow
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} kb_lang - kb_lang
 * @property {string} lang - lng
 * @property {string} item_type - item_type
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<clickTheFollowUnFollowButtonParams>} LogObject<clickTheFollowUnFollowButtonParams>
 */
export function clickTheFollowUnFollowButton(params) {
    return { evid: 504, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'replyATicket' event (evid: 508)
 *
 * Event description: reply a ticket.
 *
 * @param {replyATicketParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {string} source_name - source_name
 * @property {boolean} is_thread_creator - is_thread_creator
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<replyATicketParams>} LogObject<replyATicketParams>
 */
export function replyATicket(params) {
    return { evid: 508, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheForumLink' event (evid: 514)
 *
 * Event description: click the forum link.
 *
 * @param {clickTheForumLinkParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} referral_name - referral_name
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickTheForumLinkParams>} LogObject<clickTheForumLinkParams>
 */
export function clickTheForumLink(params) {
    return { evid: 514, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickAContent' event (evid: 517)
 *
 * Event description: click a content.
 *
 * @param {clickAContentParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {boolean} from_search - indicator if this is a click on any of the search results
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} order - order
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {string} type - type
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickAContentParams>} LogObject<clickAContentParams>
 */
export function clickAContent(params) {
    return { evid: 517, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chooseACategoryAndSubcategory' event (evid: 519)
 *
 * Event description: choose a category and subcategory.
 *
 * @param {chooseACategoryAndSubcategoryParams} params - The parameters for this event
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} source_name - source_name
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<chooseACategoryAndSubcategoryParams>} LogObject<chooseACategoryAndSubcategoryParams>
 */
export function chooseACategoryAndSubcategory(params) {
    return { evid: 519, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'askingAQuestion' event (evid: 520)
 *
 * Event description: Fire when the search results returned after user searched in the Help Center
 *
 * @param {askingAQuestionParams} params - The parameters for this event
 * @property {string} question - The search term the user searched for
 * @property {string} source_url - source_url
 * @property {string} item_id - item_id
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} presented_content - presented_content
 * @property {string} first_answer - first_answer
 * @property {string} source_name - indicates what page the user conducted the search is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} kb_lang - kb page language
 * @property {boolean} has_related - has_related
 * @property {string} lang - wix language
 * @property {DateTime} action_date - action_date
 * @property {string} item_type - item_type
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} summarized_answer_text - The full generated answer that was shown
 * @property {string} minimum_retrieval_distance - The lower distance from all the articles that were returned by the KA retrieval mechanisms.
 * @property {string} summarized_answer_type - The type of answer that was generated ('support request','prohibited','direct')
 * @property {boolean} is_support_request - Is the user query   was marked as support request by the support classifier
 * @property {string} context_msid - The user's site that was taken into consideration when returning the search results
 * @property {string} context_editor_type - The user's site editor type that was taken into consideration when returning the search results
 * @property {string} input_type - The type of input the user used to search (e.g. 'suggested question')
 * @property {string} summarized_answer_based_on - The list of articles the generated answer was based on
 * @property {number} summarized_answer_words_count - Number of words the generated answer was include
 * @return {LogObject<askingAQuestionParams>} LogObject<askingAQuestionParams>
 */
export function askingAQuestion(params) {
    return { evid: 520, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 5200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @property {string} abc - abc
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 5200, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAnswer' event (evid: 521)
 *
 * Event description: Fire when the user selects one of the search results or interact with an answer in the Help Center
 *
 * @param {clickOnAnswerParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} question - The search term the user searched for
 * @property {string} search_result_selection - search_result_selection
 * @property {string} source_url - source_url
 * @property {string} item_id - item_id
 * @property {boolean} is_related - is_related
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} clicked_item_order - clicked_item_order
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} clicked_item_id - clicked_item_id
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} order - order
 * @property {string} answer - answer
 * @property {string} kb_lang - kb page language
 * @property {boolean} has_related - has_related
 * @property {string} lang - wix language
 * @property {DateTime} action_date - action_date
 * @property {string} item_type - item_type
 * @property {number} page_number - The results page number on which the results the user chose was on
 * @property {string} clicked_url - clicked_url
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} summarized_answer_text - The full generated answer that was shown
 * @property {string} summarized_answer_type - The type of answer that was generated ('support request','prohibited','direct')
 * @property {number} output_distance - The score the clicked article got from the KA model
 * @property {string} output_distance_str - The score the clicked article got from the KA model
 * @property {string} summarized_answer_based_on - The list of articles the generated answer was based on
 *
 * @property {number} summarized_answer_words_count - Number of words the generated answer was include
 *
 * @return {LogObject<clickOnAnswerParams>} LogObject<clickOnAnswerParams>
 */
export function clickOnAnswer(params) {
    return { evid: 521, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickTheSeeAllResultsLink' event (evid: 522)
 *
 * Event description: Fired when the user clicks the option to see all search results
 *
 * @param {clickTheSeeAllResultsLinkParams} params - The parameters for this event
 * @property {string} question - text entered by the user in the search bar
 * @property {string} item_id - item_id
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} source_name - indicates what type of article the user is at:
 * home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} source_type_trigger - the source name of the source in which the user clicks the 'show x more'. If the user clicks the general 'show all results' value will get 'general'.
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<clickTheSeeAllResultsLinkParams>} LogObject<clickTheSeeAllResultsLinkParams>
 */
export function clickTheSeeAllResultsLink(params) {
    return { evid: 522, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageView' event (evid: 531)
 *
 * Event description: Fire when the user enters a page in the Help Center
 *
 * @param {pageViewParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} question - question
 * @property {string} item_id - item_id
 * @property {string} item_version - item_version
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} tab - tab
 * @property {string} filter_by - filter_by
 * @property {string} presented_content - presented_content
 * @property {string} personalized_content - Include all the personalized content on that page
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} sort_by - sort_by
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} ab_test_version - ab_test_version
 * @property {number} screen_width - The user's screen width
 * @property {number} screen_height - The user's screen height
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {boolean} page_load_at_top - false if the page was load somewhere in the middle of the page
 * @return {LogObject<pageViewParams>} LogObject<pageViewParams>
 */
export function pageView(params) {
    return { evid: 531, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedOutsideBox' event (evid: 536)
 *
 * Event description: clicked outside box.
 *
 * @param {clickedOutsideBoxParams} params - The parameters for this event
 * @property {string} question - question
 * @property {string} source_url - source_url
 * @property {string} referral_name - referral_name
 * @property {string} first_answer - first_answer
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickedOutsideBoxParams>} LogObject<clickedOutsideBoxParams>
 */
export function clickedOutsideBox(params) {
    return { evid: 536, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gotNoAnswer' event (evid: 537)
 *
 * Event description: Fire when no results return after the user search in the Help Center
 *
 * @param {gotNoAnswerParams} params - The parameters for this event
 * @property {string} question - The search term the user searched for
 * @property {string} source_url - source_url
 * @property {string} search_method - search method
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} search_session_id - search_session_id
 * @return {LogObject<gotNoAnswerParams>} LogObject<gotNoAnswerParams>
 */
export function gotNoAnswer(params) {
    return { evid: 537, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientLoadAttempt' event (evid: 558)
 *
 * Event description: Sent when the page is served and loaded, but the actual app was not fully rendered yet.
 *
 * @param {clientLoadAttemptParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {string} client_name - the client that is sending the event. e.g - app/public/widget_[id]
 * @property {string} lang - lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clientLoadAttemptParams>} LogObject<clientLoadAttemptParams>
 */
export function clientLoadAttempt(params) {
    return { evid: 558, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clientLoadSuccess' event (evid: 559)
 *
 * Event description: Sent when the client app was fully rendered (all ajax requests completed, etc).
 *
 * @param {clientLoadSuccessParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {number} ts - time since load started, in ms
 * @property {string} client_name - the client that is sending the event. e.g - app/public/widget_[id]
 * @property {string} source_name - source_name
 * @property {string} lang - answers version of lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clientLoadSuccessParams>} LogObject<clientLoadSuccessParams>
 */
export function clientLoadSuccess(params) {
    return { evid: 559, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wasItHelpfulSubmitFeedbackForm' event (evid: 569)
 *
 * Event description: Click submit feedback form after marking an article as unhelpful (evid 501, thumbs_down false)
 *
 * @param {wasItHelpfulSubmitFeedbackFormParams} params - The parameters for this event
 * @property {string} item_url - article url
 * @property {GUID} item_id - article id
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} feedback - the feedback the user submitted
 * @property {string} item_name - article name
 * @property {string} source_name - widget name
 * @property {string} lang - answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wasItHelpfulSubmitFeedbackFormParams>} LogObject<wasItHelpfulSubmitFeedbackFormParams>
 */
export function wasItHelpfulSubmitFeedbackForm(params) {
    return { evid: 569, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactSolutionView' event (evid: 573)
 *
 * Event description: A solution is presented to the user in "step 3"
 *
 * @param {wixContactSolutionViewParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} item_id - ID of the article presented to the user
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactSolutionViewParams>} LogObject<wixContactSolutionViewParams>
 */
export function wixContactSolutionView(params) {
    return { evid: 573, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnTheActionButton' event (evid: 574)
 *
 * Event description: User click on the action button next to the solution content
 *
 * @param {wixContactClickOnTheActionButtonParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} chatbot_view - chatbot_view
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} sub_option_id - the id of the final sub option
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactClickOnTheActionButtonParams>} LogObject<wixContactClickOnTheActionButtonParams>
 */
export function wixContactClickOnTheActionButton(params) {
    return { evid: 574, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnALinkInsideASolution' event (evid: 575)
 *
 * Event description: User click on a link inside the solution content
 *
 * @param {wixContactClickOnALinkInsideASolutionParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} link_name - the clickable text
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {Url} link_url - the link's url
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactClickOnALinkInsideASolutionParams>} LogObject<wixContactClickOnALinkInsideASolutionParams>
 */
export function wixContactClickOnALinkInsideASolution(params) {
    return { evid: 575, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactSubmitTicketForm' event (evid: 577)
 *
 * Event description: Clicking the "Submit a ticket" button at the bottom of the ticket form
 *
 * @param {wixContactSubmitTicketFormParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} topic - the topic of the ticket (selected from the "Issue Subject" dropdown)
 * @property {string} lang - answers language
 * @property {string} platform - NULL
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactSubmitTicketFormParams>} LogObject<wixContactSubmitTicketFormParams>
 */
export function wixContactSubmitTicketForm(params) {
    return { evid: 577, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnRequestCallback' event (evid: 578)
 *
 * Event description: Clicking the "Request Callback" button
 *
 * @param {wixContactClickOnRequestCallbackParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactClickOnRequestCallbackParams>} LogObject<wixContactClickOnRequestCallbackParams>
 */
export function wixContactClickOnRequestCallback(params) {
    return { evid: 578, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactSubmitCallbackForm' event (evid: 579)
 *
 * Event description: Clicking the "Request Callback" button at the bottom of the callback form
 *
 * @param {wixContactSubmitCallbackFormParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactSubmitCallbackFormParams>} LogObject<wixContactSubmitCallbackFormParams>
 */
export function wixContactSubmitCallbackForm(params) {
    return { evid: 579, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactCallbackSuccess' event (evid: 580)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {wixContactCallbackSuccessParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - action_url
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {number} clid - wcc call guid
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {GUID} callid - answers call guid
 * @property {boolean} view_recaptcha - true if user saw the recaptcha view and false if not
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 * @return {LogObject<wixContactCallbackSuccessParams>} LogObject<wixContactCallbackSuccessParams>
 */
export function wixContactCallbackSuccess(params) {
    return { evid: 580, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactCallbackFailedClient' event (evid: 581)
 *
 * Event description: User was not able to schedule a callback
 *
 * @param {wixContactCallbackFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} node_id - node_id
 * @property {string} server_error - the actual reason why user failed to request callback
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason for callback fail (the number of the error) , for getting the actual reason use the server_error field
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {boolean} view_recaptcha - true if user saw the recaptcha view and false if not
 * @property {string} lang - answers language
 * @property {string} platform - Null
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactCallbackFailedClientParams>} LogObject<wixContactCallbackFailedClientParams>
 */
export function wixContactCallbackFailedClient(params) {
    return { evid: 581, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionSuccessClient' event (evid: 582)
 *
 * Event description: User was able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionSuccessClientParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { contact form, SMS page etc}
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} ticket_url - ticket_url
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @property {boolean} is_dummy_ticket - True:= The ticket was closed right after it was opened.
 * False:= Otherwise.
 * @return {LogObject<wixContactTicketSubmissionSuccessClientParams>} LogObject<wixContactTicketSubmissionSuccessClientParams>
 */
export function wixContactTicketSubmissionSuccessClient(params) {
    return { evid: 582, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionFailedClient' event (evid: 584)
 *
 * Event description: User was not able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} node_id - ID of the current stage type
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason for ticket tubmission fail
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} topic - the topic of the ticket (selected from the "Issue Subject" dropdown)
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactTicketSubmissionFailedClientParams>} LogObject<wixContactTicketSubmissionFailedClientParams>
 */
export function wixContactTicketSubmissionFailedClient(params) {
    return { evid: 584, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'articleClickActionButton' event (evid: 588)
 *
 * Event description: click an action button inside an article
 *
 * @param {articleClickActionButtonParams} params - The parameters for this event
 * @property {GUID} item_id - the id of the article the button was click in
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {Url} action_url - the URL of the action button
 * @property {string} item_name - the name of the article the button was click in
 * @property {string} source_name - the page they clicked the button on
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} kb_lang - kb page language
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} action_text - the text that appear on the button
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickActionButtonParams>} LogObject<articleClickActionButtonParams>
 */
export function articleClickActionButton(params) {
    return { evid: 588, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactAttempt' event (evid: 592)
 *
 * Event description: User opens "Wix Contact" from desktop. The Contact form has started to load.
 *
 * @param {wixContactOpenWixContactAttemptParams} params - The parameters for this event
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactOpenWixContactAttemptParams>} LogObject<wixContactOpenWixContactAttemptParams>
 */
export function wixContactOpenWixContactAttempt(params) {
    return { evid: 592, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'articleClickOnBanner' event (evid: 594)
 *
 * Event description: click on a banner inside an article
 *
 * @param {articleClickOnBannerParams} params - The parameters for this event
 * @property {string} banner_text - the text that appear on the banner
 * @property {GUID} item_id - the id of the article the banner was click in
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - the name of the article the banner was click in
 * @property {string} source_name - the page they clicked the button on
 * @property {Url} banner_url - the target URL of the banner
 * @property {string} lang - Answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickOnBannerParams>} LogObject<articleClickOnBannerParams>
 */
export function articleClickOnBanner(params) {
    return { evid: 594, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactClickOnChatLive' event (evid: 596)
 *
 * Event description: Clicking the "Chat LIve" button
 *
 * @param {wixContactClickOnChatLiveParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_areaa - context_areaa
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - ID of the chatbot node
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation_id from the chatbot
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactClickOnChatLiveParams>} LogObject<wixContactClickOnChatLiveParams>
 */
export function wixContactClickOnChatLive(params) {
    return { evid: 596, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactOpenChatSuccessClient' event (evid: 597)
 *
 * Event description: User was able to open a chat conversation
 *
 * @param {wixContactOpenChatSuccessClientParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created chat
 * @property {GUID} chatid - answers chat guid
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution content
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation_id from the chatbot
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} ai_user_intent - the user intent that was recognized by the AI Chatbot
 *
 * @property {string} ai_user_intent_type - the user intent type that was recognized by the AI Chatbot
 *
 * @return {LogObject<wixContactOpenChatSuccessClientParams>} LogObject<wixContactOpenChatSuccessClientParams>
 */
export function wixContactOpenChatSuccessClient(params) {
    return { evid: 597, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'voteForGeneratedAnswerInHelpCenterSrc4Evid601' event (evid: 601)
 *
 * Event description: Fire when a user votes for a generated answer in the Help Center
 *
 * @param {voteForGeneratedAnswerInHelpCenterSrc4Evid601Params} params - The parameters for this event
 * @property {string} question - The search term the user searched for
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} clicked_item_name - clicked_item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} kb_lang - kb page language
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {string} summarized_answer_text - The full generated answer that was shown
 * @property {string} summarized_answer_based_on - The list of articles the generated answer was based on
 *
 * @property {number} summarized_answer_words_count - Number of words the generated answer was include
 *
 * @return {LogObject<voteForGeneratedAnswerInHelpCenterSrc4Evid601Params>} LogObject<voteForGeneratedAnswerInHelpCenterSrc4Evid601Params>
 */
export function voteForGeneratedAnswerInHelpCenterSrc4Evid601(params) {
    return { evid: 601, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerSubmitScheduledCallbackRequest' event (evid: 604)
 *
 * Event description: Clicking the "Schedule a Callback" button at the bottom of the Call Scheduler
 *
 * @param {callSchedulerSubmitScheduledCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerSubmitScheduledCallbackRequestParams>} LogObject<callSchedulerSubmitScheduledCallbackRequestParams>
 */
export function callSchedulerSubmitScheduledCallbackRequest(params) {
    return { evid: 604, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackSuccess' event (evid: 605)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackSuccessParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - Id of the Answers queue the call will enter
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackSuccessParams>} LogObject<callSchedulerScheduledCallbackSuccessParams>
 */
export function callSchedulerScheduledCallbackSuccess(params) {
    return { evid: 605, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickRescheduleOrCancelCall' event (evid: 606)
 *
 * Event description: User clicks the "Reschedule or cancel call" button after scheduling a call
 *
 * @param {callSchedulerClickRescheduleOrCancelCallParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleOrCancelCallParams>} LogObject<callSchedulerClickRescheduleOrCancelCallParams>
 */
export function callSchedulerClickRescheduleOrCancelCall(params) {
    return { evid: 606, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickCancel' event (evid: 607)
 *
 * Event description: User clicks the "Cancel" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickCancelParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickCancelParams>} LogObject<callSchedulerClickCancelParams>
 */
export function callSchedulerClickCancel(params) {
    return { evid: 607, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerClickReschedule' event (evid: 608)
 *
 * Event description: User clicks the "Reschedule" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickRescheduleParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleParams>} LogObject<callSchedulerClickRescheduleParams>
 */
export function callSchedulerClickReschedule(params) {
    return { evid: 608, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerOpenMyScheduledCallsPage' event (evid: 609)
 *
 * Event description: User opens the My Scheduled Calls page
 *
 * @param {callSchedulerOpenMyScheduledCallsPageParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} button_name - The button the user clicked on to access this page. (Done/Reschedule or cancel call/X)
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerOpenMyScheduledCallsPageParams>} LogObject<callSchedulerOpenMyScheduledCallsPageParams>
 */
export function callSchedulerOpenMyScheduledCallsPage(params) {
    return { evid: 609, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerCancelCallbackRequest' event (evid: 610)
 *
 * Event description: User cancels their callback request
 *
 * @param {callSchedulerCancelCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - Id of the Answers queue the call will enter
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerCancelCallbackRequestParams>} LogObject<callSchedulerCancelCallbackRequestParams>
 */
export function callSchedulerCancelCallbackRequest(params) {
    return { evid: 610, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerKeepCallbackScheduled' event (evid: 611)
 *
 * Event description: User decides not to cancel their callback request by pressing "No, Keep It Scheduled" or by exiting out of the cancel window.
 *
 * @param {callSchedulerKeepCallbackScheduledParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerKeepCallbackScheduledParams>} LogObject<callSchedulerKeepCallbackScheduledParams>
 */
export function callSchedulerKeepCallbackScheduled(params) {
    return { evid: 611, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerAddToYourCalendar' event (evid: 612)
 *
 * Event description: User clicks the button to add the scheduled callback to their calendar.
 *
 * @param {callSchedulerAddToYourCalendarParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerAddToYourCalendarParams>} LogObject<callSchedulerAddToYourCalendarParams>
 */
export function callSchedulerAddToYourCalendar(params) {
    return { evid: 612, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackFailure' event (evid: 621)
 *
 * Event description: User failed to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackFailureParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackFailureParams>} LogObject<callSchedulerScheduledCallbackFailureParams>
 */
export function callSchedulerScheduledCallbackFailure(params) {
    return { evid: 621, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callSchedulerLoadScheduleACallbackPage' event (evid: 622)
 *
 * Event description: Loading the “Schedule a Callback" page
 *
 * @param {callSchedulerLoadScheduleACallbackPageParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerLoadScheduleACallbackPageParams>} LogObject<callSchedulerLoadScheduleACallbackPageParams>
 */
export function callSchedulerLoadScheduleACallbackPage(params) {
    return { evid: 622, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnFeaturedArticleInHeaderHelpWidget' event (evid: 623)
 *
 * Event description: Events when clicking an article from the Featured Article section in 'my site' help widget .
 *
 * @param {clickOnFeaturedArticleInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} item_id - Article ID
 * @property {number} feature_article_position - index of the featured article clicked
 * @property {string} source_name - widget name
 * @property {string} lang - Article language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>} LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>
 */
export function clickOnFeaturedArticleInHeaderHelpWidget(params) {
    return { evid: 623, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewFeaturedArticlesInHeaderHelpWidget' event (evid: 624)
 *
 * Event description: View event when opening the 'my site' help widget .
 *
 * @param {viewFeaturedArticlesInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} source_name - widget name
 * @property {string} featured_articles_item_ids - Article IDs  for the featured article listed in the widget (1st position, 2nd position, 3rd position)
 * @property {string} featured_articles_lang - Article language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>} LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>
 */
export function viewFeaturedArticlesInHeaderHelpWidget(params) {
    return { evid: 624, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotUpdateBiProfileField' event (evid: 625)
 *
 * Event description: Save user information from Chatbot to BI Profile
 *
 * @param {chatbotUpdateBiProfileFieldParams} params - The parameters for this event
 * @property {string} node_name - Chatbot node name
 * @property {string} node_id - Chatbot node ID
 * @property {string} key - Field in BI profile
 * @property {string} conversation_id - conversation_id
 * @property {string} value - Value to store from BI profile
 * @property {string} action - add/remove
 * @return {LogObject<chatbotUpdateBiProfileFieldParams>} LogObject<chatbotUpdateBiProfileFieldParams>
 */
export function chatbotUpdateBiProfileField(params) {
    return { evid: 625, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixWidgetOpenAWidgetClient' event (evid: 662)
 *
 * Event description: The event is trigger when a widget of other tenants is opened (not Customer Care)
 *
 * @param {wixWidgetOpenAWidgetClientParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - where the widget is opened from (source page url)
 * @property {string} parent_name - parent_name
 * @property {string} current_platform - current_platform - where that chat is opened from currently { Editor, Biz manager, Domain page .... }
 * @property {string} source_name - source name
 * @property {string} module_name - first used module (home, chat, contact form, etc)
 * @property {string} lang - answer lang
 * @property {string} open_method - open method (api (automatically),click (user click),agent)
 * @property {string} parent_url - parent_url
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixWidgetOpenAWidgetClientParams>} LogObject<wixWidgetOpenAWidgetClientParams>
 */
export function wixWidgetOpenAWidgetClient(params) {
    return { evid: 662, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openIms' event (evid: 7002)
 *
 * Event description: when an agent clicks to open the IMS window
 *
 * @param {openImsParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} entry_point - how did the user got there. wixanswers/nudge_window
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<openImsParams>} LogObject<openImsParams>
 */
export function openIms(params) {
    return { evid: 7002, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textSearchClicked' event (evid: 7003)
 *
 * Event description: when an agent clicks on the free text search in the IMS
 *
 * @param {textSearchClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {GUID} subcategory_id - the id of the subcategory when clicking on text search bar, null if not selected yet
 * @property {GUID} product_id - the id of the product when clicking on text search bar, null if not selected yet
 * @property {string} category_id - the id of the category when clicking on text search bar, null if not selected yet
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<textSearchClickedParams>} LogObject<textSearchClickedParams>
 */
export function textSearchClicked(params) {
    return { evid: 7003, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterByClicked' event (evid: 7004)
 *
 * Event description: when an agent clicks on one of the filters. can be by product/ by category / by subcategory
 *
 * @param {filterByClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {GUID} subcategory_id - the id of the subcategory, null if not selected yet
 * @property {GUID} product_id - the id of the product when clicking, null if not selected yet
 * @property {string} category_id - the id of the category, null if not selected yet
 * @property {string} filterby_type - product/category/subcategory
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<filterByClickedParams>} LogObject<filterByClickedParams>
 */
export function filterByClicked(params) {
    return { evid: 7004, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectFilter' event (evid: 7005)
 *
 * Event description: when an agent clicks to select a filter from dropdown list. can be by product/ category / subcategory
 *
 * @param {selectFilterParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} category_name - the name of the category if the filter was by category
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} subcategory_name - the name of the subcategory if the filter was by subcategory
 * @property {string} product_name - the name of the product
 * @property {GUID} product_id - the id of the product
 * @property {string} filterby_type - product/category/subcategory
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<selectFilterParams>} LogObject<selectFilterParams>
 */
export function selectFilter(params) {
    return { evid: 7005, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emptyResultsReturned' event (evid: 7006)
 *
 * Event description: when the search results in the IMS are loaded with empty results
 *
 * @param {emptyResultsReturnedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the category
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} search_source - IMS/BO
 * @property {string} subcategory_name - the name of the subcategory
 * @property {GUID} subcategory_id - the id of the subcategory
 * @property {string} issue_id - the id of the marked issue
 * @property {GUID} search_guid - id of the search results
 * @property {string} product_name - the name of the product
 * @property {GUID} product_id - the id of the product
 * @property {string} category_id - the id of the category
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<emptyResultsReturnedParams>} LogObject<emptyResultsReturnedParams>
 */
export function emptyResultsReturned(params) {
    return { evid: 7006, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchResultsShown' event (evid: 7007)
 *
 * Event description: search results shown to the user in the IMS
 *
 * @param {searchResultsShownParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} search_source - IMS/BO
 * @property {GUID} subcategory_id - the id of the subcategory
 * @property {GUID} search_guid - the id of the search results
 * @property {string} search_term - search term
 * @property {GUID} product_id - the id of the product
 * @property {string} category_id - the id of the category
 * @property {GUID} agent_id - the guid of the agent
 * @property {string} issues_ids - list of issues ids shown to the user
 * @return {LogObject<searchResultsShownParams>} LogObject<searchResultsShownParams>
 */
export function searchResultsShown(params) {
    return { evid: 7007, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketOrUserReplyCreated' event (evid: 701)
 *
 * Event description: A UGC (ticket or user's reply) was created in Wix's tennant. This event is only for Real Time and is not stored (only collected).
 *
 * @param {ticketOrUserReplyCreatedParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} item_id - item_id
 * @property {GUID} uuid - uuid
 * @property {GUID} gsi - session_id
 * @property {string} user_agent - user_agent
 * @property {string} source_name - source_name
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} type - type
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<ticketOrUserReplyCreatedParams>} LogObject<ticketOrUserReplyCreatedParams>
 */
export function ticketOrUserReplyCreated(params) {
    return { evid: 701, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnIssue' event (evid: 7010)
 *
 * Event description: when an agent clicks on an issue from the search results
 *
 * @param {clickOnIssueParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} concern_name - the value of the concern allocated to the issue selected
 * @property {GUID} concern_id - the id of the concern allocated to the issue selected
 * @property {string} symptom_value - the value of the symptom allocated to the issue selected
 * @property {string} last_text_search - the free text search value when clicking on an issue
 * @property {string} category_name - the name of the category
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} subcategory_name - the name of the subcategory
 * @property {GUID} subcategory_id - the id of the subcategory
 * @property {boolean} is_uncheck - was the click to select an issue or to uncheck selected issue
 * @property {GUID} search_guid - the id of the search results
 * @property {number} search_results_rank - the rank of the issue selected in the search results
 * @property {string} cause_name - the value of the cause allocated to the issue selected
 * @property {string} product_name - the name of the product
 * @property {number} num_showing_results - the number of search results shown when selecting the issue
 * @property {GUID} product_id - the id of the product
 * @property {string} category_id - the id of the category
 * @property {GUID} symptom_id - the id of the symptom allocated to the issue selected
 * @property {string} item_type - the type of the item clicked on (concern/symptom/cause)
 * @property {GUID} agent_id - the guid of the agent
 * @property {GUID} cause_id - the id of the cause allocated to the issue selected
 * @return {LogObject<clickOnIssueParams>} LogObject<clickOnIssueParams>
 */
export function clickOnIssue(params) {
    return { evid: 7010, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'finishClicked' event (evid: 7011)
 *
 * Event description: when a customer care agent clicks on finish in the IMS after selecting an issue
 *
 * @param {finishClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} concern_name - the value of the concern allocated to the issue selected
 * @property {GUID} concern_id - the id of the concern allocated to the issue selected
 * @property {string} symptom_value - the value of the symptom allocated to the issue selected
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the category
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} subcategory_name - the name of the subcategory
 * @property {GUID} subcategory_id - the id of the subcategory
 * @property {string} issue_id - the id of the marked issue
 * @property {GUID} search_guid - the id of the search results
 * @property {number} search_results_rank - the rank of the issue selected in the search results
 * @property {string} cause_name - the value of the cause allocated to the issue selected
 * @property {string} product_name - the name of the product
 * @property {number} num_showing_results - the number of search results shown when selecting the issue
 * @property {GUID} product_id - the id of the product
 * @property {boolean} is_exist - DEPRECATED- is the issue already linked to the ticket
 * @property {string} category_id - the id of the category
 * @property {GUID} symptom_id - the id of the symptom allocated to the issue selected
 * @property {GUID} agent_id - the guid of the agent
 * @property {GUID} cause_id - the id of the cause allocated to the issue selected
 * @return {LogObject<finishClickedParams>} LogObject<finishClickedParams>
 */
export function finishClicked(params) {
    return { evid: 7011, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeIms' event (evid: 7012)
 *
 * Event description: when clicking to close the IMS window using the X
 *
 * @param {closeImsParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when closing the window
 * @property {string} category_name - the name of the last category when closing the IMS
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} subcategory_name - the name of the last subcategory when closing the IMS
 * @property {GUID} subcategory_id - the id of the last subcategory when closing the IMS
 * @property {string} product_name - the name of the last product when closing the IMS
 * @property {GUID} product_id - the id of the last product when closing the IMS
 * @property {string} category_id - the id of the last category when closing the IMS
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<closeImsParams>} LogObject<closeImsParams>
 */
export function closeIms(params) {
    return { evid: 7012, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listenToRecordedCallSrc4Evid702' event (evid: 702)
 *
 * Event description: recorded call is being listened to by a user in Answers
 *
 * @param {listenToRecordedCallSrc4Evid702Params} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {GUID} uuid - the user who listened to the call
 * @property {GUID} answers_uuid - user id in answers users
 * @property {string} lang - answers languages
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<listenToRecordedCallSrc4Evid702Params>} LogObject<listenToRecordedCallSrc4Evid702Params>
 */
export function listenToRecordedCallSrc4Evid702(params) {
    return { evid: 702, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestSomethingMissingOpened' event (evid: 7021)
 *
 * Event description: when clicking to Suggest Something Missing from the IMS window (after 3dot menu) or from nudge window
 *
 * @param {suggestSomethingMissingOpenedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the last category when closing the IMS
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} subcategory_name - the name of the last subcategory when closing the IMS
 * @property {GUID} subcategory_id - the id of the last subcategory when closing the IMS
 * @property {string} product_name - the name of the last product when closing the IMS
 * @property {string} entry_point - how did the user got there. ims/nudge_window
 * @property {GUID} product_id - the id of the last product when closing the IMS
 * @property {string} category_id - the id of the last category when closing the IMS
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestSomethingMissingOpenedParams>} LogObject<suggestSomethingMissingOpenedParams>
 */
export function suggestSomethingMissingOpened(params) {
    return { evid: 7021, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestMissingClicked' event (evid: 7022)
 *
 * Event description: when clicking to suggest a missing entity from the "missing something" window. it can be be clicking on suggest issue, feature or bug
 *
 * @param {suggestMissingClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the last category when closing the IMS
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} entity_type - issue/feature/bug
 * @property {string} subcategory_name - the name of the last subcategory when closing the IMS
 * @property {GUID} subcategory_id - the id of the last subcategory when closing the IMS
 * @property {string} product_name - the name of the last product when closing the IMS
 * @property {GUID} product_id - the id of the last product when closing the IMS
 * @property {string} category_id - the id of the last category when closing the IMS
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestMissingClickedParams>} LogObject<suggestMissingClickedParams>
 */
export function suggestMissingClicked(params) {
    return { evid: 7022, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestMissingIssueSubmitted' event (evid: 7023)
 *
 * Event description: when clicking to submit a suggested missing issue
 *
 * @param {suggestMissingIssueSubmittedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the last category when closing the IMS
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} suggested_issue_text - the content of the suggested issue
 * @property {string} subcategory_name - the name of the last subcategory when closing the IMS
 * @property {GUID} subcategory_id - the id of the last subcategory when closing the IMS
 * @property {string} product_name - the name of the last product when closing the IMS
 * @property {GUID} product_id - the id of the last product when closing the IMS
 * @property {string} category_id - the id of the last category when closing the IMS
 * @property {string} suggested_issue_product - the product of the suggested issue
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestMissingIssueSubmittedParams>} LogObject<suggestMissingIssueSubmittedParams>
 */
export function suggestMissingIssueSubmitted(params) {
    return { evid: 7023, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestMissingFeatureSubmitted' event (evid: 7025)
 *
 * Event description: when clicking to submit a suggested missing feature
 *
 * @param {suggestMissingFeatureSubmittedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} last_text_search - the free text search value when clicking to select an issue
 * @property {string} category_name - the name of the last category when closing the IMS
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} suggested_feature_product - the product of the suggested feature
 * @property {string} subcategory_name - the name of the last subcategory when closing the IMS
 * @property {GUID} subcategory_id - the id of the last subcategory when closing the IMS
 * @property {string} product_name - the name of the last product when closing the IMS
 * @property {GUID} product_id - the id of the last product when closing the IMS
 * @property {string} category_id - the id of the last category when closing the IMS
 * @property {string} suggested_feature_text - the content of the suggested feature
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestMissingFeatureSubmittedParams>} LogObject<suggestMissingFeatureSubmittedParams>
 */
export function suggestMissingFeatureSubmitted(params) {
    return { evid: 7025, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appClickOnScreenshareFromACallTicket' event (evid: 703)
 *
 * Event description: Agent clicks on the link inside the ticket's custom fields in order to record the user's screen realtime during a call
 *
 * @param {appClickOnScreenshareFromACallTicketParams} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {GUID} customer_uuid - Caller uuid
 * @property {GUID} callid - the call id
 * @property {string} lang - answers languages
 * @property {GUID} agent_uuid - the agent who clicked on the recording link
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<appClickOnScreenshareFromACallTicketParams>} LogObject<appClickOnScreenshareFromACallTicketParams>
 */
export function appClickOnScreenshareFromACallTicket(params) {
    return { evid: 703, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'issuesWindowOpened' event (evid: 7030)
 *
 * Event description: when the issues window is opened in wix answers, either automatically after tagging an issue or manually by clicking to open
 *
 * @param {issuesWindowOpenedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - uuid
 * @property {string} open_method - how was it opened, after_click/after_tagging
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<issuesWindowOpenedParams>} LogObject<issuesWindowOpenedParams>
 */
export function issuesWindowOpened(params) {
    return { evid: 7030, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewSolutionClicked' event (evid: 7031)
 *
 * Event description: when an agent click to view the article through the issues window
 *
 * @param {viewSolutionClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {string} solution_type - kb/internal/other...
 * @property {string} solution_language - the language code of the solution
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<viewSolutionClickedParams>} LogObject<viewSolutionClickedParams>
 */
export function viewSolutionClicked(params) {
    return { evid: 7031, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addSolutionContentClicked' event (evid: 7032)
 *
 * Event description: when an agent click to add the solution's content to the reply through the issues window
 *
 * @param {addSolutionContentClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {string} solution_type - kb/internal/other
 * @property {string} solution_language - the language code of the solution
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<addSolutionContentClickedParams>} LogObject<addSolutionContentClickedParams>
 */
export function addSolutionContentClicked(params) {
    return { evid: 7032, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addSolutionLinkClicked' event (evid: 7033)
 *
 * Event description: when an agent click to add the solution's link to the reply through the issues window
 *
 * @param {addSolutionLinkClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {string} solution_type - kb/internal/other
 * @property {string} solution_language - the language code of the solution
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<addSolutionLinkClickedParams>} LogObject<addSolutionLinkClickedParams>
 */
export function addSolutionLinkClicked(params) {
    return { evid: 7033, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'linkSolutionClicked' event (evid: 7034)
 *
 * Event description: when an agent click to link the solution to the reply through the issues window
 *
 * @param {linkSolutionClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {string} solution_type - kb/internal/other
 * @property {string} solution_language - the language code of the solution
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<linkSolutionClickedParams>} LogObject<linkSolutionClickedParams>
 */
export function linkSolutionClicked(params) {
    return { evid: 7034, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewIssueClicked' event (evid: 7035)
 *
 * Event description: when an agent click to view a tagged issue from the issues window in wix answers
 *
 * @param {viewIssueClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<viewIssueClickedParams>} LogObject<viewIssueClickedParams>
 */
export function viewIssueClicked(params) {
    return { evid: 7035, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dotIssueMenuClicked' event (evid: 7036)
 *
 * Event description: when an agent click the 3dots menu for a tagged issue from the issues window in wix answers
 *
 * @param {dotIssueMenuClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<dotIssueMenuClickedParams>} LogObject<dotIssueMenuClickedParams>
 */
export function dotIssueMenuClicked(params) {
    return { evid: 7036, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteIssueFromTicket' event (evid: 7037)
 *
 * Event description: when an agent click to delete an issue from a ticket through the issues window (after 3dot menu clicked)
 *
 * @param {deleteIssueFromTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<deleteIssueFromTicketParams>} LogObject<deleteIssueFromTicketParams>
 */
export function deleteIssueFromTicket(params) {
    return { evid: 7037, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestMissingSolutionClicked' event (evid: 7038)
 *
 * Event description: when an agent click to suggest missing solution/article after tagging an issue
 *
 * @param {suggestMissingSolutionClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestMissingSolutionClickedParams>} LogObject<suggestMissingSolutionClickedParams>
 */
export function suggestMissingSolutionClicked(params) {
    return { evid: 7038, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'suggestMissingSolutionSubmitted' event (evid: 7039)
 *
 * Event description: when an agent click to submit a suggested missing solution/article after tagging an issue
 *
 * @param {suggestMissingSolutionSubmittedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue tagged and opened in the issue window
 * @property {GUID} product_id - the id of the product
 * @property {string} suggested_solution_text - the content of the submitted suggestion
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<suggestMissingSolutionSubmittedParams>} LogObject<suggestMissingSolutionSubmittedParams>
 */
export function suggestMissingSolutionSubmitted(params) {
    return { evid: 7039, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'screenshareLinkWasEnabledForACallLabelEvent' event (evid: 704)
 *
 * Event description: Screenshare link option is enabled or disabled for a specific call --> meaning - this call is assigned to an AB test group A or B
 *
 * @param {screenshareLinkWasEnabledForACallLabelEventParams} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {string} label_name - {A - no link was added ,B - the link was added}
 * @property {GUID} customer_uuid - Caller uuid
 * @property {GUID} callid - the call id
 * @property {string} lang - answers languages
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<screenshareLinkWasEnabledForACallLabelEventParams>} LogObject<screenshareLinkWasEnabledForACallLabelEventParams>
 */
export function screenshareLinkWasEnabledForACallLabelEvent(params) {
    return { evid: 704, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'nudgeTaggingWindowShown' event (evid: 7040)
 *
 * Event description: when the nudge window is opened and shown to the agent. It is a reminder that the agent hasn't tagged an issue
 *
 * @param {nudgeTaggingWindowShownParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<nudgeTaggingWindowShownParams>} LogObject<nudgeTaggingWindowShownParams>
 */
export function nudgeTaggingWindowShown(params) {
    return { evid: 7040, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'skipTagging' event (evid: 7041)
 *
 * Event description: when an agent choose to skip tagging after the nudge window
 *
 * @param {skipTaggingParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} skipping_reason - the reason for skipping tagging an issue
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<skipTaggingParams>} LogObject<skipTaggingParams>
 */
export function skipTagging(params) {
    return { evid: 7041, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'abTestConductionCheckEvent' event (evid: 705)
 *
 * Event description: Checking perti conduction value assigned to the user
 *
 * @param {abTestConductionCheckEventParams} params - The parameters for this event
 * @property {string} petri_conduciton_value - raw label value from Petri
 * @property {boolean} is_b - checking if petri_conduciton_value = b
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<abTestConductionCheckEventParams>} LogObject<abTestConductionCheckEventParams>
 */
export function abTestConductionCheckEvent(params) {
    return { evid: 705, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsLinkIssuePopUpShown' event (evid: 7050)
 *
 * Event description: part of an IMS experiment. when a pop-up opens after linking an article and displayed to the expert.
 *
 * @param {imsLinkIssuePopUpShownParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {boolean} is_related_issues - True- if there are related issues, False- if pop-up shows "no related issues"
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} solution_type - kb/internal/other
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<imsLinkIssuePopUpShownParams>} LogObject<imsLinkIssuePopUpShownParams>
 */
export function imsLinkIssuePopUpShown(params) {
    return { evid: 7050, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsClickLinkIssueFromPopUp' event (evid: 7051)
 *
 * Event description: part of an IMS experiment. when a pop-up opens after linking an article and the expert click to link an issue
 *
 * @param {imsClickLinkIssueFromPopUpParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} solution_type - kb/internal/other
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<imsClickLinkIssueFromPopUpParams>} LogObject<imsClickLinkIssueFromPopUpParams>
 */
export function imsClickLinkIssueFromPopUp(params) {
    return { evid: 7051, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsExitFilteredView' event (evid: 7052)
 *
 * Event description: part of an IMS experiment. when an expert clicks to exit filtered by article view.
 *
 * @param {imsExitFilteredViewParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other) that filter the view according to
 * @property {string} solution_type - kb/internal/other
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<imsExitFilteredViewParams>} LogObject<imsExitFilteredViewParams>
 */
export function imsExitFilteredView(params) {
    return { evid: 7052, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsClickRelatedIssuesFromArticlesMenu' event (evid: 7053)
 *
 * Event description: part of an IMS experiment. when an expert click on related issues on an article
 *
 * @param {imsClickRelatedIssuesFromArticlesMenuParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} solution_id - the id of the solution (article id or other)
 * @property {string} entry_point - the "related button" location linked_articles/IMS
 * @property {string} solution_type - kb/internal/other
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<imsClickRelatedIssuesFromArticlesMenuParams>} LogObject<imsClickRelatedIssuesFromArticlesMenuParams>
 */
export function imsClickRelatedIssuesFromArticlesMenu(params) {
    return { evid: 7053, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsQcButtonClicked' event (evid: 7054)
 *
 * Event description: when an agent click to review if a linked issue is correct or not
 *
 * @param {imsQcButtonClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} issue_code - the code of the issue linked and opened to review
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} linked_issue_qc - correct/incorrect
 * @property {string} issue_id - the id of the issue linked and opened to review
 * @property {GUID} agent_id - the answers id of the agent who clicked on the QC button
 * @return {LogObject<imsQcButtonClickedParams>} LogObject<imsQcButtonClickedParams>
 */
export function imsQcButtonClicked(params) {
    return { evid: 7054, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imsQcButtonForMissingEntitiesClicked' event (evid: 7055)
 *
 * Event description: when an agent click to review if a missing entity is correct or not is correct or not
 *
 * @param {imsQcButtonForMissingEntitiesClickedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} entity_qc_result - correct/incorrect
 * @property {string} missing_entity_type - the type of the missing entity that was reviewed (MISSING_ISSUE/FEATURE/ARTICLE/BUG)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {GUID} missing_entity_id - the id of the missing entity that was reviewed
 * @property {GUID} agent_id - the answers id of the agent who clicked on the QC button
 * @return {LogObject<imsQcButtonForMissingEntitiesClickedParams>} LogObject<imsQcButtonForMissingEntitiesClickedParams>
 */
export function imsQcButtonForMissingEntitiesClicked(params) {
    return { evid: 7055, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agentDeclinesCall' event (evid: 706)
 *
 * Event description: Agent clicks the decline button of a call reserve attempt
 *
 * @param {agentDeclinesCallParams} params - The parameters for this event
 * @property {GUID} tenant_id - ID of the answers tenant
 * @property {GUID} call_id - The ID of the declined call
 * @property {GUID} agent_id - The performing agent ID
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<agentDeclinesCallParams>} LogObject<agentDeclinesCallParams>
 */
export function agentDeclinesCall(params) {
    return { evid: 706, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'issueAlreadyExists' event (evid: 7103)
 *
 * Event description: when trying to link an issue to a ticket but the issue already linked to that ticket
 *
 * @param {issueAlreadyExistsParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue being tagged
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<issueAlreadyExistsParams>} LogObject<issueAlreadyExistsParams>
 */
export function issueAlreadyExists(params) {
    return { evid: 7103, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'issueTagged' event (evid: 7104)
 *
 * Event description: when an issue is being tagged to a ticket
 *
 * @param {issueTaggedParams} params - The parameters for this event
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {GUID} uuid - wix uuid of the agent
 * @property {string} issue_id - the id of the issue being tagged
 * @property {GUID} agent_id - the guid of the agent
 * @return {LogObject<issueTaggedParams>} LogObject<issueTaggedParams>
 */
export function issueTagged(params) {
    return { evid: 7104, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketCreated' event (evid: 7200)
 *
 * Event description: Accounts Entry Point -  Ticket Created via API Success.
 *
 * @param {ticketCreatedParams} params - The parameters for this event
 * @property {GUID} topic_callback_queue_id - The assigned callback queue of the topic
 * @property {GUID} parent_account_id - The parent account on behalf of the sub account
 * @property {GUID} channel_user_id - The uuid of the user in the channel/partner
 * @property {string} topic_name - The name of the topic
 * @property {GUID} topic_callback_line_id - The assigned callback line of the topic
 * @property {GUID} support_platform_ticket_id - support_platform_ticket_id
 * @property {GUID} topic_post_group_id - The assigned post group of the topic
 * @property {string} ticket_type - The type of the ticket (for example - CallbackRequest)
 * @property {GUID} user_id - The uuid of the user
 * @property {GUID} topic_id - The uuid of the topic
 * @property {GUID} account_id - The associated Wix account of the user
 * @property {string} topic_language_code - The topic configured language code
 * @property {GUID} topic_skill_id - The expert skill that he is connected to it.
 * @property {boolean} is_anonymous_to_wix - is_anonymous_to_wix
 * @property {GUID} support_platform_user_id - The user id in the support platform (e.g. Answers)
 * @property {boolean} is_anonymous_to_channel - Indicates if the user is anonymous to the channel
 * @return {LogObject<ticketCreatedParams>} LogObject<ticketCreatedParams>
 */
export function ticketCreated(params) {
    return { evid: 7200, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'failedToCreateTicket' event (evid: 7201)
 *
 * Event description: When the API fails to create a ticket/requestCallback/etc on behalf of the user.
 *
 * @param {failedToCreateTicketParams} params - The parameters for this event
 * @property {GUID} topic_callback_queue_id - The assigned callback queue of the topic
 * @property {GUID} parent_account_id - The uuid of the account on behalf
 * @property {GUID} channel_user_id - The user uuid in the channel/partner platform
 * @property {string} failure_reason - The reason of the failure
 * @property {string} topic_name - The name of the topic
 * @property {GUID} topic_callback_line_id - The assigned callback line of the topic
 * @property {GUID} topic_post_group_id - The assigned post group of the topic
 * @property {string} error_metadata - Additional meta data info that might be helpful
 * @property {string} ticket_type - The type of the ticket/action (e.g. request callback)
 * @property {GUID} user_id - The Wix user uuid
 * @property {GUID} topic_id - The uuid of the topic
 * @property {GUID} account_id - The associated (wix) account of the user
 * @property {string} topic_language_code - The language code of the topic
 * @property {GUID} topic_skill_id - The expert skill that he is connected to it.
 * @property {boolean} is_anonymous_to_wix - is_anonymous_to_wix
 * @property {GUID} support_platform_user_id - The user id in the support platform (e.g. Answers)
 * @property {boolean} is_anonymous_to_channel - Indicates if the user is anonymous to the channel/partner
 * @return {LogObject<failedToCreateTicketParams>} LogObject<failedToCreateTicketParams>
 */
export function failedToCreateTicket(params) {
    return { evid: 7201, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createTicketAttempt' event (evid: 7202)
 *
 * Event description: Accounts Entry Point - Create Ticket via API Attempt.
 *
 * @param {createTicketAttemptParams} params - The parameters for this event
 * @property {GUID} parent_account_id - parent_account_id
 * @property {GUID} channel_user_id - The user uuid in the channel/partner platform
 * @property {string} ticket_type - ticket_type
 * @property {GUID} user_id - uuid
 * @property {GUID} topic_id - topic_id
 * @property {GUID} account_id - account_id
 * @property {GUID} topic_skill_id - The expert skill that he is connected to it.
 * @property {boolean} is_anonymous_to_wix - is_anonymous_to_wix
 * @property {boolean} is_anonymous_to_channel - is_anonymous_to_channel
 * @return {LogObject<createTicketAttemptParams>} LogObject<createTicketAttemptParams>
 */
export function createTicketAttempt(params) {
    return { evid: 7202, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'jiraDisconnected' event (evid: 7302)
 *
 * Event description: Disconnection event to when a Jira is disconnected
 *
 * @param {jiraDisconnectedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID received from Answers
 * @property {string} agentEmail - Wix Answers Agent email
 * @property {string} jiraKey - Jira Key connected to the ticket
 * @return {LogObject<jiraDisconnectedParams>} LogObject<jiraDisconnectedParams>
 */
export function jiraDisconnected(params) {
    return { evid: 7302, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'jiraConnected' event (evid: 7303)
 *
 * Event description: Jira connector events
 *
 * @param {jiraConnectedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID received from Answers
 * @property {string} agentEmail - Wix Answers Agent email
 * @property {GUID} userGuid - UUID of the user who contacted support
 * @property {string} jiraTicket - Jira Key connected to the ticket
 * @property {GUID} msid - MSID of chosen site
 * @return {LogObject<jiraConnectedParams>} LogObject<jiraConnectedParams>
 */
export function jiraConnected(params) {
    return { evid: 7303, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'compensationApplied' event (evid: 7304)
 *
 * Event description: Compensation applied from the compensation app, and a note was added in the User Manager backoffice
 *
 * @param {compensationAppliedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID received from Answers
 * @property {string} refundCurrency - Currency code of refund
 * @property {string} agentEmail - Wix Answers Agent email that applied the extension
 * @property {string} extensionReason - Reason for the given extension
 * @property {GUID} userGuid - UUID of the user that contacted support
 * @property {number} monthsAdded - Amount of months added to the premium plan
 * @property {string} compensationType - Type of compensation given to user, can be 'refund' or 'extension'
 * @property {string} jiraTicket - Jira Key connected to the ticket
 * @property {GUID} msid - MSID of the site that the plan was extended on
 * @property {string} refundAmountString - Amount of refund
 * @return {LogObject<compensationAppliedParams>} LogObject<compensationAppliedParams>
 */
export function compensationApplied(params) {
    return { evid: 7304, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotSendMessageSrc4Evid7400' event (evid: 7400)
 *
 * Event description: Triggers when a user sends a message or an attachment in a chatbot conversation
 *
 * @param {chatbotSendMessageSrc4Evid7400Params} params - The parameters for this event
 * @property {string} attached_files - The name and type of the files {{file_name: ,file_type:, file_size:}, {},..}
 * @property {number} number_of_files - The number of attached files
 * @property {string} attaching_method - The type of method the user used to upload the files - drag and drop, copy paste, button click {method_name:number of files, ..}
 * @property {string} conversation_id - ID of the conversation
 * @property {string} session_id - Widget session ID
 * @property {string} node_id - node_id
 * @property {string} node_name - node_name
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_type_id - ID of node_type
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} parent_url - The url where the user sees the widget
 * @property {string} referral - The string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} main_option_id - ID for the category the user clicked
 * @property {string} user_intent - Iissue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} intent_id - ID of the user_intent
 * @property {string} ai_user_intent - The user intent that was recognized by the AI Chatbot
 * @property {string} ai_user_intent_type - The user intent type that was recognized by the AI Chatbot
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} send_action_type - The type of action the user takes to send the message (e.g., clicking a button or pressing 'Enter')
 * @property {string} button_id - The button_id of the button that the user pressed to send the message.
 * @return {LogObject<chatbotSendMessageSrc4Evid7400Params>} LogObject<chatbotSendMessageSrc4Evid7400Params>
 */
export function chatbotSendMessageSrc4Evid7400(params) {
    return { evid: 7400, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'chatbotErrorMessageAppearsSrc4Evid7401' event (evid: 7401)
 *
 * Event description: Triggers when a user encounters an error while attempting to attach a file
 *
 * @param {chatbotErrorMessageAppearsSrc4Evid7401Params} params - The parameters for this event
 * @property {string} attached_files - The name and type of the files {{file_name: ,file_type:, file_size:}, {},..}
 * @property {number} number_of_files - The number of attached files
 * @property {string} attaching_method - The type of method the user used to upload the files - drag and drop, copy paste, button click {method_name:number of files, ..}
 * @property {string} conversation_id - ID of the conversation
 * @property {string} session_id - Widget session ID
 * @property {string} node_id - node_id
 * @property {string} node_name - node_name
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_type_id - ID of node_type
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} parent_url - The url where the user sees the widget
 * @property {string} referral - The string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} main_option_id - ID for the category the user clicked
 * @property {string} user_intent - Iissue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} intent_id - ID of the user_intent
 * @property {string} ai_user_intent - The user intent that was recognized by the AI Chatbot
 * @property {string} ai_user_intent_type - The user intent type that was recognized by the AI Chatbot
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} error_type - An array of the error types per file {{file_name:, error_type:},{}}
 * @property {string} invalid_files - List of invalid files that triggered an error upon attachment
 * @property {number} number_of_invalid_files - Number of invalid files that triggered an error upon attachment
 * @property {string} invalid_files_attaching_method - The type of method the user used to attached the invalid files - drag and drop, copy paste, button click {method_name:number of files, ..}
 * @return {LogObject<chatbotErrorMessageAppearsSrc4Evid7401Params>} LogObject<chatbotErrorMessageAppearsSrc4Evid7401Params>
 */
export function chatbotErrorMessageAppearsSrc4Evid7401(params) {
    return { evid: 7401, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'knowledgeAgentApiRequestReturnSuccessfullySrc4Evid75' event (evid: 75)
 *
 * Event description: Fire when the Retrieval mechanism of the Knowledge Agent response successfully to API call
 *
 * @param {knowledgeAgentApiRequestReturnSuccessfullySrc4Evid75Params} params - The parameters for this event
 * @property {string} input_text - the input text which was provided by the client (chatbot conversation, search term)
 * @property {string} artifact_name - The artifact of the platform/product that sent the API call {chatbot, Help Center}
 * @property {string} minimum_returned_distance - The lowest distnce out of all the items that were returned (if no items returned than NULL)
 * @property {string} maximum_returned_distance - The highest distnce out of all the items that were returned (if no items returned than NULL)
 * @property {number} number_of_returned_items - The number of returned items (if no items returned than 0, if return API failed than NULL)
 * @property {string} number_of_returned_items_by_type - {Total documents found: 60 AnswersArticles: 50 WixDocs: 10}
 * @property {number} number_of_requested_items - The number of requested items
 * @property {string} requested_language - The requested language of articles to be returned
 * @property {string} requested_content_type - The type of content requested via the API (e.g., only WixDocs or only AnswersArticles)
 * @property {boolean} used_ranker - Was the ranker being used in the retrival
 * @property {string} used_filters - JSON with list of all filter types and values that requested and used when returning the results
 * @return {LogObject<knowledgeAgentApiRequestReturnSuccessfullySrc4Evid75Params>} LogObject<knowledgeAgentApiRequestReturnSuccessfullySrc4Evid75Params>
 */
export function knowledgeAgentApiRequestReturnSuccessfullySrc4Evid75(params) {
    return { evid: 75, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportArticleClicked' event (evid: 7501)
 *
 * Event description: Support Article Clicked.
 *
 * @param {supportArticleClickedParams} params - The parameters for this event
 * @property {string} categoryId - category_id
 * @property {string} relatedCompanyName - related_company_name
 * @property {string} articleUrl - Url of the article that from wix-answers
 * @property {string} clickDateTime - Date and time of the click by the agent
 * @property {string} articleTitle - Title of the clicked article
 * @return {LogObject<supportArticleClickedParams>} LogObject<supportArticleClickedParams>
 */
export function supportArticleClicked(params) {
    return { evid: 7501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'extensionClicked' event (evid: 7502)
 *
 * Event description: Event that is fired when the extension is clicked, includes:
 * 1. The location of the extension (dashboard or editor)
 * 2. what component is the current agent is on or the current location in the dashboard.
 * 3. time and date in which the event was fired.
 *
 * @param {extensionClickedParams} params - The parameters for this event
 * @property {string} escalationQueue - The escalation queue that is related to the current Component or Location
 * @property {string} targetMetaSiteId - target meta site id to be debugged
 * @property {string} current_location - The current location of the agent (dashboard or editor)
 * @property {string} component - The current component type that the agent is clicking on
 * @return {LogObject<extensionClickedParams>} LogObject<extensionClickedParams>
 */
export function extensionClicked(params) {
    return { evid: 7502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsService' event (evid: 7700000)
 *
 * Event description: Error flow, when we failed to find success param from Success Params Service for data which we are passing as value to Rankings combinations.
 *
 * @param {uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams} params - The parameters for this event
 * @property {string} issues - The list of fields and their values with the issue and the reason
 * @return {LogObject<uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams>} LogObject<uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsServiceParams>
 */
export function uspSuggestionServiceFailedToMapRankingDataOnDataRetrievedFromSuccessParamsService(params) {
    return { evid: 7700000, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userCarePriorityDataApiRequest' event (evid: 7700101)
 *
 * Event description: Fire when a client makes an API request to Customer Care squad 5 to get user's care priority data
 *
 * @param {userCarePriorityDataApiRequestParams} params - The parameters for this event
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} api_client - {chatbot,kb,answers}
 * @return {LogObject<userCarePriorityDataApiRequestParams>} LogObject<userCarePriorityDataApiRequestParams>
 */
export function userCarePriorityDataApiRequest(params) {
    return { evid: 7700101, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userCarePriorityDataApiRequestReturnSuccessfully' event (evid: 7700102)
 *
 * Event description: Fire when Customer Care squad 5 successfully returns a client's API request for user's care priority data
 *
 * @param {userCarePriorityDataApiRequestReturnSuccessfullyParams} params - The parameters for this event
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} care_priority_data - An object with all care priority data about the requested user
 * @return {LogObject<userCarePriorityDataApiRequestReturnSuccessfullyParams>} LogObject<userCarePriorityDataApiRequestReturnSuccessfullyParams>
 */
export function userCarePriorityDataApiRequestReturnSuccessfully(params) {
    return { evid: 7700102, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userCarePriorityDataApiRequestFailed' event (evid: 7700103)
 *
 * Event description: Fire when Customer Care squad 5 failed to return a client's API request for user's care priority data
 *
 * @param {userCarePriorityDataApiRequestFailedParams} params - The parameters for this event
 * @property {GUID} user_id - The Wix user ID for which the request was made
 * @property {string} failed_reason - {missing required parameters,invalid user_id}
 * @return {LogObject<userCarePriorityDataApiRequestFailedParams>} LogObject<userCarePriorityDataApiRequestFailedParams>
 */
export function userCarePriorityDataApiRequestFailed(params) {
    return { evid: 7700103, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openAiExpertAssistant' event (evid: 7700300)
 *
 * Event description: When the expert open the tab of the Ai assistant we want that action will be saved.
 *
 * @param {openAiExpertAssistantParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} user_id - The expert user ID
 * @property {string} version - The version of the AI in the answer
 * @return {LogObject<openAiExpertAssistantParams>} LogObject<openAiExpertAssistantParams>
 */
export function openAiExpertAssistant(params) {
    return { evid: 7700300, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersFromTheAiExpertAssistant' event (evid: 7700301)
 *
 * Event description: AI assistant answers expert's question.
 *
 * @param {answersFromTheAiExpertAssistantParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - the article tenant_id
 * @property {string} expert_question - the content of the expert’s question that he send
 * @property {number} order_number - order of the answer as presented to the user; when null then the answer want presented
 * @property {GUID} user_id - The expert user ID
 * @property {string} answer_of_ai - the content of the message that the AI answers
 * @property {string} version - The version of the AI
 * @property {string} error_type - If there is an error, what error has sent
 * @property {GUID} request_id - The ID of the question to the AI
 * @property {GUID} response_id - The ID of the answer to the AI
 * @property {string} sources - array of the sources with links to the real articles
 * @property {DateTime} request_time - the time when the expert sent question
 * @return {LogObject<answersFromTheAiExpertAssistantParams>} LogObject<answersFromTheAiExpertAssistantParams>
 */
export function answersFromTheAiExpertAssistant(params) {
    return { evid: 7700301, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheAiAssistantFeedback' event (evid: 7700302)
 *
 * Event description: The feedback of the user that the Ai response to the expert
 *
 * @param {clickOnTheAiAssistantFeedbackParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {number} order_number - number of the answer the user gave feedback on
 * @property {string} feedback_details - 1.Incorrect product(s) , 2.Correct product, incorrect/unhelpful answer, 3. Correct answer, unhelpful/bad phrasing 4.Free text option
 * @property {boolean} feedback_choice - true = helpful / false = unhelpful
 * @property {GUID} user_id - The expert user ID
 * @property {string} bubble_name - name of the element/bubble the user gives the feedback for
 * @property {string} answer_of_ai - the content of the message that the AI answers
 * @property {string} version - The version of the AI
 * @property {string} feedback_text - free text added by the expert to the feedback
 * @property {GUID} request_id - The ID of the question to the AI
 * @property {GUID} response_id - The ID of the answer to the AI
 * @return {LogObject<clickOnTheAiAssistantFeedbackParams>} LogObject<clickOnTheAiAssistantFeedbackParams>
 */
export function clickOnTheAiAssistantFeedback(params) {
    return { evid: 7700302, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCopyAiExpertAssistantAnswer' event (evid: 7700303)
 *
 * Event description: Click to copy AI expert assistant answer
 *
 * @param {clickToCopyAiExpertAssistantAnswerParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} source - The source of the chosen answer
 * @property {number} order_number - number of the answer copied by the user
 * @property {GUID} user_id - The expert user ID
 * @property {string} answer_of_ai - The answer that been chosen to be copy
 * @property {string} version - The version of the AI
 * @property {GUID} request_id - The ID of the question to the AI
 * @property {GUID} response_id - The ID of the answer to the AI
 * @return {LogObject<clickToCopyAiExpertAssistantAnswerParams>} LogObject<clickToCopyAiExpertAssistantAnswerParams>
 */
export function clickToCopyAiExpertAssistantAnswer(params) {
    return { evid: 7700303, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bubbleFeedback' event (evid: 7700304)
 *
 * Event description: The event for the bubble that popped up and the feedback that the bubble received.
 *
 * @param {bubbleFeedbackParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {string} bubble_type - the type of the bubble that appeared
 * @property {number} order_number - number of the answer the user gave feedback on
 * @property {string} feedback_details - The details of the feedback that was given.
 * @property {GUID} user_id - The expert user ID
 * @property {GUID} request_id - The ID of the question to the AI
 * @property {boolean} bubble_feedback - the feedback that the bubble received - up - true /down - false /null
 * @property {GUID} response_id - The ID of the answer to the AI
 * @return {LogObject<bubbleFeedbackParams>} LogObject<bubbleFeedbackParams>
 */
export function bubbleFeedback(params) {
    return { evid: 7700304, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbArticlesBo' event (evid: 7700313)
 *
 * Event description: Fire when an action is performed in the KB article BO in Answers
 *
 * @param {kbArticlesBoParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} action - The action which was performed
 * @property {string} section_name - The section in the BO on which the action was performed
 * @property {string} params - The input parameters that were passed with the action
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @return {LogObject<kbArticlesBoParams>} LogObject<kbArticlesBoParams>
 */
export function kbArticlesBo(params) {
    return { evid: 7700313, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiExpertAssistantOpenArticlesFromAi' event (evid: 7700318)
 *
 * Event description: This event send when you click on the article link from the answer of the AI
 *
 * @param {aiExpertAssistantOpenArticlesFromAiParams} params - The parameters for this event
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {string} article_id - the article_id
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {GUID} tenant_id - the article tenant_id
 * @property {DateTime} date_creted - the datetime of the click on the article
 * @property {number} order_number	 - the order of the article from the answer
 * @return {LogObject<aiExpertAssistantOpenArticlesFromAiParams>} LogObject<aiExpertAssistantOpenArticlesFromAiParams>
 */
export function aiExpertAssistantOpenArticlesFromAi(params) {
    return { evid: 7700318, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'careProfileServicesApiRequest' event (evid: 7700501)
 *
 * Event description: Fire when a client makes an API request to Care Profile Services of Customer Care
 *
 * @param {careProfileServicesApiRequestParams} params - The parameters for this event
 * @property {string} care_profile_type - {account, user, site}
 * @property {GUID} entity_id - msid/user id/account id
 * @property {string} api_client - {chatbot,kb,answers}
 * @property {string} profile_fields - List of fields the client requested (if didn't specify a list then expecting all - "full profile")
 * @return {LogObject<careProfileServicesApiRequestParams>} LogObject<careProfileServicesApiRequestParams>
 */
export function careProfileServicesApiRequest(params) {
    return { evid: 7700501, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'careProfileServicesApiRequestReturnSuccessfully' event (evid: 7700502)
 *
 * Event description: Fire when the Care Profile Services of Customer Care successfully return a client's API request
 *
 * @param {careProfileServicesApiRequestReturnSuccessfullyParams} params - The parameters for this event
 * @property {GUID} entity_id - msid/user id/account id
 * @property {string} request_output - A list of all output data points
 * @return {LogObject<careProfileServicesApiRequestReturnSuccessfullyParams>} LogObject<careProfileServicesApiRequestReturnSuccessfullyParams>
 */
export function careProfileServicesApiRequestReturnSuccessfully(params) {
    return { evid: 7700502, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'careProfileServicesApiRequestFailed' event (evid: 7700503)
 *
 * Event description: Fire when the Care Profile Services of Customer Care failed to return a client's API request
 *
 * @param {careProfileServicesApiRequestFailedParams} params - The parameters for this event
 * @property {GUID} entity_id - msid/user id/account id
 * @property {string} failed_reason - {missing required parameters,invalid entity_id,invalid profile fields names}
 * @return {LogObject<careProfileServicesApiRequestFailedParams>} LogObject<careProfileServicesApiRequestFailedParams>
 */
export function careProfileServicesApiRequestFailed(params) {
    return { evid: 7700503, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hcSearchDropdownSourceSectionOnView' event (evid: 7700504)
 *
 * Event description: Fire every time a source section is visible for the user in the Help Center search dropdown
 *
 * @param {hcSearchDropdownSourceSectionOnViewParams} params - The parameters for this event
 * @property {string} source_name - name of the page the dropdown was opened on {article,roadmap,homepage}
 * @property {string} kb_lang - kb page language
 * @property {string} source_section_name - the name of the source section the user was exposed to
 * @property {string} search_session_id - Unique search session identifier
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 *
 * @return {LogObject<hcSearchDropdownSourceSectionOnViewParams>} LogObject<hcSearchDropdownSourceSectionOnViewParams>
 */
export function hcSearchDropdownSourceSectionOnView(params) {
    return { evid: 7700504, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationSrc4Evid7701' event (evid: 7701)
 *
 * Event description: Triggers whenever a new ticket is created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationSrc4Evid7701Params} params - The parameters for this event
 * @property {GUID} source_ticket_id - The ticket guid from which the callback request is created, can be null
 * @property {boolean} created_from_ticket - True if the callback was created from an existing ticket, false otherwise
 * @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
 * @return {LogObject<callbackWidgetTicketCreationSrc4Evid7701Params>} LogObject<callbackWidgetTicketCreationSrc4Evid7701Params>
 */
export function callbackWidgetTicketCreationSrc4Evid7701(params) {
    return { evid: 7701, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationSuccess' event (evid: 7702)
 *
 * Event description: Triggers whenever a new ticket is successfully created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationSuccessParams} params - The parameters for this event
 * @property {GUID} group_id - The guid of the group in which the callback is created
 * @property {GUID} user_wix_uuid - The Wix uuid of the user the callback is created for
 * @property {GUID} queue_id - The guid of the queue in which the callback is created
 * @property {GUID} topic_id - The guid of the topic in which the callback is created
 * @property {GUID} assigned_group_id - The guid of the group the created ticket is assigned to at ticket creation
 * @property {GUID} source_ticket_id - The ticket guid from which the callback request is created, can be null
 * @property {boolean} created_from_ticket - True if the callback was created from an existing ticket, false otherwise
 * @property {GUID} line_id - The line ID we call the user from
 * @property {GUID} created_ticket_id - The id of the ticket that was created using the widget
 * @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
 * @return {LogObject<callbackWidgetTicketCreationSuccessParams>} LogObject<callbackWidgetTicketCreationSuccessParams>
 */
export function callbackWidgetTicketCreationSuccess(params) {
    return { evid: 7702, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreationFailure' event (evid: 7703)
 *
 * Event description: Triggers whenever a new ticket fails to be created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationFailureParams} params - The parameters for this event
 * @property {string} failure_reason - The reason the ticket creation failed
 * @property {GUID} user_wix_uuid - The Wix uuid of the user the callback is created for
 * @property {GUID} queue_id - The guid of the queue in which the callback is created
 * @property {GUID} assigned_group_id - assigned_group_id
 * @property {GUID} source_ticket_id - source_ticket_id
 * @property {boolean} created_from_ticket - created_from_ticket
 * @property {GUID} line_id - The line ID we call the user from
 * @property {GUID} created_ticket_id - The id of the ticket that was created using the widget
 * @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
 * @return {LogObject<callbackWidgetTicketCreationFailureParams>} LogObject<callbackWidgetTicketCreationFailureParams>
 */
export function callbackWidgetTicketCreationFailure(params) {
    return { evid: 7703, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetOpenWidget' event (evid: 7704)
 *
 * Event description: Callback Widget - Open Widget.
 *
 * @param {callbackWidgetOpenWidgetParams} params - The parameters for this event
 * @property {boolean} opened_from_ticket - True if the widget was opened from a ticket, false otherwise
 * @property {string} opened_from_ticket_language - The language code of the ticket the widget was opened from if exists
 * @property {GUID} performing_angent_answers_id - answers id of the performing agent
 * @property {GUID} opened_from_ticket_id - opened_from_ticket_id
 * @return {LogObject<callbackWidgetOpenWidgetParams>} LogObject<callbackWidgetOpenWidgetParams>
 */
export function callbackWidgetOpenWidget(params) {
    return { evid: 7704, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'escalationFeedbackSubmitted' event (evid: 7900)
 *
 * Event description: Escalation feedback submitted from tool
 *
 * @param {escalationFeedbackSubmittedParams} params - The parameters for this event
 * @property {boolean} handledByQA - Feedback reason - handled by QA
 * @property {boolean} knowledgeGap - Feedback reason - knowledge gap
 * @property {string} agentEmail - Email of agent that did the escalation
 * @property {string} feedbackType - Type of feedback, can be 'good' or 'bad'
 * @property {GUID} noteId - Internal Note ID
 * @property {string} ticketId - Answers Ticket ID
 * @property {boolean} cannotRecreate - Feedback reason - cannot recreate
 * @property {boolean} wrongGroup - Feedback reason - ticket was assigned to wrong product group
 * @property {boolean} incompleteNote - Feedback reason - note is incomplete/missing
 * @property {boolean} isNecessary - Was the escalation necessary for the case, regardless of feedback
 * @property {boolean} courtesyEsc - Feedback reason - Whether ticket was escalated as "courtesy"
 * @property {boolean} lacksPermissionsOrTools - Feedback reason - lacks permissions or tools
 * @property {boolean} assignedByMistake - Feedback reason - assigned by mistake
 * @property {string} groupName - Group name that the ticket is assigned to in Answers
 * @property {string} comment - Optional comment
 * @property {string} reportingAgentEmail - Email of reporting agent
 * @property {boolean} lackOfTs - Feedback reason - lack of troubleshooting
 * @return {LogObject<escalationFeedbackSubmittedParams>} LogObject<escalationFeedbackSubmittedParams>
 */
export function escalationFeedbackSubmitted(params) {
    return { evid: 7900, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'domainTroubleshooterSubmit' event (evid: 800)
 *
 * Event description: The user clicked on 'Submit' in the domain troubleshooter
 *
 * @param {domainTroubleshooterSubmitParams} params - The parameters for this event
 * @property {string} domainName - the domain
 * @return {LogObject<domainTroubleshooterSubmitParams>} LogObject<domainTroubleshooterSubmitParams>
 */
export function domainTroubleshooterSubmit(params) {
    return { evid: 800, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCreateCallbackRequest' event (evid: 8001)
 *
 * Event description: create callback request
 *
 * @param {apiSchedulerCreateCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - The scheduled call request id
 * @property {string} lang - User's Answers language
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @return {LogObject<apiSchedulerCreateCallbackRequestParams>} LogObject<apiSchedulerCreateCallbackRequestParams>
 */
export function apiSchedulerCreateCallbackRequest(params) {
    return { evid: 8001, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCancelCallbackRequest' event (evid: 8002)
 *
 * Event description: cancel callback request
 *
 * @param {apiSchedulerCancelCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - The scheduled call request id
 * @property {string} lang - User's Answers language
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @return {LogObject<apiSchedulerCancelCallbackRequestParams>} LogObject<apiSchedulerCancelCallbackRequestParams>
 */
export function apiSchedulerCancelCallbackRequest(params) {
    return { evid: 8002, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerModifyCallbackRequest' event (evid: 8003)
 *
 * Event description: modify callback request
 *
 * @param {apiSchedulerModifyCallbackRequestParams} params - The parameters for this event
 * @property {GUID} requestid - The scheduled call request id
 * @property {string} lang - User's Answers language
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @return {LogObject<apiSchedulerModifyCallbackRequestParams>} LogObject<apiSchedulerModifyCallbackRequestParams>
 */
export function apiSchedulerModifyCallbackRequest(params) {
    return { evid: 8003, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'apiSchedulerCreateRequestToAnswers' event (evid: 8004)
 *
 * Event description: create callback request
 *
 * @param {apiSchedulerCreateRequestToAnswersParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} userid - the user who requested the call
 * @property {GUID} interaction_id - interaction id
 * @property {GUID} requestid - The scheduled call request id
 * @property {string} lang - User's Answers language
 * @property {DateTime} callback_datetime - The callback date and time chosen by the user
 * @return {LogObject<apiSchedulerCreateRequestToAnswersParams>} LogObject<apiSchedulerCreateRequestToAnswersParams>
 */
export function apiSchedulerCreateRequestToAnswers(params) {
    return { evid: 8004, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageClick' event (evid: 8201)
 *
 * Event description: Fired when a user clicks a link/button in an article/home/category page
 *
 * @param {pageClickParams} params - The parameters for this event
 * @property {string} clicked_text - The text that was clicked on
 * @property {string} item_id - id of the page presented to the user (article/category)
 * @property {string} clicked_item_order - order of the item clicked
 * @property {string} clicked_item_type - type of item clicked
 * @property {string} clicked_item_id - id of the article/category/subcategory the user is directed to
 * @property {boolean} is_page_content_click - to indicate if the user interacted with the content on the page
 * @property {string} source_name - "indicates what ""type"" of page the user is at: home, article, category, search_results"
 * @property {string} kb_lang - kb page language
 * @property {number} category_order - Order of the parent category cell
 * @property {string} item_type - indicates the type of article presented to the user: article, feature_request, known_issue
 * @property {string} clicked_url - Destination url the link takes the user to
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<pageClickParams>} LogObject<pageClickParams>
 */
export function pageClick(params) {
    return { evid: 8201, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageEngagement' event (evid: 8202)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, scroll all the way to the bottom of the screen, moved mouse, clicked.
 *
 * @param {pageEngagementParams} params - The parameters for this event
 * @property {string} item_id - id of the page presented to the user (article/category)
 * @property {boolean} max_scroll_at_first_position - indicates if the entire article is visible to the user without having to scroll
 * @property {string} tab - name of the tab the use is on in the page
 * @property {string} filter_by - filter selected by the user
 * @property {string} activity_type - indicates the type of activity done by the user on the page
 * @property {string} source_name - "indicates what ""type"" of article the user is at: home, article, category, search_results"
 * @property {string} sort_by - sorting option selected by the user
 * @property {number} max_scroll - max % of the page the user reached while visiting the page
 * @property {string} kb_lang - kb page language
 * @property {string} item_type - indicates the type of article presented to the user: article, feature_request, known_issue
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<pageEngagementParams>} LogObject<pageEngagementParams>
 */
export function pageEngagement(params) {
    return { evid: 8202, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pageError' event (evid: 8203)
 *
 * Event description: Fire when an error is shown after a user clicked a link in one of the Help Center pages
 *
 * @param {pageErrorParams} params - The parameters for this event
 * @property {string} referral_url - url of the page the user was on when clicking the link that got an error
 * @property {string} error_origin - url link that triggered the error
 * @property {string} source_name - "indicates what ""type"" of article the user is at: home, article, category, search_results"
 * @property {string} error_type_id - id of the error sent in case of a broken link
 * @property {string} kb_lang - kb page language
 * @property {string} error_type_description - description of the error in case of a broken link
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<pageErrorParams>} LogObject<pageErrorParams>
 */
export function pageError(params) {
    return { evid: 8203, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sortAndFilter' event (evid: 8403)
 *
 * Event description: Fire when a user sorts/filters page view in the Help Center
 *
 * @param {sortAndFilterParams} params - The parameters for this event
 * @property {string} item_id - id of the page presented to the user (article/category)
 * @property {string} tab - name of the tab the use is on in the page
 * @property {number} items_left - Number of items remains on the page following the filter
 * @property {string} filter_by - filtering option selected by the user
 * @property {string} search_term_filter - The search term the user used to filter the view
 * @property {string} source_name - "indicates what ""type"" of article the user is at: home, article, category, search_results"
 * @property {string} sort_by - sorting option selected by the user
 * @property {string} kb_lang - kb page language
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<sortAndFilterParams>} LogObject<sortAndFilterParams>
 */
export function sortAndFilter(params) {
    return { evid: 8403, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitWasItHelpfulForm' event (evid: 8404)
 *
 * Event description: Fire when a user submits an article feedback form
 *
 * @param {submitWasItHelpfulFormParams} params - The parameters for this event
 * @property {string} clicked_text - the answer the user selected
 * @property {GUID} item_id - article id
 * @property {boolean} thumbs_up - the value clicked on before getting to the feedback form
 * @property {string} feedback_details - feedback form version
 * @property {number} clicked_item_index - id of the feedback option the user choose
 * @property {string} presented_content - presented_content
 * @property {string} clicked_item_order - the order of the answer the user selected
 * @property {string} source_name - name pf the page the user is on
 * @property {string} kb_lang - kb page language
 * @property {string} free_text - text entered by the user in the free text box
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<submitWasItHelpfulFormParams>} LogObject<submitWasItHelpfulFormParams>
 */
export function submitWasItHelpfulForm(params) {
    return { evid: 8404, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterBannerClick' event (evid: 8405)
 *
 * Event description: Fire when a user clicks a banner in the Help Center
 *
 * @param {helpCenterBannerClickParams} params - The parameters for this event
 * @property {string} clicked_text - The text that was clicked on
 * @property {string} banner_text - banner text
 * @property {string} item_id - id of the page presented to the user (article/category)
 * @property {string} banner_type - to indicate the type of banner: status page, help center, etc.
 * @property {string} banner_name - banner name
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} source_name - indicates type of page the user is at: home, article, category, search_results
 * @property {boolean} is_resolved - param from the Status page endpoint
 * @property {string} kb_lang - kb page language
 * @property {string} item_type - indicates the type of article presented to the user: article, feature_request, known_issue
 * @property {string} banner_language - banner_language
 * @property {string} clicked_url - Destination url the link takes the user to
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<helpCenterBannerClickParams>} LogObject<helpCenterBannerClickParams>
 */
export function helpCenterBannerClick(params) {
    return { evid: 8405, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterBannerView' event (evid: 8406)
 *
 * Event description: Fire when the user see a banner inside a page in the Help Center.
 *
 * @param {helpCenterBannerViewParams} params - The parameters for this event
 * @property {string} banner_text - banner text
 * @property {string} item_id - item_id
 * @property {string} banner_type - to indicate the type of banner: status page, help center, etc.
 * @property {string} banner_name - banner name
 * @property {boolean} has_cta - true if the banner includes CTA (clickable item/link)
 * @property {string} source_name - indicates type of page the user is at: home, article, category, search_results
 * @property {boolean} is_resolved - param from the Status page endpoint i
 * @property {string} kb_lang - kb page language
 * @property {string} item_type - indicates the type of article presented to the user: article, feature_request, known_issue
 * @property {string} banner_language - lang of the banner
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<helpCenterBannerViewParams>} LogObject<helpCenterBannerViewParams>
 */
export function helpCenterBannerView(params) {
    return { evid: 8406, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wasItHelpfulView' event (evid: 8407)
 *
 * Event description: fire when a certain item is visible on a Help Center page
 *
 * @param {wasItHelpfulViewParams} params - The parameters for this event
 * @property {GUID} item_id - article id
 * @property {string} feedback_details - feedback form version
 * @property {string} item_name - item viewed
 * @property {string} source_name - name of the page the user is on (e.g. article, home etc.)
 * @property {string} kb_lang - kb page language
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<wasItHelpfulViewParams>} LogObject<wasItHelpfulViewParams>
 */
export function wasItHelpfulView(params) {
    return { evid: 8407, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'roadmapWishlistFormClick' event (evid: 8411)
 *
 * Event description: fires when a user clicks one of the buttons in the roadmap wishlist form
 *
 * @param {roadmapWishlistFormClickParams} params - The parameters for this event
 * @property {string} form_step - {'main','alternative_suggester'}
 * @property {string} chosen_alternative_resolution - Only if the user was presented with alternative {'planned','collecting votes'}
 * @property {string} clicked_item_type - the button clicked by the user (close/send/cancel, etc.)
 * @property {string} source_name - name pf the page the user is on
 * @property {string} origin - where the user got to the form from
 * @property {string} feature_description - The text the user added for the  'describe the feature' parameter when sent the form
 * @property {string} origin_url - where the user got to the form from (url)
 * @property {string} feature_impact - The text the user added for the  'how the feature will make an impact' parameter when sent the form
 * @property {string} kb_lang - kb page language
 * @property {string} product - The value the user chose for the 'product' parameter when sent the form
 * @property {GUID} chosen_alternative_id - The chosen alternative article_id - only if the user presented with alternative and clicked 'follow' or 'vote'
 * @property {string} output_distance_str - The score the alternative feature requests that was suggested got from the model
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @return {LogObject<roadmapWishlistFormClickParams>} LogObject<roadmapWishlistFormClickParams>
 */
export function roadmapWishlistFormClick(params) {
    return { evid: 8411, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpCenterModals' event (evid: 8414)
 *
 * Event description: Fire when a user interacts with a modal in the Help Center
 *
 * @param {helpCenterModalsParams} params - The parameters for this event
 * @property {string} item_id - ID of the page the modal was presented on (article/category)
 * @property {string} screen_name - The specific screen inside the modal the user interacted with
 * @property {string} clicked_button_name - The button name inside the modal the user clicked on
 * @property {string} modal_name - The name of the modal the user interacted with
 * @property {string} source_name - indicates type of page the user is at when modal is open: home, article, category, search_results
 * @property {string} kb_lang - kb page language
 * @property {string} action_type - The action type the user performed inside the modal
 * @property {GUID} self_service_session_id - The CC cross self service platforms session the user was part of
 * @property {GUID} modal_session_id - random unique guid which will follow with all actions and screens of the modal
 * @property {string} origin - where the user got to the modal from
 * @property {string} params - more information about the modal parameters and content
 * @property {GUID} clicked_item_id - the item id that was chosen inside the modal
 * @property {string} alternatives_info - information about the alternatives items that were presented inside the modal
 * @return {LogObject<helpCenterModalsParams>} LogObject<helpCenterModalsParams>
 */
export function helpCenterModals(params) {
    return { evid: 8414, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'trafficStatus' event (evid: 8500)
 *
 * Event description: Traffic status.
 *
 * @param {trafficStatusParams} params - The parameters for this event
 * @property {number} amount_of_posts_in_progress - amount_of_posts_in_progress
 * @property {number} amount_of_chats_in_progress - amount_of_chats_in_progress
 * @property {number} avg_call_duration - avg call processing time
 * @property {number} p80_calls_waiting_time - RT 80p calls waiting time
 * @property {number} total_busy_agents_in_calls - number of agents with status busy in calls
 * @property {number} amount_of_calls_in_progress - amount_of_calls_in_progress
 * @property {number} last_3_hours_calls_p80 - last_3_hours_calls_p80
 * @property {number} amount_of_waiting_chats - amount_of_waiting_chats
 * @property {number} total_active_sessions_calls - number of calls that currently handling
 * @property {number} total_available_experts_in_chats - number of experts available to take a chat
 * @property {number} total_available_experts_in_calls - number of experts available to take a call
 * @property {number} posts_waiting_time - posts_waiting_time
 * @property {number} max_workload_calls - Max number of calls that can be routed at the same time
 * @property {number} avg_chat_duration - avg chat processing time
 * @property {number} last_1_hours_calls_p80 - last_1_hours_calls_p80
 * @property {number} avg_chats_waiting_time - avg chats waiting time
 * @property {number} total_busy_agents_in_chats - number of agents with status busy in chats
 * @property {string} urgency_level - the urgency level of the current status-1very low,2low,3medium,4high,5critical
 * @property {string} staffing_group - which staffing group the status relevant for
 * @property {string} busy_status_map_on_calls - How many experts are in each of the busy statuses & toggle on calls
 * @property {string} lang - describe the staffing group's language
 * @property {number} amount_of_waiting_posts - amount_of_waiting_posts
 * @property {number} amount_of_waiting_calls - amount_of_waiting_calls
 * @property {number} total_active_sessions_chats - number of chats that currently handling
 * @property {number} max_workload_chats - Max number of chats that can be routed at the same time
 * @return {LogObject<trafficStatusParams>} LogObject<trafficStatusParams>
 */
export function trafficStatus(params) {
    return { evid: 8500, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'godaddyConnectResponse' event (evid: 851)
 *
 * Event description: Result from Godaddy Connect Response
 *
 * @param {godaddyConnectResponseParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} connectAttemptResult - result
 * @property {string} domainName - the domain
 * @return {LogObject<godaddyConnectResponseParams>} LogObject<godaddyConnectResponseParams>
 */
export function godaddyConnectResponse(params) {
    return { evid: 851, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'openaiCostUsage' event (evid: 8700)
 *
 * Event description: This event triggered after getting prompt result from 'Open AI'
 *
 * @param {openaiCostUsageParams} params - The parameters for this event
 * @property {number} token_output - the number of tokens that returned from the result of OpenAI
 * @property {number} max_tokens - The maximum number of tokens to generate in the completion.
 * @property {number} top_p - An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered.
 * @property {number} token_prompt - token_prompt
 * @property {number} prompt_length - the length of the prompt
 * @property {number} temperature - What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.
 * @property {string} feature_name - The feature that uses OpenAI (Chat/Call Summary, Knowledge Assistance,  etc..)
 * @property {GUID} prompt_id - the prompt_id is PK
 * @property {string} model_type - type of the model like: embedding, chat, creation etc..
 * @property {GUID} request_id - the request_id is PK to flow of several prompt_ids
 * @property {string} model_name - the OpenAI model that used for the prompt
 * @return {LogObject<openaiCostUsageParams>} LogObject<openaiCostUsageParams>
 */
export function openaiCostUsage(params) {
    return { evid: 8700, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ccSendRequestToOpenaiEvent' event (evid: 8800)
 *
 * Event description: This Event represent the requests of CC application to OpenAI. we can link the requests to feature name and other data fields
 *
 * @param {ccSendRequestToOpenaiEventParams} params - The parameters for this event
 * @property {string} data - json that includes data about the request
 * @property {string} feature_name - the feature that the request belongs to
 * @return {LogObject<ccSendRequestToOpenaiEventParams>} LogObject<ccSendRequestToOpenaiEventParams>
 */
export function ccSendRequestToOpenaiEvent(params) {
    return { evid: 8800, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetSessionExpired' event (evid: 8901)
 *
 * Event description: Fires when the Self Service session is expired
 *
 * @param {widgetSessionExpiredParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} last_conversation_id - ID of the last conversation the user had before the session expired
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} conversation_id - Chatbot conversation ID
 * @property {GUID} logged_user_id - Logged User ID
 * @property {GUID} logged_account_id - Logged Account ID
 * @property {GUID} target_account_id - Target Account ID
 * @property {string} device_type - Device type (Phone, computer, tablet, etc..)
 * @property {string} chatbot_view - Chatbot View
 * @return {LogObject<widgetSessionExpiredParams>} LogObject<widgetSessionExpiredParams>
 */
export function widgetSessionExpired(params) {
    return { evid: 8901, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'conversationsPageFeedbackFormSubmissionSrc4Evid8902' event (evid: 8902)
 *
 * Event description: This event will fire when the user clicks on the "send" button in the Conversations Page feedback form.
 *
 * @param {conversationsPageFeedbackFormSubmissionSrc4Evid8902Params} params - The parameters for this event
 * @property {string} conversation_id - The evaluated conversation in the Conversation Page
 * @property {string} role - Close list of user's roles [Expert, PSG, PM, UX, Dev, Other]
 * @property {string} feedback - The evaluator's feedback - Did the AI Chatbot give correct, relevant information [Yes/No]
 * @property {string} feedback_classification - If the bot's answer had deficiencies or inaccuracies, what was wrong with the information
 * @property {string} extraInfo - The evaluator's description of what was missing or incorrect
 * @return {LogObject<conversationsPageFeedbackFormSubmissionSrc4Evid8902Params>} LogObject<conversationsPageFeedbackFormSubmissionSrc4Evid8902Params>
 */
export function conversationsPageFeedbackFormSubmissionSrc4Evid8902(params) {
    return { evid: 8902, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteMe' event (evid: 9)
 *
 * Event description: pp
 *
 * @param {deleteMeParams} params - The parameters for this event
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<deleteMeParams>} LogObject<deleteMeParams>
 */
export function deleteMe(params) {
    return { evid: 9, src: 4, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprAutomationDeleteRequestEvents' event (evid: 4103)
 *
 * Event description: events revolving around user requesting gdpr deletion
 *
 * @param {gdprAutomationDeleteRequestEventsParams} params - The parameters for this event
 * @property {string} resolution_type - status request is in (submission created success, submission created fail, deletion success, deletion fail)
 * @property {GUID} account_deletion_process_id - id of the deletion request
 * @property {string} request_type - type of a request (get/delete)
 * @property {string} request_action_type - whether the request is handled automatically or manually
 * @property {string} error_type - description of the error
 * @property {DateTime} submission_date - date the request was submitted (will match date_created when resolution type is submission created)
 * @return {LogObject<gdprAutomationDeleteRequestEventsParams>} LogObject<gdprAutomationDeleteRequestEventsParams>
 */
export function gdprAutomationDeleteRequestEvents(params) {
    return { evid: 4103, src: 5, endpoint: '', params };
}
/**
 * A function to create a log object for the 'testProfileServiceOperatorUserProficiencySrc70Evid450' event (evid: 450)
 *
 * Event description: Event to test data share operator:
 * This event update User Proficiency (for Customer Care Smart Routing)
 * Possible values 2,3 (higher number means higher proficiency)
 *
 * @param {testProfileServiceOperatorUserProficiencySrc70Evid450Params} params - The parameters for this event
 * @property {string} user_proficiency - User proficiency for smart routing
 * @return {LogObject<testProfileServiceOperatorUserProficiencySrc70Evid450Params>} LogObject<testProfileServiceOperatorUserProficiencySrc70Evid450Params>
 */
export function testProfileServiceOperatorUserProficiencySrc70Evid450(params) {
    return { evid: 450, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersSupportPriorityClassDummySrc70Evid47' event (evid: 47)
 *
 * Event description: dummy event that includes all the users that entitle to priority support in Customer Care and their assigned priority class
 *
 * @param {usersSupportPriorityClassDummySrc70Evid47Params} params - The parameters for this event
 * @property {string} class - The priority class assigned to the account
 * @return {LogObject<usersSupportPriorityClassDummySrc70Evid47Params>} LogObject<usersSupportPriorityClassDummySrc70Evid47Params>
 */
export function usersSupportPriorityClassDummySrc70Evid47(params) {
    return { evid: 47, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyUsersSupportPriorityClassCopySrc70Evid48' event (evid: 48)
 *
 * Event description: Includes all the users that entitle to priority support in Customer Care and their assigned priority class
 *
 * @param {dummyUsersSupportPriorityClassCopySrc70Evid48Params} params - The parameters for this event
 * @property {string} class - The priority class assigned to the account
 * @property {GUID} logged_user_id - user id
 * @return {LogObject<dummyUsersSupportPriorityClassCopySrc70Evid48Params>} LogObject<dummyUsersSupportPriorityClassCopySrc70Evid48Params>
 */
export function dummyUsersSupportPriorityClassCopySrc70Evid48(params) {
    return { evid: 48, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userVoiceSyntheticEventForUserTypesSrc70Evid49' event (evid: 49)
 *
 * Event description: This synthetic event is fired once we receive an user/account that is linked to the interaction we aim to classify
 *
 * @param {userVoiceSyntheticEventForUserTypesSrc70Evid49Params} params - The parameters for this event
 * @property {GUID} account_id - Wix Account ID
 * @property {string} label_list - The Account type and labels
 * @return {LogObject<userVoiceSyntheticEventForUserTypesSrc70Evid49Params>} LogObject<userVoiceSyntheticEventForUserTypesSrc70Evid49Params>
 */
export function userVoiceSyntheticEventForUserTypesSrc70Evid49(params) {
    return { evid: 49, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'routingUpdateUserProficiency20SyntheticSrc70Evid70' event (evid: 70)
 *
 * Event description: Update User Proficiency (for Customer Care Smart Routing)
 * Possible values 2,3,4 (higher number means higher proficiency)
 *
 * @param {routingUpdateUserProficiency20SyntheticSrc70Evid70Params} params - The parameters for this event
 * @property {string} user_proficiency - User proficiency for smart routing
 * @return {LogObject<routingUpdateUserProficiency20SyntheticSrc70Evid70Params>} LogObject<routingUpdateUserProficiency20SyntheticSrc70Evid70Params>
 */
export function routingUpdateUserProficiency20SyntheticSrc70Evid70(params) {
    return { evid: 70, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersSupportPriorityClass' event (evid: 715)
 *
 * Event description: Includes all the users that entitle to priority support in Customer Care and their assigned priority class
 *
 * @param {usersSupportPriorityClassParams} params - The parameters for this event
 * @property {string} class - The priority class assigned to the account
 * @return {LogObject<usersSupportPriorityClassParams>} LogObject<usersSupportPriorityClassParams>
 */
export function usersSupportPriorityClass(params) {
    return { evid: 715, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersValueScore' event (evid: 716)
 *
 * Event description: Includes value score of each premium user at Wix based on the Customer Care model
 *
 * @param {usersValueScoreParams} params - The parameters for this event
 * @property {number} user_value_score - The value score of the account
 * @return {LogObject<usersValueScoreParams>} LogObject<usersValueScoreParams>
 */
export function usersValueScore(params) {
    return { evid: 716, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'b2BAccounts' event (evid: 717)
 *
 * Event description: Includes all Wix B2B accounts and their B2B type and name
 *
 * @param {b2BAccountsParams} params - The parameters for this event
 * @property {string} b2b_name - {Vista, LegalZoom}
 * @property {string} b2b_type - {Enterprise,Channel DIY)
 * @return {LogObject<b2BAccountsParams>} LogObject<b2BAccountsParams>
 */
export function b2BAccounts(params) {
    return { evid: 717, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'managedAccounts' event (evid: 718)
 *
 * Event description: Includes all Wix Managed accounts and their account manager name
 *
 * @param {managedAccountsParams} params - The parameters for this event
 * @property {string} account_manager_name - account_manager_name
 * @return {LogObject<managedAccountsParams>} LogObject<managedAccountsParams>
 */
export function managedAccounts(params) {
    return { evid: 718, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'partnersAccounts' event (evid: 719)
 *
 * Event description: Includes all Wix Confirmed Partners accounts and their partner tier
 *
 * @param {partnersAccountsParams} params - The parameters for this event
 * @property {string} partner_type - Partner tier
 * @return {LogObject<partnersAccountsParams>} LogObject<partnersAccountsParams>
 */
export function partnersAccounts(params) {
    return { evid: 719, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topVerticalsAccountsAndSites' event (evid: 720)
 *
 * Event description: Include all top verticals accounts
 *
 * @param {topVerticalsAccountsAndSitesParams} params - The parameters for this event
 * @property {string} vertical - The vertical list in which the site and account considered as top one
 * @return {LogObject<topVerticalsAccountsAndSitesParams>} LogObject<topVerticalsAccountsAndSitesParams>
 */
export function topVerticalsAccountsAndSites(params) {
    return { evid: 720, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'accountNamespaceType' event (evid: 721)
 *
 * Event description: List of all accounts that have only Headless or Anywhere sites
 *
 * @param {accountNamespaceTypeParams} params - The parameters for this event
 * @property {string} account_namespace_type - The type of sites the account includes
 * @return {LogObject<accountNamespaceTypeParams>} LogObject<accountNamespaceTypeParams>
 */
export function accountNamespaceType(params) {
    return { evid: 721, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'topVerticalsSites' event (evid: 722)
 *
 * Event description: Include all top verticals sites
 *
 * @param {topVerticalsSitesParams} params - The parameters for this event
 * @property {GUID} msid - site id
 * @property {string} vertical - The vertical list in which the site and account considered as top one
 * @return {LogObject<topVerticalsSitesParams>} LogObject<topVerticalsSitesParams>
 */
export function topVerticalsSites(params) {
    return { evid: 722, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'lastUserSatisfactionSurveyScore' event (evid: 723)
 *
 * Event description: Last user satisfaction survey score (Customer Care survey)
 *
 * @param {lastUserSatisfactionSurveyScoreParams} params - The parameters for this event
 * @property {string} survey_score - All the scores the user gave on the survey + the submission date
 * @return {LogObject<lastUserSatisfactionSurveyScoreParams>} LogObject<lastUserSatisfactionSurveyScoreParams>
 */
export function lastUserSatisfactionSurveyScore(params) {
    return { evid: 723, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userFrustrationScore' event (evid: 724)
 *
 * Event description: Includes the Customer Care's User Frustration Score for each user based on his recent activity with Customer Care and Wix.
 *
 * @param {userFrustrationScoreParams} params - The parameters for this event
 * @property {number} frustration_score - The frustration score of the user
 * @return {LogObject<userFrustrationScoreParams>} LogObject<userFrustrationScoreParams>
 */
export function userFrustrationScore(params) {
    return { evid: 724, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userPreferredCommunicationMethod' event (evid: 725)
 *
 * Event description: Includes the user's Preferred communication method with Customer Care based on the user's activity history
 *
 * @param {userPreferredCommunicationMethodParams} params - The parameters for this event
 * @property {string} user_preferred_communication_method - The user's preferred communication method
 * @return {LogObject<userPreferredCommunicationMethodParams>} LogObject<userPreferredCommunicationMethodParams>
 */
export function userPreferredCommunicationMethod(params) {
    return { evid: 725, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbTrendingArticlesPerUser' event (evid: 729)
 *
 * Event description: Includes for each user the trending articles the user should see on the Help Center homepage. Generated by a data model.
 *
 * @param {kbTrendingArticlesPerUserParams} params - The parameters for this event
 * @property {string} trending_article_list - The trending article list order by their desired ranking
 * @return {LogObject<kbTrendingArticlesPerUserParams>} LogObject<kbTrendingArticlesPerUserParams>
 */
export function kbTrendingArticlesPerUser(params) {
    return { evid: 729, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userProficiency' event (evid: 733)
 *
 * Event description: Update User Proficiency (for Customer Care Smart Routing)
 * Possible values 2,3 (higher number means higher proficiency)
 *
 * @param {userProficiencyParams} params - The parameters for this event
 * @property {string} user_proficiency - User proficiency for smart routing
 * @return {LogObject<userProficiencyParams>} LogObject<userProficiencyParams>
 */
export function userProficiency(params) {
    return { evid: 733, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummySupportPriorityClassSrc70Evid999' event (evid: 999)
 *
 * Event description: DUMMY Support Priority Class
 *
 *
 * @param {dummySupportPriorityClassSrc70Evid999Params} params - The parameters for this event
 * @property {string} top_user_type - Top user type
 * @property {number} class - Priority level assigned to the user
 * @return {LogObject<dummySupportPriorityClassSrc70Evid999Params>} LogObject<dummySupportPriorityClassSrc70Evid999Params>
 */
export function dummySupportPriorityClassSrc70Evid999(params) {
    return { evid: 999, src: 70, endpoint: '', params };
}
/**
 * A function to create a log object for the 'omniChannelAndChannelDashboardsHoverTooltip' event (evid: 1)
 *
 * Event description: hover over tooltips in omni channel, chat dashboard and call center dashboard
 *
 * @param {omniChannelAndChannelDashboardsHoverTooltipParams} params - The parameters for this event
 * @property {string} locale - on which language was the action performed?
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @property {GUID} channel_id - on which channel was the action performed?
 * @property {string} dashboard - from which dashboard was the action performed? (omni channel, chat dashboard, call center dashboard)
 * @property {string} tooltip_name - on which tooltip was the action performed?
 * @return {LogObject<omniChannelAndChannelDashboardsHoverTooltipParams>} LogObject<omniChannelAndChannelDashboardsHoverTooltipParams>
 */
export function omniChannelAndChannelDashboardsHoverTooltip(params) {
    return { evid: 1, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toolkitAiEAssistantAnswersFromTheAi' event (evid: 10)
 *
 * Event description: AI assistant answers expert's question.
 *
 * @param {toolkitAiEAssistantAnswersFromTheAiParams} params - The parameters for this event
 * @property {GUID} answers_agent_id - who is the expert that opened the Ai assistant
 * @property {string} article_id - the article_id
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {GUID} tenant_id - the article tenant_id
 * @property {string} sources - array of the sources with links to the real articles
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {number} order_number - Order of the answer as presented to the user; when null then the answer want presented
 * @property {string} answer_of_ai - the content of the message that the AI answers
 * @property {string} error_type - If there is an error, what error has sent
 * @property {string} expert_question - the content of the expert’s question that he send
 * @property {string} version - The version of the AI
 * @property {DateTime} request_time - time of the request
 * @property {GUID} uuid - The uuid of the expert that opened the Ai assistant
 * @return {LogObject<toolkitAiEAssistantAnswersFromTheAiParams>} LogObject<toolkitAiEAssistantAnswersFromTheAiParams>
 */
export function toolkitAiEAssistantAnswersFromTheAi(params) {
    return { evid: 10, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpStartSignUpFlow' event (evid: 100)
 *
 * Event description: Click on one of the 'Get Started' buttons in wixanswers.com's homepage / 'Don't have an account? Sign Up here' on login first step (page 'Enter Your Wix Answers Domain')
 *
 * @param {marketingSignUpStartSignUpFlowParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} referral_name - referral
 * @property {string} location - The field will be deprecated
 * @property {GUID} session_id - A unique guid for sign up flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - The field will be deprecated
 * @property {GUID} client_id - Answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {number} campaign_id - The field will be deprecated
 * @return {LogObject<marketingSignUpStartSignUpFlowParams>} LogObject<marketingSignUpStartSignUpFlowParams>
 */
export function marketingSignUpStartSignUpFlow(params) {
    return { evid: 100, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsLinkArticleToATicket' event (evid: 1001)
 *
 * Event description: Linking an article to a ticket.event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsLinkArticleToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} attach_method - article attachment method (immediate/paste-link/paste-content)
 * @property {string} origin_name - source name (search/suggestion/create ticket)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - the string used for searching relevant articles (input search term/ticket subject)
 * @property {GUID} article_id - linked article id
 * @property {string} suggested_article_ids - IDs of all the articles that appeared in the "suggestions component"
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @property {string} order_location - article order location in search/suggestions
 * @return {LogObject<appTicketsLinkArticleToATicketParams>} LogObject<appTicketsLinkArticleToATicketParams>
 */
export function appTicketsLinkArticleToATicket(params) {
    return { evid: 1001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveRelatedArticleFromATicket' event (evid: 1002)
 *
 * Event description: Remove a related article from a ticket
 *
 * @param {appTicketsRemoveRelatedArticleFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - linked article id
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsRemoveRelatedArticleFromATicketParams>} LogObject<appTicketsRemoveRelatedArticleFromATicketParams>
 */
export function appTicketsRemoveRelatedArticleFromATicket(params) {
    return { evid: 1002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsThumbsDownASuggestedArticle' event (evid: 1003)
 *
 * Event description: Voting against a suggested article for a ticket
 *
 * @param {appTicketsThumbsDownASuggestedArticleParams} params - The parameters for this event
 * @property {GUID} ticket_id - related ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - the string used for searching relevant articles is the ticket subject
 * @property {GUID} article_id - linked article id
 * @property {string} article_name - linked article name
 * @property {string} lang - answers lang
 * @property {string} order_location - article order location in search/suggestions
 * @return {LogObject<appTicketsThumbsDownASuggestedArticleParams>} LogObject<appTicketsThumbsDownASuggestedArticleParams>
 */
export function appTicketsThumbsDownASuggestedArticle(params) {
    return { evid: 1003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsSearchForATicket' event (evid: 1004)
 *
 * Event description: Search for a ticket in the search line
 *
 * @param {appTicketsSearchForATicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} number_of_related_tickets - number of returned tickets
 * @property {string} search_term - the string used to search a ticket
 * @property {string} first_answer - Title of first ticket shown to the user
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsSearchForATicketParams>} LogObject<appTicketsSearchForATicketParams>
 */
export function appTicketsSearchForATicket(params) {
    return { evid: 1004, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsPressButtonCreateTicket' event (evid: 1005)
 *
 * Event description: Press the button to + Create ticket
 *
 * @param {appTicketsPressButtonCreateTicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsPressButtonCreateTicketParams>} LogObject<appTicketsPressButtonCreateTicketParams>
 */
export function appTicketsPressButtonCreateTicket(params) {
    return { evid: 1005, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsCreateATicket' event (evid: 1006)
 *
 * Event description: create a ticket with all its details - click "Create ticket" blue button
 *
 * @param {appTicketsCreateATicketParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsCreateATicketParams>} LogObject<appTicketsCreateATicketParams>
 */
export function appTicketsCreateATicket(params) {
    return { evid: 1006, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxClickOnATicket' event (evid: 1007)
 *
 * Event description: Click on a ticket from the list. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxClickOnATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {Ticket list, email, notification list...}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} position - position of the ticket in the page (1,2,3...)
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxClickOnATicketParams>} LogObject<appTicketsOneInboxClickOnATicketParams>
 */
export function appTicketsOneInboxClickOnATicket(params) {
    return { evid: 1007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxChangeTicketStatus' event (evid: 1008)
 *
 * Event description: Ticket top bar - Status changed (click on button after selecting a new status). event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsOneInboxChangeTicketStatusParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name {pending, closed...}
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxChangeTicketStatusParams>} LogObject<appTicketsOneInboxChangeTicketStatusParams>
 */
export function appTicketsOneInboxChangeTicketStatus(params) {
    return { evid: 1008, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketClick' event (evid: 1009)
 *
 * Event description: click "delete" option from the bottom bar. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteATicketClickParams>} LogObject<appTicketsOneInboxDeleteATicketClickParams>
 */
export function appTicketsOneInboxDeleteATicketClick(params) {
    return { evid: 1009, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpClickSignUpWithSso' event (evid: 101)
 *
 * Event description: Click on the "Signup with .." button on the first personal step of sign up flow
 *
 * @param {marketingSignUpClickSignUpWithSsoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {string} sso_type - wix/ google / facebook
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpClickSignUpWithSsoParams>} LogObject<marketingSignUpClickSignUpWithSsoParams>
 */
export function marketingSignUpClickSignUpWithSso(params) {
    return { evid: 101, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteATicketConfirm' event (evid: 1010)
 *
 * Event description: Delete a ticket from the action bar confirm - click the red button. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteATicketConfirmParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - status name
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} is_blocked - Did the user check the "block user" check
 * @property {string} permission_level - User's permission level
 * @property {number} status_id - status id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteATicketConfirmParams>} LogObject<appTicketsOneInboxDeleteATicketConfirmParams>
 */
export function appTicketsOneInboxDeleteATicketConfirm(params) {
    return { evid: 1010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAddEmailReplySuccess' event (evid: 1011)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsOneInboxAddEmailReplySuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxAddEmailReplySuccessParams>} LogObject<appTicketsOneInboxAddEmailReplySuccessParams>
 */
export function appTicketsOneInboxAddEmailReplySuccess(params) {
    return { evid: 1011, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsDeleteAReplyClick' event (evid: 1012)
 *
 * Event description: Click Delete a reply from a ticket. event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsDeleteAReplyClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsDeleteAReplyClickParams>} LogObject<appTicketsDeleteAReplyClickParams>
 */
export function appTicketsDeleteAReplyClick(params) {
    return { evid: 1012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyConfirm' event (evid: 1013)
 *
 * Event description: Click "OK" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyConfirmParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>} LogObject<appTicketsOneInboxDeleteAReplyConfirmParams>
 */
export function appTicketsOneInboxDeleteAReplyConfirm(params) {
    return { evid: 1013, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxDeleteAReplyCancel' event (evid: 1014)
 *
 * Event description: Click "Cancel" after being asked "Are you sure?". event is triggered from both Tickets and One Inbox modules,
 *
 * @param {appTicketsOneInboxDeleteAReplyCancelParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - reply's content
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxDeleteAReplyCancelParams>} LogObject<appTicketsOneInboxDeleteAReplyCancelParams>
 */
export function appTicketsOneInboxDeleteAReplyCancel(params) {
    return { evid: 1014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsClickOnAnIcon' event (evid: 1015)
 *
 * Event description: Click on one of the icons in the reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsClickOnAnIconParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} icon_type - {emoji, KB, attachment, saved replies...}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsClickOnAnIconParams>} LogObject<appTicketsClickOnAnIconParams>
 */
export function appTicketsClickOnAnIcon(params) {
    return { evid: 1015, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAttachmentAddedToReply' event (evid: 1016)
 *
 * Event description: Add attachment to reply. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsAttachmentAddedToReplyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} attachment_type - attachment file type
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAttachmentAddedToReplyParams>} LogObject<appTicketsAttachmentAddedToReplyParams>
 */
export function appTicketsAttachmentAddedToReply(params) {
    return { evid: 1016, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsEmojiAddedToReply' event (evid: 1017)
 *
 * Event description: Select and click on the emoji itself. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsEmojiAddedToReplyParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {team note/reply/create ticket}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} emoji_type - emoji type {smiley, joy...}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsEmojiAddedToReplyParams>} LogObject<appTicketsEmojiAddedToReplyParams>
 */
export function appTicketsEmojiAddedToReply(params) {
    return { evid: 1017, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsSavedReplyAdded' event (evid: 1018)
 *
 * Event description: click "add to reply" after selecting the reply content
 *
 * @param {appTicketsSavedReplyAddedParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - Saved reply added either from the icon or by a hashtag
 * @property {string} results_option - {shared, personal}
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} content - saved reply's title
 * @property {string} shortcut - name of hashtag that is defined for this saved reply
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsSavedReplyAddedParams>} LogObject<appTicketsSavedReplyAddedParams>
 */
export function appTicketsSavedReplyAdded(params) {
    return { evid: 1018, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsSwitchReplyType' event (evid: 1019)
 *
 * Event description: Team Note - Switch reply type
 *
 * @param {appTicketsSwitchReplyTypeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - saved reply id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {string} switch_to - desired reply mode {team note/reply}
 * @return {LogObject<appTicketsSwitchReplyTypeParams>} LogObject<appTicketsSwitchReplyTypeParams>
 */
export function appTicketsSwitchReplyType(params) {
    return { evid: 1019, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAddALabelClick' event (evid: 1020)
 *
 * Event description: Click the + button from inside a ticket in order to add a label
 *
 * @param {appTicketsAddALabelClickParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddALabelClickParams>} LogObject<appTicketsAddALabelClickParams>
 */
export function appTicketsAddALabelClick(params) {
    return { evid: 1020, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnTicketLevel' event (evid: 10200)
 *
 * Event description: This event will be sent every time there is a routing attempt and the ticket is searching the relevant and available expert. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnTicketLevelParams} params - The parameters for this event
 * @property {string} skill_ids - list of all the skills on the ticket
 * @property {GUID} agentSelected - the expert that the ticket were routed to evantually
 * @property {GUID} ticket_id - ticket_id
 * @property {number} filtered - last routing  filtered population - number of agents in the group that capable in the exact moment to take the ticket
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel id of the ticket in the exact ar process
 * @property {string} routingId - change every time that there is a change on a ticket that requires new routing (like skill change)
 * @property {string} assignmentId - change every routing attempt
 * @property {boolean} isTicketMatch - checks if the ticket find a relevant expert
 * @property {number} groupMembers - number of agents assigned to the group with no consideration of filters/skills/availability/etc.
 * @property {number} candidates - first routing filtered population - number of agents in the group and who had any action in answers impacting on AR since June 2023
 * @property {string} failedCandidates - array of the reasons for all agent that in candidates list but fall before filtered list
 * @property {GUID} interactionId - call_id if it's a call, chat_id if it's a chat
 * @property {DateTime} last_update_time - the date the ar process was triggered
 * @property {string} groupId - group id of the ticket
 * @property {string} sortedSummary - array of agent_id of all agents that can be matched to the ticket, the first one is the chosen to the ticket and reasons
 * @property {boolean} isTransfer - is the trigger to the ar process is transfer action
 * @property {string} language - the language code on the ticket same moment
 * @property {GUID} userId - agent id or tenant id when there is no user
 * @return {LogObject<autoRoutingOnTicketLevelParams>} LogObject<autoRoutingOnTicketLevelParams>
 */
export function autoRoutingOnTicketLevel(params) {
    return { evid: 10200, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverAnswerToAutoRoutingTicket' event (evid: 10201)
 *
 * Event description: This event will be sent every time there is a routing attempt and the answer from the server if it's fails the routing attempt or not (for example if the same ticket is routed to more than one expert at the same routing attempt
 *
 * @param {serverAnswerToAutoRoutingTicketParams} params - The parameters for this event
 * @property {GUID} agentSelected - selected agent id
 * @property {string} routingId - routing id
 * @property {string} ticketId - ticket id
 * @property {number} statusId - if the server didn't failed the routing attempt, what is the status of the ticket (declined, missed, accept)
 * @property {string} status - if the server didn't failed the routing attempt, what is the status of the ticket (declined, missed, accept)
 * @property {boolean} isFailed - is the server failed the routing attempt
 * @return {LogObject<serverAnswerToAutoRoutingTicketParams>} LogObject<serverAnswerToAutoRoutingTicketParams>
 */
export function serverAnswerToAutoRoutingTicket(params) {
    return { evid: 10201, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsLabelAddedToTicket' event (evid: 1021)
 *
 * Event description: Click the + button in order to add a label. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsLabelAddedToTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {ticket filters (include/exclude), ticket top bar}
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} label_name - label name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {boolean} is_new_label - was the label just created?
 * @property {GUID} label_id - label id
 * @return {LogObject<appTicketsLabelAddedToTicketParams>} LogObject<appTicketsLabelAddedToTicketParams>
 */
export function appTicketsLabelAddedToTicket(params) {
    return { evid: 1021, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveLabelFromATicket' event (evid: 1022)
 *
 * Event description: Click a label in order to remove it from the ticket. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsRemoveLabelFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {ticket filters (include/exclude), ticket top bar}
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} label_name - label name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers lang
 * @property {GUID} label_id - label id
 * @return {LogObject<appTicketsRemoveLabelFromATicketParams>} LogObject<appTicketsRemoveLabelFromATicketParams>
 */
export function appTicketsRemoveLabelFromATicket(params) {
    return { evid: 1022, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAddReplyAttempt' event (evid: 1023)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddReplyAttemptParams>} LogObject<appTicketsAddReplyAttemptParams>
 */
export function appTicketsAddReplyAttempt(params) {
    return { evid: 1023, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAddReplyFail' event (evid: 1024)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note"
 *
 * @param {appTicketsAddReplyFailParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} reply_and_go_to_tickets_list - true is when the Reply and Go to Tickets List is checked when the reply is submitted. false is when it's checked off
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} failReason - fail_reason
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsAddReplyFailParams>} LogObject<appTicketsAddReplyFailParams>
 */
export function appTicketsAddReplyFail(params) {
    return { evid: 1024, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAssignATicket' event (evid: 1025)
 *
 * Event description: Assign a ticket to a Group or to an Agent. event is triggered from both Tickets and One Inbox modules.
 *
 * @param {appTicketsAssignATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id of the ticket being assigned
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} to_entity_name - name of the entity which the ticket is assigned to{ Group name, for user it will be null} for real time use. ***in order to use history please use the groups table
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user who assigning the ticket
 * @property {string} operator - who made the assignment { User or Macro }
 * @property {GUID} to_entity_id - id of the entity which the ticket is assigned to{ Group ID, User ID}
 * @property {string} to_entity_type - Type of the entity which the ticket is assigned to {Group, Agent}
 * @return {LogObject<appTicketsAssignATicketParams>} LogObject<appTicketsAssignATicketParams>
 */
export function appTicketsAssignATicket(params) {
    return { evid: 1025, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxAMemberClientEngagement' event (evid: 1026)
 *
 * Event description: A generic event for member's clicks/engagements related to One Inbox different components: Views Panel, Tickets List, Ticket Item, Ticket Header, Ticket Actions (footer), Reply Box, Info Panel, App header and Bulk Actions
 *
 * @param {appOneInboxAMemberClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Change Ticket Status, (2) Ticket Info, (3) Views, (4) Pin/Unpin menu etc.
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data related to the member's engagement. Examples: (1) when changing ticket priority it will show priority before and after, ticket ID etc. , (2) when clicking on a ticket it will show ticket ID
 * @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: Views Panel, Tickets list, Ticket Item, reply box etc.
 * @property {GUID} role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The name of the Engagement
 * @property {string} layout - ticket list page layout (table/side by side/ list)
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxAMemberClientEngagementParams>} LogObject<appOneInboxAMemberClientEngagementParams>
 */
export function appOneInboxAMemberClientEngagement(params) {
    return { evid: 1026, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketListPageLoadSuccess' event (evid: 1027)
 *
 * Event description: This Event is triggered every time the Ticket List Page is Loaded Successfully in One Inbox.
 * (please remember to create position columns for all existed columns of table layout and let me know their names afterwards and I will add them to the event)
 *
 * @param {appOneInboxTicketListPageLoadSuccessParams} params - The parameters for this event
 * @property {string} table_or_list_sort - If Layout is Table or List - The Type of sort (newest reply, highest priority etc.)
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} layout_type - Ticket List layout type (Split Pane, List or Table)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} ticket_list_width - If Layout is Split Pane  - Active and Inactive ticket list width
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {boolean} is_my_activity - True - if "only my activity" toggle is enabled, False - if not
 * @property {string} ticket_page_area_width - If Layout is Split Pane -  The ticket page area width
 * @property {boolean} is_views_pinned - Is view menu pinned (True or False)
 * @property {number} ticket_subject_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {string} active_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {number} first_message_position - If Layout is Table what is the position of this column, if layout is table and the column is not presented - 0, if layout is not table - NULL
 * @property {GUID} view_id - The Ticket List view ID
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {boolean} is_active_ticket_list_collapsed - True, False or blank (if If layout is Split Pane)
 * @property {string} active_ticket_list_height - If Layout is Split Pane  - Active ticket list height
 * @property {number} screen_height - View Port height
 * @property {string} inactive_ticket_list_height - If Layout is Split Pane - Inactive ticket list height
 * @property {string} status_filter - For all layouts (if Split pane - Inactive list) - What status filter is being applied (all, open, solved etc.)
 * @property {string} inactive_ticket_list_sort - If Layout is Split Pane - The Type of sort (newest reply, highest priority etc.)
 * @property {string} lang - answers language
 * @property {string} table_column_positions - If Layout is Table - A Json with all the columns appear in the table layout and their positions, if layout is not table - NULL
 * @property {string} ticket_view_filters - A json with all the filters being applied as part of the ticket view
 * @return {LogObject<appOneInboxTicketListPageLoadSuccessParams>} LogObject<appOneInboxTicketListPageLoadSuccessParams>
 */
export function appOneInboxTicketListPageLoadSuccess(params) {
    return { evid: 1027, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketPagePageLoadSuccess' event (evid: 1028)
 *
 * Event description: This Event is triggered every time the Ticket page is Loaded Successfully in One Inbox
 *
 * @param {appOneInboxTicketPagePageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} is_show_reply_suggestions - True or False - according to reply box settings
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {boolean} is_add_signature - True or False - according to reply box settings
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {boolean} is_set_and_end_action - True or False - according to reply box settings
 * @property {string} ticket_page_width - Ticket page width
 * @property {number} screen_height - View Port height
 * @property {boolean} is_send_and_assign_to_me - True or False - according to reply box settings
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxTicketPagePageLoadSuccessParams>} LogObject<appOneInboxTicketPagePageLoadSuccessParams>
 */
export function appOneInboxTicketPagePageLoadSuccess(params) {
    return { evid: 1028, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsTicketSnoozeStart' event (evid: 1029)
 *
 * Event description: A ticket has been snoozed by an Answers member.
 *
 * @param {appTicketsTicketSnoozeStartParams} params - The parameters for this event
 * @property {GUID} ticket_id - The Id of the Ticket being snoozed
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} week_start_day - TBD - The first day of the week according to the snooze settings (Sunday, Monday)
 * @property {string} snooze_type - The type of Snooze time reference used (Later today, Tomorrow, next week, choose Date & Time)
 * @property {boolean} costumer_reply_unsnooze - Should snooze be ended (canceled) if user reply the ticket (True/False)
 * @property {boolean} is_from_bulk - True - if the Snooze triggered as part of bulk Action, False - If not
 * @property {boolean} is_snooze_update - True- if  it is a Snooze update, False - if it is a "New Snooze"
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member updating the snooze
 * @property {boolean} change_status_to_open - Does end of snooze should change ticket status to open (True/False)
 * @property {GUID} macro_id - Phase 2 - If done by Macro - Macro ID, if not - Null
 * @property {string} operator - Phase 2 - Who made the action (Member, Macro, Spotter)
 * @property {boolean} send_notification - True / False - according to snooze settings
 * @property {GUID} scenario_id - Phase 2 - If done by Spotter - Scenario ID, if not - Null
 * @property {GUID} snooze_id - ID of the Snooze
 * @property {DateTime} last_snooze_time - If it is a Snooze Update, what was the last Snooze time before the update
 * @property {DateTime} snooze_time - The Time the ticket was set to be snoozed
 * @return {LogObject<appTicketsTicketSnoozeStartParams>} LogObject<appTicketsTicketSnoozeStartParams>
 */
export function appTicketsTicketSnoozeStart(params) {
    return { evid: 1029, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingClickSubmitSignUpForm' event (evid: 103)
 *
 * Event description: User attempt to submit the sign- up form.
 *
 * @param {marketingClickSubmitSignUpFormParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingClickSubmitSignUpFormParams>} LogObject<marketingClickSubmitSignUpFormParams>
 */
export function marketingClickSubmitSignUpForm(params) {
    return { evid: 103, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsOneInboxAddEmailReplyFailedSrc77Evid1030' event (evid: 1030)
 *
 * Event description: Write a reply for a ticket + click "Send" or "Send & Resolve" or "Post note" and its failed
 *
 * @param {appTicketsOneInboxAddEmailReplyFailedSrc77Evid1030Params} params - The parameters for this event
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} reply_id - reply id
 * @property {string} permission_level - User's permission level
 * @property {string} reply_type - {team note/reply}
 * @property {GUID} client_id - client_id
 * @property {GUID} answers_user_id - Expert Answers uuid
 * @property {string} resolution - what is the desired status of the ticket after sending the reply {Open, closed, investigating, resolved, none}
 * @property {string} lang - answers lang
 * @return {LogObject<appTicketsOneInboxAddEmailReplyFailedSrc77Evid1030Params>} LogObject<appTicketsOneInboxAddEmailReplyFailedSrc77Evid1030Params>
 */
export function appTicketsOneInboxAddEmailReplyFailedSrc77Evid1030(params) {
    return { evid: 1030, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnTicketLevelArTenant' event (evid: 10301)
 *
 * Event description: This event will be sent every time there is a routing attempt and the ticket is searching the relevant and available expert. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnTicketLevelArTenantParams} params - The parameters for this event
 * @property {string} skill_ids - list of all the skills on the ticket
 * @property {GUID} agentSelected - the expert that the ticket were routed to evantually
 * @property {GUID} ticket_id - ticket_id
 * @property {number} filtered - last routing  filtered population - number of agents in the group that capable in the exact moment to take the ticket
 * @property {GUID} tenant_id - tenant_id
 * @property {string} channel - channel id of the ticket in the exact ar process
 * @property {string} routingId - change every time that there is a change on a ticket that requires new routing (like skill change)
 * @property {string} assignmentId - change every routing attempt
 * @property {boolean} isTicketMatch - checks if the ticket find a relevant expert
 * @property {number} groupMembers - number of agents assigned to the group with no consideration of filters/skills/availability/etc.
 * @property {number} candidates - first routing filtered population - number of agents in the group and who had any action in answers impacting on AR since June 2023
 * @property {string} failedCandidates - array of the reasons for all agent that in candidates list but fall before filtered list
 * @property {GUID} interactionId - call_id if it's a call, chat_id if it's a chat
 * @property {DateTime} last_update_time - the date the ar process was triggered
 * @property {string} groupId - group id of the ticket
 * @property {string} sortedSummary - array of agent_id of all agents that can be matched to the ticket, the first one is the chosen to the ticket and reasons
 * @property {boolean} isTransfer - is the trigger to the ar process is transfer action
 * @property {string} language - the language code on the ticket same moment
 * @property {GUID} userId - agent id or tenant id when there is no user
 * @return {LogObject<autoRoutingOnTicketLevelArTenantParams>} LogObject<autoRoutingOnTicketLevelArTenantParams>
 */
export function autoRoutingOnTicketLevelArTenant(params) {
    return { evid: 10301, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'autoRoutingOnExpertLevelArTenant' event (evid: 10302)
 *
 * Event description: This event will be sent for tickets in the waiting list while the expert become available. NOTE: there are duplicates due to different hosts, you can add host field or remove the duplicates
 *
 * @param {autoRoutingOnExpertLevelArTenantParams} params - The parameters for this event
 * @property {string} sortedTicketsSummary - array of ticket_id of all tickets that can be matched to the expert, the first one is the chosen to the expert and reasons
 * @property {string} agentId - agent id that became available to take ticket
 * @property {string} routingId - change every time that there is a change on a ticket that requires new routing (like skill change)
 * @property {string} assignmentId - change every routing attempt
 * @property {string} failedTicketsSummary - array of the reasons for all ticket that in waiting list but fall before filtered list
 * @property {boolean} isTicketMatch - checks if the expert find a relevant ticket
 * @property {GUID} interactionId - call_id if it's a call, chat_id if it's a chat
 * @property {string} ticketSelected - the ticket that were routed to an expert
 * @property {number} unassignedTicketsNum - number of tickets in the waiting list
 * @property {string} agentSkillIds - agent skill ids
 * @property {string} pendingTickets - all pending tickets ids that are waiting (the 30 sec that the ticket waits for an expert to answer)
 * @property {string} ticketSkillIds - ticket skill ids
 * @property {number} filteredTasks - number of tickets in the waiting list and group that relevant to be routed
 * @property {number} pendingTicketsNum - total pending tickets
 * @property {string} ticketGroupInfo - group id of the ticket
 * @property {string} unassignedTickets - tickets in the waiting list
 * @property {string} channelId - channel id of the ticket in the exact ar process
 * @return {LogObject<autoRoutingOnExpertLevelArTenantParams>} LogObject<autoRoutingOnExpertLevelArTenantParams>
 */
export function autoRoutingOnExpertLevelArTenant(params) {
    return { evid: 10302, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverAnswerToAutoRoutingExperts' event (evid: 10303)
 *
 * Event description: This event will be sent every time there is a routing attempt and the answer from the server if it's fails the routing attempt or not (for example if the same ticket is routed to more than one expert at the same routing attempt
 *
 * @param {serverAnswerToAutoRoutingExpertsParams} params - The parameters for this event
 * @property {GUID} agentSelected - selected agent id
 * @property {string} routingId - routing id
 * @property {string} ticketSelected - ticket id
 * @property {number} statusId - if the server didn't failed the routing attempt, what is the status of the ticket (declined, missed, accept)
 * @property {string} status - if the server didn't failed the routing attempt, what is the status of the ticket (declined, missed, accept)
 * @property {boolean} isFailed - is the server failed the routing attempt
 * @return {LogObject<serverAnswerToAutoRoutingExpertsParams>} LogObject<serverAnswerToAutoRoutingExpertsParams>
 */
export function serverAnswerToAutoRoutingExperts(params) {
    return { evid: 10303, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoFormModal' event (evid: 10304)
 *
 * Event description: Fire when a form modal is being opened and interacted inside the KB back office in Answers
 *
 * @param {kbBoFormModalParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} modal_name - {'content_generator' / 'content_rephraser'}
 * @property {string} action_type - {'load'/'click'}
 * @property {string} modal_step - {'add_parameters'/'options'}
 * @property {string} button_name - the name of the button the user clicked on
 * @property {string} params - The input parameters that the user added in the form
 * @property {number} option_order - The order of the item that the user chose (from top to bottom)
 * @property {string} option_text - The text of the item the user chose
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} kb_bo_page - The page in the BO the user was on when interacting with the modal {'roadmap','categories','article list','article'}
 *
 * @return {LogObject<kbBoFormModalParams>} LogObject<kbBoFormModalParams>
 */
export function kbBoFormModal(params) {
    return { evid: 10304, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoMessageModal' event (evid: 10305)
 *
 * Event description: Fire when a warning/error/failed/confirmation modal is being opened and interacted inside the KB back office in Answers
 *
 * @param {kbBoMessageModalParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that viewed the modal
 * @property {GUID} article_id - {optional} the article id for which the modal was opened for
 * @property {string} article_language - {optional} the article language code for which the modal was opened for
 * @property {string} related_feature - the feature in the BO which the modal relates to
 * @property {string} modal_name - the modal unique name
 * @property {string} action_type - {'load'/'click'}
 * @property {string} button_name - the name of the button the user clicked on
 * @property {string} kb_bo_page - The page in the BO the user was on when interacting with the modal {'roadmap','categories','article list','article'}
 * @property {string} reason - The detailed reasons for which the action failed
 * @return {LogObject<kbBoMessageModalParams>} LogObject<kbBoMessageModalParams>
 */
export function kbBoMessageModal(params) {
    return { evid: 10305, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoArticleAbTestStart' event (evid: 10307)
 *
 * Event description: Fire when a KB article AB test was started via the dedicated feature in the articles back office in Answers
 *
 * @param {kbBoArticleAbTestStartParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that started the test
 * @property {GUID} article_id - The article ID for which the test was started
 * @property {number} petri_experiment_id - The experiment ID in Petri of the test
 * @property {string} locale - The article language code for which the test was started
 * @return {LogObject<kbBoArticleAbTestStartParams>} LogObject<kbBoArticleAbTestStartParams>
 */
export function kbBoArticleAbTestStart(params) {
    return { evid: 10307, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoItemClickSrc77Evid10308' event (evid: 10308)
 *
 * Event description: Fire when a user clicks a link/button in the KB back office
 *
 * @param {kbBoItemClickSrc77Evid10308Params} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} item_name - the name of the button/link the user clicked on
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} kb_bo_page - The page in the BO the user was on when interacting with the modal {'roadmap','categories','article list','article'}
 * @property {string} clicked_item_type - type of item clicked
 * @return {LogObject<kbBoItemClickSrc77Evid10308Params>} LogObject<kbBoItemClickSrc77Evid10308Params>
 */
export function kbBoItemClickSrc77Evid10308(params) {
    return { evid: 10308, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoArticleAbTestEnd' event (evid: 10309)
 *
 * Event description: Fire when a KB article AB test was ended via the dedicated feature in the articles back office in Answers
 *
 *
 * @param {kbBoArticleAbTestEndParams} params - The parameters for this event
 * @property {GUID} article_id - The article ID for which the test was ended
 * @property {string} published_version_2 - The article version that was opened to 100% after the test was ended {'A'/'B')
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {GUID} user_answers_id - The Answers ID of the user that ended the test
 * @property {number} petri_experiment_id - The experiment ID in Petri of the test
 * @property {string} locale - The article language code for which the test was ended
 * @return {LogObject<kbBoArticleAbTestEndParams>} LogObject<kbBoArticleAbTestEndParams>
 */
export function kbBoArticleAbTestEnd(params) {
    return { evid: 10309, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxStartActiveSession' event (evid: 1031)
 *
 * Event description: This Event is triggered every time a member is starting an active session by clicking the "Take Ticket"/"Join Active session" button or by start typing in the reply box.
 *
 * @param {appOneInboxStartActiveSessionParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {number} ticket_existed_active_sessions - The number of active sessions the ticket already have
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The Channel of the ticket
 * @property {string} start_session_type - Take Ticket/Join Active session/start typing
 * @property {string} assigned_entity - Second phase - Is the ticket assigned to a Group or Member
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} member_existed_active_sessions - The number of active sessions the member already have
 * @property {GUID} user_id - Answers user ID of the member loading the page
 * @property {GUID} assigned_entity_id - assigned_entity_id
 * @property {number} ticket_status_type - Second phase - Ticket Status
 * @property {string} lang - Answers language
 * @return {LogObject<appOneInboxStartActiveSessionParams>} LogObject<appOneInboxStartActiveSessionParams>
 */
export function appOneInboxStartActiveSession(params) {
    return { evid: 1031, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessFirstStep' event (evid: 104)
 *
 * Event description: success on first step of the sign up flow
 *
 * @param {marketingSignUpSignUpSuccessFirstStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} wix_user_id - wix user id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {GUID} wix_client_id - Wix client (Anonymous) ID
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpSuccessFirstStepParams>} LogObject<marketingSignUpSignUpSuccessFirstStepParams>
 */
export function marketingSignUpSignUpSuccessFirstStep(params) {
    return { evid: 104, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedFirstStep' event (evid: 105)
 *
 * Event description: User's first step of sign up failed
 *
 * @param {marketingSignUpSignUpFailedFirstStepParams} params - The parameters for this event
 * @property {string} errorReason - the reason for the failure
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} error_reason - the reason for the failure
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpFailedFirstStepParams>} LogObject<marketingSignUpSignUpFailedFirstStepParams>
 */
export function marketingSignUpSignUpFailedFirstStep(params) {
    return { evid: 105, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSubmitSignUpSecondStep' event (evid: 106)
 *
 * Event description: User sign up attempt on the second step of sign in flow of organization registartion
 *
 * @param {marketingSignUpSubmitSignUpSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSubmitSignUpSecondStepParams>} LogObject<marketingSignUpSubmitSignUpSecondStepParams>
 */
export function marketingSignUpSubmitSignUpSecondStep(params) {
    return { evid: 106, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpSuccessSecondStep' event (evid: 107)
 *
 * Event description: Click on the "Log In" button to start l````````````````````````````````````````````````````````````````````````````````````````````````````````````ogin form in wixanswers.com's homepage or from sign up the first step-
 *
 * @param {marketingSignUpSignUpSuccessSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id
 * @property {string} referral_name - referral
 * @property {string} location - DEPRECATE
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - client_id
 * @property {GUID} wix_user_id - wix user id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} sign_up_method - The method that was used to sign up the user (Email, Wix, Google, etc.)
 * @property {GUID} wix_client_id - Wix client (Anonymous) ID
 * @property {number} campaign_id - DEPRECATE
 * @property {Url} page_url - URL of current page
 * @return {LogObject<marketingSignUpSignUpSuccessSecondStepParams>} LogObject<marketingSignUpSignUpSuccessSecondStepParams>
 */
export function marketingSignUpSignUpSuccessSecondStep(params) {
    return { evid: 107, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingSignUpSignUpFailedSecondStep' event (evid: 108)
 *
 * Event description: User attempt to submit second sign up flow - add organization and URL
 *
 * @param {marketingSignUpSignUpFailedSecondStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client ID
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {string} error_reason - failure reason
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingSignUpSignUpFailedSecondStepParams>} LogObject<marketingSignUpSignUpFailedSecondStepParams>
 */
export function marketingSignUpSignUpFailedSecondStep(params) {
    return { evid: 108, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInSubmitPreLoginRedirectToAnswersUrl' event (evid: 109)
 *
 * Event description: User attempts to continue with his login first step - recognize tenant URL
 *
 * @param {marketingLogInSubmitPreLoginRedirectToAnswersUrlParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - DEPRECATE
 * @property {Url} referral_url - referral
 * @property {string} permission_level - DEPRECATE
 * @property {GUID} client_id - Answers client id
 * @property {GUID} user_id - Answers uuid
 * @property {string} subdomain - Answers URL
 * @property {string} locale - DEPRECATE
 * @property {GUID} marketing_id - DEPRECATE
 * @property {number} campaign_id - DEPRECATE
 * @return {LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>} LogObject<marketingLogInSubmitPreLoginRedirectToAnswersUrlParams>
 */
export function marketingLogInSubmitPreLoginRedirectToAnswersUrl(params) {
    return { evid: 109, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toolkitAiEAssistantClickOnTheAiAssistantFeedback' event (evid: 11)
 *
 * Event description: The feedback of the user that the Ai response to the expert.
 *
 * @param {toolkitAiEAssistantClickOnTheAiAssistantFeedbackParams} params - The parameters for this event
 * @property {GUID} answers_agent_id - who is the expert that opened the Ai assistant
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {string} sources - array of the sources with links to the real articles
 * @property {boolean} feedback_choice - true = helpful / false = unhelpful
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {number} order_number - Order of the answer as presented to the user; when null then the answer want presented
 * @property {string} version - The version of the AI
 * @property {string} feedback_text - free text added by the expert to the feedback
 * @property {string} answer_of_ai - the content of the message that the AI answers
 * @property {GUID} uuid - the uuid of the expert that opened the Ai assistant
 * @return {LogObject<toolkitAiEAssistantClickOnTheAiAssistantFeedbackParams>} LogObject<toolkitAiEAssistantClickOnTheAiAssistantFeedbackParams>
 */
export function toolkitAiEAssistantClickOnTheAiAssistantFeedback(params) {
    return { evid: 11, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectSuccess' event (evid: 110)
 *
 * Event description: User's Pre- login success - redirect tenant URL
 *
 * @param {marketingLogInPreLoginRedirectSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for login flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - The field will be deprtecated
 * @property {GUID} client_id
 * @property {GUID} user_id
 * @property {string} subdomain - Answers tenant URL
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {number} campaign_id - The field will be deprtecated
 * @return {LogObject<marketingLogInPreLoginRedirectSuccessParams>} LogObject<marketingLogInPreLoginRedirectSuccessParams>
 */
export function marketingLogInPreLoginRedirectSuccess(params) {
    return { evid: 110, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveAttempt' event (evid: 1100)
 *
 * Event description: start save process after clicking "Save"
 *
 * @param {appKbEditArticleSaveAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since "save" button clicked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleSaveAttemptParams>} LogObject<appKbEditArticleSaveAttemptParams>
 */
export function appKbEditArticleSaveAttempt(params) {
    return { evid: 1100, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleSaveSuccess' event (evid: 1101)
 *
 * Event description: Finish save process
 *
 * @param {appKbEditArticleSaveSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleSaveSuccessParams>} LogObject<appKbEditArticleSaveSuccessParams>
 */
export function appKbEditArticleSaveSuccess(params) {
    return { evid: 1101, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleDelete' event (evid: 1102)
 *
 * Event description: Click "Delete" from the top bar
 *
 * @param {appKbEditArticleDeleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleDeleteParams>} LogObject<appKbEditArticleDeleteParams>
 */
export function appKbEditArticleDelete(params) {
    return { evid: 1102, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleDeleteConfirm' event (evid: 1103)
 *
 * Event description: Click "Delete" after "Are you sure?" massage
 *
 * @param {appKbEditArticleDeleteConfirmParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleDeleteConfirmParams>} LogObject<appKbEditArticleDeleteConfirmParams>
 */
export function appKbEditArticleDeleteConfirm(params) {
    return { evid: 1103, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublish' event (evid: 1104)
 *
 * Event description: Click "Publish" button
 *
 * @param {appKbEditArticlePublishParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishParams>} LogObject<appKbEditArticlePublishParams>
 */
export function appKbEditArticlePublish(params) {
    return { evid: 1104, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublishConfirm' event (evid: 1105)
 *
 * Event description: Click "Publish my article now" after being asked:
 * "Ready to publish your article?"
 *
 * @param {appKbEditArticlePublishConfirmParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishConfirmParams>} LogObject<appKbEditArticlePublishConfirmParams>
 */
export function appKbEditArticlePublishConfirm(params) {
    return { evid: 1105, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleUnpublish' event (evid: 1106)
 *
 * Event description: Click "Unpublish article" from the top bar
 *
 * @param {appKbEditArticleUnpublishParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticleUnpublishParams>} LogObject<appKbEditArticleUnpublishParams>
 */
export function appKbEditArticleUnpublish(params) {
    return { evid: 1106, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticleAssignCategory' event (evid: 1107)
 *
 * Event description: Choose a category for an article
 *
 * @param {appKbEditArticleAssignCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article/categories page}
 * @property {GUID} orig_parent_id - current category/subcategory of an article (null if new)
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - selected category name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} dest_parent_id - selected category/subcategory
 * @property {GUID} article_id - relevant article id
 * @property {GUID} category_id - selected category id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbEditArticleAssignCategoryParams>} LogObject<appKbEditArticleAssignCategoryParams>
 */
export function appKbEditArticleAssignCategory(params) {
    return { evid: 1107, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbArticlesListSearch' event (evid: 1108)
 *
 * Event description: When the user searches for an article
 *
 * @param {appKbArticlesListSearchParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} search_term - What the user typed
 * @property {string} first_answer - The first article shown to the user (on the left side) - article id
 * @property {string} lang - answers language
 * @property {number} number_of_related_articles - number of returned articles in answer
 * @return {LogObject<appKbArticlesListSearchParams>} LogObject<appKbArticlesListSearchParams>
 */
export function appKbArticlesListSearch(params) {
    return { evid: 1108, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbArticlesListCreateArticle' event (evid: 1109)
 *
 * Event description: Click on the button to "Create new article"
 *
 * @param {appKbArticlesListCreateArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {articles list, categories screen}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - article_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category/subcategory id
 * @return {LogObject<appKbArticlesListCreateArticleParams>} LogObject<appKbArticlesListCreateArticleParams>
 */
export function appKbArticlesListCreateArticle(params) {
    return { evid: 1109, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInPreLoginRedirectFailed' event (evid: 111)
 *
 * Event description: User's Pre- login - redirect tenant URL failed
 *
 * @param {marketingLogInPreLoginRedirectFailedParams} params - The parameters for this event
 * @property {string} errorReason - The failed reason
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for login flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - the field will be deprecated
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} subdomain - The sub-domain entered in the form
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The filed will be deprecated
 * @property {string} error_reason - The failed reason
 * @property {number} campaign_id - The filed will be deprecated
 * @property {Url} page_url - current page
 * @return {LogObject<marketingLogInPreLoginRedirectFailedParams>} LogObject<marketingLogInPreLoginRedirectFailedParams>
 */
export function marketingLogInPreLoginRedirectFailed(params) {
    return { evid: 111, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbArticlesListSelectArticle' event (evid: 1110)
 *
 * Event description: Click on an article from the screen
 *
 * @param {appKbArticlesListSelectArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @return {LogObject<appKbArticlesListSelectArticleParams>} LogObject<appKbArticlesListSelectArticleParams>
 */
export function appKbArticlesListSelectArticle(params) {
    return { evid: 1110, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryStart' event (evid: 1111)
 *
 * Event description: Click on the button "+ Add category"
 *
 * @param {appKbCategoriesAddCategoryStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryStartParams>} LogObject<appKbCategoriesAddCategoryStartParams>
 */
export function appKbCategoriesAddCategoryStart(params) {
    return { evid: 1111, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryComplete' event (evid: 1112)
 *
 * Event description: Create the category after inserting the name
 *
 * @param {appKbCategoriesAddCategoryCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - category_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryCompleteParams>} LogObject<appKbCategoriesAddCategoryCompleteParams>
 */
export function appKbCategoriesAddCategoryComplete(params) {
    return { evid: 1112, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbCategoriesAddCategoryCancel' event (evid: 1113)
 *
 * Event description: Create category --> click cancel
 *
 * @param {appKbCategoriesAddCategoryCancelParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category (can be null)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - category_id
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesAddCategoryCancelParams>} LogObject<appKbCategoriesAddCategoryCancelParams>
 */
export function appKbCategoriesAddCategoryCancel(params) {
    return { evid: 1113, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbCategoriesDeleteCategory' event (evid: 1114)
 *
 * Event description: Click Delete category from the category menu
 *
 * @param {appKbCategoriesDeleteCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {side bar/main screen}
 * @property {string} permission_level - User's permission level
 * @property {string} category_name - User's entered value for category
 * @property {GUID} client_id - client_id
 * @property {boolean} is_complete - if no articles inside - this will be "1". else "0" (an error will pop-up)
 * @property {GUID} user_id - uuid
 * @property {GUID} category_id - Category ID
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - If category - null, if subcategory - category's id
 * @return {LogObject<appKbCategoriesDeleteCategoryParams>} LogObject<appKbCategoriesDeleteCategoryParams>
 */
export function appKbCategoriesDeleteCategory(params) {
    return { evid: 1114, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbEditArticlePublishSuccess' event (evid: 1121)
 *
 * Event description: Successfully publishing an article
 *
 * @param {appKbEditArticlePublishSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {article page/categories page}
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} article_id - relevant article id
 * @property {string} article_name - relevant article name
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbEditArticlePublishSuccessParams>} LogObject<appKbEditArticlePublishSuccessParams>
 */
export function appKbEditArticlePublishSuccess(params) {
    return { evid: 1121, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbMoveAssignSubcategory' event (evid: 1122)
 *
 * Event description: Assign a subcategory to a different category or make it its own category
 *
 * @param {appKbMoveAssignSubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} method - {menu, drag, api...}
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} orig_parent_id - current category/subcategory
 * @property {string} permission_level - User's permission level
 * @property {number} ts - amount of time (milliseconds) since save process started
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} dest_parent_id - selected category/subcategory. if null than it is now a category
 * @property {string} lang - answers language
 * @return {LogObject<appKbMoveAssignSubcategoryParams>} LogObject<appKbMoveAssignSubcategoryParams>
 */
export function appKbMoveAssignSubcategory(params) {
    return { evid: 1122, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbRenameCategorySubcategory' event (evid: 1123)
 *
 * Event description: Rename a category or a subcategory
 *
 * @param {appKbRenameCategorySubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - only relevant for subcategories {side menu, main menu}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {GUID} parent_guid - category id
 * @return {LogObject<appKbRenameCategorySubcategoryParams>} LogObject<appKbRenameCategorySubcategoryParams>
 */
export function appKbRenameCategorySubcategory(params) {
    return { evid: 1123, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appKbChangeCategorySIcon' event (evid: 1124)
 *
 * Event description: Change the category's icon for display
 *
 * @param {appKbChangeCategorySIconParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} lang - answers language
 * @property {string} action - {Remove,Upload,Stock}
 * @return {LogObject<appKbChangeCategorySIconParams>} LogObject<appKbChangeCategorySIconParams>
 */
export function appKbChangeCategorySIcon(params) {
    return { evid: 1124, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageView' event (evid: 113)
 *
 * Event description: Viewing a page in Answers Marketing Site.
 *
 * @param {marketingPageViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} utm_source - Campaign Source (utm_source component in the url)
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {GUID} session_id - A unique guid for sign up flow
 * @property {Url} referral_url - referral
 * @property {string} permission_level - Level of permission of the performing user
 * @property {GUID} client_id - Answers Client ID
 * @property {GUID} wix_user_id - Wix User ID
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language
 * @property {GUID} marketing_id - The field will be deprecated
 * @property {string} utm_campaign - Campaign Name (utm_campaign component in the url)
 * @property {GUID} wix_client_id - Wix Client (Anonymous) ID
 * @property {number} campaign_id - The field will be deprecated
 * @property {Url} page_url - URL of the current page
 * @return {LogObject<marketingPageViewParams>} LogObject<marketingPageViewParams>
 */
export function marketingPageView(params) {
    return { evid: 113, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInUserLoginAttempt' event (evid: 114)
 *
 * Event description: User attempt to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInUserLoginAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomain
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/emial
 * @return {LogObject<marketingLogInUserLoginAttemptParams>} LogObject<marketingLogInUserLoginAttemptParams>
 */
export function marketingLogInUserLoginAttempt(params) {
    return { evid: 114, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInSuccessUserLogin' event (evid: 115)
 *
 * Event description: User succeeds to sign in with mail or another login type on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInSuccessUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {boolean} is_agent - is account agent
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomian
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/ email
 * @return {LogObject<marketingLogInSuccessUserLoginParams>} LogObject<marketingLogInSuccessUserLoginParams>
 */
export function marketingLogInSuccessUserLogin(params) {
    return { evid: 115, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLogInFailedUserLogin' event (evid: 116)
 *
 * Event description: User failed to sign in with mail or other login types on the second personal login step, after identifying his answers domain on the first step.
 *
 * @param {marketingLogInFailedUserLoginParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers uuid
 * @property {GUID} user_id - answers ID
 * @property {string} subdomain - answers subdomain
 * @property {string} error_reason - failed reason
 * @property {Url} page_url - current page
 * @property {string} login_type - wix/ google / facebook/ emial
 * @return {LogObject<marketingLogInFailedUserLoginParams>} LogObject<marketingLogInFailedUserLoginParams>
 */
export function marketingLogInFailedUserLogin(params) {
    return { evid: 116, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetWidgetLoaded' event (evid: 117)
 *
 * Event description: The widget is loaded and the user can see the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetWidgetLoadedParams>} LogObject<marketingRequestDemoWidgetWidgetLoadedParams>
 */
export function marketingRequestDemoWidgetWidgetLoaded(params) {
    return { evid: 117, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetOpenTheWidget' event (evid: 118)
 *
 * Event description: The user open the 'Request Demo' widget.
 *
 * @param {marketingRequestDemoWidgetOpenTheWidgetParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>} LogObject<marketingRequestDemoWidgetOpenTheWidgetParams>
 */
export function marketingRequestDemoWidgetOpenTheWidget(params) {
    return { evid: 118, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoWidgetSubmitRequestDemo' event (evid: 119)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoWidgetSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - uuid
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>} LogObject<marketingRequestDemoWidgetSubmitRequestDemoParams>
 */
export function marketingRequestDemoWidgetSubmitRequestDemo(params) {
    return { evid: 119, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toolkitAiEAssistantClickToCopyAiAnswer' event (evid: 12)
 *
 * Event description: Click to copy AI expert assistant answer
 *
 *
 * @param {toolkitAiEAssistantClickToCopyAiAnswerParams} params - The parameters for this event
 * @property {GUID} answers_agent_id - who is the expert that opened the Ai assistant
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {string} sources - array of the sources with links to the real articles
 * @property {string} answer_of_ai - The answer that been chosen to be copy
 * @property {number} order_number - Order of the answer as presented to the user; when null then the answer want presented
 * @property {string} version - The version of the AI
 * @property {GUID} uuid - The user UUID - who is the expert that opened the Ai assistant
 * @return {LogObject<toolkitAiEAssistantClickToCopyAiAnswerParams>} LogObject<toolkitAiEAssistantClickToCopyAiAnswerParams>
 */
export function toolkitAiEAssistantClickToCopyAiAnswer(params) {
    return { evid: 12, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingWatchAVideoPressOnButton' event (evid: 120)
 *
 * Event description: The user Click on "Watch a video" (a button on the first fold which will link to our YT video)
 *
 * @param {marketingWatchAVideoPressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - Answers user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingWatchAVideoPressOnButtonParams>} LogObject<marketingWatchAVideoPressOnButtonParams>
 */
export function marketingWatchAVideoPressOnButton(params) {
    return { evid: 120, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamTeamMemberInvitationSentButtonClick' event (evid: 1203)
 *
 * Event description: Click on the "send" button after adding group members
 *
 * @param {appTeamTeamMemberInvitationSentButtonClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {number} count_admins - count admins added
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {number} count_agents - count agents added
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamTeamMemberInvitationSentButtonClickParams>} LogObject<appTeamTeamMemberInvitationSentButtonClickParams>
 */
export function appTeamTeamMemberInvitationSentButtonClick(params) {
    return { evid: 1203, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamCreateANewGroupClick' event (evid: 1205)
 *
 * Event description: Clicking the "Create Team" button after inserting group name
 *
 * @param {appTeamCreateANewGroupClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamCreateANewGroupClickParams>} LogObject<appTeamCreateANewGroupClickParams>
 */
export function appTeamCreateANewGroupClick(params) {
    return { evid: 1205, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAddNewGroupMember' event (evid: 1206)
 *
 * Event description: Selecting a group member after clicking the "+ New Team member" button
 *
 * @param {appTeamAddNewGroupMemberParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} source - {Edit group/New group}
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} member_name - member name
 * @property {string} lang - answers lang
 * @property {GUID} member_uuid - member uuid
 * @return {LogObject<appTeamAddNewGroupMemberParams>} LogObject<appTeamAddNewGroupMemberParams>
 */
export function appTeamAddNewGroupMember(params) {
    return { evid: 1206, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAddMembersToGroupClick' event (evid: 1207)
 *
 * Event description: Click on the button "Add members to Group" (blue button or from empty group state)
 *
 * @param {appTeamAddMembersToGroupClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group id
 * @property {number} current_members_count - How many people currently in goup
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} group_name - group name
 * @property {string} lang - answers lang
 * @return {LogObject<appTeamAddMembersToGroupClickParams>} LogObject<appTeamAddMembersToGroupClickParams>
 */
export function appTeamAddMembersToGroupClick(params) {
    return { evid: 1207, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingLearnMorePressOnButton' event (evid: 121)
 *
 * Event description: The user Click on "Learn more" (a button which will be added below each Product on the home page, linking to the product's specific page)
 *
 * @param {marketingLearnMorePressOnButtonParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} section_name - section name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - Answers user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingLearnMorePressOnButtonParams>} LogObject<marketingLearnMorePressOnButtonParams>
 */
export function marketingLearnMorePressOnButton(params) {
    return { evid: 121, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingRequestDemoFormSubmitRequestDemo' event (evid: 122)
 *
 * Event description: The user fill all the inputs and submit the request to schedule a demo.
 *
 * @param {marketingRequestDemoFormSubmitRequestDemoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user id
 * @property {string} page_url - current page
 * @return {LogObject<marketingRequestDemoFormSubmitRequestDemoParams>} LogObject<marketingRequestDemoFormSubmitRequestDemoParams>
 */
export function marketingRequestDemoFormSubmitRequestDemo(params) {
    return { evid: 122, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingCampaignView' event (evid: 124)
 *
 * Event description: The user view a campaign page.
 *
 * @param {marketingCampaignViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - current page
 * @return {LogObject<marketingCampaignViewParams>} LogObject<marketingCampaignViewParams>
 */
export function marketingCampaignView(params) {
    return { evid: 124, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingCampaignPageSubmitCampaignForm' event (evid: 125)
 *
 * Event description: The user submit the campaign form and send his details.
 *
 * @param {marketingCampaignPageSubmitCampaignFormParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} campaign_name - campaign_name
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {GUID} campaign_id - campaign_id
 * @property {string} page_url - current page
 * @return {LogObject<marketingCampaignPageSubmitCampaignFormParams>} LogObject<marketingCampaignPageSubmitCampaignFormParams>
 */
export function marketingCampaignPageSubmitCampaignForm(params) {
    return { evid: 125, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageViewOnEditorMarketingPage' event (evid: 126)
 *
 * Event description: The user view an Answers page in editor marketing page.
 *
 * @param {marketingPageViewOnEditorMarketingPageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {GUID} client_id - Answers anonymous id
 * @property {GUID} user_id - user_id
 * @property {string} page_name - page name
 * @property {string} page_url - current page
 * @return {LogObject<marketingPageViewOnEditorMarketingPageParams>} LogObject<marketingPageViewOnEditorMarketingPageParams>
 */
export function marketingPageViewOnEditorMarketingPage(params) {
    return { evid: 126, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toolkitAiEAssistantOpenArticlesFromAi' event (evid: 13)
 *
 * Event description: This event send when you click on the article link from the answer of the AI
 *
 * @param {toolkitAiEAssistantOpenArticlesFromAiParams} params - The parameters for this event
 * @property {GUID} answers_agent_id - who is the expert that opened the Ai assistant
 * @property {string} article_id - the article_id
 * @property {GUID} request_id - the Id of the question
 * @property {GUID} response_id - the Id of the answer
 * @property {GUID} tenant_id - the article tenant_id
 * @property {DateTime} date_creted - the datetime of the click on the article
 * @property {GUID} ticket_id - The ticket Id where the ai got used
 * @property {number} order_number - the order of the article from the answer
 * @property {GUID} uuid - the uuid of the expert that use the Ai assistant
 * @return {LogObject<toolkitAiEAssistantOpenArticlesFromAiParams>} LogObject<toolkitAiEAssistantOpenArticlesFromAiParams>
 */
export function toolkitAiEAssistantOpenArticlesFromAi(params) {
    return { evid: 13, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadStart' event (evid: 1320)
 *
 * Event description: This event is fired when a dashboard has begun loading, when its tiles will start loading and querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadStart(params) {
    return { evid: 1320, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiDashboardLoadComplete' event (evid: 1321)
 *
 * Event description: This event is fired when a dashboard has finished running and all tiles have finished loading and querying. This event is fired whether or not all tiles load successfully.
 *
 * @param {appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - Indicates whether the dashboard and its elements have successfully run, failed, or stopped before finished running
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiDashboardLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiDashboardLoadComplete(params) {
    return { evid: 1321, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadStart' event (evid: 1322)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadStartParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {string} tile_listen - The global dashboard filters this tile is listening for
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} tile_title - The tile title, as shown at the top of the tile
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadStartParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadStart(params) {
    return { evid: 1322, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInsightsAdvancedReportsWasabiTileLoadComplete' event (evid: 1323)
 *
 * Event description: This event is fired when a tile in a dashboard starts loading or querying for data.
 *
 * @param {appInsightsAdvancedReportsWasabiTileLoadCompleteParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} status_name - Whether the tile query completed successfully. Possible values are "complete" or "error"
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} dashboard_filters - Applied filters on that dashboard run
 * @property {string} tile_listen - The global dashboard filters this tile is listening for
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Performing User ID
 * @property {string} looker_dashboard_id - Looker Dashboard ID
 * @property {string} dashboard_refresh_id - Random ID that is regenerated every time the dashboard is refreshed (from the Looker refresh button).
 * @property {string} dashboard_load_id - Random ID that is regenerated every time the dashboard is loaded (enter/refresh the page). Binds together events from the same load instance
 * @property {string} tile_title - The tile title, as shown at the top of the tile
 * @property {string} dashboard_title - Looker Dashboard Title
 * @return {LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>} LogObject<appInsightsAdvancedReportsWasabiTileLoadCompleteParams>
 */
export function appInsightsAdvancedReportsWasabiTileLoadComplete(params) {
    return { evid: 1323, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsClickOn3Dots' event (evid: 1330)
 *
 * Event description: User Click on 3 dots (more option per report)
 * after selecting an action - View / Duplicate / Delete
 *
 * @param {appWasabiAdvancedReportsClickOn3DotsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} selectedValue - selected_value
 * @return {LogObject<appWasabiAdvancedReportsClickOn3DotsParams>} LogObject<appWasabiAdvancedReportsClickOn3DotsParams>
 */
export function appWasabiAdvancedReportsClickOn3Dots(params) {
    return { evid: 1330, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsCreateNewReport' event (evid: 1331)
 *
 * Event description: User Created new report - 2 options: Reports view / duplicate
 * after clicking on 'Create Report'
 *
 * @param {appWasabiAdvancedReportsCreateNewReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} source_component - source
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @return {LogObject<appWasabiAdvancedReportsCreateNewReportParams>} LogObject<appWasabiAdvancedReportsCreateNewReportParams>
 */
export function appWasabiAdvancedReportsCreateNewReport(params) {
    return { evid: 1331, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appWasabiAdvancedReportsDeleteReport' event (evid: 1332)
 *
 * Event description: User deleted an existing report (non standard report)
 * after clicking on 'Yes, Delete'
 *
 * @param {appWasabiAdvancedReportsDeleteReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant_id
 * @property {string} reportName - report_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appWasabiAdvancedReportsDeleteReportParams>} LogObject<appWasabiAdvancedReportsDeleteReportParams>
 */
export function appWasabiAdvancedReportsDeleteReport(params) {
    return { evid: 1332, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsChangeAttempt' event (evid: 1450)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeAttemptParams>} LogObject<appSettingsChangeAttemptParams>
 */
export function appSettingsChangeAttempt(params) {
    return { evid: 1450, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsChangeSuccess' event (evid: 1451)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeSuccessParams>} LogObject<appSettingsChangeSuccessParams>
 */
export function appSettingsChangeSuccess(params) {
    return { evid: 1451, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsChangeFail' event (evid: 1452)
 *
 * Event description: Change event attempt: save/toggle in the setting section
 *
 * @param {appSettingsChangeFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - tenant_id
 * @property {string} errorReason - Reason for fail
 * @property {GUID} client_id - client_id
 * @property {string} changeType - {delete/create/update}
 * @property {GUID} user_id - user_id
 * @property {string} source_name - hc-1 / hc-2
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {string} change_content - json with all the changed information
 * @property {Url} page_url - page_url
 * @return {LogObject<appSettingsChangeFailParams>} LogObject<appSettingsChangeFailParams>
 */
export function appSettingsChangeFail(params) {
    return { evid: 1452, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAgentClickRolesInTheSettingsMenu' event (evid: 1453)
 *
 * Event description: An agent click "roles" in the settings menu of Answers App
 *
 * @param {appSettingsAgentClickRolesInTheSettingsMenuParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @return {LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>} LogObject<appSettingsAgentClickRolesInTheSettingsMenuParams>
 */
export function appSettingsAgentClickRolesInTheSettingsMenu(params) {
    return { evid: 1453, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickAddCustomRole' event (evid: 1454)
 *
 * Event description: An agent clicks "Add custom role" inside "roles" section of Answers Settings
 *
 * @param {appSettingsRolesAgentClickAddCustomRoleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @return {LogObject<appSettingsRolesAgentClickAddCustomRoleParams>} LogObject<appSettingsRolesAgentClickAddCustomRoleParams>
 */
export function appSettingsRolesAgentClickAddCustomRole(params) {
    return { evid: 1454, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesAgentClickEditRole' event (evid: 1455)
 *
 * Event description: An agent click "Edit" in the right corner menu (3 dots) in the roles section within Answers Settings.
 *
 * @param {appSettingsRolesAgentClickEditRoleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} role_id - The Role ID of the role being "clicked"
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} role_name - The Role Name of the role being "clicked"
 * @return {LogObject<appSettingsRolesAgentClickEditRoleParams>} LogObject<appSettingsRolesAgentClickEditRoleParams>
 */
export function appSettingsRolesAgentClickEditRole(params) {
    return { evid: 1455, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingClickUpdatePaymentMethodModalLink' event (evid: 1459)
 *
 * Event description: Member clicks on the Update Payment Method link in the upper right corner of the Billing Page
 *
 * @param {appSettingsBillingClickUpdatePaymentMethodModalLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>} LogObject<appSettingsBillingClickUpdatePaymentMethodModalLinkParams>
 */
export function appSettingsBillingClickUpdatePaymentMethodModalLink(params) {
    return { evid: 1459, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodAttempt' event (evid: 1460)
 *
 * Event description: Update Payment Method Attempt
 *
 * @param {appSettingsBillingUpdatePaymentMethodAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>} LogObject<appSettingsBillingUpdatePaymentMethodAttemptParams>
 */
export function appSettingsBillingUpdatePaymentMethodAttempt(params) {
    return { evid: 1460, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodSuccess' event (evid: 1461)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Success.
 *
 * @param {appSettingsBillingUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>} LogObject<appSettingsBillingUpdatePaymentMethodSuccessParams>
 */
export function appSettingsBillingUpdatePaymentMethodSuccess(params) {
    return { evid: 1461, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodFail' event (evid: 1462)
 *
 * Event description: App (Settings) - Billing -  Update Payment Method Fail.
 *
 * @param {appSettingsBillingUpdatePaymentMethodFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Reason of failure
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodFail(params) {
    return { evid: 1462, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail' event (evid: 1463)
 *
 * Event description: Update payment method modal preview fails to render
 *
 * @param {appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>} LogObject<appSettingsBillingUpdatePaymentMethodModalPreviewRenderFailParams>
 */
export function appSettingsBillingUpdatePaymentMethodModalPreviewRenderFail(params) {
    return { evid: 1463, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingPaymentMethodModalUseADifferentCardClick' event (evid: 1464)
 *
 * Event description: App (Settings) - Billing - Payment Method Modal - Use A Different Card Click.
 *
 * @param {appSettingsBillingPaymentMethodModalUseADifferentCardClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {boolean} is_checked - True if checkbox is checked, False if it is un-checked
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @return {LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>} LogObject<appSettingsBillingPaymentMethodModalUseADifferentCardClickParams>
 */
export function appSettingsBillingPaymentMethodModalUseADifferentCardClick(params) {
    return { evid: 1464, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsBillingDownloadInvoiceFile' event (evid: 1465)
 *
 * Event description: Download Invoice file CTA in the invoice history list
 *
 * @param {appSettingsBillingDownloadInvoiceFileParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {number} invoice_amount - Invoice Amount
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the member
 * @property {DateTime} invoice_date - Invoice Date
 * @return {LogObject<appSettingsBillingDownloadInvoiceFileParams>} LogObject<appSettingsBillingDownloadInvoiceFileParams>
 */
export function appSettingsBillingDownloadInvoiceFile(params) {
    return { evid: 1465, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserOpenedPp' event (evid: 1811)
 *
 * Event description: Answers PP - lightbox appears successfully.
 * First step - User select team size
 * Second Step -  User choose a plan and product.
 * Third step - User select subscription type.
 *
 * @param {appPremiumPackagePickerUserOpenedPpParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - upgrade origin component
 * @return {LogObject<appPremiumPackagePickerUserOpenedPpParams>} LogObject<appPremiumPackagePickerUserOpenedPpParams>
 */
export function appPremiumPackagePickerUserOpenedPp(params) {
    return { evid: 1811, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedPpLightBox' event (evid: 1812)
 *
 * Event description: Answers PP - Close lightbox on any step with closing method attribute: click on X button
 *
 * @param {appPremiumPackagePickerUserClosedPpLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers product plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly/monthly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedPpLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedPpLightBox(params) {
    return { evid: 1812, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerFirstStepUserSelectTeamSize' event (evid: 1813)
 *
 * Event description: Answers PP First step - User select team size (radio button) :
 * {2-5, 6-10, 11-20, 21-50, 51-100,100+ (-1)}
 * (All 'product' and 'plan' attributes will be NULL when the other steps are not exposed but not if they changed after advanced steps.)
 *
 * @param {appPremiumPackagePickerFirstStepUserSelectTeamSizeParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - plan price depend on tenant selection of number of agents and plan selection
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>} LogObject<appPremiumPackagePickerFirstStepUserSelectTeamSizeParams>
 */
export function appPremiumPackagePickerFirstStepUserSelectTeamSize(params) {
    return { evid: 1813, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepProductCheckboxChecked' event (evid: 1814)
 *
 * Event description: Answers PP - Second step: user checked on one of the products checkboxes : KB/ Ticketing(HD)/ Call center. (custom as plan type)
 * for example:
 * checked_product: Call center
 * product_call_center=1
 * product_ticketing =0
 * product_knowledge_base=0
 *
 * @param {appPremiumPackagePickerSecondStepProductCheckboxCheckedParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} checked_product - checked product: KB, Ticketing (HD), Call center
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>} LogObject<appPremiumPackagePickerSecondStepProductCheckboxCheckedParams>
 */
export function appPremiumPackagePickerSecondStepProductCheckboxChecked(params) {
    return { evid: 1814, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserUncheckedProduct' event (evid: 1815)
 *
 * Event description: Answers Package Picker - Second step - User unchecked product checkbox on Custom plan type: uncheck call center/uncheck knowledge base/uncheck ticketing.
 * for example:
 * product_call_center=0
 * product_ticketing =0
 * product_knowledge_base=0
 * and unchecked_product: Call center
 *
 * @param {appPremiumPackagePickerSecondStepUserUncheckedProductParams} params - The parameters for this event
 * @property {boolean} product_call_center - 1- if call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - 1- if knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {string} unchecked_product - product that was unchecked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly / Monthly
 * @property {boolean} product_ticketing - 1- if ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>} LogObject<appPremiumPackagePickerSecondStepUserUncheckedProductParams>
 */
export function appPremiumPackagePickerSecondStepUserUncheckedProduct(params) {
    return { evid: 1815, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan' event (evid: 1816)
 *
 * Event description: Answers PP Second step - User clicked on Unlimited plan select button or 3 products custom plan selected
 *
 * @param {appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge_base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step user click
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Unlimited plan/ Custom plan
 * @property {string} origin - upgrade origin component
 * @property {boolean} unlimited_selected - relevant only for unlimited plan: user select unlimited =1 ,user checked 3 products=0
 * @property {number} plan_price - Total Answers plan price
 * @property {string} team_size - The max number of agents
 * @property {string} subscription_type - monthly/yearly subscription
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>} LogObject<appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlanParams>
 */
export function appPremiumPackagePickerSecondStepUserSelectedUnlimitedPlan(params) {
    return { evid: 1816, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerThirdStepChooseSubscriptionCycle' event (evid: 1817)
 *
 * Event description: Answers PP Third step - Choose Answers subscription cycle:
 * Monthly / Yearly
 *
 * @param {appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers total plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Monthly / Yearly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>} LogObject<appPremiumPackagePickerThirdStepChooseSubscriptionCycleParams>
 */
export function appPremiumPackagePickerThirdStepChooseSubscriptionCycle(params) {
    return { evid: 1817, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerProceedToCheckoutClick' event (evid: 1818)
 *
 * Event description: Answers PP last step
 *
 * @param {appPremiumPackagePickerProceedToCheckoutClickParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers plan price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - monthly/ yearly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>} LogObject<appPremiumPackagePickerProceedToCheckoutClickParams>
 */
export function appPremiumPackagePickerProceedToCheckoutClick(params) {
    return { evid: 1818, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerUserClosedUpgradeSuccessLightBox' event (evid: 1819)
 *
 * Event description: Answers PP last step:  upgrade success lightbox closed.
 * Method is for user closing action: user click on okay button /click outside of the lightbox
 *
 * @param {appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams} params - The parameters for this event
 * @property {boolean} product_call_center - call center checkbox checked
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {boolean} product_knowledge_base - knowledge base checkbox checked
 * @property {boolean} product_chat - chat checkbox checked
 * @property {string} from_step - last step on pp the user was before this event
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} plan_type - Custom plan/Unlimited plan
 * @property {string} origin - upgrade origin component
 * @property {number} plan_price - Answers product price
 * @property {string} team_size - max team size the user selected
 * @property {string} subscription_type - Yearly/monthly
 * @property {boolean} product_ticketing - ticketing checkbox checked
 * @return {LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>} LogObject<appPremiumPackagePickerUserClosedUpgradeSuccessLightBoxParams>
 */
export function appPremiumPackagePickerUserClosedUpgradeSuccessLightBox(params) {
    return { evid: 1819, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSecondStepContactUsClickOnLink' event (evid: 1820)
 *
 * Event description: Answers PP - Second step - Contact us user click on the contact link - vip@wixanswers.com mail after choosing  maximum num of agents (101+ agents)
 *
 * @param {appPremiumPackagePickerSecondStepContactUsClickOnLinkParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} from_step - last step user click
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - upgrade origin component
 * @return {LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>} LogObject<appPremiumPackagePickerSecondStepContactUsClickOnLinkParams>
 */
export function appPremiumPackagePickerSecondStepContactUsClickOnLink(params) {
    return { evid: 1820, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadStarted' event (evid: 1821)
 *
 * Event description: User opens the Package Picker and it starts to load
 *
 * @param {appPremiumPackagePickerLoadStartedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerLoadStartedParams>} LogObject<appPremiumPackagePickerLoadStartedParams>
 */
export function appPremiumPackagePickerLoadStarted(params) {
    return { evid: 1821, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerLoadSuccess' event (evid: 1822)
 *
 * Event description: User opens the Package Picker and it loads successfully
 *
 * @param {appPremiumPackagePickerLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerLoadSuccessParams>} LogObject<appPremiumPackagePickerLoadSuccessParams>
 */
export function appPremiumPackagePickerLoadSuccess(params) {
    return { evid: 1822, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerHoverOnPackage' event (evid: 1823)
 *
 * Event description: App (Premium) - Package Picker - Hover on Package.
 *
 * @param {appPremiumPackagePickerHoverOnPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @return {LogObject<appPremiumPackagePickerHoverOnPackageParams>} LogObject<appPremiumPackagePickerHoverOnPackageParams>
 */
export function appPremiumPackagePickerHoverOnPackage(params) {
    return { evid: 1823, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectPackage' event (evid: 1824)
 *
 * Event description: User selects premium package - CTA click (Unlimited / Multi-Channel / Self-Service / Call Center)
 *
 * @param {appPremiumPackagePickerSelectPackageParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectPackageParams>} LogObject<appPremiumPackagePickerSelectPackageParams>
 */
export function appPremiumPackagePickerSelectPackage(params) {
    return { evid: 1824, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectTeamSize' event (evid: 1825)
 *
 * Event description: User selects team size (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 *
 * @param {appPremiumPackagePickerSelectTeamSizeParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectTeamSizeParams>} LogObject<appPremiumPackagePickerSelectTeamSizeParams>
 */
export function appPremiumPackagePickerSelectTeamSize(params) {
    return { evid: 1825, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerSelectSubscriptionCycle' event (evid: 1826)
 *
 * Event description: User selects subscription cycle - the whole strip is clickable, not just radio button (Monthly / Yearly / 2 Years)
 *
 * @param {appPremiumPackagePickerSelectSubscriptionCycleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>} LogObject<appPremiumPackagePickerSelectSubscriptionCycleParams>
 */
export function appPremiumPackagePickerSelectSubscriptionCycle(params) {
    return { evid: 1826, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerOrderPreviewRendered' event (evid: 1827)
 *
 * Event description: Order preview is rendered
 *
 * @param {appPremiumPackagePickerOrderPreviewRenderedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {GUID} preview_id - ID of the order preview
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>} LogObject<appPremiumPackagePickerOrderPreviewRenderedParams>
 */
export function appPremiumPackagePickerOrderPreviewRendered(params) {
    return { evid: 1827, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerEnterpriseRequestCallback' event (evid: 1828)
 *
 * Event description: User requests callback (CTA button) after selecting the enterprise solution (50+), which opens the widget
 *
 * @param {appPremiumPackagePickerEnterpriseRequestCallbackParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>} LogObject<appPremiumPackagePickerEnterpriseRequestCallbackParams>
 */
export function appPremiumPackagePickerEnterpriseRequestCallback(params) {
    return { evid: 1828, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutAttempt' event (evid: 1829)
 *
 * Event description: User attempts to checkout (CTA button)
 *
 * @param {appPremiumPackagePickerCheckoutAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutAttemptParams>} LogObject<appPremiumPackagePickerCheckoutAttemptParams>
 */
export function appPremiumPackagePickerCheckoutAttempt(params) {
    return { evid: 1829, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutSuccess' event (evid: 1830)
 *
 * Event description: User succeeds to checkout - Zuora iframe is rendered
 *
 * @param {appPremiumPackagePickerCheckoutSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutSuccessParams>} LogObject<appPremiumPackagePickerCheckoutSuccessParams>
 */
export function appPremiumPackagePickerCheckoutSuccess(params) {
    return { evid: 1830, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutFail' event (evid: 1831)
 *
 * Event description: User fails to checkout - Zuora iframe cannot be rendered
 *
 * @param {appPremiumPackagePickerCheckoutFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerCheckoutFailParams>} LogObject<appPremiumPackagePickerCheckoutFailParams>
 */
export function appPremiumPackagePickerCheckoutFail(params) {
    return { evid: 1831, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseAttempt' event (evid: 1832)
 *
 * Event description: App (Premium) - Package Picker - Purchase Attempt.
 *
 * @param {appPremiumPackagePickerPurchaseAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseAttemptParams>} LogObject<appPremiumPackagePickerPurchaseAttemptParams>
 */
export function appPremiumPackagePickerPurchaseAttempt(params) {
    return { evid: 1832, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseSuccess' event (evid: 1833)
 *
 * Event description: User succeeds to purchase
 *
 * @param {appPremiumPackagePickerPurchaseSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} tts - Time since load started in ms
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseSuccessParams>} LogObject<appPremiumPackagePickerPurchaseSuccessParams>
 */
export function appPremiumPackagePickerPurchaseSuccess(params) {
    return { evid: 1833, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseFail' event (evid: 1834)
 *
 * Event description: User fails to purchase
 *
 * @param {appPremiumPackagePickerPurchaseFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseFailParams>} LogObject<appPremiumPackagePickerPurchaseFailParams>
 */
export function appPremiumPackagePickerPurchaseFail(params) {
    return { evid: 1834, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseModalLinkClick' event (evid: 1835)
 *
 * Event description: User clicks link from modal after purchase success or fail
 *
 * @param {appPremiumPackagePickerPurchaseModalLinkClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {Url} link_name - Link clicked
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} modal_name - Modal name (success / failure)
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>} LogObject<appPremiumPackagePickerPurchaseModalLinkClickParams>
 */
export function appPremiumPackagePickerPurchaseModalLinkClick(params) {
    return { evid: 1835, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerWhatSInsideHover' event (evid: 1836)
 *
 * Event description: User hovers on "What's Inside" - tip tool
 *
 * @param {appPremiumPackagePickerWhatSInsideHoverParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerWhatSInsideHoverParams>} LogObject<appPremiumPackagePickerWhatSInsideHoverParams>
 */
export function appPremiumPackagePickerWhatSInsideHover(params) {
    return { evid: 1836, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerGoBackToPreviousStep' event (evid: 1837)
 *
 * Event description: User clicks button to go back to previous page
 *
 * @param {appPremiumPackagePickerGoBackToPreviousStepParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {number} from_step - PP step user takes the action from (1 / 2 / 3)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>} LogObject<appPremiumPackagePickerGoBackToPreviousStepParams>
 */
export function appPremiumPackagePickerGoBackToPreviousStep(params) {
    return { evid: 1837, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPreviewRenderFail' event (evid: 1839)
 *
 * Event description: Order preview fails to render
 *
 * @param {appPremiumPackagePickerPreviewRenderFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} origin - Upgrade origin component
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPreviewRenderFailParams>} LogObject<appPremiumPackagePickerPreviewRenderFailParams>
 */
export function appPremiumPackagePickerPreviewRenderFail(params) {
    return { evid: 1839, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksIncentiveView' event (evid: 1851)
 *
 * Event description: An user views a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksIncentiveViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksIncentiveViewParams>} LogObject<appPremiumBlocksIncentiveViewParams>
 */
export function appPremiumBlocksIncentiveView(params) {
    return { evid: 1851, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksIncentiveCtaClick' event (evid: 1852)
 *
 * Event description: A user clicks on a CTA in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksIncentiveCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksIncentiveCtaClickParams>} LogObject<appPremiumBlocksIncentiveCtaClickParams>
 */
export function appPremiumBlocksIncentiveCtaClick(params) {
    return { evid: 1852, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveView' event (evid: 1853)
 *
 * Event description: An user views a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksCreditIncentiveViewParams>} LogObject<appPremiumBlocksCreditIncentiveViewParams>
 */
export function appPremiumBlocksCreditIncentiveView(params) {
    return { evid: 1853, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksCreditIncentiveIncentiveCtaClick' event (evid: 1854)
 *
 * Event description: A user clicks on a CTA in a call center credit incentive
 *
 * @param {appPremiumBlocksCreditIncentiveIncentiveCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>} LogObject<appPremiumBlocksCreditIncentiveIncentiveCtaClickParams>
 */
export function appPremiumBlocksCreditIncentiveIncentiveCtaClick(params) {
    return { evid: 1854, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumBlocksPremiumIncentiveContactUsClick' event (evid: 1855)
 *
 * Event description: A user clicks on the "Contact Us" button in a premium incentive of a blocked premium feature
 *
 * @param {appPremiumBlocksPremiumIncentiveContactUsClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} feature - Name of the blocked feature
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {boolean} is_eligible - Is the user eligible to buy a premium plan
 * @return {LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>} LogObject<appPremiumBlocksPremiumIncentiveContactUsClickParams>
 */
export function appPremiumBlocksPremiumIncentiveContactUsClick(params) {
    return { evid: 1855, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenCccModal' event (evid: 1861)
 *
 * Event description: Call Center Credits (CCC) modal lightbox appears successfully
 *
 * @param {appPremiumCcCreditsOpenCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsOpenCccModalParams>} LogObject<appPremiumCcCreditsOpenCccModalParams>
 */
export function appPremiumCcCreditsOpenCccModal(params) {
    return { evid: 1861, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCloseCccModal' event (evid: 1862)
 *
 * Event description: Call Center Credits (CCC) modal lightbox closed
 *
 * @param {appPremiumCcCreditsCloseCccModalParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsCloseCccModalParams>} LogObject<appPremiumCcCreditsCloseCccModalParams>
 */
export function appPremiumCcCreditsCloseCccModal(params) {
    return { evid: 1862, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsModalCtaClick' event (evid: 1863)
 *
 * Event description: User clicked on the Call Center Credits (CCC) modal CTA (to the premium plans PP or the credits PP)
 *
 * @param {appPremiumCcCreditsModalCtaClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {boolean} is_premium - Is the tenant Premium or Free
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsModalCtaClickParams>} LogObject<appPremiumCcCreditsModalCtaClickParams>
 */
export function appPremiumCcCreditsModalCtaClick(params) {
    return { evid: 1863, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsOpenPackagePicker' event (evid: 1864)
 *
 * Event description: Call Center Credits (CCC) Package Picker opened successfully.
 *
 * @param {appPremiumCcCreditsOpenPackagePickerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsOpenPackagePickerParams>} LogObject<appPremiumCcCreditsOpenPackagePickerParams>
 */
export function appPremiumCcCreditsOpenPackagePicker(params) {
    return { evid: 1864, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsSelectAmountForPurchase' event (evid: 1865)
 *
 * Event description: User selected the amount of call center credits for purchase
 *
 * @param {appPremiumCcCreditsSelectAmountForPurchaseParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} credits_amount - Selected amount of credits
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>} LogObject<appPremiumCcCreditsSelectAmountForPurchaseParams>
 */
export function appPremiumCcCreditsSelectAmountForPurchase(params) {
    return { evid: 1865, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsClickOnCheckout' event (evid: 1866)
 *
 * Event description: User attempts to proceed to the call center credits checkout
 *
 * @param {appPremiumCcCreditsClickOnCheckoutParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {string} credits_amount - Selected amount of credits
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @property {string} origin - CCC modal origin
 * @property {string} current_balance - Current CCC balance
 * @return {LogObject<appPremiumCcCreditsClickOnCheckoutParams>} LogObject<appPremiumCcCreditsClickOnCheckoutParams>
 */
export function appPremiumCcCreditsClickOnCheckout(params) {
    return { evid: 1866, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseSuccessLb' event (evid: 1867)
 *
 * Event description: Call center credits purchase success lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseSuccessLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseSuccessLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseSuccessLb(params) {
    return { evid: 1867, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCreditPurchaseFailLb' event (evid: 1868)
 *
 * Event description: Call center credits purchase fail lightbox appears
 *
 * @param {appPremiumCcCreditsCreditPurchaseFailLbParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - answers user ID
 * @return {LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>} LogObject<appPremiumCcCreditsCreditPurchaseFailLbParams>
 */
export function appPremiumCcCreditsCreditPurchaseFailLb(params) {
    return { evid: 1868, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralWelcomeLightboxView' event (evid: 1901)
 *
 * Event description: The Answers welcome lightbox was viewed by the user. Event avaiable since 2018-10-11
 *
 * @param {appGeneralWelcomeLightboxViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - The type of the welcome message (Freemium, Trial, etc.)
 * @return {LogObject<appGeneralWelcomeLightboxViewParams>} LogObject<appGeneralWelcomeLightboxViewParams>
 */
export function appGeneralWelcomeLightboxView(params) {
    return { evid: 1901, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxView' event (evid: 1947)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was viewed by the user
 *
 * @param {appGeneralFtueVideoLightboxViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxViewParams>} LogObject<appGeneralFtueVideoLightboxViewParams>
 */
export function appGeneralFtueVideoLightboxView(params) {
    return { evid: 1947, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxPlayVideo' event (evid: 1948)
 *
 * Event description: User clicks the "Play" button of the video in the First Time User Experience (FTUE) Video Lightbox of a certain feature
 *
 * @param {appGeneralFtueVideoLightboxPlayVideoParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxPlayVideoParams>} LogObject<appGeneralFtueVideoLightboxPlayVideoParams>
 */
export function appGeneralFtueVideoLightboxPlayVideo(params) {
    return { evid: 1948, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralFtueVideoLightboxClose' event (evid: 1949)
 *
 * Event description: First Time User Experience (FTUE) Video Lightbox of a certain feature was closed by the user
 *
 * @param {appGeneralFtueVideoLightboxCloseParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} feature - Name of the feature the lightbox is shown in
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appGeneralFtueVideoLightboxCloseParams>} LogObject<appGeneralFtueVideoLightboxCloseParams>
 */
export function appGeneralFtueVideoLightboxClose(params) {
    return { evid: 1949, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadAttempt' event (evid: 1950)
 *
 * Event description: General event - like "page view". This event is sent after the app is already loaded, and the specific page/module is starting to load
 *
 * @param {appGeneralPageLoadAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - User's permission level
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadAttemptParams>} LogObject<appGeneralPageLoadAttemptParams>
 */
export function appGeneralPageLoadAttempt(params) {
    return { evid: 1950, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadSuccess' event (evid: 1951)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {number} screen_resolution_height - Screen resolution height
 * @property {string} permission_level - User's permission level
 * @property {number} screen_resolution_width - Screen resolution width
 * @property {GUID} answers_role_id - Answers Role ID
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - View Port width
 * @property {GUID} user_id - user_id
 * @property {string} pixel_ratio - Device Pixel Ratio
 * @property {number} screen_height - View Port height
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadSuccessParams>} LogObject<appGeneralPageLoadSuccessParams>
 */
export function appGeneralPageLoadSuccess(params) {
    return { evid: 1951, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralPageLoadFail' event (evid: 1952)
 *
 * Event description: General event - like "page view"
 *
 * @param {appGeneralPageLoadFailParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module
 * @property {GUID} tenant_id - tenant_id
 * @property {string} permission_level - User's permission level
 * @property {string} errorReason - reason for fail
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} section_key - specific section that user tried to change
 * @property {string} lang - answers language
 * @property {Url} page_url - page_url
 * @return {LogObject<appGeneralPageLoadFailParams>} LogObject<appGeneralPageLoadFailParams>
 */
export function appGeneralPageLoadFail(params) {
    return { evid: 1952, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicPageViewArticle' event (evid: 1997)
 *
 * Event description: When a user view an article page in an Help Center of other tenants
 *
 * @param {publicPageViewArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {GUID} sub_category_id - sub_category_id
 * @property {string} category_name - category_name
 * @property {string} source_type - {Help center/widget}
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} sub_category_name - sub_category_name
 * @property {string} article_type - {article/feature request/bug...}
 * @property {string} source_name - source_name
 * @property {GUID} article_id - article_id
 * @property {GUID} source_id - help center/ widget id
 * @property {GUID} category_id - category_id
 * @property {string} article_name - article_name
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewArticleParams>} LogObject<publicPageViewArticleParams>
 */
export function publicPageViewArticle(params) {
    return { evid: 1997, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicPageViewTicket' event (evid: 1998)
 *
 * Event description: When a user view a ticket in an Help Center of other tenants
 *
 * @param {publicPageViewTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewTicketParams>} LogObject<publicPageViewTicketParams>
 */
export function publicPageViewTicket(params) {
    return { evid: 1998, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicPageViewCategory' event (evid: 1999)
 *
 * Event description: When a user view a category/sub-category page in an Help Center of other tenants
 *
 * @param {publicPageViewCategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {GUID} sub_category_id - sub_category_id
 * @property {string} category_name - category_name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} sub_category_name - sub_category_name
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - category_id
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewCategoryParams>} LogObject<publicPageViewCategoryParams>
 */
export function publicPageViewCategory(params) {
    return { evid: 1999, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCancelEditAvailabilityModal' event (evid: 2)
 *
 * Event description: Users enter the availability modal but don't make any changes, and click Cancel
 *
 * @param {clickOnCancelEditAvailabilityModalParams} params - The parameters for this event
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @return {LogObject<clickOnCancelEditAvailabilityModalParams>} LogObject<clickOnCancelEditAvailabilityModalParams>
 */
export function clickOnCancelEditAvailabilityModal(params) {
    return { evid: 2, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicPageView' event (evid: 2001)
 *
 * Event description: When a user view any page in an Help Center of other tenants
 *
 * @param {publicPageViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - {help center/widget}
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
 * @property {GUID} source_id - source_id
 * @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
 * @property {string} parent_url - parent_url (widget)
 * @return {LogObject<publicPageViewParams>} LogObject<publicPageViewParams>
 */
export function publicPageView(params) {
    return { evid: 2001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicVoteForArticle' event (evid: 2002)
 *
 * Event description: When a user vote for an article in an Help Center of other tenants
 *
 * @param {publicVoteForArticleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - parent_url (widget)
 * @property {string} clicked_text - the text of the option the user clicked
 * @return {LogObject<publicVoteForArticleParams>} LogObject<publicVoteForArticleParams>
 */
export function publicVoteForArticle(params) {
    return { evid: 2002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicVoteForFeatureRequest' event (evid: 2003)
 *
 * Event description: When a user vote/unvote for a feature request in an Help Center of other tenants
 *
 * @param {publicVoteForFeatureRequestParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - in case of a widget
 * @return {LogObject<publicVoteForFeatureRequestParams>} LogObject<publicVoteForFeatureRequestParams>
 */
export function publicVoteForFeatureRequest(params) {
    return { evid: 2003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicVoteForKnownIssue' event (evid: 2004)
 *
 * Event description: When a user vote/unvote for a known issue in an Help Center of other tenants
 *
 * @param {publicVoteForKnownIssueParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - Tenant ID
 * @property {boolean} thumbs_up - {true, false}
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - Category ID
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicVoteForKnownIssueParams>} LogObject<publicVoteForKnownIssueParams>
 */
export function publicVoteForKnownIssue(params) {
    return { evid: 2004, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSearch' event (evid: 2005)
 *
 * Event description: When a user search in a Help Center of other tenants
 *
 * @param {publicSearchParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} result_article_id_1 - result_article_id_1
 * @property {string} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {number} results_count - number of search results
 * @property {string} source_name - source_name
 * @property {GUID} result_article_id_2 - result_article_id_2
 * @property {GUID} source_id - source_id
 * @property {GUID} result_article_id_3 - result_article_id_3
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSearchParams>} LogObject<publicSearchParams>
 */
export function publicSearch(params) {
    return { evid: 2005, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSelectSearchResult' event (evid: 2006)
 *
 * Event description: When a user interacts with an answer or clicks search results after searching in an Help Center of other tenants
 *
 * @param {publicSelectSearchResultParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} question - user's search terms (question)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search term which lead to this answer
 * @property {string} source_name - source_name
 * @property {GUID} article_id - Article ID
 * @property {GUID} source_id - source_id
 * @property {string} answer - The selected answer
 * @property {GUID} category_id - Category ID
 * @property {number} answer_index - index of answer (1,2,3,4,5..)
 * @property {string} parent_url - widget's parent page
 * @property {string} search_result_selection - From where the user picked the answer (dropdown/search results page)
 * @return {LogObject<publicSelectSearchResultParams>} LogObject<publicSelectSearchResultParams>
 */
export function publicSelectSearchResult(params) {
    return { evid: 2006, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSeeAllResults' event (evid: 2007)
 *
 * Event description: Click the See All Results Button
 *
 * @param {publicSeeAllResultsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} result_article_id_1 - result_article_id_1
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {string} source_name - source_name
 * @property {GUID} result_article_id_2 - result_article_id_2
 * @property {GUID} source_id - source_id
 * @property {GUID} result_article_id_3 - result_article_id_3
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSeeAllResultsParams>} LogObject<publicSeeAllResultsParams>
 */
export function publicSeeAllResults(params) {
    return { evid: 2007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicNoSearchResults' event (evid: 2008)
 *
 * Event description: When a user get no results after searching
 *
 * @param {publicNoSearchResultsParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers brand id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} search_term - search_term
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicNoSearchResultsParams>} LogObject<publicNoSearchResultsParams>
 */
export function publicNoSearchResults(params) {
    return { evid: 2008, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicPageViewError' event (evid: 2009)
 *
 * Event description: When a user encounters a page view error in an Help Center of other tenants
 *
 * @param {publicPageViewErrorParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral url
 * @property {string} errorReason - Error Reason
 * @property {string} source_type - {help center/widget}
 * @property {GUID} client_id - Client ID
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - examples: {widget_123, yotpo_help_center1...}
 * @property {GUID} source_id - source_id
 * @property {string} page_type - the type of the viewed page (for ex. home page, article, ticket..)
 * @property {Url} page_url - The page's URL
 * @property {string} parent_url - parent_url (widget)
 * @property {string} source_clicked_text - The link text that was clicked and led to the error
 * @return {LogObject<publicPageViewErrorParams>} LogObject<publicPageViewErrorParams>
 */
export function publicPageViewError(params) {
    return { evid: 2009, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSelectCategoryOrSubcategory' event (evid: 2010)
 *
 * Event description: Clicking on a category or a subcategory in an Help Center of other tenants
 *
 * @param {publicSelectCategoryOrSubcategoryParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} category_name - category name
 * @property {string} widget_name - widget name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} category_id - category id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSelectCategoryOrSubcategoryParams>} LogObject<publicSelectCategoryOrSubcategoryParams>
 */
export function publicSelectCategoryOrSubcategory(params) {
    return { evid: 2010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'csiSubmitWasItHelpfulFormSrc77Evid2011' event (evid: 2011)
 *
 * Event description: Fires when a user clicks submit on the feedback form of an article in the CSI
 *
 *
 * @param {csiSubmitWasItHelpfulFormSrc77Evid2011Params} params - The parameters for this event
 * @property {GUID} user_id - The CSI ID of the user that submitted the form
 * @property {GUID} article_id - The article for which the form was submitted
 * @property {string} locale - The language of the article
 * @property {boolean} thumbs_up - Did the form was submitted with helpful (true) or unhelpful (false) vote
 * @property {string} feedback_reason - The feedback reason the user submitted
 * @property {string} feedback_text - The free text the user added to the form
 * @property {string} tenant_id - Answer tenant ID
 * @return {LogObject<csiSubmitWasItHelpfulFormSrc77Evid2011Params>} LogObject<csiSubmitWasItHelpfulFormSrc77Evid2011Params>
 */
export function csiSubmitWasItHelpfulFormSrc77Evid2011(params) {
    return { evid: 2011, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetWidgetLauncherLoadedClient' event (evid: 2014)
 *
 * Event description: The event is trigger when a launcher is loaded
 *
 * @param {publicWidgetWidgetLauncherLoadedClientParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @return {LogObject<publicWidgetWidgetLauncherLoadedClientParams>} LogObject<publicWidgetWidgetLauncherLoadedClientParams>
 */
export function publicWidgetWidgetLauncherLoadedClient(params) {
    return { evid: 2014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetToggleModule' event (evid: 2230)
 *
 * Event description: Click on the top icon to switch between "contact" and "help"
 *
 * @param {publicWidgetToggleModuleParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} parent_url - parent_url
 * @property {string} switch_to - the new state of the widget
 * @return {LogObject<publicWidgetToggleModuleParams>} LogObject<publicWidgetToggleModuleParams>
 */
export function publicWidgetToggleModule(params) {
    return { evid: 2230, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesResolved' event (evid: 2240)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "Yes! my issues was resolved".
 *
 * @param {publicWidgetSuggestedArticlesResolvedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {GUID} article_id - selected article id
 * @property {string} article_name - selected article name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesResolvedParams>} LogObject<publicWidgetSuggestedArticlesResolvedParams>
 */
export function publicWidgetSuggestedArticlesResolved(params) {
    return { evid: 2240, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWidgetSuggestedArticlesReport' event (evid: 2250)
 *
 * Event description: After Clicking on one of the suggested articles from inside a ticket submission (only in a widget!!), click on "No! I want to report my issue".
 *
 * @param {publicWidgetSuggestedArticlesReportParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} widget_name - widget name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {GUID} article_id - selected article id
 * @property {string} article_name - selected article name
 * @property {string} parent_url - parent_url
 * @return {LogObject<publicWidgetSuggestedArticlesReportParams>} LogObject<publicWidgetSuggestedArticlesReportParams>
 */
export function publicWidgetSuggestedArticlesReport(params) {
    return { evid: 2250, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicWismoChatbotStepReached' event (evid: 2260)
 *
 * Event description: Public (Wismo chatbot) - step reached.
 *
 * @param {publicWismoChatbotStepReachedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - tenant_id
 * @property {GUID} widget_id - widget_id
 * @property {GUID} session_id - wismo chat bot session id
 * @property {string} data - json formatted string, containing all info on the current chat bot step, including step id, type, ticket id if created, etc.
 * @property {string} user_device_type - the device type of the user - Desktop, Tablet, Smartphone, Feature Phone, Smart-TV, Robot, Other non-Mobile, Other Mobile.
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<publicWismoChatbotStepReachedParams>} LogObject<publicWismoChatbotStepReachedParams>
 */
export function publicWismoChatbotStepReached(params) {
    return { evid: 2260, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatbotTicketCreatedFromTheChatbot' event (evid: 2261)
 *
 * Event description: Public (Chatbot) - Ticket created from the chatbot.
 *
 * @param {publicChatbotTicketCreatedFromTheChatbotParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id that user opened from the chat bot
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tenant_id - tenant_id
 * @property {GUID} session_id - session_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @return {LogObject<publicChatbotTicketCreatedFromTheChatbotParams>} LogObject<publicChatbotTicketCreatedFromTheChatbotParams>
 */
export function publicChatbotTicketCreatedFromTheChatbot(params) {
    return { evid: 2261, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerClientEngagement' event (evid: 2400)
 *
 * Event description: Public (Customer Portal) - Viewer Client Engagement.
 *
 * @param {publicCustomerPortalViewerClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with.
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data related to the member's engagement.
 * @property {string} engaged_component - What "component" the member clicked/engaged with.
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The name of the Engagement
 * @property {string} lang - Answers language
 * @return {LogObject<publicCustomerPortalViewerClientEngagementParams>} LogObject<publicCustomerPortalViewerClientEngagementParams>
 */
export function publicCustomerPortalViewerClientEngagement(params) {
    return { evid: 2400, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCustomerPortalViewerPageLoadSuccess' event (evid: 2401)
 *
 * Event description: This Event is triggered every time Customer Portal viewer page is Loaded Successfully
 *
 * @param {publicCustomerPortalViewerPageLoadSuccessParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {boolean} is_user_ticket_ccd - Is the ticket viewer cc'd to the ticket? relevant only for section_key = Ticket page
 * @property {boolean} is_status_filtered - Relevant only for section_key = support requests list
 * @property {boolean} is_company_filtered - Relevant only for section_key = support requests list
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {boolean} is_reporter_filtered - Relevant only for section_key = support requests list
 * @property {boolean} page_has_contact_us_button - Does the contact us buttons are visible in the page (True or False)
 * @property {boolean} is_language_filtered - Relevant only for section_key = support requests list
 * @property {boolean} is_page_load_from_portal - Is the load of the ticket page is happening internally from the portal (True) or is it stand alone (False) - relevant only for section_key = Ticket page
 * @property {string} section_key - Support requests/followed articles/ticket page
 * @property {string} lang - Answers language
 * @property {boolean} is_user_ticket_reporter - Is the ticket viewer (user) also the ticket reporter? relevant only for section_key = Ticket page
 * @property {boolean} page_has_custom_fields - If section_key = support requests - does custom fields column presented, if section_key = ticket page - does custom fields presented in the info panel
 * @return {LogObject<publicCustomerPortalViewerPageLoadSuccessParams>} LogObject<publicCustomerPortalViewerPageLoadSuccessParams>
 */
export function publicCustomerPortalViewerPageLoadSuccess(params) {
    return { evid: 2401, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicClickContactUsFooter' event (evid: 2500)
 *
 * Event description: Click on "Contact Us" button
 *
 * @param {publicClickContactUsFooterParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} location_identifier - header/footer
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @return {LogObject<publicClickContactUsFooterParams>} LogObject<publicClickContactUsFooterParams>
 */
export function publicClickContactUsFooter(params) {
    return { evid: 2500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketAttempt' event (evid: 2510)
 *
 * Event description: Submission attempt for feedback following an unhelpful vote for an article
 *
 * @param {publicSubmitTicketAttemptParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketAttemptParams>} LogObject<publicSubmitTicketAttemptParams>
 */
export function publicSubmitTicketAttempt(params) {
    return { evid: 2510, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketValidationError' event (evid: 2511)
 *
 * Event description: Public - "Submit Ticket" - validation error
 *
 * @param {publicSubmitTicketValidationErrorParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {boolean} error_in_costume_field - error_in_costume_field
 * @property {boolean} error_in_description - Has error in description?
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {boolean} error_in_name - error_in_name
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {boolean} error_in_email - error_in_email
 * @property {GUID} source_id - source_id
 * @property {boolean} error_in_subject - Has error in subject?
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketValidationErrorParams>} LogObject<publicSubmitTicketValidationErrorParams>
 */
export function publicSubmitTicketValidationError(params) {
    return { evid: 2511, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketSuccess' event (evid: 2512)
 *
 * Event description: When a user submit feedback form for an article in an Help Center of other tenants
 *
 * @param {publicSubmitTicketSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_after_suggestion - rather the user already clicked on a features article and clicked "No, I want to report my issue"
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketSuccessParams>} LogObject<publicSubmitTicketSuccessParams>
 */
export function publicSubmitTicketSuccess(params) {
    return { evid: 2512, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicKbOtherTenantsClickOnItemSrc77Evid2513' event (evid: 2513)
 *
 * Event description: Fire when the user clicks an item / link / component within the article
 *
 * @param {publicKbOtherTenantsClickOnItemSrc77Evid2513Params} params - The parameters for this event
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} user_id - Answers user id
 * @property {string} locale - Answers language
 * @property {string} source_name - The type of page the user is on
 * @property {string} clicked_text - The text that was clicked on
 * @property {string} clicked_item_order - order of the item clicked
 * @property {string} clicked_item_type - type of item clicked
 * @property {string} clicked_item_id	 - id of the article/category/subcategory the user is directed to
 * @property {string} clicked_url - Destination url the link takes the user to
 * @property {string} target_item_type - The type of item the clicked link will take the user to
 * @return {LogObject<publicKbOtherTenantsClickOnItemSrc77Evid2513Params>} LogObject<publicKbOtherTenantsClickOnItemSrc77Evid2513Params>
 */
export function publicKbOtherTenantsClickOnItemSrc77Evid2513(params) {
    return { evid: 2513, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSubmitTicketCancel' event (evid: 2520)
 *
 * Event description: Cancel the ticket submission
 *
 * @param {publicSubmitTicketCancelParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject
 * @property {Url} referral_url - referral_url
 * @property {boolean} is_attached - if there is an attachment
 * @property {string} description - Ticket content
 * @property {string} form_source - {Contact , article...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} article_id - null if form_source is = 1
 * @property {GUID} source_id - source_id
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSubmitTicketCancelParams>} LogObject<publicSubmitTicketCancelParams>
 */
export function publicSubmitTicketCancel(params) {
    return { evid: 2520, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSuggestedArticlesClick' event (evid: 2530)
 *
 * Event description: Clicking on one of the suggested articles from inside a ticket submission.
 *
 * @param {publicSuggestedArticlesClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} referral_name - referral_name
 * @property {string} subject - Ticket subject (used as search term for suggested articles)
 * @property {Url} referral_url - referral_url
 * @property {string} description - Ticket content (used as search term for suggested articles)
 * @property {string} form_source - {Contact , article, widget...} Option 1: Click "Contact Us" . Option 2: Click on "No" in an article after being asked "Did this answer your question?"
 * @property {GUID} source_article_id - null if form_source is = 1
 * @property {string} source_type - source_type
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers language
 * @property {string} source_name - source_name
 * @property {GUID} source_id - source_id
 * @property {GUID} selected_article_id - selected article id
 * @property {string} selected_article_name - selected article name
 * @property {string} parent_url - widget's parent page
 * @return {LogObject<publicSuggestedArticlesClickParams>} LogObject<publicSuggestedArticlesClickParams>
 */
export function publicSuggestedArticlesClick(params) {
    return { evid: 2530, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicDidThisArticleHelpBannerLoaded' event (evid: 2531)
 *
 * Event description: The event is triggered when a "Did this article help?" banner is loaded while a user is viewing an article. (currently the only flow that should lead to this, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicDidThisArticleHelpBannerLoadedParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id that the article was recommended for
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicDidThisArticleHelpBannerLoadedParams>} LogObject<publicDidThisArticleHelpBannerLoadedParams>
 */
export function publicDidThisArticleHelpBannerLoaded(params) {
    return { evid: 2531, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAUserClickOnDidThisArticleHelpBanner' event (evid: 2532)
 *
 * Event description: The event is triggered when a user click "Yes my issue is solved" or "No, I still need help" on "Did this article help?" banner while viewing this article. (currently the only flow that should allow it, is after a user clicks this article in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation))
 *
 * @param {publicAUserClickOnDidThisArticleHelpBannerParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id that the article was recommended for
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @property {boolean} help_or_not - 0 - "No, I still need help", 1- "Yes my issue is solved"
 * @return {LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>} LogObject<publicAUserClickOnDidThisArticleHelpBannerParams>
 */
export function publicAUserClickOnDidThisArticleHelpBanner(params) {
    return { evid: 2532, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicUserArticleEngagementPing' event (evid: 2533)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, scroll all the way to the bottom of the screen, moved mouse, clicked.
 *
 * @param {publicUserArticleEngagementPingParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant id
 * @property {string} activity_type - The activity actions which the user performed (array)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID
 * @property {string} locale - Answers language
 * @property {GUID} article_id - article_id
 * @property {string} article_name - article_name
 * @return {LogObject<publicUserArticleEngagementPingParams>} LogObject<publicUserArticleEngagementPingParams>
 */
export function publicUserArticleEngagementPing(params) {
    return { evid: 2533, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAccessibilityUserActivityInArticles' event (evid: 2540)
 *
 * Event description: Watching video, expand collapsible and clicking on external links in accessibility articles by article_id.
 *
 * @param {publicAccessibilityUserActivityInArticlesParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - The client id of the user who have an activity in the article.
 * @property {GUID} user_id - The user of the user who have an activity in the article.
 * @property {string} category - video,expand,link
 * @return {LogObject<publicAccessibilityUserActivityInArticlesParams>} LogObject<publicAccessibilityUserActivityInArticlesParams>
 */
export function publicAccessibilityUserActivityInArticles(params) {
    return { evid: 2540, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appControlRoomAMemberClientEngagement' event (evid: 2600)
 *
 * Event description: A generic event covering the following member's Client engagements:
 * (1) Click on agent from main table
 * (2) Assign members to channels - data = {multi channel (True/False), multi members (True/False)}
 * (3) Click unassign members  from all channels - data = { multi members (True/False)}
 * (4) Set members workloads - data = {multi channel (True/False), multi members (True/False)}
 * (5) reset members workloads to account settings - data {multi members (True/False)}
 * (6) Update members groups - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (7) Click on manage groups
 * Update members queues - data = {multi add (True/False), multi remove (True/False), multi members (True/False)}
 * (8) Click on manage queues
 * (9) Click on search bar
 * (10) Start typing in search bar. for more details: https://docs.google.com/document/d/1IT8vPXK0mDTTVnI3TSF3__Ti_dXvB8E2SVZnCwe7AFs/edit
 *
 * @param {appControlRoomAMemberClientEngagementParams} params - The parameters for this event
 * @property {string} engaged_sub_component - What "sub component" the member clicked/engaged with. Examples: (1) Edit Groups modal (2) update queues modal
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} data - Json of Data directly related to the member's click/engagement.
 * @property {string} engaged_component - What "component" the member clicked/engaged with. Examples: main table, upper tool bar, etc.
 * @property {GUID} answers_role_id - Role Id of the Answers member loading the page
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} engagement_name - The engagement the member is doing
 * @property {string} lang - Answers language
 * @return {LogObject<appControlRoomAMemberClientEngagementParams>} LogObject<appControlRoomAMemberClientEngagementParams>
 */
export function appControlRoomAMemberClientEngagement(params) {
    return { evid: 2600, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appControlRoomPageLoadSuccess' event (evid: 2601)
 *
 * Event description: App (Control Room) - Page Load Success.
 *
 * @param {appControlRoomPageLoadSuccessParams} params - The parameters for this event
 * @property {number} whatsapp_workload_position - whatsapp_workload_position
 * @property {number} role_position - The position of this column in the main table, if not presented = 0
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {number} total_call_duration_position - total_call_duration_position
 * @property {number} name_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_team - Does this filter applied or not
 * @property {boolean} is_agentchannels - is_agentchannels
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {boolean} is_manager - Does this filter applied or not
 * @property {number} manager_position - The position of this column in the main table, if not presented = 0
 * @property {number} job_title_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_chats_position - completed_chats_position
 * @property {string} time_frame - The time frame being viewed (Last hour, Last 3 Hours etc.)
 * @property {number} avg_call_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} team_position - team_position
 * @property {number} facebook_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_calls_position - The position of this column in the main table, if not presented = 0
 * @property {number} languages_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_statuses - Does this filter applied or not
 * @property {number} status_position - The position of this column in the main table, if not presented = 0
 * @property {number} queues_position - The position of this column in the main table, if not presented = 0
 * @property {number} attempt_outbound_calls_position - The position of this column in the main table, if not presented = 0
 * @property {number} median_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} chat_workload_position - chat_workload_position
 * @property {number} location_position - The position of this column in the main table, if not presented = 0
 * @property {number} completed_handling_tickets_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_handling_tickets_duration_position - total_handling_tickets_duration_position
 * @property {GUID} role_id - Answers Role ID
 * @property {number} call_workload_position - call_workload_position
 * @property {GUID} client_id - client_id
 * @property {boolean} is_queue - Does this filter applied or not
 * @property {GUID} user_id - uuid
 * @property {boolean} is_group - Does this filter applied or not
 * @property {number} avg_completed_call_duration_position - avg_completed_call_duration_position
 * @property {number} utilization_rate_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_filters_applied - total_filters_applied
 * @property {number} avg_handling_tickets_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_calls_position - total_calls_position
 * @property {number} resolved_tickets_position - resolved_tickets_position
 * @property {number} sms_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_completed_call_duration_position - The position of this column in the main table, if not presented = 0
 * @property {number} median_call_duration_position - median_call_duration_position
 * @property {number} total_columns_presented - Total number of presented columns in the main table
 * @property {number} groups_position - The position of this column in the main table, if not presented = 0
 * @property {number} email_workload_position - The position of this column in the main table, if not presented = 0
 * @property {number} qualified_channels_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_location - Does this filter applied or not
 * @property {string} lang - lang
 * @property {number} channel_position - The position of this column in the main table, if not presented = 0
 * @property {number} total_replies_position - The position of this column in the main table, if not presented = 0
 * @property {boolean} is_role - is_role
 * @return {LogObject<appControlRoomPageLoadSuccessParams>} LogObject<appControlRoomPageLoadSuccessParams>
 */
export function appControlRoomPageLoadSuccess(params) {
    return { evid: 2601, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGoBackInTheEditAvailabilityModalAlert' event (evid: 3)
 *
 * Event description: The user made some changes in the channel availability modal and received an alert before saving, he should choose between "change availability" and go back,
 * and choose "go back" without making any changes
 *
 * @param {clickOnGoBackInTheEditAvailabilityModalAlertParams} params - The parameters for this event
 * @property {GUID} group_id - on which group was the action performed?
 * @property {GUID} user_id - who performed the action?
 * @property {string} change - changes that the user wanted to make
 * @return {LogObject<clickOnGoBackInTheEditAvailabilityModalAlertParams>} LogObject<clickOnGoBackInTheEditAvailabilityModalAlertParams>
 */
export function clickOnGoBackInTheEditAvailabilityModalAlert(params) {
    return { evid: 3, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledAttempt' event (evid: 3000)
 *
 * Event description: The server attempted to call a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledAttemptParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<devIntegrationsWebhookCalledAttemptParams>} LogObject<devIntegrationsWebhookCalledAttemptParams>
 */
export function devIntegrationsWebhookCalledAttempt(params) {
    return { evid: 3000, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledSuccess' event (evid: 3001)
 *
 * Event description: The server successfully called a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledSuccessParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<devIntegrationsWebhookCalledSuccessParams>} LogObject<devIntegrationsWebhookCalledSuccessParams>
 */
export function devIntegrationsWebhookCalledSuccess(params) {
    return { evid: 3001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devIntegrationsWebhookCalledFail' event (evid: 3002)
 *
 * Event description: The server failed to call a webhook of a certain integration on behalf of a tenant.
 *
 * @param {devIntegrationsWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<devIntegrationsWebhookCalledFailParams>} LogObject<devIntegrationsWebhookCalledFailParams>
 */
export function devIntegrationsWebhookCalledFail(params) {
    return { evid: 3002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devApiKeysApiAccessByAnApiKeyAttempt' event (evid: 3010)
 *
 * Event description: An API was attempted to be accessed by a certain API key of a certain tenant.
 *
 * @param {devApiKeysApiAccessByAnApiKeyAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID of the accessing tenant
 * @property {GUID} client_id - client_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the accessing tenant
 * @property {GUID} key_id - API key ID
 * @property {string} api_end_point - Full API path (for example, for get ticket method, will be logged : 'TicketController.getTicket')
 * @return {LogObject<devApiKeysApiAccessByAnApiKeyAttemptParams>} LogObject<devApiKeysApiAccessByAnApiKeyAttemptParams>
 */
export function devApiKeysApiAccessByAnApiKeyAttempt(params) {
    return { evid: 3010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devApiKeysApiAccessByAnApiKeySuccess' event (evid: 3011)
 *
 * Event description: An API was successfully accessed by a certain API key of a certain tenant.
 *
 * @param {devApiKeysApiAccessByAnApiKeySuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID of the accessing tenant
 * @property {GUID} client_id - client_id
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the accessing tenant
 * @property {GUID} key_id - API key ID
 * @property {string} api_end_point - Full API path (for example, for get ticket method, will be logged : 'TicketController.getTicket')
 * @return {LogObject<devApiKeysApiAccessByAnApiKeySuccessParams>} LogObject<devApiKeysApiAccessByAnApiKeySuccessParams>
 */
export function devApiKeysApiAccessByAnApiKeySuccess(params) {
    return { evid: 3011, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devApiKeysApiAccessByAnApiKeyFail' event (evid: 3012)
 *
 * Event description: An API key of a certain tenant failed to access an API.
 *
 * @param {devApiKeysApiAccessByAnApiKeyFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID of the accessing tenant
 * @property {string} error_class - Deprecated
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the accessing tenant
 * @property {GUID} key_id - API key ID
 * @property {string} error_type - Error Type
 * @property {string} api_end_point - Full API path (for example, for get ticket method, will be logged : 'TicketController.getTicket')
 * @return {LogObject<devApiKeysApiAccessByAnApiKeyFailParams>} LogObject<devApiKeysApiAccessByAnApiKeyFailParams>
 */
export function devApiKeysApiAccessByAnApiKeyFail(params) {
    return { evid: 3012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingFirstAnonymous' event (evid: 3100)
 *
 * Event description: First anonymous event in Wix Answers
 *
 * @param {marketingFirstAnonymousParams} params - The parameters for this event
 * @property {Url} referral_url - URL of referral
 * @property {GUID} client_id - Answers anonymous ID
 * @property {string} last_referrer - The original url the user came from
 * @property {string} page_type - Where is the page served from (Marketo / Editor / App)
 * @property {Url} page_url - URL of current page
 * @return {LogObject<marketingFirstAnonymousParams>} LogObject<marketingFirstAnonymousParams>
 */
export function marketingFirstAnonymous(params) {
    return { evid: 3100, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingPageViewSrc77Evid3101' event (evid: 3101)
 *
 * Event description: Page view event in Wix Answers
 *
 * @param {marketingPageViewSrc77Evid3101Params} params - The parameters for this event
 * @property {Url} referral_url - URL of referral
 * @property {GUID} client_id - Answers anonymous ID
 * @property {string} last_referrer - The original url the user came from
 * @property {string} page_type - Where is the page served from (Marketo / Editor / App)
 * @property {Url} page_url - URL of current page
 * @return {LogObject<marketingPageViewSrc77Evid3101Params>} LogObject<marketingPageViewSrc77Evid3101Params>
 */
export function marketingPageViewSrc77Evid3101(params) {
    return { evid: 3101, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'marketingClick' event (evid: 3102)
 *
 * Event description: Click event in Wix Answers Marketing Site
 *
 * @param {marketingClickParams} params - The parameters for this event
 * @property {string} element_id - ID of element clicked generated by Wix Editor
 * @property {string} element_name - Name of element
 * @property {GUID} client_id - Answers anonymous ID
 * @property {string} link_to - URL which the element links to
 * @property {string} element_type - Type of element (button, text_link, image)
 * @property {string} element_label - Text on element
 * @property {Url} page_url - URL of page on which the action takes place
 * @return {LogObject<marketingClickParams>} LogObject<marketingClickParams>
 */
export function marketingClick(params) {
    return { evid: 3102, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'generalSpotterScenarioTriggered' event (evid: 3500)
 *
 * Event description: A Spotter Scenario has been triggered by the system
 *
 * @param {generalSpotterScenarioTriggeredParams} params - The parameters for this event
 * @property {number} recipe_type - What type of recipe is it (every recipe is represented by a number)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} role_id - Role ID of the member creating the Scenario
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID (In this case it will be the tenant_id)
 * @property {DateTime} last_update_date - The Date in which the Scenario was "last updated"
 * @property {string} actions_data - Data about the triggered actions as defined in the Scenario
 * @property {string} conditions_data - Data about the conditions as defined in the Scenario
 * @property {string} triggers_data - Data about the triggers defined in the Scenario
 * @property {GUID} recipe_id - Spotter Scenario ID
 * @return {LogObject<generalSpotterScenarioTriggeredParams>} LogObject<generalSpotterScenarioTriggeredParams>
 */
export function generalSpotterScenarioTriggered(params) {
    return { evid: 3500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketWasSentToRevaluationFlowSrc77Evid4' event (evid: 4)
 *
 * Event description: Ticket was sent to revaluation flow. Triggers after gathering all information that needed for routing (about ticket, system state and recommendations).
 *
 * @param {ticketWasSentToRevaluationFlowSrc77Evid4Params} params - The parameters for this event
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} ticket_id - Unique id of the ticket
 * @property {GUID} interaction_id - Unique interaction id
 * @property {GUID} prediction_id - Unique id for each model prediction
 * @property {string} revaluation_reason - reason ticket is sent to revaluation
 * @return {LogObject<ticketWasSentToRevaluationFlowSrc77Evid4Params>} LogObject<ticketWasSentToRevaluationFlowSrc77Evid4Params>
 */
export function ticketWasSentToRevaluationFlowSrc77Evid4(params) {
    return { evid: 4, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsLinkAnArticleToATicket' event (evid: 4001)
 *
 * Event description: Linking an article to a ticket. The uuid in this event id the ID of the user who linked the article.
 *
 * @param {appTicketsLinkAnArticleToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {boolean} is_by_rule_engine - True = The link was generated by the Rule Engine, False = The link was generated by an actual agent/user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} article_id - Linked article id
 * @return {LogObject<appTicketsLinkAnArticleToATicketParams>} LogObject<appTicketsLinkAnArticleToATicketParams>
 */
export function appTicketsLinkAnArticleToATicket(params) {
    return { evid: 4001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsRemoveARelatedArticleFromATicket' event (evid: 4002)
 *
 * Event description: Remove a related article from a ticket. The uuid in this event id the ID of the user who removed the article.
 *
 * @param {appTicketsRemoveARelatedArticleFromATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {boolean} is_by_rule_engine - True = The link was generated by the Rule Engine, False = The link was generated by an actual agent/user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} article_id - Linked article id
 * @return {LogObject<appTicketsRemoveARelatedArticleFromATicketParams>} LogObject<appTicketsRemoveARelatedArticleFromATicketParams>
 */
export function appTicketsRemoveARelatedArticleFromATicket(params) {
    return { evid: 4002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsMacroAddedToATicket' event (evid: 4003)
 *
 * Event description: Applying a "Macro" within a ticket. The uuid in this event is the ID of the user who applied the Macro.
 *
 * @param {appTicketsMacroAddedToATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID in which Macro has been applied
 * @property {string} macro_description - The description of the applied Macro
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user adding the Macro
 * @property {GUID} macro_id - Applied Macro id
 * @property {string} actions - The actions inserted inside the Macro by order
 * @property {string} macro_name - Applied Macro name
 * @return {LogObject<appTicketsMacroAddedToATicketParams>} LogObject<appTicketsMacroAddedToATicketParams>
 */
export function appTicketsMacroAddedToATicket(params) {
    return { evid: 4003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOneInboxTicketSBrandChanged' event (evid: 4007)
 *
 * Event description: Ticket's brand changed or set (by agent - from the info panel)
 *
 * @param {appOneInboxTicketSBrandChangedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} new_brand_id - New Answers Brand ID
 * @property {GUID} tenant_id - Answers Tenant id
 * @property {string} new_brand_name - New Answers Brand Name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} performed_by - Who changed the status (SessionUser, Automatic Actions, Spotter, Macro)
 * @property {string} locale - Answers language
 * @property {GUID} previous_brand_id - Previous Answers Brand ID (Null if it's set for the first time)
 * @return {LogObject<appOneInboxTicketSBrandChangedParams>} LogObject<appOneInboxTicketSBrandChangedParams>
 */
export function appOneInboxTicketSBrandChanged(params) {
    return { evid: 4007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsTicketSnoozeStartSrc77Evid4008' event (evid: 4008)
 *
 * Event description: A ticket has been snoozed by an Answers member or by the system (Automatic actions, Spotter, Macro). if snooze happens in bulk, the event will be triggered separately for every ticket.
 *
 * @param {appTicketsTicketSnoozeStartSrc77Evid4008Params} params - The parameters for this event
 * @property {GUID} ticket_id - The Id of the Ticket being snoozed
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} costumer_reply_unsnooze - Should snooze be ended (canceled) if user reply the ticket (True/False)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member setting the snooze or system user ID if snooze was set by rule engine (Spotter, Macro etc.)
 * @property {boolean} change_status_to_open - Does end of snooze should change ticket status to open (True/False)
 * @property {GUID} macro_id - Phase 2 - If done by Macro - Macro ID, if not - Null
 * @property {string} operator - Phase 2 - Who made the action (Member, Macro, Spotter)
 * @property {boolean} send_notification - True / False - according to snooze settings
 * @property {GUID} scenario_id - Phase 2 - If done by Spotter - Scenario ID, if not - Null
 * @property {DateTime} snooze_time - The Time the ticket was set to be snoozed
 * @return {LogObject<appTicketsTicketSnoozeStartSrc77Evid4008Params>} LogObject<appTicketsTicketSnoozeStartSrc77Evid4008Params>
 */
export function appTicketsTicketSnoozeStartSrc77Evid4008(params) {
    return { evid: 4008, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsTicketSnoozeEnd' event (evid: 4009)
 *
 * Event description: A ticket snooze has been ended by a member or by the system, it can happen naturally if ticket's snooze time ended or by a specific action that ended it before like: another user reply in the ticket, a member unsnooze the ticket etc.
 *
 * @param {appTicketsTicketSnoozeEndParams} params - The parameters for this event
 * @property {GUID} ticket_id - The Id of the Ticket being snoozed
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member canceling the snooze (if done by the system - system user ID)
 * @property {string} end_reason - The reason the Snooze was ended (snooze time ended naturally, member click cancel, user reply etc.)
 * @property {DateTime} natural_end_time - The time that the snooze was set to end when it was created/updated
 * @return {LogObject<appTicketsTicketSnoozeEndParams>} LogObject<appTicketsTicketSnoozeEndParams>
 */
export function appTicketsTicketSnoozeEnd(params) {
    return { evid: 4009, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsTicketSnoozeUpdate' event (evid: 4010)
 *
 * Event description: A ticket snooze time has been updated
 *
 * @param {appTicketsTicketSnoozeUpdateParams} params - The parameters for this event
 * @property {GUID} ticket_id - The Id of the Ticket being snoozed
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} costumer_reply_unsnooze - Should snooze be ended (canceled) if user reply the ticket (True/False)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member updating the snooze
 * @property {boolean} change_status_to_open - Does end of snooze should change ticket status to open (True/False)
 * @property {DateTime} snooze_time_after - The Time the ticket was set to be snoozed after it was updated
 * @property {boolean} send_notification - True / False - according to snooze settings
 * @property {DateTime} snooze_time_before - The Time the ticket was set to be snoozed before it was updated
 * @return {LogObject<appTicketsTicketSnoozeUpdateParams>} LogObject<appTicketsTicketSnoozeUpdateParams>
 */
export function appTicketsTicketSnoozeUpdate(params) {
    return { evid: 4010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsAutomaticActionsTriggeredByRuleExecutor' event (evid: 4011)
 *
 * Event description: Will be triggered each time rule executor is applied on a specific ticket (rule executor is "going over" the automatic actions rules defined in the system and triggering actions accordingly on the ticket)
 *
 * @param {appTicketsAutomaticActionsTriggeredByRuleExecutorParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID in which the automatic actions happened
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - In this case will be identical to the tenant_id
 * @property {number} total_execution_time - Total rule engine execution time in milliseconds
 * @property {number} total_actions_triggered - The number of actions that were triggered on the ticket
 * @property {number} total_rules_triggered - The number of rules that were triggered on the ticket
 * @return {LogObject<appTicketsAutomaticActionsTriggeredByRuleExecutorParams>} LogObject<appTicketsAutomaticActionsTriggeredByRuleExecutorParams>
 */
export function appTicketsAutomaticActionsTriggeredByRuleExecutor(params) {
    return { evid: 4011, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsActionTriggeredByMultiActionExecutor' event (evid: 4012)
 *
 * Event description: Will be triggered on by each Action that was Triggered Automatically by multi action executor (Can be triggered from Automatic actions or Macros)
 *
 * @param {appTicketsActionTriggeredByMultiActionExecutorParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID in which the automatic action happened
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {number} action_type_id - The action that has been triggered automatically
 * @property {number} multi_action_type - Automatic Action - 1, Macro - 2
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - In this case will be identical to the tenant_id
 * @property {GUID} multi_action_id - "Automatic action" or Macro ID
 * @return {LogObject<appTicketsActionTriggeredByMultiActionExecutorParams>} LogObject<appTicketsActionTriggeredByMultiActionExecutorParams>
 */
export function appTicketsActionTriggeredByMultiActionExecutor(params) {
    return { evid: 4012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsPrimaryTicketMerge' event (evid: 4013)
 *
 * Event description: 1 ticket or more has been merged to Primary ticket.
 *
 * @param {appTicketsPrimaryTicketMergeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ID of the primary ticket
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} channel - The channel of the primary ticket
 * @property {DateTime} ticket_creation_date - The date the Primary ticket was created
 * @property {number} tickets_merged_count - Total number of tickets being merged as part of this Merge
 * @property {string} articles - Article ID's related to the Primary ticket
 * @property {number} replies_count - Number of replies (not internal)  in the primary ticket
 * @property {GUID} client_id - client_id
 * @property {GUID} merge_id - The ID of the Merge action
 * @property {GUID} user_id - Answers User ID of the member merging the tickets
 * @property {string} labels - Label ID's related to the Primary ticket
 * @property {GUID} ticket_creator_id - The user ID of the Primary ticket creator
 * @property {string} title - The title of the primary ticket
 * @return {LogObject<appTicketsPrimaryTicketMergeParams>} LogObject<appTicketsPrimaryTicketMergeParams>
 */
export function appTicketsPrimaryTicketMerge(params) {
    return { evid: 4013, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTicketsSecondaryTicketMerge' event (evid: 4014)
 *
 * Event description: A ticket has been merged as Secondary ticket to a primary ticket. if a few secondary tickets has been merged in bulk, this event will be fired for each one of them separately.
 *
 * @param {appTicketsSecondaryTicketMergeParams} params - The parameters for this event
 * @property {GUID} ticket_id - ID of the secondary ticket
 * @property {GUID} tenant_id - Answers Tenant ID of the Primary ticket
 * @property {string} channel - The channel of the secondary ticket
 * @property {DateTime} ticket_creation_date - The date the secondary ticket has been created
 * @property {string} articles - Article ID's related to the Secondary ticket
 * @property {number} replies_count - Number of replies (not internal) in the Secondary ticket at the time of the merge
 * @property {GUID} client_id - client_id
 * @property {GUID} merge_id - ID of the merge action
 * @property {GUID} user_id - Answers User ID of the member merging the tickets
 * @property {string} labels - Label ID's related to the Secondary ticket
 * @property {GUID} ticket_creator_id - The user ID of the secondary ticket creator
 * @property {string} title - The title of the secondary ticket
 * @return {LogObject<appTicketsSecondaryTicketMergeParams>} LogObject<appTicketsSecondaryTicketMergeParams>
 */
export function appTicketsSecondaryTicketMerge(params) {
    return { evid: 4014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appInboxAgentSGlobalStatusWasChanged' event (evid: 4050)
 *
 * Event description: The event is fired whenever an agent's global status (including going in-and-out of an active session) or assigned channels are changed (Also referred to as "State change").
 * The change might be triggered by the user herself or an admin.
 * The UUID always belongs to the agent.
 * The data in the event is about the status that just ended.
 *
 * @param {appInboxAgentSGlobalStatusWasChangedParams} params - The parameters for this event
 * @property {number} duration_status - Duration from the last status change, in seconds
 * @property {number} duration - Duration from the last event (last state change), in seconds
 * @property {boolean} is_active - The agent is on (at least one) active session
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} custom_status_id - While on "Busy" status, the agent can specify which type of "Busy" (Break, Lunch, Meeting, etc.)
 * @property {number} duration_channels - Duration from the last channels change, in seconds
 * @property {number} status_id - Status eNum
 * @property {string} changed_by - Who changed the status (SessionUser, Admin, Auto, Repair)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} channel_ids - List of assigned channels (Call Center, Chat, etc.)
 * @property {number} event_type - The type of change that triggered the event (10 = Channels; 20 = Status)
 * @property {string} agent_active_tickets_list - List of tickets agent is currently processing
 *
 * @property {number} agent_active_tickets_num	 - Number of tickets agent is currently processing
 * @property {boolean} agent_is_routing_ready_calls	 - Agent can get new tickets added to their personal queue
 * @property {string} agent_waiting_tickets_list - List of tickets waiting in agent's personal queue
 * @property {number} agent_waiting_tickets_num - Number of tickets waiting in agent's personal queue
 * @property {string} call_center_status_id	 - Callcenter status of the agent
 * @return {LogObject<appInboxAgentSGlobalStatusWasChangedParams>} LogObject<appInboxAgentSGlobalStatusWasChangedParams>
 */
export function appInboxAgentSGlobalStatusWasChanged(params) {
    return { evid: 4050, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devGeneralAnswersFedEvent' event (evid: 42)
 *
 * Event description: This is a general event that serves as "event candidate". Relevant events will be later developed as standalone events.
 *
 * @param {devGeneralAnswersFedEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} module - module in the app (kb / ticketing / cc / chat / etc.)
 * @property {GUID} item_id - Item ID
 * @property {GUID} tenant_id - tenant ID
 * @property {string} feature - feature
 * @property {string} data - data
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} type - event description
 * @return {LogObject<devGeneralAnswersFedEventParams>} LogObject<devGeneralAnswersFedEventParams>
 */
export function devGeneralAnswersFedEvent(params) {
    return { evid: 42, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAMemberHasBeenAddedToAGroup' event (evid: 4200)
 *
 * Event description: A member has been added to one of the tenant's groups. note that this action can be triggered from several action sources (settings > team members, Control room etc.)
 *
 * @param {appTeamAMemberHasBeenAddedToAGroupParams} params - The parameters for this event
 * @property {GUID} group_id - The group ID the member has been added to
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user adding the member to the group
 * @property {string} group_name - The group name the member has been added to
 * @property {string} member_name - The name of the member added to the group
 * @property {GUID} member_id - The user ID of the member added to the group
 * @return {LogObject<appTeamAMemberHasBeenAddedToAGroupParams>} LogObject<appTeamAMemberHasBeenAddedToAGroupParams>
 */
export function appTeamAMemberHasBeenAddedToAGroup(params) {
    return { evid: 4200, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appTeamAMemberHasBeenRemovedFromAGroup' event (evid: 4201)
 *
 * Event description: A member has been removed from one of the tenant's groups. note that this action can be triggered from several action sources (settings > team members, Control room etc.)
 *
 * @param {appTeamAMemberHasBeenRemovedFromAGroupParams} params - The parameters for this event
 * @property {GUID} group_id - The group ID the member has been removed from
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user removing the member fromthe group
 * @property {string} group_name - The group name the member has been removed from
 * @property {string} member_name - The name of the member removed from group
 * @property {GUID} member_id - The user ID of the member removed from the group
 * @return {LogObject<appTeamAMemberHasBeenRemovedFromAGroupParams>} LogObject<appTeamAMemberHasBeenRemovedFromAGroupParams>
 */
export function appTeamAMemberHasBeenRemovedFromAGroup(params) {
    return { evid: 4201, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnStatusPageBanner' event (evid: 44)
 *
 * Event description: Click on "Status Page" Banner
 *
 * @param {clickOnStatusPageBannerParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {string} incident_name - The title of the incident fetched from the status page
 * @property {GUID} user_id - uuid
 * @property {boolean} resolved - State of the Incident
 * @return {LogObject<clickOnStatusPageBannerParams>} LogObject<clickOnStatusPageBannerParams>
 */
export function clickOnStatusPageBanner(params) {
    return { evid: 44, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationAttempt' event (evid: 4400)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationAttemptParams>} LogObject<appSettingsIntegrationsRegisterIntegrationAttemptParams>
 */
export function appSettingsIntegrationsRegisterIntegrationAttempt(params) {
    return { evid: 4400, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationSuccess' event (evid: 4401)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationSuccessParams>} LogObject<appSettingsIntegrationsRegisterIntegrationSuccessParams>
 */
export function appSettingsIntegrationsRegisterIntegrationSuccess(params) {
    return { evid: 4401, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsRegisterIntegrationFail' event (evid: 4402)
 *
 * Event description: The user failed to register (install) an integration on the tenant.
 *
 * @param {appSettingsIntegrationsRegisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsRegisterIntegrationFailParams>} LogObject<appSettingsIntegrationsRegisterIntegrationFailParams>
 */
export function appSettingsIntegrationsRegisterIntegrationFail(params) {
    return { evid: 4402, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationAttempt' event (evid: 4403)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationAttemptParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationAttemptParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationAttempt(params) {
    return { evid: 4403, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationSuccess' event (evid: 4404)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationSuccessParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationSuccessParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationSuccess(params) {
    return { evid: 4404, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsIntegrationsUnregisterIntegrationFail' event (evid: 4405)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {appSettingsIntegrationsUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<appSettingsIntegrationsUnregisterIntegrationFailParams>} LogObject<appSettingsIntegrationsUnregisterIntegrationFailParams>
 */
export function appSettingsIntegrationsUnregisterIntegrationFail(params) {
    return { evid: 4405, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroCreated' event (evid: 4406)
 *
 * Event description: Macro has been created in the system
 *
 * @param {appSettingsMacrosMacroCreatedParams} params - The parameters for this event
 * @property {string} macro_description - The description of the created Macro
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user creating the Macro
 * @property {GUID} macro_id - Created Macro id
 * @property {string} actions - The actions inserted inside the Macro by order
 * @property {string} macro_name - Created Macro name
 * @return {LogObject<appSettingsMacrosMacroCreatedParams>} LogObject<appSettingsMacrosMacroCreatedParams>
 */
export function appSettingsMacrosMacroCreated(params) {
    return { evid: 4406, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroEdited' event (evid: 4407)
 *
 * Event description: Macros has been edited
 *
 * @param {appSettingsMacrosMacroEditedParams} params - The parameters for this event
 * @property {string} macro_description - The description of the edited Macro
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user editing the Macro
 * @property {GUID} macro_id - Edited Macro id after edit
 * @property {string} actions - The actions inserted inside the Macro by order after edit
 * @property {string} macro_name - Edited Macro name after edit
 * @return {LogObject<appSettingsMacrosMacroEditedParams>} LogObject<appSettingsMacrosMacroEditedParams>
 */
export function appSettingsMacrosMacroEdited(params) {
    return { evid: 4407, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroDeleted' event (evid: 4408)
 *
 * Event description: Macros has been deleted
 *
 * @param {appSettingsMacrosMacroDeletedParams} params - The parameters for this event
 * @property {string} macro_description - The description of the deleted Macro
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user deleting the Macro
 * @property {GUID} macro_id - Macro id
 * @property {string} actions - The actions inserted inside the deleted Macro by order
 * @property {string} macro_name - Macro name
 * @return {LogObject<appSettingsMacrosMacroDeletedParams>} LogObject<appSettingsMacrosMacroDeletedParams>
 */
export function appSettingsMacrosMacroDeleted(params) {
    return { evid: 4408, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsMacrosMacroActivateDeactivate' event (evid: 4409)
 *
 * Event description: Macros has been activate or deactivate
 *
 * @param {appSettingsMacrosMacroActivateDeactivateParams} params - The parameters for this event
 * @property {string} macro_description - The description of the deleted Macro
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {boolean} status_type - True for activate false for deactivate (determine if the Macro be available for use)
 * @property {GUID} user_id - Answers User ID of the user activating / deactivating
 * @property {GUID} macro_id - Macro id
 * @property {string} actions - The actions inserted inside the deleted Macro by order
 * @property {string} macro_name - Macro name
 * @return {LogObject<appSettingsMacrosMacroActivateDeactivateParams>} LogObject<appSettingsMacrosMacroActivateDeactivateParams>
 */
export function appSettingsMacrosMacroActivateDeactivate(params) {
    return { evid: 4409, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterWaitingInQueueNoAgentsSettingsChange' event (evid: 4410)
 *
 * Event description: Call Center "Waiting in Queue When there is no agents” Queue settings of a specific queue has been changed
 *
 * @param {appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} action_name - Action name  (hang up the Call / Voicemail/ Transfer to different queue/ IVR flow)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID who made the change
 * @property {GUID} queue_id - Initial queue of the call (for callback only)
 * @property {string} locale - Locale of the queue
 * @property {string} play_type_name - play type name ( Text to speech, recorded sound file etc)
 * @property {string} queue_name - Queue Name
 * @return {LogObject<appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams>} LogObject<appSettingsCallCenterWaitingInQueueNoAgentsSettingsChangeParams>
 */
export function appSettingsCallCenterWaitingInQueueNoAgentsSettingsChange(params) {
    return { evid: 4410, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterQueueBusinessHoursChange' event (evid: 4411)
 *
 * Event description: Queue Business hours settings has been changed
 *
 * @param {appSettingsCallCenterQueueBusinessHoursChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} action_name - "When Queue is closed" action name ( hang up the Call / Voicemail/ Transfer to different queue/ IVR flow)
 * @property {boolean} is_custom - Business hours same as Line = FALSE or Custom business hours for specific queue = TRUE
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID who made the change
 * @property {GUID} queue_id - Initial queue of the call (for callback only)
 * @property {string} locale - Locale of the queue
 * @property {string} play_type_name - "When Queue is closed" play type ( Text to speech, recorded sound file etc)
 * @property {string} business_hours - Json of the business hours after the change
 * @property {string} queue_name - Queue Name
 * @return {LogObject<appSettingsCallCenterQueueBusinessHoursChangeParams>} LogObject<appSettingsCallCenterQueueBusinessHoursChangeParams>
 */
export function appSettingsCallCenterQueueBusinessHoursChange(params) {
    return { evid: 4411, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChange' event (evid: 4412)
 *
 * Event description: Call Center "Waiting and Hold” Queue settings of a specific queue has been changed
 *
 * @param {appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} queue_wait_offers_thresholds - Json of the thresholds numbers applied in order to get the options given to the waiting caller (request a Callback, leaving a message, move to another queue)
 * @property {boolean} is_suggest_offer_options_enabled - Does the option to suggest other contact options than play waiting queue message is enabled or not
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID who made the change
 * @property {GUID} queue_id - Initial queue of the call (for callback only)
 * @property {string} locale - Locale of the queue
 * @property {string} play_type_name - "When Queue is closed" play type (Text to speech, recorded sound file etc)
 * @property {string} queue_wait_offer_options - Json of the options given to the waiting caller (request a Callback, leaving a message, move to another queue)
 * @property {string} queue_name - Queue Name
 * @return {LogObject<appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams>} LogObject<appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChangeParams>
 */
export function appSettingsCallCenterWaitingInQueueWaitingAndHoldSettingsChange(params) {
    return { evid: 4412, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleCreated' event (evid: 4413)
 *
 * Event description: A new role has been created in Answers App.
 *
 * @param {appSettingsRolesRoleCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} permissions - Json of the permissions in this role
 * @property {GUID} role_id - The role ID of the role created
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user created the role
 * @property {string} role_name - The role name of the role created
 * @return {LogObject<appSettingsRolesRoleCreatedParams>} LogObject<appSettingsRolesRoleCreatedParams>
 */
export function appSettingsRolesRoleCreated(params) {
    return { evid: 4413, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleChanged' event (evid: 4414)
 *
 * Event description: A role has been changed in Answers App.
 *
 * @param {appSettingsRolesRoleChangedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} role_id - The role ID of the role created
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user created the role
 * @property {string} permissions_before - Json of the permissions in this role before the change
 * @property {string} permissions_after - Json of the permissions in this role after the change
 * @return {LogObject<appSettingsRolesRoleChangedParams>} LogObject<appSettingsRolesRoleChangedParams>
 */
export function appSettingsRolesRoleChanged(params) {
    return { evid: 4414, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesRoleHasBeenDeleted' event (evid: 4415)
 *
 * Event description: A role has been deleted from Answers App.
 *
 * @param {appSettingsRolesRoleHasBeenDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} role_id - The role ID of the role created
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user created the role
 * @return {LogObject<appSettingsRolesRoleHasBeenDeletedParams>} LogObject<appSettingsRolesRoleHasBeenDeletedParams>
 */
export function appSettingsRolesRoleHasBeenDeleted(params) {
    return { evid: 4415, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsRolesTeamMemberRoleHasBeenChanged' event (evid: 4416)
 *
 * Event description: A team member role has been changed in Answers
 *
 * @param {appSettingsRolesTeamMemberRoleHasBeenChangedParams} params - The parameters for this event
 * @property {GUID} role_id_before - The role ID of team member before the change
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} role_id_after - The role ID of team member after the change
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user created the role
 * @property {string} source_page - The source page which the role has been changed from
 * @return {LogObject<appSettingsRolesTeamMemberRoleHasBeenChangedParams>} LogObject<appSettingsRolesTeamMemberRoleHasBeenChangedParams>
 */
export function appSettingsRolesTeamMemberRoleHasBeenChanged(params) {
    return { evid: 4416, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueue' event (evid: 4417)
 *
 * Event description: A new team member has been assigned to get priority in a specific queue. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritized to get the call)
 *
 * @param {appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams} params - The parameters for this event
 * @property {number} priority - The priority number of the member
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID who assigned the member to queue
 * @property {GUID} queue_id - Queue ID of the Queue the member has been assigned to
 * @property {GUID} assigned_user_id - The user ID of the new member that has been assigned to queue
 * @return {LogObject<appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams>} LogObject<appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueueParams>
 */
export function appSettingsCallCenterANewTeamMemberHasBeenAssignedToQueue(params) {
    return { evid: 4417, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChanged' event (evid: 4418)
 *
 * Event description: The priority of a member who is assigned to a queue has been changed. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritised to get the call)
 *
 * @param {appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams} params - The parameters for this event
 * @property {number} priority - The priority number of the member after the change
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - Queue ID
 * @property {GUID} assigned_user_id - assigned_user_id
 * @return {LogObject<appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams>} LogObject<appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChangedParams>
 */
export function appSettingsCallCenterATeamMemberPriorityInQueueHasBeenChanged(params) {
    return { evid: 4418, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueue' event (evid: 4419)
 *
 * Event description: A member who was assigned to a queue has been removed from being assigned to this queue and therefore will no longer be prioritized in this queue. (In calls, if there is more than one agent available, the agent whose queue priority is the highest will be prioritized to get the call)
 *
 * @param {appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams} params - The parameters for this event
 * @property {GUID} assigned_member_id - **Wrong**
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers user ID who removed the member from the queue
 * @property {GUID} queue_id - ID of the queue from which the member has been removed
 * @property {GUID} assigned_user_id - The User ID of the member that has been removed from the queue
 * @return {LogObject<appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams>} LogObject<appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueueParams>
 */
export function appSettingsCallCenterATeamMemberHasBeenRemovedUnassignedFromQueue(params) {
    return { evid: 4419, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsWidgetLiveChatSettingsChange' event (evid: 4420)
 *
 * Event description: Widget Live Chat Settings has been updated - this event will be triggered whenever there is a change in one of the Widget's Live Chat Settings
 *
 * @param {appSettingsWidgetLiveChatSettingsChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} widget_id - ID of the Widget
 * @property {string} settings_before - Settings before the change
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} locale - Answers language
 * @property {string} settings_after - Settings after the change
 * @return {LogObject<appSettingsWidgetLiveChatSettingsChangeParams>} LogObject<appSettingsWidgetLiveChatSettingsChangeParams>
 */
export function appSettingsWidgetLiveChatSettingsChange(params) {
    return { evid: 4420, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyEnabledDisabledByLanguage' event (evid: 4421)
 *
 * Event description: A language has been enabled or disabled from sending a survey (change is done by a toggle)
 *
 * @param {appSettingsCsatSurveyEnabledDisabledByLanguageParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} locale - Language
 * @property {boolean} survey_enabled - Survey sending is enabled (True) or disabled (False)
 * @return {LogObject<appSettingsCsatSurveyEnabledDisabledByLanguageParams>} LogObject<appSettingsCsatSurveyEnabledDisabledByLanguageParams>
 */
export function appSettingsCsatSurveyEnabledDisabledByLanguage(params) {
    return { evid: 4421, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyEnabledDisabledByChannel' event (evid: 4422)
 *
 * Event description: A channel has been enabled or disabled from sending a survey (change is done by a toggle)
 *
 * @param {appSettingsCsatSurveyEnabledDisabledByChannelParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} channel_enabled - Survey sending is enabled (true) or disabled (false)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} locale - Language
 * @property {string} csat_channel - The CSAT channel that has been enabled or disabled from sending surveys
 * @return {LogObject<appSettingsCsatSurveyEnabledDisabledByChannelParams>} LogObject<appSettingsCsatSurveyEnabledDisabledByChannelParams>
 */
export function appSettingsCsatSurveyEnabledDisabledByChannel(params) {
    return { evid: 4422, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyContentChange' event (evid: 4423)
 *
 * Event description: A content of a survey has been changed
 *
 * @param {appSettingsCsatSurveyContentChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} response_data - Json with all data related to responses of all types (Response type, Response enabled/disabled, response text, follow-up question enabled/disabled, follow-up question text, thank you message text)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} locale - Language
 * @property {string} survey_title - The survey title
 * @property {string} thank_you_message - This message will appear after customers click Send.
 * @property {boolean} comment_option - Does commenting in the survey is enabled (True) ot disabled (False)
 * @return {LogObject<appSettingsCsatSurveyContentChangeParams>} LogObject<appSettingsCsatSurveyContentChangeParams>
 */
export function appSettingsCsatSurveyContentChange(params) {
    return { evid: 4423, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyDelayTimeChange' event (evid: 4424)
 *
 * Event description: The time that should pass from the moment the ticket status had changed to ‘Solved’ and until the survey is sent has been changed
 *
 * @param {appSettingsCsatSurveyDelayTimeChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {number} delay_after - Survey delay time after the change (immediately = 0)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User id of the user that made the change
 * @property {number} delay_before - Survey delay time before the change (immediately = 0)
 * @return {LogObject<appSettingsCsatSurveyDelayTimeChangeParams>} LogObject<appSettingsCsatSurveyDelayTimeChangeParams>
 */
export function appSettingsCsatSurveyDelayTimeChange(params) {
    return { evid: 4424, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyThrottlingTimeChange' event (evid: 4425)
 *
 * Event description: The time that should pass from the moment a customer had submitted the survey and before a new survey can be sent for the same ticket has been changed
 *
 * @param {appSettingsCsatSurveyThrottlingTimeChangeParams} params - The parameters for this event
 * @property {number} time_after - Survey Throttling time after the change (immediately = 0)
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user that made the change
 * @property {number} time_before - Survey Throttling time before the change (immediately = 0)
 * @return {LogObject<appSettingsCsatSurveyThrottlingTimeChangeParams>} LogObject<appSettingsCsatSurveyThrottlingTimeChangeParams>
 */
export function appSettingsCsatSurveyThrottlingTimeChange(params) {
    return { evid: 4425, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsCsatSurveyInvitationMessageChange' event (evid: 4427)
 *
 * Event description: Survey invitation message of one of the relevant channels (currently Facebook or Whatsapp) has been changed
 *
 * @param {appSettingsCsatSurveyInvitationMessageChangeParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel for which the invitation message has been changed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the user that made the change
 * @property {string} locale - Language
 * @property {string} invitation_message_before - The invitation message before the change
 * @property {string} invitation_message_after - The invitation message after the change
 * @property {string} csat_channel - The channel for which the invitation message has been changed
 * @return {LogObject<appSettingsCsatSurveyInvitationMessageChangeParams>} LogObject<appSettingsCsatSurveyInvitationMessageChangeParams>
 */
export function appSettingsCsatSurveyInvitationMessageChange(params) {
    return { evid: 4427, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyCreate' event (evid: 4428)
 *
 * Event description: A new SLA policy has been created
 *
 * @param {appSettingsSlaPolicyCreateParams} params - The parameters for this event
 * @property {string} policy_activity_hours - A Json of the policy activity hours
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} policy_id - The ID of the policy that has been created
 * @property {string} ticket_create_conditions - A Json with the conditions the policy applied to when ticket is created
 * @property {string} policy_time_targets - A Json with the policy time targets, including reset settings
 * @property {GUID} client_id - client_id
 * @property {string} time_zone_type - Time zone type of this policy’s business hours (Account or Company)
 * @property {GUID} user_id - The user ID of the member that created the policy
 * @property {string} triggers - A Json with data indicating which triggers are enabled/disabled
 * @property {boolean} is_reset_resolution_time - Reset the resolution time when a solved/closed ticket is reopened - True or False
 * @property {string} policy_name - The name of the policy that has been created
 * @property {string} policy_description - The description of the policy that has been created
 * @property {string} breach_rules - Policy breach rules (for each rule: Conditions, priorities applied and Actions)
 * @property {string} ticket_assign_conditions - A Json with the conditions the policy applied to when ticket is being assigned to an agent or a group
 * @property {boolean} is_reset_first_reply_time - Reset the first reply time when a solved/closed ticket is reopened - True or False
 * @return {LogObject<appSettingsSlaPolicyCreateParams>} LogObject<appSettingsSlaPolicyCreateParams>
 */
export function appSettingsSlaPolicyCreate(params) {
    return { evid: 4428, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyUpdate' event (evid: 4429)
 *
 * Event description: SLA policy has been updated
 *
 * @param {appSettingsSlaPolicyUpdateParams} params - The parameters for this event
 * @property {string} policy_activity_hours - Json of the policy activity hours after the update
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} policy_id - The ID of the policy that has been updated
 * @property {string} ticket_create_conditions - Json with the conditions the policy applied to when ticket is created after the update
 * @property {string} policy_time_targets - Json with the policy time targets, including reset settings after the update
 * @property {GUID} client_id - client_id
 * @property {string} time_zone_type - Time zone type of this policy’s business hours (Account or Company)
 * @property {GUID} user_id - The user ID of the member that updated the policy
 * @property {string} triggers - Json with data indicating which triggers are enabled/disabled
 * @property {boolean} is_reset_resolution_time - Reset the resolution time when a solved/closed ticket is reopened - True or False
 * @property {string} policy_name - The name of the policy that has been updated after the update
 * @property {string} policy_description - The description of the policy that has been updated after the update
 * @property {string} breach_rules - Policy breach rules (for each rule: Conditions, priorities applied and Actions)
 * @property {string} ticket_assign_conditions - Json with the conditions the policy applied to when ticket is being assigned to an agent or a group after the update
 * @property {boolean} is_reset_first_reply_time - Reset the first reply time when a solved/closed ticket is reopened - True or False
 * @return {LogObject<appSettingsSlaPolicyUpdateParams>} LogObject<appSettingsSlaPolicyUpdateParams>
 */
export function appSettingsSlaPolicyUpdate(params) {
    return { evid: 4429, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyDelete' event (evid: 4430)
 *
 * Event description: SLA policy has been deleted
 *
 * @param {appSettingsSlaPolicyDeleteParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} policy_id - The ID of the policy that has been deleted
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The user ID of the member that deleted the policy
 * @property {string} policy_name - The name of the policy that has been deleted
 * @property {string} policy_description - The description of the policy that has been deleted
 * @return {LogObject<appSettingsSlaPolicyDeleteParams>} LogObject<appSettingsSlaPolicyDeleteParams>
 */
export function appSettingsSlaPolicyDelete(params) {
    return { evid: 4430, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSlaPolicyActivatedOrDeactivated' event (evid: 4431)
 *
 * Event description: SLA policy has been activated or deactivated
 *
 * @param {appSettingsSlaPolicyActivatedOrDeactivatedParams} params - The parameters for this event
 * @property {boolean} is_active - True - if the policy has been activated, False if the policy has been deactivated
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} policy_id - The ID of the policy that has been activated/deactivated
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The user ID of the member that activated/deactivated the policy
 * @property {string} policy_name - The name of the policy that has been activated/deactivated
 * @property {string} policy_description - The description of the policy that has been activated/deactivated
 * @return {LogObject<appSettingsSlaPolicyActivatedOrDeactivatedParams>} LogObject<appSettingsSlaPolicyActivatedOrDeactivatedParams>
 */
export function appSettingsSlaPolicyActivatedOrDeactivated(params) {
    return { evid: 4431, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingChannelsEnabled' event (evid: 4432)
 *
 * Event description: The user enabled auto-routing for a specific channel
 *
 * @param {appSettingsAutoRoutingChannelsEnabledParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} channel_name - Channel name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} channel_id - Channel eNum
 * @return {LogObject<appSettingsAutoRoutingChannelsEnabledParams>} LogObject<appSettingsAutoRoutingChannelsEnabledParams>
 */
export function appSettingsAutoRoutingChannelsEnabled(params) {
    return { evid: 4432, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingChannelDisabled' event (evid: 4433)
 *
 * Event description: The user disabled auto-routing for a specific channel
 *
 * @param {appSettingsAutoRoutingChannelDisabledParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {string} channel_name - Channel name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} channel_id - Channel eNum
 * @return {LogObject<appSettingsAutoRoutingChannelDisabledParams>} LogObject<appSettingsAutoRoutingChannelDisabledParams>
 */
export function appSettingsAutoRoutingChannelDisabled(params) {
    return { evid: 4433, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingGroupAdded' event (evid: 4434)
 *
 * Event description: App (Settings) - Auto Routing - Group Added.
 *
 * @param {appSettingsAutoRoutingGroupAddedParams} params - The parameters for this event
 * @property {string} method - Method (Single, Bulk)
 * @property {GUID} group_id - Group ID (Single GUID)
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appSettingsAutoRoutingGroupAddedParams>} LogObject<appSettingsAutoRoutingGroupAddedParams>
 */
export function appSettingsAutoRoutingGroupAdded(params) {
    return { evid: 4434, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsAutoRoutingGroupRemoved' event (evid: 4435)
 *
 * Event description: App (Settings) - Auto Routing - Group Removed.
 *
 * @param {appSettingsAutoRoutingGroupRemovedParams} params - The parameters for this event
 * @property {string} method - method
 * @property {GUID} group_id - group_id
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @return {LogObject<appSettingsAutoRoutingGroupRemovedParams>} LogObject<appSettingsAutoRoutingGroupRemovedParams>
 */
export function appSettingsAutoRoutingGroupRemoved(params) {
    return { evid: 4435, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioCreate' event (evid: 4436)
 *
 * Event description: A Spotter Scenario has been created
 *
 * @param {appSettingsSpotterScenarioCreateParams} params - The parameters for this event
 * @property {number} recipe_type - What type of recipe is it (every recipe is represented by a number)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} display_name - The name of the scenario, will be null for scenarios with custom name
 * @property {GUID} role_id - Role ID of the member creating the Scenario
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member creating the Scenario
 * @property {string} actions_data - Data about the actions triggered by the Scenario
 * @property {string} conditions_data - Data about the conditions of the Scenario
 * @property {string} triggers_data - Data about the Scenario triggers
 * @property {GUID} recipe_id - Spotter Scenario ID
 * @return {LogObject<appSettingsSpotterScenarioCreateParams>} LogObject<appSettingsSpotterScenarioCreateParams>
 */
export function appSettingsSpotterScenarioCreate(params) {
    return { evid: 4436, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioUpdate' event (evid: 4437)
 *
 * Event description: A Spotter Scenario has been updated
 *
 * @param {appSettingsSpotterScenarioUpdateParams} params - The parameters for this event
 * @property {number} recipe_type - What type of recipe is it (every recipe is represented by a number)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} triggers_data_after - Data about the triggers of the Scenario after the change
 * @property {string} triggers_data_before - Data about the triggers of the Scenario before the change
 * @property {string} conditions_data_after - Data about the conditions of the Scenario after the change
 * @property {GUID} role_id - Role ID of the member updating the Scenario
 * @property {string} conditions_data_before - Data about the conditions of the Scenario before the change
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member updating the Scenario
 * @property {string} actions_data_before - Data about the actions of the Scenario before the change
 * @property {string} actions_data - Data about the actions triggered by the Scenario before and after the change
 * @property {string} actions_data_after - Data about the actions of the Scenario after the change
 * @property {string} conditions_data - Data about the conditions of the Scenario before and after the change
 * @property {string} triggers_data - Data of the Scenario triggers before and after the change
 * @property {GUID} recipe_id - Spotter Scenario ID
 * @return {LogObject<appSettingsSpotterScenarioUpdateParams>} LogObject<appSettingsSpotterScenarioUpdateParams>
 */
export function appSettingsSpotterScenarioUpdate(params) {
    return { evid: 4437, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioDelete' event (evid: 4438)
 *
 * Event description: A Spotter Scenario has been deleted
 *
 * @param {appSettingsSpotterScenarioDeleteParams} params - The parameters for this event
 * @property {number} recipe_type - What type of recipe is it (every recipe is represented by a number)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} display_name - The name of the scenario before the update, will be null for scenarios with custom name
 * @property {GUID} role_id - Role ID of the member deleting the Scenario
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member deleting the Scenario
 * @property {GUID} recipe_id - Spotter Scenario ID
 * @return {LogObject<appSettingsSpotterScenarioDeleteParams>} LogObject<appSettingsSpotterScenarioDeleteParams>
 */
export function appSettingsSpotterScenarioDelete(params) {
    return { evid: 4438, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsSpotterScenarioEnabledDisabled' event (evid: 4439)
 *
 * Event description: A Spotter Scenario has been activated or deactivated
 *
 * @param {appSettingsSpotterScenarioEnabledDisabledParams} params - The parameters for this event
 * @property {number} recipe_type - What type of recipe is it (every recipe is represented by a number)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} display_name - The name of the scenario before the update, will be null for scenarios with custom name
 * @property {GUID} role_id - Role ID of the member deleting the Scenario
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member deleting the Scenario
 * @property {boolean} is_enabled - True - if the scenario has been enabled, False if the scenario has been disabled
 * @property {GUID} recipe_id - Spotter Scenario ID
 * @return {LogObject<appSettingsSpotterScenarioEnabledDisabledParams>} LogObject<appSettingsSpotterScenarioEnabledDisabledParams>
 */
export function appSettingsSpotterScenarioEnabledDisabled(params) {
    return { evid: 4439, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsActivateDeactivateLineForCallCenterOrSms' event (evid: 4441)
 *
 * Event description: A line has been activated or deactivated for Incoming or Outgoing traffic  (or both) for Call Center or SMS
 *
 * @param {appSettingsActivateDeactivateLineForCallCenterOrSmsParams} params - The parameters for this event
 * @property {string} line_name - Name of the Line
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The Channel the Line has been activated or deactivated for (Call Center, SMS)
 * @property {boolean} is_sms_capable - True- if capable , False - if not
 * @property {boolean} is_default_sms - True- if default , False - if not
 * @property {boolean} outbound_enabled - True- Outbound enabled , False - Not
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The User ID of the Member activating/deactivating the Line
 * @property {GUID} line_id - ID of the Line
 * @property {boolean} inbound_enabled - True- Inbound enabled , False - Not
 * @property {boolean} is_default_call_center - True- if default , False - if not
 * @return {LogObject<appSettingsActivateDeactivateLineForCallCenterOrSmsParams>} LogObject<appSettingsActivateDeactivateLineForCallCenterOrSmsParams>
 */
export function appSettingsActivateDeactivateLineForCallCenterOrSms(params) {
    return { evid: 4441, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineAdded' event (evid: 4442)
 *
 * Event description: A line has been added to Answers account
 *
 * @param {appSettingsLineAddedParams} params - The parameters for this event
 * @property {string} line_name - Name of the Line
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} is_sms_capable - True- if capable , False - if not
 * @property {string} line_country - The country of the Line (based on dial code)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The User ID of the Member adding the line
 * @property {string} line_description - Description of the Line
 * @property {string} line_number - The number of the line
 * @property {GUID} line_id - ID of the Line
 * @property {boolean} is_default_call_center - True- if default , False - if not
 * @return {LogObject<appSettingsLineAddedParams>} LogObject<appSettingsLineAddedParams>
 */
export function appSettingsLineAdded(params) {
    return { evid: 4442, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineBusinessHoursChange' event (evid: 4443)
 *
 * Event description: A line business hours has been changed
 *
 * @param {appSettingsLineBusinessHoursChangeParams} params - The parameters for this event
 * @property {string} line_name - Name of the Line
 * @property {GUID} tenant_id - Tenant ID
 * @property {boolean} is_sms_capable - True - if capable , False - if not
 * @property {boolean} is_default_sms - True - if default , False - if not
 * @property {GUID} client_id - client_id
 * @property {string} after_business_hours - business hours after the change
 * @property {GUID} user_id - The User ID of the Member implementing the change
 * @property {GUID} line_id - ID of the Line
 * @property {boolean} is_default_call_center - True- if default , False - if not
 * @property {string} before_business_hours - business hours before the change
 * @return {LogObject<appSettingsLineBusinessHoursChangeParams>} LogObject<appSettingsLineBusinessHoursChangeParams>
 */
export function appSettingsLineBusinessHoursChange(params) {
    return { evid: 4443, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineDelete' event (evid: 4444)
 *
 * Event description: A line has been removed (deleted) from Answers account
 *
 * @param {appSettingsLineDeleteParams} params - The parameters for this event
 * @property {string} line_name - Name of the Line
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The User ID of the Member deleting the Line
 * @property {GUID} line_id - ID of the Line
 * @return {LogObject<appSettingsLineDeleteParams>} LogObject<appSettingsLineDeleteParams>
 */
export function appSettingsLineDelete(params) {
    return { evid: 4444, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsLineDowntimesChange' event (evid: 4445)
 *
 * Event description: A line Downtimes hours has been changed
 *
 * @param {appSettingsLineDowntimesChangeParams} params - The parameters for this event
 * @property {string} line_name - line_name
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_sms_capable - is_sms_capable
 * @property {string} before_downtimes - Downtimes before the change
 * @property {boolean} is_default_sms - True - if default , False - if not
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The User ID of the Member implementing the change
 * @property {string} after_downtimes - after_downtimes
 * @property {GUID} line_id - ID of the Line
 * @property {boolean} is_default_call_center - True- if default , False - if not
 * @return {LogObject<appSettingsLineDowntimesChangeParams>} LogObject<appSettingsLineDowntimesChangeParams>
 */
export function appSettingsLineDowntimesChange(params) {
    return { evid: 4445, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleCreated' event (evid: 4446)
 *
 * Event description: New schedule created
 *
 * @param {appSettingsScheduleCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - schedule id
 * @property {string} settings - in json format, name, description, opening hours, timezone
 * @return {LogObject<appSettingsScheduleCreatedParams>} LogObject<appSettingsScheduleCreatedParams>
 */
export function appSettingsScheduleCreated(params) {
    return { evid: 4446, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDeleted' event (evid: 4447)
 *
 * Event description: A schedule was deleted
 *
 * @param {appSettingsScheduleDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - schedule id
 * @return {LogObject<appSettingsScheduleDeletedParams>} LogObject<appSettingsScheduleDeletedParams>
 */
export function appSettingsScheduleDeleted(params) {
    return { evid: 4447, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleUpdated' event (evid: 4448)
 *
 * Event description: A schedule was updated
 *
 * @param {appSettingsScheduleUpdatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - schedule id
 * @property {string} settings - new and old schedule settings in json format, name, description, opening hours, timezone
 * @return {LogObject<appSettingsScheduleUpdatedParams>} LogObject<appSettingsScheduleUpdatedParams>
 */
export function appSettingsScheduleUpdated(params) {
    return { evid: 4448, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeCreated' event (evid: 4449)
 *
 * Event description: Schedule Down Time created
 *
 * @param {appSettingsScheduleDownTimeCreatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - downtime id
 * @property {string} schedule_id - schedule_id
 * @property {string} settings - downtime settings in json format
 * @return {LogObject<appSettingsScheduleDownTimeCreatedParams>} LogObject<appSettingsScheduleDownTimeCreatedParams>
 */
export function appSettingsScheduleDownTimeCreated(params) {
    return { evid: 4449, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeDeleted' event (evid: 4450)
 *
 * Event description: Schedule Down Time deleted
 *
 * @param {appSettingsScheduleDownTimeDeletedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - downtime id
 * @property {string} schedule_id - schedule_id
 * @return {LogObject<appSettingsScheduleDownTimeDeletedParams>} LogObject<appSettingsScheduleDownTimeDeletedParams>
 */
export function appSettingsScheduleDownTimeDeleted(params) {
    return { evid: 4450, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appSettingsScheduleDownTimeUpdated' event (evid: 4451)
 *
 * Event description: Schedule Down Time updated
 *
 * @param {appSettingsScheduleDownTimeUpdatedParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} id - downtime id
 * @property {string} schedule_id - schedule_id
 * @property {string} settings - new and old settings in json format
 * @return {LogObject<appSettingsScheduleDownTimeUpdatedParams>} LogObject<appSettingsScheduleDownTimeUpdatedParams>
 */
export function appSettingsScheduleDownTimeUpdated(params) {
    return { evid: 4451, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'statusPageBannerLoaded' event (evid: 45)
 *
 * Event description: Status Page Banner loaded
 *
 * @param {statusPageBannerLoadedParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - client_id
 * @property {string} incident_name - The title of the incident fetched from the status page
 * @property {GUID} user_id - uuid
 * @property {boolean} resolved - State of the Incident
 * @return {LogObject<statusPageBannerLoadedParams>} LogObject<statusPageBannerLoadedParams>
 */
export function statusPageBannerLoaded(params) {
    return { evid: 45, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallStarted' event (evid: 4500)
 *
 * Event description: Event is fired when a call in Answers has started (both user and agent are connected to the call).
 * The user_id or client_id in this event is the id of the user (not the agent).
 *
 * @param {appCallCenterCallStartedParams} params - The parameters for this event
 * @property {GUID} group_id - Initial group of the call
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} phone_number - User's phone number
 * @property {string} queue - Initial queue of the call (for callback only)
 * @property {GUID} client_id - Answers Client ID (Anonymous)
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language, not always available upon call creation
 * @property {GUID} callid - Call ID
 * @property {string} type - type of the call (outbound, callback, etc.)
 * @return {LogObject<appCallCenterCallStartedParams>} LogObject<appCallCenterCallStartedParams>
 */
export function appCallCenterCallStarted(params) {
    return { evid: 4500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterAgentSStatusWasChanged' event (evid: 4510)
 *
 * Event description: The event is fired whenever an agent's status is changed to another one. The change might be triggered by the user herself or an admin. The UUID always belong to the agent. The data in the event is about the status that just ended.
 *
 * @param {callCenterAgentSStatusWasChangedParams} params - The parameters for this event
 * @property {number} duration - Status duration, in seconds
 * @property {string} status_name - Status name (Busy, Available, etc.)
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {number} status_id - Status eNum
 * @property {string} changed_by - Who changed the status (SessionUser, Admin, Auto, Repair)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<callCenterAgentSStatusWasChangedParams>} LogObject<callCenterAgentSStatusWasChangedParams>
 */
export function callCenterAgentSStatusWasChanged(params) {
    return { evid: 4510, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterCallParticipantJoined' event (evid: 4511)
 *
 * Event description: A participant (user/agent) joined a call.
 * Possible join methods are:
 * 1. Primary - The first agent and/or first user of the call
 * 2. An additional agent or user that was invited
 * 3. An agent who's only listening to the call
 *  If the call was answered, it will have exactly one primary agent and one primary user. All additional participants will have other join methods.
 *  If the call wasn't answered by the recipient, it will only have one primary participant (the participant who initiated the call).
 *
 * @param {appCallCenterCallParticipantJoinedParams} params - The parameters for this event
 * @property {GUID} group_id - The group of the call at the time the participant joined
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {boolean} is_agent - True = Agent, False = User
 * @property {string} topicId - The topic of the call at the time the participant joined
 * @property {GUID} client_id - client_id
 * @property {string} join_method - How did the participant joined the call (Primary, Invitation, Listen)
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} queue_id - The queue of the call at the time the participant joined
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterCallParticipantJoinedParams>} LogObject<appCallCenterCallParticipantJoinedParams>
 */
export function appCallCenterCallParticipantJoined(params) {
    return { evid: 4511, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCallParticipantLeft' event (evid: 4512)
 *
 * Event description: A participant Left a call.
 *
 * A participant may leave a call using one of the following methods:
 * 1. The participant left the call
 * 2. The participant ended the call
 * 3. Other participant ended the call - Agent (the other participant is an agent)
 * 4. Other participant ended the call - User (the other participant is a user) .                                  join_method can be fetched via the 4511 event. In this event it will return as NULL
 *
 * @param {callCenterCallParticipantLeftParams} params - The parameters for this event
 * @property {GUID} group_id - The group of the call at the time the participant joined
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {boolean} is_agent - True = Agent, False = User
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} queue_id - The queue of the call at the time the participant joined
 * @property {GUID} topic_id - The topic of the call at the time the participant joined
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<callCenterCallParticipantLeftParams>} LogObject<callCenterCallParticipantLeftParams>
 */
export function callCenterCallParticipantLeft(params) {
    return { evid: 4512, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsReservedToACallAttempt' event (evid: 4513)
 *
 * Event description: An agent is reserved to a call by the system (the systems assigns the call to the agent)
 *
 * @param {appCallCenterAgentIsReservedToACallAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterAgentIsReservedToACallAttemptParams>} LogObject<appCallCenterAgentIsReservedToACallAttemptParams>
 */
export function appCallCenterAgentIsReservedToACallAttempt(params) {
    return { evid: 4513, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsReservedToACallSuccess' event (evid: 4514)
 *
 * Event description: The agent joined the call after being reserved by the system.
 *
 * @param {appCallCenterAgentIsReservedToACallSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {boolean} agent_is_callback_delay - Is the agent callback delay enabled
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterAgentIsReservedToACallSuccessParams>} LogObject<appCallCenterAgentIsReservedToACallSuccessParams>
 */
export function appCallCenterAgentIsReservedToACallSuccess(params) {
    return { evid: 4514, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsReservedToACallFail' event (evid: 4515)
 *
 * Event description: The agent didn't join the call after being reserved by the system.
 *
 * @param {appCallCenterAgentIsReservedToACallFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {string} reason - Fail reason (“No Answer” \ “Declined”)
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {boolean} agent_is_callback_delay - Is the agent callback delay enabled
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterAgentIsReservedToACallFailParams>} LogObject<appCallCenterAgentIsReservedToACallFailParams>
 */
export function appCallCenterAgentIsReservedToACallFail(params) {
    return { evid: 4515, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterAgentIsInvitedToACallAttempt' event (evid: 4516)
 *
 * Event description: An agent is invited to a call by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {callCenterAgentIsInvitedToACallAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @property {GUID} inviting_agent - The user ID of the agent who sent the invitation, if there is one
 * @return {LogObject<callCenterAgentIsInvitedToACallAttemptParams>} LogObject<callCenterAgentIsInvitedToACallAttemptParams>
 */
export function callCenterAgentIsInvitedToACallAttempt(params) {
    return { evid: 4516, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsInvitedToACallSuccess' event (evid: 4517)
 *
 * Event description: The agent joined the call after being invited by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {appCallCenterAgentIsInvitedToACallSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterAgentIsInvitedToACallSuccessParams>} LogObject<appCallCenterAgentIsInvitedToACallSuccessParams>
 */
export function appCallCenterAgentIsInvitedToACallSuccess(params) {
    return { evid: 4517, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterAgentIsInvitedToACallFail' event (evid: 4518)
 *
 * Event description: The agent didn't join the call after being invited by another agent. The user_id in this event is the id of the invited agent.
 *
 * @param {appCallCenterAgentIsInvitedToACallFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {string} reason - Fail reason (“No Answer” \ “Declined”)
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<appCallCenterAgentIsInvitedToACallFailParams>} LogObject<appCallCenterAgentIsInvitedToACallFailParams>
 */
export function appCallCenterAgentIsInvitedToACallFail(params) {
    return { evid: 4518, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterAgentPutTheUserOnHold' event (evid: 4519)
 *
 * Event description: An agent put the user on hold during the call. The user_id (uuid) in this event is the id of the agent.
 *
 * @param {callCenterAgentPutTheUserOnHoldParams} params - The parameters for this event
 * @property {GUID} group_id - The group of the call at the time the user was put on hold
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {string} reason - When WARM transferring the reason is “IN_PROGRESS” When COLD transferring the reason is “TRANSFERRED_TO_QUEUE” Using API - “BY_AGENT”
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} queue_id - The queue of the call at the time the user was put on hold
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<callCenterAgentPutTheUserOnHoldParams>} LogObject<callCenterAgentPutTheUserOnHoldParams>
 */
export function callCenterAgentPutTheUserOnHold(params) {
    return { evid: 4519, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterAgentPutTheUserOffHold' event (evid: 4520)
 *
 * Event description: An agent put the user off hold, back to the call. The user_id (uuid) in this event is the id of the agent.
 *
 * @param {callCenterAgentPutTheUserOffHoldParams} params - The parameters for this event
 * @property {number} duration - In seconds. The time duration the user was on hold
 * @property {GUID} group_id - The group of the call at the time the user was put off hold
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {string} reason - User was on hold and left the call “IN_PROGRESS” Using API - “BY_AGENT”
 * @property {GUID} user_id - Answers User ID, when user is hanging up the id will be of the user and not of the agent
 * @property {GUID} queue_id - The queue of the call at the time the user was put off hold
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @return {LogObject<callCenterAgentPutTheUserOffHoldParams>} LogObject<callCenterAgentPutTheUserOffHoldParams>
 */
export function callCenterAgentPutTheUserOffHold(params) {
    return { evid: 4520, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterCallParticipantAdditionRequest' event (evid: 4521)
 *
 * Event description: Answers is asking Twilio to add a participant to the conference. The request is being sent with a time limit for that participant, based on the remaining credit in the account
 *
 * @param {callCenterCallParticipantAdditionRequestParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} callid - Call ID
 * @property {string} type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @property {number} duration_limit - In seconds, the time limit for the participant based on the remaining credit in the account
 * @return {LogObject<callCenterCallParticipantAdditionRequestParams>} LogObject<callCenterCallParticipantAdditionRequestParams>
 */
export function callCenterCallParticipantAdditionRequest(params) {
    return { evid: 4521, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterAddingAgentFromAnotherQueueTransfer' event (evid: 4522)
 *
 * Event description: this event will be triggered when an agent is in a call and need to transfer the call to another agent from another queue.
 *
 * @param {callCenterAddingAgentFromAnotherQueueTransferParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} group_id - The group of the call at the time the transfer occurs
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {GUID} invited_userid - Answer User ID of the agent who joining the call (Null in case of Hard transfer)
 * @property {GUID} transferred_queue_id - The queue which the agent decided to transfer the call to
 * @property {string} call_type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @property {GUID} transferred_group_id - The group which the agent decided to transfer the call to
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the agent who made the transfer call
 * @property {GUID} queue_id - The queue of the call at the time the transfer occurs
 * @property {GUID} topic_id - The topic of the call at the time the transfer occurs
 * @property {number} transfer_type - 1 for hard, 2 for soft
 * @property {number} processing_time - how much time agent spent on a call before the transfer, in sec
 * @property {GUID} callid - Call ID
 * @return {LogObject<callCenterAddingAgentFromAnotherQueueTransferParams>} LogObject<callCenterAddingAgentFromAnotherQueueTransferParams>
 */
export function callCenterAddingAgentFromAnotherQueueTransfer(params) {
    return { evid: 4522, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallAttempt' event (evid: 4523)
 *
 * Event description: Every call in CC is comprised of two calls, from Twilio to the agent and from Twilio to the user. This is when Twilio attempts to call the user/agent.
 *
 * @param {appCallCenterTwilioCallAttemptParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - Twilio Reservation ID
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {boolean} is_agent - True = Agent, False = User
 * @property {string} phone_country_code - Country code from the user's phone number
 * @property {string} twilio_call_sid - Twilio Call ID
 * @property {string} call_type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @property {string} agent_location_id - Agent Location ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - Call ID
 * @return {LogObject<appCallCenterTwilioCallAttemptParams>} LogObject<appCallCenterTwilioCallAttemptParams>
 */
export function appCallCenterTwilioCallAttempt(params) {
    return { evid: 4523, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallWasAnswered' event (evid: 4524)
 *
 * Event description: Every call in CC is comprised of two calls, from Twilio to the agent and from Twilio to the user. This event is for when Twilio call was answered by user/agent.
 *
 * @param {appCallCenterTwilioCallWasAnsweredParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - Twilio Reservation ID
 * @property {GUID} tenant_id - Tenant of the performing user
 * @property {boolean} is_agent - True = Agent, False = User
 * @property {string} phone_country_code - Country code from the user's phone number
 * @property {string} twilio_call_sid - Twilio Call ID
 * @property {string} call_type - Type of the call (Inbound, Outbound, Callback, etc.)
 * @property {string} agent_location_id - Agent Location ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - Call ID
 * @return {LogObject<appCallCenterTwilioCallWasAnsweredParams>} LogObject<appCallCenterTwilioCallWasAnsweredParams>
 */
export function appCallCenterTwilioCallWasAnswered(params) {
    return { evid: 4524, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appCallCenterTwilioCallResolution' event (evid: 4525)
 *
 * Event description: App (Call Center) - Twilio Call Resolution.
 *
 * @param {appCallCenterTwilioCallResolutionParams} params - The parameters for this event
 * @property {string} twilio_reservation_id - twilio_reservation_id
 * @property {GUID} tenant_id - tenant_id
 * @property {boolean} is_agent - is_agent
 * @property {string} phone_country_code - phone_country_code
 * @property {string} twilio_call_sid - twilio_call_sid
 * @property {string} call_type - call_type
 * @property {string} agent_location_id - agent_location_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} twilio_call_status - twilio_call_status
 * @property {number} call_duration - call_duration
 * @property {number} callcenter_agent_status - agents status
 * @property {number} twilio_callcenter_agent_status - agents status
 * @property {GUID} auto_routing_assignment_id - auto_routing_assignment_id
 * @property {GUID} callid - callid
 * @return {LogObject<appCallCenterTwilioCallResolutionParams>} LogObject<appCallCenterTwilioCallResolutionParams>
 */
export function appCallCenterTwilioCallResolution(params) {
    return { evid: 4525, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'statusPageReportedAProblem' event (evid: 46)
 *
 * Event description: User clicked on “I have a problem” button on the External Wix Status Page
 *
 * @param {statusPageReportedAProblemParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} description - description
 * @property {GUID} client_id - client_id
 * @property {string} service - Edit or Publish a site, Access site, Other
 * @property {GUID} user_id - uuid
 * @return {LogObject<statusPageReportedAProblemParams>} LogObject<statusPageReportedAProblemParams>
 */
export function statusPageReportedAProblem(params) {
    return { evid: 46, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appChatChatRestarted' event (evid: 4600)
 *
 * Event description: A closed chat was restarted by the user
 *
 * @param {appChatChatRestartedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Answers Account ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the ticket's user
 * @return {LogObject<appChatChatRestartedParams>} LogObject<appChatChatRestartedParams>
 */
export function appChatChatRestarted(params) {
    return { evid: 4600, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appChatsAgentMessageAttempt' event (evid: 4601)
 *
 * Event description: Answers (Member or System) attempted to send a Chat message to Widget, SMS or Whatsapp
 *
 * @param {appChatsAgentMessageAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} chat_id - Chat ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel of the message (Widget, Whatsapp, Facebook etc.)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member sending the message (If user_id = tenant_id and operator_id is null it means it is an auto-reply sent by the system when user message received outside of Business Hours )
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Message ID
 * @return {LogObject<appChatsAgentMessageAttemptParams>} LogObject<appChatsAgentMessageAttemptParams>
 */
export function appChatsAgentMessageAttempt(params) {
    return { evid: 4601, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appChatsAgentMessageSuccess' event (evid: 4602)
 *
 * Event description: Answers Member or System user successfully sent a chat message to Widget / SMS number or Whatsapp
 *
 * @param {appChatsAgentMessageSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} chat_id - Ticket ID of the message
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel (Widget, Whatsapp, SMS)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member sending the message (If user_id = tenant_id and operator_id is null it means it is an auto-reply sent by the system when user message received outside of Business Hours )
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Message ID
 * @return {LogObject<appChatsAgentMessageSuccessParams>} LogObject<appChatsAgentMessageSuccessParams>
 */
export function appChatsAgentMessageSuccess(params) {
    return { evid: 4602, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appChatsAgentMessageFailed' event (evid: 4603)
 *
 * Event description: Answers Member or System failed to send a chat message to Widget / SMS or Whatsapp
 *
 * @param {appChatsAgentMessageFailedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} chat_id - Chat ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel of the message (Widget, Whatsapp, Facebook, SMS etc.)
 * @property {GUID} client_id - client_id
 * @property {string} reason - Fail reason
 * @property {GUID} user_id - Answers User ID of the member sending the message (If user_id = tenant_id and operator_id is null it means it is an auto-reply sent by the system when user message received outside of Business Hours )
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Reply ID
 * @property {GUID} operator_id - NOT LIVE YET - If Spotter - recipe ID
 * @return {LogObject<appChatsAgentMessageFailedParams>} LogObject<appChatsAgentMessageFailedParams>
 */
export function appChatsAgentMessageFailed(params) {
    return { evid: 4603, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestAttempt' event (evid: 4800)
 *
 * Event description: User requested to move from the package picker to the purchase page
 *
 * @param {appPremiumPackagePickerCheckoutRequestAttemptParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestAttemptParams>} LogObject<appPremiumPackagePickerCheckoutRequestAttemptParams>
 */
export function appPremiumPackagePickerCheckoutRequestAttempt(params) {
    return { evid: 4800, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestSuccess' event (evid: 4801)
 *
 * Event description: The user is redirected from the package picker to the purchase page
 *
 * @param {appPremiumPackagePickerCheckoutRequestSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestSuccessParams>} LogObject<appPremiumPackagePickerCheckoutRequestSuccessParams>
 */
export function appPremiumPackagePickerCheckoutRequestSuccess(params) {
    return { evid: 4801, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerCheckoutRequestFail' event (evid: 4802)
 *
 * Event description: User request to move from the package picker to the purchase page was rejected
 *
 * @param {appPremiumPackagePickerCheckoutRequestFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumPackagePickerCheckoutRequestFailParams>} LogObject<appPremiumPackagePickerCheckoutRequestFailParams>
 */
export function appPremiumPackagePickerCheckoutRequestFail(params) {
    return { evid: 4802, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPremiumProductCreation' event (evid: 4803)
 *
 * Event description: A premium product was delivered to a tenant (was added to the tenant_products table) after payment accepted in SBS. UUID in this event is the ID of the user who ordered the product.
 *
 * @param {appPremiumPremiumProductCreationParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumPremiumProductCreationParams>} LogObject<appPremiumPremiumProductCreationParams>
 */
export function appPremiumPremiumProductCreation(params) {
    return { evid: 4803, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPremiumProductCancellation' event (evid: 4804)
 *
 * Event description: A premium product was cancelled. UUID in this event is the tenant ID.
 *
 * @param {appPremiumPremiumProductCancellationParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Cancellation reason
 * @property {GUID} user_id - Answers Tenant ID
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumPremiumProductCancellationParams>} LogObject<appPremiumPremiumProductCancellationParams>
 */
export function appPremiumPremiumProductCancellation(params) {
    return { evid: 4804, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductSubscriptionRenewalSuccess' event (evid: 4805)
 *
 * Event description: A premium product's subscription was renewed. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductSubscriptionRenewalSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers Tenant ID
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @property {DateTime} expiry_date - New expiry date product
 * @return {LogObject<appPremiumProductSubscriptionRenewalSuccessParams>} LogObject<appPremiumProductSubscriptionRenewalSuccessParams>
 */
export function appPremiumProductSubscriptionRenewalSuccess(params) {
    return { evid: 4805, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductSubscriptionRenewalFail' event (evid: 4806)
 *
 * Event description: SBS wasn't able to renew the subscription of a premium product. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductSubscriptionRenewalFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers Tenant ID
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumProductSubscriptionRenewalFailParams>} LogObject<appPremiumProductSubscriptionRenewalFailParams>
 */
export function appPremiumProductSubscriptionRenewalFail(params) {
    return { evid: 4806, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductAutoRenewOn' event (evid: 4807)
 *
 * Event description: Tenant's auto-renewal status was toggled on. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductAutoRenewOnParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers Tenant ID
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumProductAutoRenewOnParams>} LogObject<appPremiumProductAutoRenewOnParams>
 */
export function appPremiumProductAutoRenewOn(params) {
    return { evid: 4807, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumProductAutoRenewOff' event (evid: 4808)
 *
 * Event description: Tenant's auto-renewal status was toggled off. UUID in this event is the tenant ID.
 *
 * @param {appPremiumProductAutoRenewOffParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers Tenant ID
 * @property {string} team_size - Max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumProductAutoRenewOffParams>} LogObject<appPremiumProductAutoRenewOffParams>
 */
export function appPremiumProductAutoRenewOff(params) {
    return { evid: 4808, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumOverrideTeamSize' event (evid: 4809)
 *
 * Event description: Answers team overridden the team size of a premium product. UUID in this event is the Answers User ID of the person (from Answers team) who made the override
 *
 * @param {appPremiumOverrideTeamSizeParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} override_team_size - New max team size
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID - Belong to the user who made the override
 * @property {string} team_size - Old max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @return {LogObject<appPremiumOverrideTeamSizeParams>} LogObject<appPremiumOverrideTeamSizeParams>
 */
export function appPremiumOverrideTeamSize(params) {
    return { evid: 4809, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumOverrideProductExpiryDate' event (evid: 4810)
 *
 * Event description: Answers team overridden the expiry date of a premium product. UUID in this event is the Answers User ID of the person (from Answers team) who made the override
 *
 * @param {appPremiumOverrideProductExpiryDateParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} feature - KB, Ticketing (HD), Call center
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID - Belong to the user who made the override
 * @property {string} team_size - Old max team size
 * @property {GUID} subscription_id - ID of the specific product of the specific tenant
 * @property {DateTime} expiry_date - New expiry date
 * @return {LogObject<appPremiumOverrideProductExpiryDateParams>} LogObject<appPremiumOverrideProductExpiryDateParams>
 */
export function appPremiumOverrideProductExpiryDate(params) {
    return { evid: 4810, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseAttemptSrc77Evid4811' event (evid: 4811)
 *
 * Event description: User requests to purchase a premium
 *
 * @param {appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params} params - The parameters for this event
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params>} LogObject<appPremiumPackagePickerPurchaseAttemptSrc77Evid4811Params>
 */
export function appPremiumPackagePickerPurchaseAttemptSrc77Evid4811(params) {
    return { evid: 4811, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseSuccessSrc77Evid4812' event (evid: 4812)
 *
 * Event description: User request to purchase a premium is accepted
 *
 * @param {appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params} params - The parameters for this event
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {string} package_id - ID of package - Unlimited (1,2,3,4) / Multi-Channel (1,2,4) / Self-Service (1) / Call Center (2,3,4)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {number} team_size - Max num of agents in package (1 / 5 / 10 / 20 / 30 / 40 / 50 / 50+ (-1))
 * @property {string} subscription_id - ID of the premium subscription
 * @property {string} payment_cycle - Subscription cycle (monthly / yearly / two_years)
 * @return {LogObject<appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params>} LogObject<appPremiumPackagePickerPurchaseSuccessSrc77Evid4812Params>
 */
export function appPremiumPackagePickerPurchaseSuccessSrc77Evid4812(params) {
    return { evid: 4812, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumPackagePickerPurchaseFailSrc77Evid4813' event (evid: 4813)
 *
 * Event description: User request to purchase a premium is rejected
 *
 * @param {appPremiumPackagePickerPurchaseFailSrc77Evid4813Params} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appPremiumPackagePickerPurchaseFailSrc77Evid4813Params>} LogObject<appPremiumPackagePickerPurchaseFailSrc77Evid4813Params>
 */
export function appPremiumPackagePickerPurchaseFailSrc77Evid4813(params) {
    return { evid: 4813, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseAttempt' event (evid: 4814)
 *
 * Event description: User requests to purchase CC credits
 *
 * @param {appPremiumCcCreditsPurchaseAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appPremiumCcCreditsPurchaseAttemptParams>} LogObject<appPremiumCcCreditsPurchaseAttemptParams>
 */
export function appPremiumCcCreditsPurchaseAttempt(params) {
    return { evid: 4814, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseSuccess' event (evid: 4815)
 *
 * Event description: User request to purchase CC credits is accepted
 *
 * @param {appPremiumCcCreditsPurchaseSuccessParams} params - The parameters for this event
 * @property {number} new_balance - New accumulated CCC balance
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} subscription_id - ID of the premium subscription
 * @property {number} current_balance - Current accumulated CCC balance
 * @return {LogObject<appPremiumCcCreditsPurchaseSuccessParams>} LogObject<appPremiumCcCreditsPurchaseSuccessParams>
 */
export function appPremiumCcCreditsPurchaseSuccess(params) {
    return { evid: 4815, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsPurchaseFail' event (evid: 4816)
 *
 * Event description: User request to purchase CC credits is rejected
 *
 * @param {appPremiumCcCreditsPurchaseFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers User ID
 * @return {LogObject<appPremiumCcCreditsPurchaseFailParams>} LogObject<appPremiumCcCreditsPurchaseFailParams>
 */
export function appPremiumCcCreditsPurchaseFail(params) {
    return { evid: 4816, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestAttempt' event (evid: 4830)
 *
 * Event description: User requested to move from the call center credits package picker to the purchase page
 *
 * @param {appPremiumCcCreditsCheckoutRequestAttemptParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestAttemptParams>} LogObject<appPremiumCcCreditsCheckoutRequestAttemptParams>
 */
export function appPremiumCcCreditsCheckoutRequestAttempt(params) {
    return { evid: 4830, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestSuccess' event (evid: 4831)
 *
 * Event description: The user is redirected from the call center credits package picker to the purchase page
 *
 * @param {appPremiumCcCreditsCheckoutRequestSuccessParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestSuccessParams>} LogObject<appPremiumCcCreditsCheckoutRequestSuccessParams>
 */
export function appPremiumCcCreditsCheckoutRequestSuccess(params) {
    return { evid: 4831, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCcCreditsCheckoutRequestFail' event (evid: 4832)
 *
 * Event description: User request to move from the call center credits package picker to the purchase page was rejected
 *
 * @param {appPremiumCcCreditsCheckoutRequestFailParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} client_id - client_id
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @return {LogObject<appPremiumCcCreditsCheckoutRequestFailParams>} LogObject<appPremiumCcCreditsCheckoutRequestFailParams>
 */
export function appPremiumCcCreditsCheckoutRequestFail(params) {
    return { evid: 4832, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPremiumCallCenterCreditsAddition' event (evid: 4833)
 *
 * Event description: Call center credits were added to a tenant's balance (was added to the accumulated_balance field in the call_center_balance table) after payment accepted in SBS. UUID in this event is the ID of the user who ordered the product.
 *
 * @param {appPremiumCallCenterCreditsAdditionParams} params - The parameters for this event
 * @property {GUID} purchase_id - ID of the purchase (PP submission)
 * @property {string} new_balance - New accumulated CCC balance
 * @property {GUID} tenant_id - Answers Tenant ID
 * @property {GUID} product_guid - Premium product ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the user who ordered the product
 * @property {string} current_balance - Current accumulated CCC balance
 * @return {LogObject<appPremiumCallCenterCreditsAdditionParams>} LogObject<appPremiumCallCenterCreditsAdditionParams>
 */
export function appPremiumCallCenterCreditsAddition(params) {
    return { evid: 4833, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralAgentClickOnUnPermittedActionInAnswersApp' event (evid: 4900)
 *
 * Event description: An Answers member has been blocked from doing an un-permitted action. (based on this member roles and permissions)
 *
 * @param {appGeneralAgentClickOnUnPermittedActionInAnswersAppParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {number} required_permission_id - The permission ID that is required to not being blocked while doing this action
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID
 * @property {string} required_permission_name - The permission name that is required to not being blocked while doing this action
 * @return {LogObject<appGeneralAgentClickOnUnPermittedActionInAnswersAppParams>} LogObject<appGeneralAgentClickOnUnPermittedActionInAnswersAppParams>
 */
export function appGeneralAgentClickOnUnPermittedActionInAnswersApp(params) {
    return { evid: 4900, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralInAppNotificationsClientEngagement' event (evid: 4902)
 *
 * Event description: A generic event for the following clicks/engagements related to In-app notifications: (1) click on main notifications button to open the notification list, (2) click on notification (3) create announcement click,  (4) Send announcement click
 *
 * @param {appGeneralInAppNotificationsClientEngagementParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} engagement - What kind of engagement happened. Examples: (1) main notification button click (2) notification click (3) create announcement click (4) send announcement click
 * @property {string} data - Json of Data related to the engagement. Examples: (1) If the engagement is "notification click" data will include notification_id, notification_type, notification_content etc (2) If the engagement is "send announcement click" data will include announcement title, content, type, recipients etc
 * @property {GUID} role_id - Role ID of the engaging member
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - User ID of the engaging member
 * @property {string} lang - Answers language according to the Account settings
 * @return {LogObject<appGeneralInAppNotificationsClientEngagementParams>} LogObject<appGeneralInAppNotificationsClientEngagementParams>
 */
export function appGeneralInAppNotificationsClientEngagement(params) {
    return { evid: 4902, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralBulkTicketsCreationSuccess' event (evid: 4904)
 *
 * Event description: Answers Member successfully created tickets in Bulk through one of the channels (currently it is possible through Email, SMS or Chat)
 *
 * @param {appGeneralBulkTicketsCreationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel (Email, SMS, Chat)
 * @property {GUID} bulk_id - Id of the Bulk Action
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the member creating the tickets
 * @property {string} locale - Answers Language
 * @property {number} messages_count - The number of Tickets created in bulk
 * @property {string} tickets_and_users_ids - Json matching Ticket ID, Item ID and recipient user ID for each message/reply sent in bulk (For Example: {{"ticket_id":1213,"user_id":434244},{"ticket_id":1214,"user_id":444332},{"ticket_id":1213,"user_id":443424}}
 * @return {LogObject<appGeneralBulkTicketsCreationSuccessParams>} LogObject<appGeneralBulkTicketsCreationSuccessParams>
 */
export function appGeneralBulkTicketsCreationSuccess(params) {
    return { evid: 4904, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agentDeclinesCallSrc77Evid4906' event (evid: 4906)
 *
 * Event description: Triggers when an agent delines a call, returns Call Id and Tenant ID,
 * Agent ID as implicit UUID field.
 *
 * @param {agentDeclinesCallSrc77Evid4906Params} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} callid - Call ID of the declined call
 * @return {LogObject<agentDeclinesCallSrc77Evid4906Params>} LogObject<agentDeclinesCallSrc77Evid4906Params>
 */
export function agentDeclinesCallSrc77Evid4906(params) {
    return { evid: 4906, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackWidgetTicketCreation' event (evid: 4907)
 *
 * Event description: Triggers whenever a new ticket is created via the callback request widget
 *
 * @param {callbackWidgetTicketCreationParams} params - The parameters for this event
 * @property {GUID} ticket_id - The id of the ticket that was created using the widget
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The Wix uuid of the user the callback is created for
 * @property {GUID} queue_id - The guid of the queue in which the callback is created
 * @property {GUID} topic_id - The guid of the topic in which the callback is created
 * @property {GUID} assigned_group_id - The guid of the group the created ticket is assigned to at ticket creation
 * @property {GUID} source_ticket_id - The ticket guid from which the callback request is created, can be null
 * @property {GUID} line_id - The line ID we call the user from
 * @property {GUID} agent_id - The Answers UUID of the agent who created a ticket using the widget
 * @return {LogObject<callbackWidgetTicketCreationParams>} LogObject<callbackWidgetTicketCreationParams>
 */
export function callbackWidgetTicketCreation(params) {
    return { evid: 4907, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersBannerView' event (evid: 4908)
 *
 * Event description: Fired when the user enters a page that has a banner
 *
 * @param {answersBannerViewParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} banner_text - banner text
 * @property {GUID} tenant_id - Answers tenant ID
 * @property {string} banner_name - banner_name
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} lang - Answers language
 * @property {string} banner_language - banner_language
 * @return {LogObject<answersBannerViewParams>} LogObject<answersBannerViewParams>
 */
export function answersBannerView(params) {
    return { evid: 4908, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersBannerClick' event (evid: 4909)
 *
 * Event description: Fired when a user clicks a banner in Answers
 *
 * @param {answersBannerClickParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} clicked_text - The text that was clicked on
 * @property {string} banner_text - banner text
 * @property {GUID} tenant_id - tenant_id
 * @property {string} banner_name - banner name
 * @property {GUID} client_id - client_id
 * @property {string} clicked_item_type - what was clicked on (link/close etc.)
 * @property {GUID} user_id - uuid
 * @property {string} lang - Answers language
 * @property {string} banner_language - banner language
 * @property {string} clicked_url - Destination url the link takes the user to
 * @return {LogObject<answersBannerClickParams>} LogObject<answersBannerClickParams>
 */
export function answersBannerClick(params) {
    return { evid: 4909, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appGeneralPriorityScoringSetInitialScore' event (evid: 4910)
 *
 * Event description: Priority scoring - change score of interaction
 *
 * @param {appGeneralPriorityScoringSetInitialScoreParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {number} item_type_id - 10, 20, 30 etc.
 * @property {GUID} item_id - item_id of the interaction
 * @property {GUID} tenant_id - Tenant ID
 * @property {number} action_type_id - 1,2,3
 * @property {number} score - The current score
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID of the one that scored the interaction, can be system user
 * @property {string} item_type - item type value - TICKETING, CALL_CENTER, CHAT, FACEBOOK, WHATSAPP, SMS, KNOWLEDGEBASE, TWITTER
 * @property {number} previous_score - The previous score
 * @property {string} action_type - set, increase, decrease
 * @property {GUID} recipe_id - recipe id that is triggering this action
 * @return {LogObject<appGeneralPriorityScoringSetInitialScoreParams>} LogObject<appGeneralPriorityScoringSetInitialScoreParams>
 */
export function appGeneralPriorityScoringSetInitialScore(params) {
    return { evid: 4910, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEscalateToVistaButton' event (evid: 4914)
 *
 * Event description: Button appears to experts only for Vista Users threads. The experts clicks on this button if he wants to request a callback from Vista CC to the user.
 *
 * @param {clickOnEscalateToVistaButtonParams} params - The parameters for this event
 * @property {GUID} ticket_id - The vista ticket
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} description - The issue description of the user
 * @property {boolean} is_action_successful - Did the action of the expert was approved
 * @property {GUID} uuid - uuid
 * @property {string} country - the vista user country
 * @property {GUID} client_id - the vista user
 * @property {GUID} user_id - uuid
 * @property {string} language - the vista user language
 * @property {GUID} agent_id - The expert that clicked on the button
 * @return {LogObject<clickOnEscalateToVistaButtonParams>} LogObject<clickOnEscalateToVistaButtonParams>
 */
export function clickOnEscalateToVistaButton(params) {
    return { evid: 4914, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'securityCheckUsagePerRoleInAnswers' event (evid: 4915)
 *
 * Event description: Event to check the usage per role in Answers.
 *
 * @param {securityCheckUsagePerRoleInAnswersParams} params - The parameters for this event
 * @property {GUID} tenant_id - The tenant ID
 * @property {GUID} user_role_id - User role ID
 * @property {number} endpoint_required_permission - The he enum value of the permission needed to access this endpoint
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The user UUID
 * @property {string} endpoint - The endpoint URL
 * @return {LogObject<securityCheckUsagePerRoleInAnswersParams>} LogObject<securityCheckUsagePerRoleInAnswersParams>
 */
export function securityCheckUsagePerRoleInAnswers(params) {
    return { evid: 4915, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callTheAiSummary' event (evid: 4916)
 *
 * Event description: The event that marks when the summary was requested to be generated when Call the Ai summary
 *
 * @param {callTheAiSummaryParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket ID
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<callTheAiSummaryParams>} LogObject<callTheAiSummaryParams>
 */
export function callTheAiSummary(params) {
    return { evid: 4916, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiSummaryAppearsInTheInternalNote' event (evid: 4917)
 *
 * Event description: It tracks the time between asking the AI for a summary and when it appears in the user's inbox.
 *
 * @param {aiSummaryAppearsInTheInternalNoteParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket ID
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {DateTime} request_time - The moment that the expert request from the AI the summary
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<aiSummaryAppearsInTheInternalNoteParams>} LogObject<aiSummaryAppearsInTheInternalNoteParams>
 */
export function aiSummaryAppearsInTheInternalNote(params) {
    return { evid: 4917, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiSummaryErrors' event (evid: 4918)
 *
 * Event description: There are a few possible reasons why the AI summary fails such as: API failed , Realtime Event Not Received, Saved Reply Not Found
 *
 * @param {aiSummaryErrorsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - who is the expert that opened the Ai assistant
 * @property {string} error_type - API failed , Realtime Event Not Received, Saved Reply Not Found
 * @property {boolean} is_error - if TRUE there is an error
 * @property {GUID} agent_id - who is the expert that opened the Ai assistant
 * @return {LogObject<aiSummaryErrorsParams>} LogObject<aiSummaryErrorsParams>
 */
export function aiSummaryErrors(params) {
    return { evid: 4918, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wrapUpSessionEndedAutomatically' event (evid: 4921)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, and this event will be sanded.
 *
 * @param {wrapUpSessionEndedAutomaticallyParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<wrapUpSessionEndedAutomaticallyParams>} LogObject<wrapUpSessionEndedAutomaticallyParams>
 */
export function wrapUpSessionEndedAutomatically(params) {
    return { evid: 4921, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wrapUpIsTheExpertBackToTheTicket' event (evid: 4922)
 *
 * Event description: In the end of the wrap up by the timer, the session will be ended automatically, if the expert open back the same ticket this event will be sanded
 *
 * @param {wrapUpIsTheExpertBackToTheTicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<wrapUpIsTheExpertBackToTheTicketParams>} LogObject<wrapUpIsTheExpertBackToTheTicketParams>
 */
export function wrapUpIsTheExpertBackToTheTicket(params) {
    return { evid: 4922, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersSidePanelClickEvent' event (evid: 4923)
 *
 * Event description: triggers when a user (expert) clicks a tab or one of the elements within the tabs in the side bar
 *
 * @param {answersSidePanelClickEventParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} widget_id - in case of a widget, the id of the widget the user interacts with
 * @property {string} toolkit_element_mode - state of the toolkit- for example: regular/condensed mode for the header
 * @property {number} sub_element_order - order of the sub element clicked on
 * @property {string} tab_name - name of the tab clicked on/the user is on when clicking an element
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {string} sub_element - name of the sub element clicked on
 * @property {string} toolkit_element - the section in the toolkit the user is engaging with (header, tab, navbar)
 * @property {GUID} client_id - client_id
 * @property {string} element - name of the element clicked on
 * @property {number} element_order - order of the element clicked on
 * @property {string} version_name - to differentiate from which side panel the events are fired- old one or new (toolkit)
 * @property {string} sub_element_thread_id - id of the thread interacted with from the 'recent tickets' part
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @property {string} product - tab section the user is on when performing the action
 * @property {GUID} sbs_id - the id from the sbs system
 * @property {boolean} is_within_policy_refund - within or out of policy refund
 * @property {number} specific_plan_order - the order of the plan in the list of plans
 * @property {string} view_details - details for viewing plan section:
 * sbs_id | is_within_policy_refund | specific_plan_order)
 * @property {number} plan_count - how many plans there are in the plan section (for viewing this section)
 * @property {string} tab_section - name of the section in the tab the click happned on
 * @property {string} value - The value that as chosen/ written.
 * @property {string} uuid - id of the user the ticket is assigned to
 * @return {LogObject<answersSidePanelClickEventParams>} LogObject<answersSidePanelClickEventParams>
 */
export function answersSidePanelClickEvent(params) {
    return { evid: 4923, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersSidePanelViewEvent' event (evid: 4924)
 *
 * Event description: Fires when a side bar tab is opened.
 *
 * @param {answersSidePanelViewEventParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} tab_name - name of the tab clicked on/the user is on when clicking an element
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} previous_tab - the tab the user was on before arriving to the current tab
 * @property {string} open_method - how the user got to the tab- manual/auto
 * @property {GUID} agent_id - The expert handling the ticket.
 * @return {LogObject<answersSidePanelViewEventParams>} LogObject<answersSidePanelViewEventParams>
 */
export function answersSidePanelViewEvent(params) {
    return { evid: 4924, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'channelAvailabilityTransfers' event (evid: 4925)
 *
 * Event description: before offering the expert to make the transfer and the relevant transfer type,  the API checks if there are experts not offline, and the queue in business hours
 *
 * @param {channelAvailabilityTransfersParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} group_id - group of the ticket
 * @property {string} channel - channel of the ticket
 * @property {string} transferred_topic_id - the topic id that the ticket is transferred to
 * @property {GUID} transferred_group_id - the group id that the ticket is transferred to
 * @property {GUID} client_id - client_id
 * @property {string} reason - why the channel is not available
 * @property {GUID} user_id - user
 * @property {string} currentCallId - from call id of the ticket
 * @property {GUID} topic_id - topic of the ticket
 * @property {string} request_id - request_id of the API
 * @property {boolean} channel_availability - is the channel available or not
 * @property {string} lastInteractionId - Interaction id of the chat
 * @return {LogObject<channelAvailabilityTransfersParams>} LogObject<channelAvailabilityTransfersParams>
 */
export function channelAvailabilityTransfers(params) {
    return { evid: 4925, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersCallsEvent' event (evid: 4926)
 *
 * Event description: Fires when elements are presented/clicked in the UI during a call in Answers
 *
 * @param {answersCallsEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} element_name - name of the element presented/interacted with
 * @property {string} elementText - Additional details about the element presented/interacted with
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} interacted_element - specifying the exact element (e.g. button, CTA name, etc) the user interacted with
 * @property {string} value - additional detailed for the interaction
 * @property {string} action_type - type of action taken by the user- click, type, etc.
 * @property {GUID} agent_id - The user triggering the event
 * @return {LogObject<answersCallsEventParams>} LogObject<answersCallsEventParams>
 */
export function answersCallsEvent(params) {
    return { evid: 4926, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersPageEngegement' event (evid: 4927)
 *
 * Event description: Fired every 10 seconds and indicates if within that timeframe the user performed one of the following actions: scroll, mouse move, click.
 *
 * @param {answersPageEngegementParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} reply_area - reply area the expert was engaged with (engaged=wrote): pubic/internal/both
 * @property {string} replay_area - replay area the expert was engaged with (engaged=wrote): pubic/internal/both
 * @property {string} tab_name - last tab that was opened in the ping time frame
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {GUID} client_id - client_id
 * @property {number} screen_width - width of the screen used by the user
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} page_name - last answers page user was on in the ping time frame
 * @property {number} window_width - width of the window (tab) used by the user to view Answers
 * @property {string} action_type - indicates the type of activity done by the user on the page
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersPageEngegementParams>} LogObject<answersPageEngegementParams>
 */
export function answersPageEngegement(params) {
    return { evid: 4927, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersCallFlowUiEvents' event (evid: 4928)
 *
 * Event description: triggers when a user interacts with call elements in Answers
 *
 * @param {answersCallFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {number} call_process_time - seconds counter of the call at event time
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} ticket_user_id - the user id the thread is assigned to (wix id)
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} element - name of the element clicked on/viewed
 * @property {string} instance_id - id of the interaction the expert is currently on for the call
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersCallFlowUiEventsParams>} LogObject<answersCallFlowUiEventsParams>
 */
export function answersCallFlowUiEvents(params) {
    return { evid: 4928, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersChatFlowUiEvents' event (evid: 4929)
 *
 * Event description: triggers when a user interacts with Chat elements in Answers
 *
 * @param {answersChatFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {string} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} element - name of the element clicked on/viewed
 * @property {number} chat_process_time - seconds counter of the call at event time
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersChatFlowUiEventsParams>} LogObject<answersChatFlowUiEventsParams>
 */
export function answersChatFlowUiEvents(params) {
    return { evid: 4929, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersWrapUpFlowUiEvents' event (evid: 4930)
 *
 * Event description: triggers when a user interacts with wrap up elements in Answers
 *
 * @param {answersWrapUpFlowUiEventsParams} params - The parameters for this event
 * @property {GUID} ticket_id - The ticket id
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {string} type_of_interaction - The type of interaction chat/call
 * @property {GUID} tenant_id - The user tenant Id
 * @property {string} sub_element - name of the sub element clicked on/viewed
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - id of the user the ticket is assigned to
 * @property {GUID} interaction_id - id of the interaction the expert is currently on for the call
 * @property {string} element - name of the element clicked on/viewed
 * @property {number} processing_time - seconds counter of the call/chat at event time
 * @property {string} value - action value
 * @property {string} action_type - type of the action performed by the user (click, scroll, etc.)
 * @property {GUID} agent_id - The expert handling the ticket
 * @return {LogObject<answersWrapUpFlowUiEventsParams>} LogObject<answersWrapUpFlowUiEventsParams>
 */
export function answersWrapUpFlowUiEvents(params) {
    return { evid: 4930, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'smartAvailabilitySrc77Evid5' event (evid: 5)
 *
 * Event description: checks the availability result of the Smart availability
 *
 * @param {smartAvailabilitySrc77Evid5Params} params - The parameters for this event
 * @property {string} skill_ids - refer to the ticket skills that the availability was checked for
 * @property {GUID} group_id - refer to the assigned group of the ticket that the availability was checked for
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - refer the the locale that the availability was checked for
 * @property {boolean} is_transfer - refer to is the availability requests was for transfer flow
 * @property {string} availability_results - refer to the availability results
 * @property {GUID} ticket_id - ticket_id
 * @property {string} candidates - top 5 experts for availability
 * @property {string} user_proficiency - user_proficiency 1,2,3
 * @property {number} users_in_sys - number of users  in the system on the time of the event
 * @property {number} experts_in_sys - number of experts in the system on the time of the event
 * @property {number} users_same_skill_in_sys - number of users with same skill in sys
 * @property {number} experts_same_skill_in_sys - number of experts with same skill in sys
 * @property {number} busy_experts_in_sys - number of busy experts in sys
 * @property {number} busy_experts_same_skill_in_sys - number of busy experts in sys with same skill
 * @property {string} request_id - request_id of the API
 * @return {LogObject<smartAvailabilitySrc77Evid5Params>} LogObject<smartAvailabilitySrc77Evid5Params>
 */
export function smartAvailabilitySrc77Evid5(params) {
    return { evid: 5, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devBindingAnswersAndWixIdentifiers' event (evid: 50)
 *
 * Event description: Event is fired every time that: 1. A user loads the Answers Marketing site or the Answers App  2. A wixCIDX and/or wixUIDX cookie was detected
 *
 * @param {devBindingAnswersAndWixIdentifiersParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} client_id - Answers Client (Anonymous) ID
 * @property {GUID} wix_user_id - Wix User ID
 * @property {GUID} user_id - Answers User ID
 * @property {GUID} wix_client_id - Wix Client (Anonymous) ID
 * @return {LogObject<devBindingAnswersAndWixIdentifiersParams>} LogObject<devBindingAnswersAndWixIdentifiersParams>
 */
export function devBindingAnswersAndWixIdentifiers(params) {
    return { evid: 50, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicAttachmentSentWithATicket' event (evid: 5001)
 *
 * Event description: Event is being fired whenever an attached file is sent with a ticket or reply to a certain tenant.
 *
 * @param {publicAttachmentSentWithATicketParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - The tenant that the ticket was sent to
 * @property {GUID} reply_id - Reply ID, only if the file was attached to a reply
 * @property {Url} url - URL of the attached file
 * @property {number} file_size - The size of the attached file, in KB
 * @property {GUID} client_id - Answers Client ID (Anonymous)
 * @property {GUID} user_id - Answers User ID
 * @property {string} attachment_status - Final status of the attachment (Failed, Invalid Extension, Max File Size Exceeded, OK)
 * @property {string} file_type - The type of the attached file
 * @return {LogObject<publicAttachmentSentWithATicketParams>} LogObject<publicAttachmentSentWithATicketParams>
 */
export function publicAttachmentSentWithATicket(params) {
    return { evid: 5001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tenantsCallCreationAttempt' event (evid: 5002)
 *
 * Event description: Event is fired when the call initiator tries to create a call.
 *
 * For Outbound and Callback calls: The stage of the creation of the call in Answers and before the creation of it in Twilio.
 * For Inbound: The stage of the creation of the call in Twilio and before it is being accepted in Answers.
 *
 * @param {tenantsCallCreationAttemptParams} params - The parameters for this event
 * @property {GUID} group_id - group of the call
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} phone_number - User's phone Number
 * @property {string} queue - Initial queue of the call (for callback only)
 * @property {GUID} client_id - Answers Client ID (Anonymous)
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language
 * @property {string} type - type of the call (inbound, outbound, callback, etc.)
 * @return {LogObject<tenantsCallCreationAttemptParams>} LogObject<tenantsCallCreationAttemptParams>
 */
export function tenantsCallCreationAttempt(params) {
    return { evid: 5002, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallCreationSuccess' event (evid: 5003)
 *
 * Event description: Event is fired when the call was successfully created but not yet started.
 *
 * For Outbound and Callback calls: The call was accepted in Twilio and Twilio dialed to the user
 * For Inbound: The call was accepted in Answers
 *
 * @param {publicCallCreationSuccessParams} params - The parameters for this event
 * @property {GUID} group_id - group of the call
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} phone_number - User's phone Number
 * @property {string} queue - Initial queue of the call (for callback only)
 * @property {GUID} client_id - Answers Client ID (Anonymous)
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language
 * @property {GUID} callid - Call ID
 * @property {string} type - type of the call (inbound, outbound, callback, etc.)
 * @return {LogObject<publicCallCreationSuccessParams>} LogObject<publicCallCreationSuccessParams>
 */
export function publicCallCreationSuccess(params) {
    return { evid: 5003, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallCreationFail' event (evid: 5004)
 *
 * Event description: Event is fired when the call was not created.
 *
 * The user/client ID in this event is always of the user.
 *
 * @param {publicCallCreationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant of the performing user
 * @property {string} phone_number - User's phone Number
 * @property {GUID} client_id - Answers Client ID (Anonymous)
 * @property {string} reason - Reason for call creation failure (Ban, Closed Line, etc.)
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers language
 * @property {GUID} callid - Call ID
 * @property {string} type - type of the call (inbound, outbound, callback, etc.)
 * @return {LogObject<publicCallCreationFailParams>} LogObject<publicCallCreationFailParams>
 */
export function publicCallCreationFail(params) {
    return { evid: 5004, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tenantsTicketCreationSuccess' event (evid: 5006)
 *
 * Event description: A new ticket was successfully created in Answers DB.
 *
 * @param {tenantsTicketCreationSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel of the ticket (Web, Email, Widget, Facebook, etc.)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @return {LogObject<tenantsTicketCreationSuccessParams>} LogObject<tenantsTicketCreationSuccessParams>
 */
export function tenantsTicketCreationSuccess(params) {
    return { evid: 5006, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tenantsTicketCreationFail' event (evid: 5007)
 *
 * Event description: A request for a new ticket creation in Answers DB was denied.
 *
 * @param {tenantsTicketCreationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel of the ticket (Web, Email, Widget, Facebook, etc.)
 * @property {string} subject - The subject/title of the ticket
 * @property {GUID} client_id - Answers Client ID
 * @property {string} reason - Fail reason
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @return {LogObject<tenantsTicketCreationFailParams>} LogObject<tenantsTicketCreationFailParams>
 */
export function tenantsTicketCreationFail(params) {
    return { evid: 5007, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tenantsReplyCreationSuccess' event (evid: 5009)
 *
 * Event description: A new reply for a ticket was successfully created in Answers DB.
 *
 * @param {tenantsReplyCreationSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel of the ticket (Web, Email, Widget, Facebook, etc.)
 * @property {boolean} is_agent - True = Agent reply, False = User reply
 * @property {boolean} is_by_rule_engine - True = The reply was generated by the Rule Engine, False = The reply was generated by an actual agent
 * @property {GUID} reply_id - Reply ID
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} agent_uuid - the agent who reply on the ticket
 * @return {LogObject<tenantsReplyCreationSuccessParams>} LogObject<tenantsReplyCreationSuccessParams>
 */
export function tenantsReplyCreationSuccess(params) {
    return { evid: 5009, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tenantsReplyCreationFail' event (evid: 5010)
 *
 * Event description: A request for a new reply creation in Answers DB was denied.
 *
 * @param {tenantsReplyCreationFailParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel of the ticket (Web, Email, Widget, Facebook, etc.)
 * @property {boolean} is_agent - True = Agent reply, False = User reply
 * @property {boolean} is_by_rule_engine - True = The reply was generated by the Rule Engine, False = The reply was generated by an actual agent
 * @property {GUID} client_id - Answers Client ID
 * @property {string} reason - Fail reason
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @return {LogObject<tenantsReplyCreationFailParams>} LogObject<tenantsReplyCreationFailParams>
 */
export function tenantsReplyCreationFail(params) {
    return { evid: 5010, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallTransferFromQueueToVoicemailPerUserRequest' event (evid: 5012)
 *
 * Event description: This event is triggered when a user is transferred from his current queue to a voicemail per his request.
 *
 * @param {publicCallTransferFromQueueToVoicemailPerUserRequestParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket_id related with the call
 * @property {GUID} group_id - The group id of the call at the time the transfer occurs
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} call_type - Type of the call (inbound, outbound, callback, etc.)
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - The queue id of the call at the time the transfer occurs
 * @property {number} processing_time - How much time user spent on a call before the transfer, in sec
 * @property {GUID} callid - Call ID
 * @return {LogObject<publicCallTransferFromQueueToVoicemailPerUserRequestParams>} LogObject<publicCallTransferFromQueueToVoicemailPerUserRequestParams>
 */
export function publicCallTransferFromQueueToVoicemailPerUserRequest(params) {
    return { evid: 5012, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallbackRequestFromAQueueByAUser' event (evid: 5013)
 *
 * Event description: Public - Callback request from a queue by a user.
 *
 * @param {publicCallbackRequestFromAQueueByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - ticket_id
 * @property {GUID} group_id - group id of the call
 * @property {GUID} tenant_id - tenant_id
 * @property {string} call_type - call_type
 * @property {GUID} uuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} queue_id - queue_id
 * @property {number} processing_time - processing_time
 * @property {GUID} callid - Call ID
 * @return {LogObject<publicCallbackRequestFromAQueueByAUserParams>} LogObject<publicCallbackRequestFromAQueueByAUserParams>
 */
export function publicCallbackRequestFromAQueueByAUser(params) {
    return { evid: 5013, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicCallTransferBetweenQueuesPerUserRequest' event (evid: 5014)
 *
 * Event description: This event is triggered when a user is transferred from his current queue to another one per his request.
 *
 * @param {publicCallTransferBetweenQueuesPerUserRequestParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket_id related with the call
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} source_queue_id - The queue ID that the call is transferred from
 * @property {string} call_type - Type of the call (inbound, outbound, callback, etc.)
 * @property {GUID} uuid - uuid
 * @property {GUID} source_topic_id - The topic ID that the call is transferred from
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {GUID} target_queue_id - The queue ID that the call is transferred to
 * @property {number} processing_time - How much time user spent on a call before the transfer, in sec
 * @property {GUID} target_topic_id - The topic ID that the call is transferred to
 * @property {GUID} callid - Call ID
 * @property {string} target_locale - The language ID that the call is transferred to
 * @property {string} source_locale - The language ID that the call is transferred from
 * @return {LogObject<publicCallTransferBetweenQueuesPerUserRequestParams>} LogObject<publicCallTransferBetweenQueuesPerUserRequestParams>
 */
export function publicCallTransferBetweenQueuesPerUserRequest(params) {
    return { evid: 5014, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageAttempt' event (evid: 5015)
 *
 * Event description: A Public User attempted to send a new Chat message
 *
 * @param {publicChatUserMessageAttemptParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} chat_id - Chat ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel of the message (Widget, Whatsapp, Facebook etc.)
 * @property {GUID} userGuid - uuid
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Reply ID
 * @return {LogObject<publicChatUserMessageAttemptParams>} LogObject<publicChatUserMessageAttemptParams>
 */
export function publicChatUserMessageAttempt(params) {
    return { evid: 5015, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageSuccess' event (evid: 5016)
 *
 * Event description: A chat message was successfully sent by a public user
 *
 * @param {publicChatUserMessageSuccessParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel of the message (Widget, Whatsapp, Facebook etc.)
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Reply ID
 * @return {LogObject<publicChatUserMessageSuccessParams>} LogObject<publicChatUserMessageSuccessParams>
 */
export function publicChatUserMessageSuccess(params) {
    return { evid: 5016, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatUserMessageFailed' event (evid: 5017)
 *
 * Event description: Public user has failed to send a chat message
 *
 * @param {publicChatUserMessageFailedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} chat_id - Chat ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - Channel of the message (Widget, Whatsapp, Facebook etc.)
 * @property {GUID} client_id - client_id
 * @property {string} reason - Fail reason
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} message_id - Reply ID
 * @return {LogObject<publicChatUserMessageFailedParams>} LogObject<publicChatUserMessageFailedParams>
 */
export function publicChatUserMessageFailed(params) {
    return { evid: 5017, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetLauncherRequested' event (evid: 6001)
 *
 * Event description: The event is trigger when the server gets a request from the page to load the launcher.
 *
 * @param {widgetLauncherRequestedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Answers tenant id
 * @property {GUID} widget_id - widget id
 * @property {Url} referral_url - referral_url
 * @property {GUID} client_id - client_id
 * @property {string} locale - Answers language
 * @return {LogObject<widgetLauncherRequestedParams>} LogObject<widgetLauncherRequestedParams>
 */
export function widgetLauncherRequested(params) {
    return { evid: 6001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSurveyHasBeenSentToAUser' event (evid: 7000)
 *
 * Event description: A survey request has been successfully sent to a user
 *
 * @param {publicSurveyHasBeenSentToAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket_id
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel the Survey relates to
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The user ID of the user that got the survey
 * @property {string} locale - Answers language
 * @property {boolean} comment_option - True - if the survey includes an option for the user to comment, False if not
 * @property {GUID} survey_id - The ID of the survey
 * @return {LogObject<publicSurveyHasBeenSentToAUserParams>} LogObject<publicSurveyHasBeenSentToAUserParams>
 */
export function publicSurveyHasBeenSentToAUser(params) {
    return { evid: 7000, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicSurveyHasBeenSentByAUser' event (evid: 7001)
 *
 * Event description: A survey has been sent by a user to the system
 *
 * @param {publicSurveyHasBeenSentByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket_id
 * @property {string} comment_content - The comment that the user sent (if he sent - it is not mandatory)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} channel - The channel the Survey relates to
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - The user ID of the user that sent the survey
 * @property {string} locale - Answers language
 * @property {number} rating - Satisfaction score rated and submitted by the user
 * @property {boolean} comment_option - True - if the survey includes an option for the user to comment, False if not
 * @property {GUID} survey_id - The ID of the survey
 * @property {GUID} agent_id - The Agent ID that last commented and the survey relates to
 * @return {LogObject<publicSurveyHasBeenSentByAUserParams>} LogObject<publicSurveyHasBeenSentByAUserParams>
 */
export function publicSurveyHasBeenSentByAUser(params) {
    return { evid: 7001, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoAiContentGenerator' event (evid: 7700314)
 *
 * Event description: Fire when the AI content generator was activated in the article's back office
 *
 * @param {kbBoAiContentGeneratorParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} params - The input parameters that were passed with the request for the generator service
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} locale - The article language code for which the action was performed
 * @return {LogObject<kbBoAiContentGeneratorParams>} LogObject<kbBoAiContentGeneratorParams>
 */
export function kbBoAiContentGenerator(params) {
    return { evid: 7700314, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOnboardingGeneralOnboardingEvent' event (evid: 901)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Guide" screen
 *
 * @param {appOnboardingGeneralOnboardingEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Account ID
 * @property {string} params - Parameters
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - Type of event
 * @return {LogObject<appOnboardingGeneralOnboardingEventParams>} LogObject<appOnboardingGeneralOnboardingEventParams>
 */
export function appOnboardingGeneralOnboardingEvent(params) {
    return { evid: 901, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appOnboardingGeneralQuestionsEvent' event (evid: 902)
 *
 * Event description: This is a general onboarding event. At first phase of the Onboarding dev process, this event will be used for reporting all actions in the "Questions" screen
 *
 * @param {appOnboardingGeneralQuestionsEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} tenant_id - Answers Account ID
 * @property {string} params - Parameters
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - Answers User ID
 * @property {string} type - Type of event
 * @return {LogObject<appOnboardingGeneralQuestionsEventParams>} LogObject<appOnboardingGeneralQuestionsEventParams>
 */
export function appOnboardingGeneralQuestionsEvent(params) {
    return { evid: 902, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralRegisterIntegrationAttempt' event (evid: 9500)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsGeneralRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralRegisterIntegrationAttemptParams>} LogObject<integratorsGeneralRegisterIntegrationAttemptParams>
 */
export function integratorsGeneralRegisterIntegrationAttempt(params) {
    return { evid: 9500, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralRegisterIntegrationSuccess' event (evid: 9501)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsGeneralRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralRegisterIntegrationSuccessParams>} LogObject<integratorsGeneralRegisterIntegrationSuccessParams>
 */
export function integratorsGeneralRegisterIntegrationSuccess(params) {
    return { evid: 9501, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationAttempt' event (evid: 9503)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralUnregisterIntegrationAttemptParams>} LogObject<integratorsGeneralUnregisterIntegrationAttemptParams>
 */
export function integratorsGeneralUnregisterIntegrationAttempt(params) {
    return { evid: 9503, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationSuccess' event (evid: 9504)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralUnregisterIntegrationSuccessParams>} LogObject<integratorsGeneralUnregisterIntegrationSuccessParams>
 */
export function integratorsGeneralUnregisterIntegrationSuccess(params) {
    return { evid: 9504, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralUnregisterIntegrationFail' event (evid: 9505)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsGeneralUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralUnregisterIntegrationFailParams>} LogObject<integratorsGeneralUnregisterIntegrationFailParams>
 */
export function integratorsGeneralUnregisterIntegrationFail(params) {
    return { evid: 9505, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSettingsRendered' event (evid: 9506)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsGeneralSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @property {string} type - Type of screen that was rendered (Auth, Settings, etc.)
 * @return {LogObject<integratorsGeneralSettingsRenderedParams>} LogObject<integratorsGeneralSettingsRenderedParams>
 */
export function integratorsGeneralSettingsRendered(params) {
    return { evid: 9506, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionAttempt' event (evid: 9507)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralAuthFlowCompletionAttemptParams>} LogObject<integratorsGeneralAuthFlowCompletionAttemptParams>
 */
export function integratorsGeneralAuthFlowCompletionAttempt(params) {
    return { evid: 9507, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionSuccess' event (evid: 9508)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralAuthFlowCompletionSuccessParams>} LogObject<integratorsGeneralAuthFlowCompletionSuccessParams>
 */
export function integratorsGeneralAuthFlowCompletionSuccess(params) {
    return { evid: 9508, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralAuthFlowCompletionFail' event (evid: 9509)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsGeneralAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralAuthFlowCompletionFailParams>} LogObject<integratorsGeneralAuthFlowCompletionFailParams>
 */
export function integratorsGeneralAuthFlowCompletionFail(params) {
    return { evid: 9509, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSaveSettingsAttempt' event (evid: 9510)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsGeneralSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralSaveSettingsAttemptParams>} LogObject<integratorsGeneralSaveSettingsAttemptParams>
 */
export function integratorsGeneralSaveSettingsAttempt(params) {
    return { evid: 9510, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralSaveSettingsSuccess' event (evid: 9511)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsGeneralSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID of the performing user
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralSaveSettingsSuccessParams>} LogObject<integratorsGeneralSaveSettingsSuccessParams>
 */
export function integratorsGeneralSaveSettingsSuccess(params) {
    return { evid: 9511, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralTicketViewRendered' event (evid: 9513)
 *
 * Event description: Integration rendered the ticket view for a certain ticket.
 *
 * @param {integratorsGeneralTicketViewRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Tenant ID of the requesting tenant
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsGeneralTicketViewRenderedParams>} LogObject<integratorsGeneralTicketViewRenderedParams>
 */
export function integratorsGeneralTicketViewRendered(params) {
    return { evid: 9513, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralWebhookCalledAttempt' event (evid: 9514)
 *
 * Event description: The integration attempted to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsGeneralWebhookCalledAttemptParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsGeneralWebhookCalledAttemptParams>} LogObject<integratorsGeneralWebhookCalledAttemptParams>
 */
export function integratorsGeneralWebhookCalledAttempt(params) {
    return { evid: 9514, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralWebhookCalledSuccess' event (evid: 9517)
 *
 * Event description: The integration successfully called a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsGeneralWebhookCalledSuccessParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsGeneralWebhookCalledSuccessParams>} LogObject<integratorsGeneralWebhookCalledSuccessParams>
 */
export function integratorsGeneralWebhookCalledSuccess(params) {
    return { evid: 9517, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralWebhookCalledFail' event (evid: 9518)
 *
 * Event description: The integration failed to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsGeneralWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Tenant ID of the calling tenant
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsGeneralWebhookCalledFailParams>} LogObject<integratorsGeneralWebhookCalledFailParams>
 */
export function integratorsGeneralWebhookCalledFail(params) {
    return { evid: 9518, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsGeneralFailedTokenValidation' event (evid: 9519)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsGeneralFailedTokenValidationParams} params - The parameters for this event
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {Url} request_origin - The URL the request was originated from
 * @return {LogObject<integratorsGeneralFailedTokenValidationParams>} LogObject<integratorsGeneralFailedTokenValidationParams>
 */
export function integratorsGeneralFailedTokenValidation(params) {
    return { evid: 9519, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callnoteCreatedByAiSummary' event (evid: 9525)
 *
 * Event description: Every time the AI summary sends a callnote, this event is sent.
 *
 * @param {callnoteCreatedByAiSummaryParams} params - The parameters for this event
 * @property {GUID} ticket_id - the ticket/thread ID
 * @property {GUID} tenant_id - the tenant ID
 * @property {GUID} closing_agent_id - The ID of the expert who closed the call
 * @property {DateTime} start_summary_processing_time - the time when the callnote summary as request.
 * @property {GUID} client_id - client_id
 * @property {DateTime} end_summary_processing_time - The time when the callnote summary as sent
 * @property {GUID} user_id - The user (client) ID
 * @property {number} call_duration - The duration of the call
 * @property {GUID} call_id - The call ID
 * @return {LogObject<callnoteCreatedByAiSummaryParams>} LogObject<callnoteCreatedByAiSummaryParams>
 */
export function callnoteCreatedByAiSummary(params) {
    return { evid: 9525, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'channelAvailabilityOfflineExperts' event (evid: 9526)
 *
 * Event description: checks the availability result of the API
 *
 * @param {channelAvailabilityOfflineExpertsParams} params - The parameters for this event
 * @property {string} skill_ids - refer the the skills that the availability was checked for
 * @property {GUID} group_id - refer to the assigned group that the availability was checked for
 * @property {GUID} tenant_id - tenant_id
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - user_id
 * @property {string} locale - refer the the locale that the availability was checked for
 * @property {boolean} is_transfer - refer to is the availability requests was for transfer flow
 * @property {string} availability_results - refer to the availability results
 * @property {string} request_id - request_id of the API
 * @return {LogObject<channelAvailabilityOfflineExpertsParams>} LogObject<channelAvailabilityOfflineExpertsParams>
 */
export function channelAvailabilityOfflineExperts(params) {
    return { evid: 9526, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicTicketHasBeenResolvedByAUser' event (evid: 9530)
 *
 * Event description: A ticket was resolved by a user.
 * (The only flow for it to happen at the moment is that the user is directed to the article after clicking it in "Article suggestions" section of "Ticket received" Email. (Ticket confirmation email))
 *
 * @param {publicTicketHasBeenResolvedByAUserParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID
 * @property {string} locale - Answers Language
 * @property {GUID} article_id - Article ID
 * @property {string} article_name - Article name
 * @return {LogObject<publicTicketHasBeenResolvedByAUserParams>} LogObject<publicTicketHasBeenResolvedByAUserParams>
 */
export function publicTicketHasBeenResolvedByAUser(params) {
    return { evid: 9530, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsArticleSuggestionEmailRendered' event (evid: 9531)
 *
 * Event description: Article recommendation Email was rendered after a user submitted a ticket. When a ticket is submitted an AI article recommendation is generated and sent to the user attached to the ticket confirmation email. This event is not a guarantee that the email was in did delivered to the user.
 *
 * @param {integratorsArticleSuggestionEmailRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Answers User ID that submitted the ticket
 * @property {string} locale - Answers Language
 * @property {string} article_ids - The articles id's that were recommended for this ticket (array)
 * @return {LogObject<integratorsArticleSuggestionEmailRenderedParams>} LogObject<integratorsArticleSuggestionEmailRenderedParams>
 */
export function integratorsArticleSuggestionEmailRendered(params) {
    return { evid: 9531, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationAttempt' event (evid: 9550)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraRegisterIntegrationAttemptParams>} LogObject<integratorsJiraRegisterIntegrationAttemptParams>
 */
export function integratorsJiraRegisterIntegrationAttempt(params) {
    return { evid: 9550, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationSuccess' event (evid: 9551)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraRegisterIntegrationSuccessParams>} LogObject<integratorsJiraRegisterIntegrationSuccessParams>
 */
export function integratorsJiraRegisterIntegrationSuccess(params) {
    return { evid: 9551, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraRegisterIntegrationFail' event (evid: 9552)
 *
 * Event description: The user failed to register (install) an integration on the tenant.
 *
 * @param {integratorsJiraRegisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraRegisterIntegrationFailParams>} LogObject<integratorsJiraRegisterIntegrationFailParams>
 */
export function integratorsJiraRegisterIntegrationFail(params) {
    return { evid: 9552, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraUnregisterIntegrationAttempt' event (evid: 9553)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsJiraUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraUnregisterIntegrationAttemptParams>} LogObject<integratorsJiraUnregisterIntegrationAttemptParams>
 */
export function integratorsJiraUnregisterIntegrationAttempt(params) {
    return { evid: 9553, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraUnregisterIntegrationSuccess' event (evid: 9554)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsJiraUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraUnregisterIntegrationSuccessParams>} LogObject<integratorsJiraUnregisterIntegrationSuccessParams>
 */
export function integratorsJiraUnregisterIntegrationSuccess(params) {
    return { evid: 9554, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSettingsRendered' event (evid: 9556)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsJiraSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {string} type - Type of screen that was rendered (Auth, Settings, etc.)
 * @return {LogObject<integratorsJiraSettingsRenderedParams>} LogObject<integratorsJiraSettingsRenderedParams>
 */
export function integratorsJiraSettingsRendered(params) {
    return { evid: 9556, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionAttempt' event (evid: 9557)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraAuthFlowCompletionAttemptParams>} LogObject<integratorsJiraAuthFlowCompletionAttemptParams>
 */
export function integratorsJiraAuthFlowCompletionAttempt(params) {
    return { evid: 9557, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionSuccess' event (evid: 9558)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraAuthFlowCompletionSuccessParams>} LogObject<integratorsJiraAuthFlowCompletionSuccessParams>
 */
export function integratorsJiraAuthFlowCompletionSuccess(params) {
    return { evid: 9558, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraAuthFlowCompletionFail' event (evid: 9559)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsJiraAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraAuthFlowCompletionFailParams>} LogObject<integratorsJiraAuthFlowCompletionFailParams>
 */
export function integratorsJiraAuthFlowCompletionFail(params) {
    return { evid: 9559, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSaveSettingsAttempt' event (evid: 9560)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsJiraSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraSaveSettingsAttemptParams>} LogObject<integratorsJiraSaveSettingsAttemptParams>
 */
export function integratorsJiraSaveSettingsAttempt(params) {
    return { evid: 9560, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraSaveSettingsSuccess' event (evid: 9561)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsJiraSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraSaveSettingsSuccessParams>} LogObject<integratorsJiraSaveSettingsSuccessParams>
 */
export function integratorsJiraSaveSettingsSuccess(params) {
    return { evid: 9561, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraTicketViewRendered' event (evid: 9563)
 *
 * Event description: Integration rendered the ticket view for a certain ticket.
 *
 * @param {integratorsJiraTicketViewRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsJiraTicketViewRenderedParams>} LogObject<integratorsJiraTicketViewRenderedParams>
 */
export function integratorsJiraTicketViewRendered(params) {
    return { evid: 9563, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraFailedTokenValidation' event (evid: 9569)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsJiraFailedTokenValidationParams} params - The parameters for this event
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {Url} request_origin - The URL the request was originated from
 * @return {LogObject<integratorsJiraFailedTokenValidationParams>} LogObject<integratorsJiraFailedTokenValidationParams>
 */
export function integratorsJiraFailedTokenValidation(params) {
    return { evid: 9569, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsJiraGeneralError' event (evid: 9570)
 *
 * Event description: The Jira integration returned an exception
 *
 * @param {integratorsJiraGeneralErrorParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID (Optional)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error reason
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {string} error_type - Error type
 * @return {LogObject<integratorsJiraGeneralErrorParams>} LogObject<integratorsJiraGeneralErrorParams>
 */
export function integratorsJiraGeneralError(params) {
    return { evid: 9570, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceRegisterIntegrationAttempt' event (evid: 9600)
 *
 * Event description: The user is attempting to register (install) an integration on the tenant.
 *
 * @param {integratorsSalesforceRegisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - User ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceRegisterIntegrationAttemptParams>} LogObject<integratorsSalesforceRegisterIntegrationAttemptParams>
 */
export function integratorsSalesforceRegisterIntegrationAttempt(params) {
    return { evid: 9600, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceRegisterIntegrationSuccess' event (evid: 9601)
 *
 * Event description: The user successfully registered (installed) an integration on the tenant.
 *
 * @param {integratorsSalesforceRegisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceRegisterIntegrationSuccessParams>} LogObject<integratorsSalesforceRegisterIntegrationSuccessParams>
 */
export function integratorsSalesforceRegisterIntegrationSuccess(params) {
    return { evid: 9601, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationAttempt' event (evid: 9603)
 *
 * Event description: The user is attempting to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationAttemptParams>} LogObject<integratorsSalesforceUnregisterIntegrationAttemptParams>
 */
export function integratorsSalesforceUnregisterIntegrationAttempt(params) {
    return { evid: 9603, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationSuccess' event (evid: 9604)
 *
 * Event description: The user successfully unregistered (removed) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationSuccessParams>} LogObject<integratorsSalesforceUnregisterIntegrationSuccessParams>
 */
export function integratorsSalesforceUnregisterIntegrationSuccess(params) {
    return { evid: 9604, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceUnregisterIntegrationFail' event (evid: 9605)
 *
 * Event description: The user failed to unregister (remove) an integration from the tenant.
 *
 * @param {integratorsSalesforceUnregisterIntegrationFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceUnregisterIntegrationFailParams>} LogObject<integratorsSalesforceUnregisterIntegrationFailParams>
 */
export function integratorsSalesforceUnregisterIntegrationFail(params) {
    return { evid: 9605, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSettingsRendered' event (evid: 9606)
 *
 * Event description: The settings page of the integration was rendered par user's request.
 *
 * @param {integratorsSalesforceSettingsRenderedParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {string} type - Type of screen that was rendered (Auth, Settings, etc.)
 * @return {LogObject<integratorsSalesforceSettingsRenderedParams>} LogObject<integratorsSalesforceSettingsRenderedParams>
 */
export function integratorsSalesforceSettingsRendered(params) {
    return { evid: 9606, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionAttempt' event (evid: 9607)
 *
 * Event description: The user is attempting to complete the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionAttemptParams>} LogObject<integratorsSalesforceAuthFlowCompletionAttemptParams>
 */
export function integratorsSalesforceAuthFlowCompletionAttempt(params) {
    return { evid: 9607, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionSuccess' event (evid: 9608)
 *
 * Event description: The user successfully completed the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionSuccessParams>} LogObject<integratorsSalesforceAuthFlowCompletionSuccessParams>
 */
export function integratorsSalesforceAuthFlowCompletionSuccess(params) {
    return { evid: 9608, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceAuthFlowCompletionFail' event (evid: 9609)
 *
 * Event description: The user failed to complete the auth flow of an integration.
 *
 * @param {integratorsSalesforceAuthFlowCompletionFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceAuthFlowCompletionFailParams>} LogObject<integratorsSalesforceAuthFlowCompletionFailParams>
 */
export function integratorsSalesforceAuthFlowCompletionFail(params) {
    return { evid: 9609, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsAttempt' event (evid: 9610)
 *
 * Event description: The user is attempting to save the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsAttemptParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceSaveSettingsAttemptParams>} LogObject<integratorsSalesforceSaveSettingsAttemptParams>
 */
export function integratorsSalesforceSaveSettingsAttempt(params) {
    return { evid: 9610, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsSuccess' event (evid: 9611)
 *
 * Event description: The user successfully saved the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsSuccessParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceSaveSettingsSuccessParams>} LogObject<integratorsSalesforceSaveSettingsSuccessParams>
 */
export function integratorsSalesforceSaveSettingsSuccess(params) {
    return { evid: 9611, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceSaveSettingsFail' event (evid: 9612)
 *
 * Event description: The user failed to save the settings of an integration.
 *
 * @param {integratorsSalesforceSaveSettingsFailParams} params - The parameters for this event
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceSaveSettingsFailParams>} LogObject<integratorsSalesforceSaveSettingsFailParams>
 */
export function integratorsSalesforceSaveSettingsFail(params) {
    return { evid: 9612, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceTicketViewRendered' event (evid: 9613)
 *
 * Event description: Integration rendered the ticket view for a certain ticket.
 *
 * @param {integratorsSalesforceTicketViewRenderedParams} params - The parameters for this event
 * @property {GUID} ticket_id - Ticket ID
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @return {LogObject<integratorsSalesforceTicketViewRenderedParams>} LogObject<integratorsSalesforceTicketViewRenderedParams>
 */
export function integratorsSalesforceTicketViewRendered(params) {
    return { evid: 9613, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledAttempt' event (evid: 9614)
 *
 * Event description: The integration attempted to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledAttemptParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsSalesforceWebhookCalledAttemptParams>} LogObject<integratorsSalesforceWebhookCalledAttemptParams>
 */
export function integratorsSalesforceWebhookCalledAttempt(params) {
    return { evid: 9614, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledSuccess' event (evid: 9615)
 *
 * Event description: The integration successfully called a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledSuccessParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsSalesforceWebhookCalledSuccessParams>} LogObject<integratorsSalesforceWebhookCalledSuccessParams>
 */
export function integratorsSalesforceWebhookCalledSuccess(params) {
    return { evid: 9615, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceWebhookCalledFail' event (evid: 9616)
 *
 * Event description: The integration failed to call a webhook on behalf of an Answers tenant.
 *
 * @param {integratorsSalesforceWebhookCalledFailParams} params - The parameters for this event
 * @property {GUID} item_id - The entity ID (ticket_id for "Ticket Created" webhook_type, etc.)
 * @property {GUID} tenant_id - Tenant ID
 * @property {string} reason - Error Reason
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {string} webhook_type - Type of webhook (Ticket reply, Ticket Created, etc.)
 * @property {GUID} integration_id - Integration ID
 * @property {number} attempt - The attempt number for the same webhook call
 * @return {LogObject<integratorsSalesforceWebhookCalledFailParams>} LogObject<integratorsSalesforceWebhookCalledFailParams>
 */
export function integratorsSalesforceWebhookCalledFail(params) {
    return { evid: 9616, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'integratorsSalesforceFailedTokenValidation' event (evid: 9617)
 *
 * Event description: The integration failed to validate a token
 *
 * @param {integratorsSalesforceFailedTokenValidationParams} params - The parameters for this event
 * @property {string} user_agent - user_agent
 * @property {GUID} user_id - Integration ID
 * @property {GUID} integration_id - Integration ID
 * @property {Url} request_origin - The URL the request was originated from
 * @return {LogObject<integratorsSalesforceFailedTokenValidationParams>} LogObject<integratorsSalesforceFailedTokenValidationParams>
 */
export function integratorsSalesforceFailedTokenValidation(params) {
    return { evid: 9617, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingSlackbotAlert' event (evid: 9800)
 *
 * Event description: The event is fired with all the details when a alert is sent to onboarding team slack channel after a tenant wrote in urgent/support channel
 *
 * @param {onboardingSlackbotAlertParams} params - The parameters for this event
 * @property {GUID} tenant_id - tenant_id
 * @property {string} alert_id - a combination of the time of the original msg time, and the channel
 * @property {string} channel_name - slack channel name
 * @property {string} reporter - reporter name
 * @property {GUID} acknowledged_by_id - who clicked the button
 * @property {string} alert_type - slack alert type
 * @property {string} outcome - outcome
 * @property {string} bot_id - bot_id
 * @property {GUID} client_id - client_id
 * @property {DateTime} original_time - The original alert time
 * @property {GUID} user_id - user_id
 * @property {string} link - link
 * @property {DateTime} acknowledge_time - acknowledge_time
 * @return {LogObject<onboardingSlackbotAlertParams>} LogObject<onboardingSlackbotAlertParams>
 */
export function onboardingSlackbotAlert(params) {
    return { evid: 9800, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'devGeneralTwilioEvent' event (evid: 99)
 *
 * Event description: This is a general event for data we get from Twilio. We use for QA and debug.
 *
 * @param {devGeneralTwilioEventParams} params - The parameters for this event
 * @property {GUID} answers_brand_id - answers_brand_id
 * @property {GUID} item_id - Item ID
 * @property {GUID} tenant_id - tenant ID
 * @property {string} data - data
 * @property {string} tab_id - persistent id for the open tab, to debug multiple tab issues
 * @property {GUID} client_id - client_id
 * @property {GUID} user_id - uuid
 * @property {string} type - type
 * @return {LogObject<devGeneralTwilioEventParams>} LogObject<devGeneralTwilioEventParams>
 */
export function devGeneralTwilioEvent(params) {
    return { evid: 99, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publicChatbotStepReached' event (evid: 9900)
 *
 * Event description: Public (chatbot) - step reached.
 *
 * @param {publicChatbotStepReachedParams} params - The parameters for this event
 * @property {GUID} chatbot_flow_id - chatbot_flow_id
 * @property {string} chatbot_step_type - chatbot_step_type
 * @property {string} tenant_name - tenant_name
 * @property {GUID} sessionId - session_id
 * @property {string} chatbot_step_id - chatbot_step_id
 * @return {LogObject<publicChatbotStepReachedParams>} LogObject<publicChatbotStepReachedParams>
 */
export function publicChatbotStepReached(params) {
    return { evid: 9900, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketIsReadyForRouting' event (evid: 9904)
 *
 * Event description: New ticket was created or ticket was sent to revaluation flow. Triggers after gathering all information that needed for routing (about ticket, system state and recommendations).
 *
 * @param {ticketIsReadyForRoutingParams} params - The parameters for this event
 * @property {string} locale -  Language of the ticket
 * @property {string} skill_ids - List of topics and soft skills the ticket does require
 * @property {number} agent_active_tickets_num - Number of interactions chosen agent is currently processing
 * @property {string} agent_active_tickets_list - List of interactions chosen agent is currently processing
 * @property {number} agent_waiting_tickets_num - Number of interactions waiting in agent's personal queue
 * @property {string} agent_waiting_tickets_list - List of interactions waiting in agent's personal queue
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} ticket_id - Unique id of the ticket
 * @property {GUID} interaction_id - Unique interaction id
 * @property {string} channel_id - Id of channel
 * @property {GUID} group_id - id of the group
 * @property {string} interaction_proficiency - proficiency of ticket / interaction
 * @property {boolean} is_new_interaction - true if it's a new ticket to be sent to routing
 * @property {boolean} is_revaluation - true if ticket was sent to revaluation (ticket was updated, transfer, declined, agent status changed)
 * @property {number} priority_score - priority score
 * @property {GUID} wix_user_id - Wix user id (external)
 * @property {GUID} wix_user_account_id - Wix Account id (external)
 * @property {GUID} answers_user_id - Wix user id from Answers
 * @property {string} user_proficiency - Level of user's proficiency
 * @property {number} routing_version - version of model/policy used for routing
 * @property {number} agents_filtered_num - number of agents sent to the model or filtered by policy
 * @property {string} agents_filtered_list - List of agent that were considered as options for this interaction
 * @property {GUID} agent_id - Main candidate for routing
 * @property {boolean} agent_is_routing_ready - If candidate is in one of the statuses that allow to push tickets to their queue
 * @property {string} agent_proficiency - The level of agent proficiency
 * @property {string} agent_status - Agent status
 * @property {string} agent_call_center_status - Agent call center status
 * @property {string} agent_channels - List of channels agent is currently on
 * @property {string} agent_skill_ids - List of topic and soft skills that agent currently has
 * @property {string} agent_group_ids - List of groups agent is currently a part of
 * @property {number} agent_capacity - Max number of tickets agent can process in the same moment of time
 * @property {DateTime} agent_last_session_start_time - When was the last session start of the agent
 * @property {DateTime} agent_last_session_end_time - When was the last session end of the agent
 * @property {GUID} prediction_id - Unique id for each model prediction
 * @property {string} reward - match reward (score)
 * @property {string} model_skill - skill recognised by model
 * @property {number} num_unknown_ranked_experts - out of top experts that model gives in response - how much it doesn't have personal stats on
 * @property {string} revaluation_reason - reason ticket is sent to revaluation
 * @property {boolean} is_transferred - is transferred
 * @property {GUID} agent_custom_busy_status_id - agent custom busy status
 * @return {LogObject<ticketIsReadyForRoutingParams>} LogObject<ticketIsReadyForRoutingParams>
 */
export function ticketIsReadyForRouting(params) {
    return { evid: 9904, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'routingRecommendation' event (evid: 9905)
 *
 * Event description: Triggers after get recommendation from model - send batch of events for top recommendations (one event per recommended agent with common prediction_id for each model runs).
 *
 * @param {routingRecommendationParams} params - The parameters for this event
 * @property {number} agent_active_tickets_num - Number of interactions chosen agent is currently processing
 * @property {string} agent_active_tickets_list - List of interactions chosen agent is currently processing
 * @property {number} agent_waiting_tickets_num - Number of interactions waiting in agent's personal queue
 * @property {string} agent_waiting_tickets_list - List of interactions waiting in agent's personal queue
 * @property {number} routing_version - routing_version (1-skill based, 2 - SR, 3 - skill based v2, 4 - SR v2)
 * @property {GUID} ticket_id - ticket id
 * @property {GUID} interaction_id - interaction id
 * @property {string} channel_id - channel
 * @property {GUID} agent_id - candidate for routing
 * @property {string} match_reward_details - rewards for each of the parameters, coefficients and exact predictions
 * @property {boolean} agent_is_routing_ready - If candidate is in one of the statuses that allow to push tickets to their queue
 * @property {string} agent_proficiency - The level of agent proficiency
 * @property {string} agent_status - Agent status
 * @property {string} agent_call_center_status - Agent call center status
 * @property {string} agent_channels - List of channels agent is currently on
 * @property {string} agent_skill_ids - List of topic and soft skills that agent currently has
 * @property {string} agent_group_ids - List of groups agent is currently a part of
 * @property {number} agent_capacity - Max number of tickets agent can process in the same moment of time
 * @property {DateTime} agent_last_session_start_time - When was the last session start of the agent
 * @property {DateTime} agent_last_session_end_time - When was the last session end of the agent
 * @property {GUID} predictionId - Unique id for each model prediction
 * @property {string} agent_custom_busy_status_id	 - custom busy status details
 * @property {string} agent_rank - rank of the agent according to the score
 * @property {string} reward - match reward (score)
 * @property {string} stats_snapshot_date - statistics snapshot date was used for predictions
 * @property {string} model_date - last date the model was updated
 * @property {string} pred_explain - Details about model's choice.
 * @property {GUID} tenant_id - Answers account id
 * @return {LogObject<routingRecommendationParams>} LogObject<routingRecommendationParams>
 */
export function routingRecommendation(params) {
    return { evid: 9905, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketFallbackToArPolicy' event (evid: 9907)
 *
 * Event description: Triggers in case of "red button" - when ticket is sent to our current flow (waiting list on the group level)
 *
 * @param {ticketFallbackToArPolicyParams} params - The parameters for this event
 * @property {string} locale -  Language of the ticket
 * @property {string} skill_ids - List of topics and soft skills the ticket does require
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} ticket_id - Unique id of the ticket
 * @property {GUID} interaction_id - Unique interaction id
 * @property {string} channel_id - Id of channel
 * @property {GUID} group_id - id of the group
 * @property {number} priority_score - priority score
 * @property {GUID} agent_id - Id of the last assigned agent
 * @property {string} user_proficiency - Level of user's proficiency
 * @return {LogObject<ticketFallbackToArPolicyParams>} LogObject<ticketFallbackToArPolicyParams>
 */
export function ticketFallbackToArPolicy(params) {
    return { evid: 9907, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'kbBoAiContentRephrase' event (evid: 9908)
 *
 * Event description: Fire when the AI content rephrase was activated in the article's back office
 *
 * @param {kbBoAiContentRephraseParams} params - The parameters for this event
 * @property {GUID} article_id - The article for which the action was performed
 * @property {string} params - The input parameters that were passed with the request for the rephrase service
 * @property {GUID} user_answers_id - The Answers ID of the user that triggered the action
 * @property {GUID} tenant_id - The tenant id in Answers
 * @property {string} article_language - The article language code for which the action was performed
 * @property {string} locale - The article language code for which the action was performed
 * @return {LogObject<kbBoAiContentRephraseParams>} LogObject<kbBoAiContentRephraseParams>
 */
export function kbBoAiContentRephrase(params) {
    return { evid: 9908, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agentIsReadyForRoutingSrc77Evid9909' event (evid: 9909)
 *
 * Event description: Triggers on change of agent status to online (from any other status), if: agent support english language, cc-channel enabled and agent doesn’t have waiting tickets in the queue.
 * (Smart Routing event)
 *
 * @param {agentIsReadyForRoutingSrc77Evid9909Params} params - The parameters for this event
 * @property {string} agent_previous_status - agent status before trigger this event
 * @property {GUID} agent_previous_custom_busy_status_id - agent custom busy status before trigger this event
 * @property {string} agent_previous_call_center_status - Agent call center status before trigger this event
 * @property {number} routing_version - routing_version (1-skill based, 2 - SR, 3 - skill based v2, 4 - SR v2)
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} agent_id - Main candidate for routing
 * @property {string} agent_proficiency - The level of agent proficiency
 * @property {string} agent_status - Agent status
 * @property {string} agent_call_center_status - Agent call center status
 * @property {string} agent_channels - List of channels agent is currently on
 * @property {string} agent_skill_ids - List of topic and soft skills that agent currently has
 * @property {string} agent_group_ids - List of groups agent is currently a part of
 * @property {number} agent_capacity - Max number of tickets agent can process in the same moment of time
 * @property {DateTime} agent_last_session_start_time - When was the last session start of the agent
 * @property {DateTime} agent_last_session_end_time - When was the last session end of the agent
 * @property {GUID} agent_custom_busy_status_id - agent custom busy status
 * @property {string} agent_locales - list of agent's locales
 * @return {LogObject<agentIsReadyForRoutingSrc77Evid9909Params>} LogObject<agentIsReadyForRoutingSrc77Evid9909Params>
 */
export function agentIsReadyForRoutingSrc77Evid9909(params) {
    return { evid: 9909, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'agentFlowModelResponseSrc77Evid9910' event (evid: 9910)
 *
 * Event description: Model response (recommendation) on agent flow - main recommendation according to which we take action
 *
 * @param {agentFlowModelResponseSrc77Evid9910Params} params - The parameters for this event
 * @property {GUID} ticket_id - Unique id of the ticket recommended for the agent
 * @property {number} tickets_filtered_num - number of tickets sent to the model
 * @property {string} tickets_filtered_list - List of tickets that were considered as options for this agent
 * @property {GUID} prediction_id - Unique id for each model prediction
 * @property {string} unknown_experts - list of experts who model did not recognise
 * @property {number} routing_version - routing_version (1-skill based, 2 - SR, 3 - skill based v2, 4 - SR v2)
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} agent_id - Main candidate for routing
 * @property {string} channel_id - channel
 * @property {GUID} interaction_id - id of interaction
 * @return {LogObject<agentFlowModelResponseSrc77Evid9910Params>} LogObject<agentFlowModelResponseSrc77Evid9910Params>
 */
export function agentFlowModelResponseSrc77Evid9910(params) {
    return { evid: 9910, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'routingRecommendationExpertsFlowSrc77Evid9911' event (evid: 9911)
 *
 * Event description: Triggers after get recommendation from model - send batch of events for top recommendations (one event per recommended ticket with common prediction_id for each model runs).
 *
 * @param {routingRecommendationExpertsFlowSrc77Evid9911Params} params - The parameters for this event
 * @property {string} locale -  Language of the ticket
 * @property {GUID} ticket_id - Main ticket candidate recommended for the agent
 * @property {string} interaction_proficiency - proficiency of recommended ticket / interaction
 * @property {number} previous_ticket_place_in_queue - from which place in previous agent's queue the ticket to be removed
 * @property {number} priority_score - priority score
 * @property {GUID} wix_user_id - Wix user id (external)
 * @property {GUID} answers_user_id - Wix user id from Answers
 * @property {GUID} prediction_id - Unique id for each model prediction
 * @property {string} reward - match reward (score)
 * @property {GUID} previous_ticket_agent_id - ticket to be removed from the queue of this agent
 * @property {string} ticket_rank - rank of the ticket according to the score
 * @property {string} stats_snapshot_date - statistics snapshot date was used for predictions
 * @property {string} model_date - last date the model was updated
 * @property {string} match_reward_details - rewards for each of the parameters, coefficients and exact predictions
 * @property {string} pred_explain	 - Details about model's choice.
 * @property {number} routing_version - routing_version (1-skill based, 2 - SR, 3 - skill based v2, 4 - SR v2)
 * @property {GUID} tenant_id - Answers account id
 * @property {GUID} agent_id - Agent id
 * @property {boolean} is_final_recommendation - true if system performs action based on this prediction
 * @property {GUID} interaction_id - interaction id
 * @property {string} channel_id - channel
 * @property {string} user_proficiency - level of user proficiency, 1 -3
 * @property {GUID} wix_user_account_id - external account id of the user
 * @property {GUID} group_id - id of group
 * @property {string} skill_ids - list of skills
 * @return {LogObject<routingRecommendationExpertsFlowSrc77Evid9911Params>} LogObject<routingRecommendationExpertsFlowSrc77Evid9911Params>
 */
export function routingRecommendationExpertsFlowSrc77Evid9911(params) {
    return { evid: 9911, src: 77, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sentimentalProjectResults' event (evid: 1000)
 *
 * Event description: Transcription and Sentiment analysis of support calls
 *
 * @param {sentimentalProjectResultsParams} params - The parameters for this event
 * @property {string} phase_configuration_display_name - The display name of the phase configuration used to run this job
 * @property {string} job_id - Internal identifier of the sentimental pipeline
 * @property {string} interaction_id - Interaction id provided by the user (callId for CC calls)
 * @property {string} sentiment_result - Sentiment analysis result
 * @return {LogObject<sentimentalProjectResultsParams>} LogObject<sentimentalProjectResultsParams>
 */
export function sentimentalProjectResults(params) {
    return { evid: 1000, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sentimentalJobsTracker' event (evid: 1001)
 *
 * Event description: Transcription and Sentiment analysis of support calls
 *
 * @param {sentimentalJobsTrackerParams} params - The parameters for this event
 * @property {string} phase_configuration_display_name - The display name of the phase configuration used to run this job
 * @property {string} job_id - Internal identifier of the sentimental pipeline
 * @property {string} interaction_id - Interaction id provided by the user (callId for CC calls)
 * @property {string} job_status - started/completed
 * @return {LogObject<sentimentalJobsTrackerParams>} LogObject<sentimentalJobsTrackerParams>
 */
export function sentimentalJobsTracker(params) {
    return { evid: 1001, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackMainFormOpened' event (evid: 101)
 *
 * Event description: callback -> main form opened.
 *
 * @param {callbackMainFormOpenedParams} params - The parameters for this event
 * @return {LogObject<callbackMainFormOpenedParams>} LogObject<callbackMainFormOpenedParams>
 */
export function callbackMainFormOpened(params) {
    return { evid: 101, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackLoginFormSkip' event (evid: 103)
 *
 * Event description: callback login form -> skip.
 *
 * @param {callbackLoginFormSkipParams} params - The parameters for this event
 * @return {LogObject<callbackLoginFormSkipParams>} LogObject<callbackLoginFormSkipParams>
 */
export function callbackLoginFormSkip(params) {
    return { evid: 103, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callbackByPhoneSubmit' event (evid: 113)
 *
 * Event description: callback by phone -> submit.
 *
 * @param {callbackByPhoneSubmitParams} params - The parameters for this event
 * @property {string} desc - renamed desc -> dsc on Jan 16
 * @property {string} 'sub-cat' - renamed sub-cat -> subcat on Jan 16
 * @property {string} date - date
 * @property {string} timeslot - timeslot
 * @property {string} title - title
 * @property {string} cat - changed cat -> category on Oct 03, 2013
 * @property {boolean} has_attach - has_attach
 * @return {LogObject<callbackByPhoneSubmitParams>} LogObject<callbackByPhoneSubmitParams>
 */
export function callbackByPhoneSubmit(params) {
    return { evid: 113, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userSubmittedASurvey' event (evid: 2)
 *
 * Event description: user submitted a survey.
 *
 * @param {userSubmittedASurveyParams} params - The parameters for this event
 * @property {DateTime} submitted - submitted
 * @property {string} rep_needs - rep_needs
 * @property {DateTime} contacted - date_contacted
 * @property {GUID} uuid - uuid
 * @property {string} rep_curt - rep_curt
 * @property {string} agent_name - agent_name
 * @property {string} country - country_code
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} rep_prompt - rep_prompt
 * @property {string} comment - comment
 * @property {number} clid - clid
 * @property {string} rep_help - rep_help
 * @property {string} province - region
 * @property {string} serv_sat - serv_sat
 * @property {string} rep_know - rep_know
 * @property {string} rep_effic - rep_effic
 * @property {string} wix_sat - wix_sat
 * @property {number} call_id - call_id
 * @return {LogObject<userSubmittedASurveyParams>} LogObject<userSubmittedASurveyParams>
 */
export function userSubmittedASurvey(params) {
    return { evid: 2, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inboundCallCallCreated' event (evid: 3)
 *
 * Event description: An inbound call was created in WCC
 *
 * @param {inboundCallCallCreatedParams} params - The parameters for this event
 * @property {string} customer_id - In WCC: assoc_user_id
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - Call ID
 * @return {LogObject<inboundCallCallCreatedParams>} LogObject<inboundCallCallCreatedParams>
 */
export function inboundCallCallCreated(params) {
    return { evid: 3, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inboundCallLanguageSelected' event (evid: 4)
 *
 * Event description: The caller selected a language in the IVR
 *
 * @param {inboundCallLanguageSelectedParams} params - The parameters for this event
 * @property {string} customer_id - In WCC: assoc_user_id
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - Call ID
 * @property {string} lang - User's selected language
 * @return {LogObject<inboundCallLanguageSelectedParams>} LogObject<inboundCallLanguageSelectedParams>
 */
export function inboundCallLanguageSelected(params) {
    return { evid: 4, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inboundCallQueueSelected' event (evid: 5)
 *
 * Event description: The caller selected a specific issue/queue in the IVR
 *
 * @param {inboundCallQueueSelectedParams} params - The parameters for this event
 * @property {string} customer_id - In WCC: assoc_user_id
 * @property {string} queue - Name of the queue the user was assigned to
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - Call ID
 * @property {string} lang - User's selected language
 * @return {LogObject<inboundCallQueueSelectedParams>} LogObject<inboundCallQueueSelectedParams>
 */
export function inboundCallQueueSelected(params) {
    return { evid: 5, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'answersTroubleshooterLinkSent' event (evid: 500)
 *
 * Event description: Indication we sent the link to the mobile app to the user who called our call center
 *
 * @param {answersTroubleshooterLinkSentParams} params - The parameters for this event
 * @property {boolean} lines_closed - was the link to the app sent when the call center was closed or not
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - the call id of the inbound call
 * @return {LogObject<answersTroubleshooterLinkSentParams>} LogObject<answersTroubleshooterLinkSentParams>
 */
export function answersTroubleshooterLinkSent(params) {
    return { evid: 500, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCallMe' event (evid: 501)
 *
 * Event description: user clicked on the link of the mobile app we sent him
 *
 * @param {clickCallMeParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - the call id of the inbound call
 * @return {LogObject<clickCallMeParams>} LogObject<clickCallMeParams>
 */
export function clickCallMe(params) {
    return { evid: 501, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCallMeResponse' event (evid: 502)
 *
 * Event description: user clicked an item in the mobile app we sent him
 *
 * @param {clickCallMeResponseParams} params - The parameters for this event
 * @property {string} item_id - the id of the item the user selected
 * @property {number} item_order - the order the selected item appeared in the list
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} reason - the call me response
 * @property {string} parent_item_id - NULL if top level item, otherwise the parent level item id
 * @property {string} item_name - the name of the item the user selected
 * @property {number} clid - the call id of the inbound call
 * @property {string} parent_item_name - NULL if top level item, otherwise the parent level item name
 * @return {LogObject<clickCallMeResponseParams>} LogObject<clickCallMeResponseParams>
 */
export function clickCallMeResponse(params) {
    return { evid: 502, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'xClickReadMore' event (evid: 503)
 *
 * Event description: user clicked the read more link in an article item mobile app we sent him
 *
 * @param {xClickReadMoreParams} params - The parameters for this event
 * @property {number} item_order - the order the selected item appeared in the list
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {GUID} article_id - the id of the article the user clicked read more from
 * @property {string} article_name - the name of the article the user clicked read more from
 * @return {LogObject<xClickReadMoreParams>} LogObject<xClickReadMoreParams>
 */
export function xClickReadMore(params) {
    return { evid: 503, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduledCallUserContacted' event (evid: 6)
 *
 * Event description: User receives a callback
 *
 * @param {scheduledCallUserContactedParams} params - The parameters for this event
 * @property {string} customer_id - In WCC: assoc_user_id
 * @property {string} queue - Name of the queue the user was assigned to
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {number} clid - Call ID
 * @property {string} lang - User's selected language
 * @return {LogObject<scheduledCallUserContactedParams>} LogObject<scheduledCallUserContactedParams>
 */
export function scheduledCallUserContacted(params) {
    return { evid: 6, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listenToLiveCall' event (evid: 600)
 *
 * Event description: live call is being listened to by a user in wcc
 *
 * @param {listenToLiveCallParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @return {LogObject<listenToLiveCallParams>} LogObject<listenToLiveCallParams>
 */
export function listenToLiveCall(params) {
    return { evid: 600, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'listenToRecordedCall' event (evid: 601)
 *
 * Event description: recorded call is being listened to by a user in wcc
 *
 * @param {listenToRecordedCallParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @return {LogObject<listenToRecordedCallParams>} LogObject<listenToRecordedCallParams>
 */
export function listenToRecordedCall(params) {
    return { evid: 601, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterLinesLogClosedManually' event (evid: 7)
 *
 * Event description: This event is fired when the Call Center lines are being toggled off during regular operation hours (due to high volume, system issues, holidays, etc.)
 *
 * @param {callCenterLinesLogClosedManuallyParams} params - The parameters for this event
 * @property {boolean} is_inbound - Was the inbound line toggled off
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} id - Closing ID
 * @property {string} lang - Language of the Closed line
 * @property {boolean} is_scheduler - Was the scheduler toggled off
 * @property {string} closing_reason - Reason for the closing (answering tickets, high volume, system issues, holiday, etc.)
 * @return {LogObject<callCenterLinesLogClosedManuallyParams>} LogObject<callCenterLinesLogClosedManuallyParams>
 */
export function callCenterLinesLogClosedManually(params) {
    return { evid: 7, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'callCenterLinesLogOpenedManually' event (evid: 8)
 *
 * Event description: This event is fired when the Call Center lines are being toggled on after being toggled off during regular operation hours (due to high volume, system issues, holidays, etc.)
 *
 * @param {callCenterLinesLogOpenedManuallyParams} params - The parameters for this event
 * @property {number} closing_duration - In seconds
 * @property {boolean} is_inbound - Was the inbound line toggled on
 * @property {GUID} uuid - uuid
 * @property {string} agent - agent
 * @property {GUID} client_id - client_id
 * @property {string} id - Closing ID
 * @property {string} lang - Language of the Opened line
 * @property {boolean} is_scheduler - Was the scheduler toggled on
 * @property {string} closing_reason - Reason for the closing (answering tickets, high volume, system issues, holiday, etc.)
 * @return {LogObject<callCenterLinesLogOpenedManuallyParams>} LogObject<callCenterLinesLogOpenedManuallyParams>
 */
export function callCenterLinesLogOpenedManually(params) {
    return { evid: 8, src: 7, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc7Evid801' event (evid: 801)
 *
 * Event description: sentimental-poc.
 *
 * @param {dummyNameSrc7Evid801Params} params - The parameters for this event
 * @property {string} answers_call_id - answers call id
 * @property {string} sentiment_result - sentiment_result
 * @property {string} sentiment_score - sentiment_score
 * @return {LogObject<dummyNameSrc7Evid801Params>} LogObject<dummyNameSrc7Evid801Params>
 */
export function dummyNameSrc7Evid801(params) {
    return { evid: 801, src: 7, endpoint: '', params };
}
//# sourceMappingURL=index.js.map